// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&family=Sora:wght@100..800&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
body {
  font-family: "Nunito", sans-serif !important;
}

:root {
  overflow: hidden;
  --blue: rgb(16, 60, 94);
  --approved_color: rgb(133, 186, 133);
  --unapproved_color: rgb(196, 196, 196);
  --red_color: rgb(255, 0, 0);
  --inactive_menu_color: rgb(67, 67, 67);
  /* Inactive Menu Color */
  --base: #5e5690;
  --base-light: #7873a7;
  --base-dark: #555184;
  --shadow: #4f4c6b;
  --letter: #d8d7e5;
  --white: rgb(255, 255, 255);
  --border_color: rgb(237, 237, 237);
}

.br3 {
  border-radius: 3px !important;
}

.alert {
  padding: 3px 8px !important;
  font-size: 10px;
  border-radius: 2px !important;
  margin: 0 !important;
}

.removeCaptionBorder {
  width: 170px;
}
.removeCaptionBorder .blockquote-footer::before {
  display: none;
}

.paneOverflow {
  position: static !important;
}

.w-200 {
  width: 200px;
}

.white {
  color: var(--white) !important;
}

.bg-main {
  background-color: var(--blue) !important;
  border: 1px solid var(--blue) !important;
}

.white-background {
  background: var(--white) !important;
}

:disabled {
  cursor: no-drop;
  pointer-events: all !important;
}

.rotate-on-load {
  transform: rotate(360deg);
  transition: transform 0.5s ease;
}

.btn:disabled,
button:disabled {
  background-color: #ececec !important;
  border-color: #ececec !important;
  color: var(--bg-secondary-subtle) !important;
}

.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: var(--blue);
  outline: 0;
  box-shadow: none;
}

.normalHeight {
  max-height: calc(100vh - 180px);
}
.normalHeight table .form-select {
  border-radius: 3px;
  border: 0;
  padding: 1px 7px !important;
  cursor: pointer;
}

.modal-header,
.offcanvas-header {
  padding: 10px !important;
  background: var(--blue) !important;
  border: 1px solid var(--blue) !important;
  border-radius: 3px 3px 0 0 !important;
  width: 100% !important;
}
.modal-header .modal-title,
.modal-header .offcanvas-title,
.offcanvas-header .modal-title,
.offcanvas-header .offcanvas-title {
  font-size: 15px;
  color: #fff;
}
.modal-header .btn-close,
.offcanvas-header .btn-close {
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.offcanvas-header {
  border-radius: 0 !important;
}

.blue {
  color: var(--blue);
}

.green {
  color: green;
}

.orange {
  color: orange;
}

.red {
  color: red;
}

.gray {
  color: rgb(138, 138, 138);
}

.fontSize12 {
  font-size: 12px;
}

.fontSize14 {
  font-size: 14px;
}

.bg-blue {
  background: var(--blue);
}

.bg-red {
  background: red !important;
}

.gray {
  color: gray;
}

.green {
  color: green;
}

.dashed {
  opacity: 0.7;
}

/* .................................................................. */
table.sortable td,
table.sortable th {
  padding: 0.125em 0.25em;
  width: 8em;
}

table.sortable th {
  font-weight: bold;
  border-bottom: thin solid #888;
  position: relative;
}

table.sortable th.no-sort {
  padding-top: 0.35em;
}

table.sortable th:nth-child(5) {
  width: 10em;
}

table.sortable th button {
  position: absolute;
  padding: 4px;
  margin: 1px;
  font-size: 100%;
  font-weight: bold;
  background: transparent;
  border: none;
  display: inline;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  text-align: left;
  outline: none;
  cursor: pointer;
}

table.sortable th button span {
  position: absolute;
  right: 4px;
}

table.sortable th[aria-sort=descending] span::after {
  content: "▼";
  color: currentcolor;
  font-size: 100%;
  top: 0;
}

table.sortable th[aria-sort=ascending] span::after {
  content: "▲";
  color: currentcolor;
  font-size: 100%;
  top: 0;
}

table.show-unsorted-icon th:not([aria-sort]) button span::after {
  content: "♢";
  color: currentcolor;
  font-size: 100%;
  position: relative;
  top: -3px;
  left: -4px;
}

table.sortable td.num {
  text-align: right;
}

table.sortable tbody tr:nth-child(odd) {
  background-color: #ddd;
}

/* Focus and hover styling */
table.sortable th button:focus,
table.sortable th button:hover {
  padding: 2px;
  border: 2px solid currentcolor;
  background-color: #e5f4ff;
}

table.sortable th button:focus span,
table.sortable th button:hover span {
  right: 2px;
}

table.sortable th:not([aria-sort]) button:focus span::after,
table.sortable th:not([aria-sort]) button:hover span::after {
  content: "▼";
  color: currentcolor;
  font-size: 100%;
  top: 0;
}

.table td,
.table th {
  border: 1px solid var(--bs-border-color);
}

.table tr:first-child td,
table tr th {
  border-top: none !important;
}

.table tr:last-child td {
  border-bottom: 1px solid var(--bs-border-color);
}

.table tr td:first-child,
.table tr th {
  border-left: none;
}

.table tr td:last-child {
  border-right: none;
}

/* ........................................... */
.gb_Te {
  height: 28px;
  width: 35px;
}

.v {
  cursor: pointer;
  opacity: 0.4;
}

.download {
  margin-top: 5px;
}

.userspan {
  background: transparent;
  border: none;
  height: 20px;
}

.login {
  font-size: 0.8rem;
}

.signout {
  font-size: 0.8rem;
  margin-left: -19px;
}

.mr-nav {
  font-size: 1.5rem;
  margin-bottom: 0px;
  margin-left: 6px;
}

.rr {
  margin: 0;
  color: var(--white);
  font-size: 3rem;
}

.col-form-label {
  font-size: 0.8rem;
}

.small.text-success,
.small.text-danger {
  font-size: 11px;
}

.form-control,
.text-primary,
.text-muted,
.form-select,
.d-none .h5 {
  font-size: 11px !important;
  border-radius: 3px !important;
}

.form-label {
  font-size: 12px;
}

.searchWrapper {
  padding: 0 !important;
}

.multiSelectContainer li.option,
.notFound,
.hstack span,
button span {
  font-size: 12px;
}

.multiSelectContainer li {
  padding: 2px 10px !important;
}

.multiSelectContainer li:hover {
  background: var(--blue) !important;
}

.highlightOption {
  background: var(--blue) !important;
  color: var(--white) !important;
  font-size: 12px;
}

.full-screen-component {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  padding: 5px;
  overflow: hidden;
  background: var(--white);
}

.pdf_viwer_section_full {
  height: 99vh;
  overflow: auto;
}

.pdf_viwer_original_section {
  height: calc(100vh - 424px);
  overflow: auto;
}

.notFound {
  position: absolute;
  left: 50%;
  top: 40%;
  transform: translateX(-50%);
}

.pdf_viwer_section_full .table > thead.fixed_property_header {
  top: 0px;
}

.searchWrapper {
  padding: 0 !important;
}

.table > thead.fixed_property_header {
  position: sticky;
  top: 0px;
  z-index: 99;
}

.multiSelectContainer input {
  padding: 6px !important;
  font-size: 11px;
}

.chip {
  background: var(--blue) !important;
  border-radius: 4px !important;
  font-size: 11px !important;
  line-height: 20px !important;
  margin: 4px;
  margin-right: 2px !important;
  padding: 2px 10px !important;
}

.smalls {
  font-size: small;
}

.inputsize {
  height: 40px;
  font-size: 0.8rem;
}

.topuseremail {
  height: 30px;
  font-size: 0.8rem;
  width: 100%;
}

.useremailid {
  width: 10%;
}

.usertopsubject {
  padding-left: 35px;
}

.clienttophr {
  margin-top: 4px;
  margin-left: -24px;
  margin-right: -24px;
}

.newclientcreation {
  overflow-x: hidden;
}

.upload {
  height: 1.8rem;
  padding-top: 2px;
}

.h4 {
  font-size: large;
}

.apps {
  display: flex;
}

.cross {
  height: 1.3rem;
}

.refresh {
  height: 1rem;
}

.clientsicon {
  height: 1rem;
}

.mailicon {
  height: 0.8rem;
}

.usersicon {
  height: 1rem;
}

.rolesicon {
  height: 0.9rem;
}

.auditsicon {
  height: 0.8rem;
}

.avatarborder {
  border: 1px solid var(--blue);
  border-radius: 8px;
  padding: 1px;
  height: 9rem;
  width: 9rem;
}

.countryoption {
  background-color: transparent;
}

.seclect_dropdown_status {
  width: 69%;
  height: 35px;
  border: none;
  font-size: 0.8rem;
}

.form-select:focus {
  border-color: var(--blue);
  box-shadow: none;
}

.newaddress {
  height: 6rem;
}

.senthead {
  padding-bottom: 5px;
}

.editicon {
  height: 1rem;
}

.inputborder {
  border: 1px solid var(--blue);
  width: 75%;
}

.inputfonts,
.avatarleft,
.uploadlogo {
  font-size: 0.8rem;
  width: 25%;
  opacity: 0.9;
}

.uploadlogo {
  font-size: 0.8rem;
  width: 25%;
  opacity: 0.9;
}

.space {
  width: 500px;
  display: inline;
  visibility: hidden;
  background-color: red;
  margin-left: 15rem;
}

.eventtable {
  border: transparent;
}

.file1,
.file2 {
  height: 1.3rem;
  margin-left: 0px;
}

.chooselogo {
  border-radius: 10px;
  width: 75%;
}

.bottombuttons {
  margin-top: 4rem;
}

.title {
  border-radius: 10px 10px 0 0;
  background: hsl(206, 60%, 30%);
  color: white;
  font-size: 18px;
}

.updateProfile,
.rpv-core__button {
  background: transparent;
  border: 1px solid #103c5e !important;
  color: #103c5e;
  border-radius: 3px;
  font-size: 12px !important;
  padding: 3px 10px 4px;
  transition: 1s;
}
.updateProfile:hover,
.rpv-core__button:hover {
  background: #103c5e;
  color: white;
  border: 1px solid #103c5e;
}

.rpv-core__button {
  height: auto !important;
}

.rpv-thumbnail__items--selected .rpv-thumbnail__item,
.rpv-thumbnail__item--single:hover,
.rpv-thumbnail__item--dual-cover:hover,
.rpv-thumbnail__items--dual:hover .rpv-thumbnail__item,
.rpv-thumbnail__items--dual-cover:hover .rpv-thumbnail__item,
.rpv-core__minimal-button:hover,
.rpv-bookmark__item:hover,
.rpv-bookmark__item:focus,
cr .rpv-core__minimal-button--selected {
  background-color: rgb(219, 230, 239) !important;
}

.rpv-bookmark__title {
  font-size: 12px !important;
}

.removeProfile {
  background: transparent;
  border: 1px solid red !important;
  color: red;
  border-radius: 3px;
  font-size: 12px;
  padding: 3px 10px 4px;
  transition: 1s;
}
.removeProfile:hover {
  background: red;
  color: white;
  border: 1px solid red;
}

.profile-section {
  height: calc(100vh - 121px);
  overflow-y: auto;
  overflow-x: hidden;
}

.profileSection {
  width: 100%;
  height: calc(100vh - 112px);
  margin: 4px 0;
}
.profileSection img {
  width: 50px;
  height: 50px;
  margin: 4px 0;
  border: 1px solid;
}

.img-account-profile {
  height: 10rem;
}

.card .card-header {
  font-weight: 500;
}

.card-header:first-child {
  border-radius: 0.35rem 0.35rem 0 0;
}

.card-header {
  margin-bottom: 0 !important;
  background-color: rgb(31, 83, 122) !important;
  border: 1px solid rgb(31, 83, 122) !important;
  color: #fff !important;
}

.nav-borders .nav-link.active {
  color: #0061f2;
  border-bottom-color: #0061f2;
}

.nav-borders .nav-link {
  color: #69707a;
  border-bottom-width: 0.125rem;
  border-bottom-style: solid;
  border-bottom-color: transparent;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0;
  padding-right: 0;
  margin-left: 1rem;
  margin-right: 1rem;
}

.col-form-label {
  font-size: 0.9rem !important;
}

.dedicon {
  height: 1rem;
}

.newrequest1icon {
  height: 1rem;
}

.requesttypebox {
  width: 100%;
}

.reqtype,
.projectiddiv,
.studyiddiv {
  width: 33.33%;
}

.newrequestbuttons {
  width: 8rem;
}

.createroleicon {
  height: 1rem;
}

.createrolerightbottom {
  margin-top: -11px;
}

.createroleright {
  width: 33%;
  margin-left: 5px;
  height: 100vh;
}

.createrolebutton {
  background-color: var(--white);
  border: 1px solid rgb(34, 163, 255);
  width: 7rem;
}

.rolename {
  border: 1px solid var(--blue);
  width: 30%;
  height: 30px;
}

.roledescription {
  border: 1px solid var(--blue);
  width: 30%;
  height: 93px;
  border-radius: 10px;
}

.createrolefloppyicon {
  font-size: 5px;
}

.createrolefloppybutton {
  margin-top: 0px;
}

.elementana {
  background-color: hsl(102, 39%, 94%);
}

.backupleft {
  width: 53%;
}

.backuprightbottom {
  width: 46%;
  margin-left: 10px;
  height: 43rem;
}

.createroleselect {
  border: 1px solid var(--blue);
  width: 30%;
  height: 30px;
}

.createrolebuttons {
  margin-top: 5rem;
}

.roletext {
  opacity: 0.8;
  width: 13%;
}

.roleform {
  width: 100%;
}

.homecross {
  height: 0.8rem;
}

.arrowup {
  height: 1rem;
}

.arrowdown {
  height: 1rem;
}

.calender {
  height: 23px;
}

.backuprightarrow {
  height: 1rem;
}

.rightarrow {
  height: 1rem;
}

.visitrightarrow {
  height: 0.8rem;
  margin: 0px;
  padding: 0px;
}

.mainfolder {
  height: 1rem;
}

.demographics {
  height: 1rem;
}

.selectfeild {
  height: 25px;
  width: 115px;
}

.selectfont {
  height: 24px;
  width: 101px;
  margin-top: 18px;
  padding-top: 1px;
}

.fontsize {
  width: 67px;
  height: 23px;
  padding-top: 0px;
}

.democolorselect {
  background-color: red;
  opacity: 1;
  height: 2px;
}

.selectfontlabel,
.fontsizelabel,
.fontsize,
.feildtypelabel,
.selectfeild {
  margin-top: 18px;
}

.feildtype {
  margin-bottom: -8px;
  margin-top: 2px;
}

.studysiteedit {
  height: 1rem;
}

.studysitebody {
  margin-top: 2px;
}

.mail,
.info {
  height: 1rem;
}

.trash {
  height: 1rem;
}

.childplay {
  height: 1rem;
}

.customshow {
  margin-bottom: 5px;
}

.cdashselect {
  border-radius: 5px;
  width: 54px;
  color: hsl(0, 0%, 64%);
  height: 25px;
  padding-left: 5px;
  font-size: 9px;
  text-align: center;
  border: 1px solid hsl(48, 21%, 86%);
}

.studysiteselect {
  border-radius: 5px;
  width: 54px;
  color: hsl(0, 0%, 64%);
  height: 25px;
  padding-left: 5px;
  font-size: 9px;
  text-align: center;
  border: 1px solid hsl(48, 21%, 86%);
}

.file {
  height: 1rem;
}

.sentdatafont {
  color: hsl(0, 2%, 52%);
}

.tborder {
  border: 1px solid var(--blue);
  border-radius: 10px;
}

.check {
  height: 12px;
}

.ddob {
  color: hsl(0, 0%, 39%);
}

.ddobs {
  color: hsl(0, 0%, 35%);
}

.pagelink {
  background-color: hsl(205, 100%, 38%);
  margin-right: 4px;
  margin-left: 4px;
  border-radius: 6px;
  margin-top: 1px;
  width: 100px;
  height: 1.5rem;
  color: var(--white);
  font-size: 13px;
  border: none;
  text-align: center;
}

.rightangle {
  height: 1.4rem;
  margin-top: 2px;
  border: none;
}

.rntable {
  padding-bottom: 20rem;
}

.rightpage {
  height: 1.5rem;
}

.showentries {
  font-size: 13px;
  padding-top: 3px;
}

.showentriesselect {
  padding-top: 2px;
}

.transferright {
  width: 33%;
  height: 100vh;
  border-left: 1px solid #dee2e6 !important;
  margin-left: 5px;
}

.transfereye {
  background: transparent;
  border: none;
  padding: 0px;
}

.eyeicon {
  height: 10px;
}

@media screen and (max-width: 761px) {
  .transferright {
    border-left: none;
    margin-left: 0px;
  }
}
/* DATA TRANSFER JOB .................................. */
.datatransferjob {
  margin-top: 3px;
}

@media screen and (max-width: 1528px) {
  .datatransferleft {
    width: 130%;
  }
}
@media screen and (max-width: 960px) {
  .transferrightbottom,
  .datatransferrighttop {
    width: 210%;
  }
  .datatransferleft {
    width: 150%;
  }
}
@media screen and (max-width: 877px) {
  .transferrightbottom {
    width: 250%;
  }
  .datatransferleft {
    width: 150%;
  }
}
@media screen and (max-width: 816px) {
  .datatransferleft {
    width: 170%;
  }
}
@media screen and (max-width: 761px) {
  .transferleft,
  .transferright,
  .transferrightbottom,
  .datatransferrighttop {
    width: 100%;
  }
  .datatransferrighttop {
    margin-top: 5px;
  }
}
@media screen and (max-width: 613px) {
  .transferrightbottom {
    width: 130%;
  }
}
@media screen and (max-width: 480px) {
  .datatransferleft {
    width: 210%;
  }
}
@media screen and (max-width: 476px) {
  .transferrightbottom {
    width: 150%;
  }
}
@media screen and (max-width: 476px) {
  .datatransferrighttop {
    width: 120%;
  }
}
@media screen and (max-width: 393px) {
  .datatransferleft {
    width: 270%;
  }
}
@media screen and (max-width: 366px) {
  .datatransferrighttop {
    width: 150%;
  }
  .transferrightbottom {
    width: 220%;
  }
}
/* ..................................................... */
/* STUDYDETAILS.......................................... */
.studydetail {
  width: 100%;
  margin-top: 2px;
}

@media screen and (max-width: 1239px) {
  .studydetailtable {
    width: 130%;
  }
}
@media screen and (max-width: 956px) {
  .studydetailtable {
    width: 150%;
  }
}
@media screen and (max-width: 830px) {
  .studydetailtable {
    width: 180%;
  }
}
@media screen and (max-width: 693px) {
  .studydetailtable {
    width: 210%;
  }
}
@media screen and (max-width: 596px) {
  .studydetailtable {
    width: 260%;
  }
}
@media screen and (max-width: 483px) {
  .studydetailtable {
    width: 300%;
  }
}
@media screen and (max-width: 403px) {
  .studydetailtable {
    width: 400%;
  }
}
/* ...................................................... */
/* CODELIST.............................................. */
.codelistmain {
  height: 100vh;
}

.codelistleft {
  width: 50%;
}

.codelistright {
  width: 49.6%;
  margin-left: 5px;
}

@media screen and (max-width: 1313px) {
  .codelistlefttable {
    width: 130%;
  }
}
@media screen and (max-width: 1182px) {
  .codelistrighttable {
    width: 130%;
  }
}
@media screen and (max-width: 1016px) {
  .codelistlefttable {
    width: 140%;
  }
  .codelistrighttable {
    width: 130%;
  }
}
@media screen and (max-width: 945px) {
  .codelistlefttable {
    width: 160%;
  }
  .codelistrighttable {
    width: 130%;
  }
}
@media screen and (max-width: 945px) {
  .codelistlefttable {
    width: 160%;
  }
  .codelistrighttable {
    width: 150%;
  }
}
@media screen and (max-width: 830px) {
  .codelistlefttable {
    width: 200%;
  }
  .codelistrighttable {
    width: 170%;
  }
}
@media screen and (max-width: 761px) {
  .codelistmain {
    display: flex;
    flex-direction: column;
  }
  .codelistlefttable,
  .codelistrighttable,
  .codelistright,
  .codelistleft {
    width: 100%;
  }
}
@media screen and (max-width: 667px) {
  .codelistlefttable {
    width: 130%;
  }
}
@media screen and (max-width: 597px) {
  .codelistlefttable {
    width: 130%;
  }
  .codelistrighttable {
    width: 130%;
  }
}
@media screen and (max-width: 518px) {
  .codelistlefttable {
    width: 150%;
  }
  .codelistrighttable {
    width: 130%;
  }
}
@media screen and (max-width: 464px) {
  .codelistlefttable {
    width: 150%;
  }
  .codelistrighttable {
    width: 160%;
  }
}
@media screen and (max-width: 452px) {
  .codelistlefttable {
    width: 180%;
  }
  .codelistrighttable {
    width: 160%;
  }
}
@media screen and (max-width: 381px) {
  .codelistlefttable {
    width: 210%;
  }
  .codelistrighttable {
    width: 200%;
  }
}
/* ...................................................... */
/* VALUELEVEL............................................ */
.valuelevelleft {
  width: 36%;
}

.valuelevelright {
  width: 63.6%;
  margin-left: 5px;
}

.valuelevelrighttable {
  width: 130%;
}

@media screen and (max-width: 1533px) {
  .valuelevellefttable {
    width: 130%;
  }
}
@media screen and (max-width: 1462px) {
  .valuelevelrighttable {
    width: 150%;
  }
}
@media screen and (max-width: 1269px) {
  .valuelevelrighttable {
    width: 170%;
  }
}
@media screen and (max-width: 1183px) {
  .valuelevellefttable {
    width: 150%;
  }
}
@media screen and (max-width: 1121px) {
  .valuelevelrighttable {
    width: 200%;
  }
}
@media screen and (max-width: 1027px) {
  .valuelevellefttable {
    width: 180%;
  }
}
@media screen and (max-width: 955px) {
  .valuelevelrighttable {
    width: 220%;
  }
}
@media screen and (max-width: 869px) {
  .valuelevelmain {
    display: flex;
    flex-direction: column;
  }
  .valuelevelleft,
  .valuelevelright,
  .valuelevellefttable {
    width: 100%;
    margin: 0px;
  }
}
@media screen and (max-width: 869px) {
  .valuelevellefttable {
    width: 130%;
  }
  .valuelevelrighttable {
    width: 250%;
  }
}
@media screen and (max-width: 491px) {
  .valuelevellefttable {
    width: 130%;
  }
  .valuelevelrighttable {
    width: 300%;
  }
}
@media screen and (max-width: 433px) {
  .valuelevellefttable {
    width: 150%;
  }
  .valuelevelrighttable {
    width: 320%;
  }
}
@media screen and (max-width: 387px) {
  .valuelevellefttable {
    width: 150%;
  }
  .valuelevelrighttable {
    width: 400%;
  }
}
@media screen and (max-width: 377px) {
  .valuelevellefttable {
    width: 180%;
  }
  .valuelevelrighttable {
    width: 400%;
  }
}
/* ...................................................... */
.settingright {
  width: 58%;
  margin-left: 5px;
  height: 100vh;
}

.demographic2main {
  width: 100%;
  overflow-x: hidden;
}

.demographic2bg {
  width: 100%;
  height: 30vh;
}

.demo2left {
  width: 20%;
}

.demo2genderbutton {
  border-radius: 0px;
}

.demo2genderflex {
  display: flex;
  flex-direction: column;
  height: 60vh;
}

.menuclose {
  background: transparent;
  border: none;
}

.demographic2genderselect {
  background-color: hsl(0, 0%, 94%);
  height: 30vh;
}

.demo2gender {
  width: 20%;
}

.demographic2column {
  display: flex;
  flex-direction: column;
  width: 79.6%;
  margin-left: 5px;
  height: 100vh;
}

.settingtablebg {
  background-color: #eaf1f6;
}

.demographicstablebg,
.settingbg {
  background-color: rgb(207, 221, 252);
}

.visitbg {
  background-color: #eaf1f6;
}

.visitfont {
  color: hsl(220, 94%, 31%);
  font-weight: lighter;
}

.visitdatafont {
  color: hsl(0, 0%, 37%);
}

.visitdatabg {
  background-color: hsl(0, 0%, 95%);
}

.visitright {
  width: 49.8%;
  margin-left: 2px;
  height: 44rem;
}

.eventsearch {
  border: 1px solid hsl(196, 100%, 47%);
  border-radius: 5px;
  height: 1.7rem;
  width: 130px;
}

.sentrequesttable {
  margin-left: 0px;
  margin-right: 0px;
}

.scheduleleft {
  width: 66.5%;
  margin-right: 2px;
  height: 40rem;
}

.scheduleright {
  height: 40rem;
}

.schedulesecond {
  height: 13rem;
}

.schedulethird {
  height: 15rem;
}

.sno {
  border: 1px solid rgb(1, 70, 119);
  border-radius: 10px;
  margin-top: 7px;
  height: 37px;
  padding-top: 5px;
  width: 98.4%;
  margin-left: auto;
  margin-right: auto;
}

.asiancheck {
  width: 17px;
  height: 17px;
  color: blue;
}

.birthcheck {
  width: 17px;
  height: 14px;
}

.sn {
  padding-left: 5px;
  width: 25%;
}

.dateofbirth {
  margin-left: 25rem;
}

.datepick {
  margin-right: 3rem;
}

.year {
  margin-left: 2rem;
}

.month {
  margin-left: 2rem;
}

.date,
.month,
.year {
  width: 5rem;
  height: 2rem;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 5px;
  border: 1px solid var(--blue);
}

.racecheck {
  width: 20px;
  height: 20px;
  border-radius: 5px;
  border: solid #ff0000 1px;
}

.race2 {
  margin-right: 2.7rem;
}

.asian {
  margin-right: 14px;
}

.alaska {
  margin-left: 36.5rem;
}

.datat1 {
  margin-left: 3.5rem;
}

.demographicsdatatype {
  width: 25%;
  text-align: center;
}

.demographiccdashvariable {
  width: 25%;
}

.demographicsunit {
  width: 25%;
}

.scheduleleft {
  overflow: auto;
}

.labdatabg {
  background-color: #e2f0d9;
}

.labdatabg1 {
  background-color: #eaf1f6;
}

.labtableleft {
  width: 60%;
  height: 45rem;
  overflow: auto;
}

.customlefttable {
  height: 42rem;
}

.customrighttable {
  height: 42rem;
  width: 33.1%;
  margin-left: 3px;
}

.labrighttbbg {
  background-color: #f2f2f2;
}

.labtableright {
  width: 39.6%;
  height: 45rem;
  overflow: auto;
  margin-left: 5px;
}

.dataentryleft {
  height: 100vh;
}

.dataentrytab {
  background-color: hsl(48, 21%, 86%);
}

.dataentryright {
  height: 100vh;
}

.demographicstablefont,
.tophead {
  color: gray;
  font-size: 13px;
}

.settinginput {
  height: 11px;
}

.table-bordereds {
  border: 1px solid var(--white);
}

.leftdiv {
  width: 65%;
  height: 100vh;
}

.userright {
  width: 35%;
  height: 100vh;
}

.methodbuttons {
  border: 1px solid #cfd3d6;
  width: 10rem;
  height: 2.1rem;
  background-color: var(--white);
  margin-bottom: 4px;
}

.middlemethod {
  background-color: var(--white);
  border-radius: 10px;
  width: 93%;
  margin: auto;
  padding: 17px;
}

.tbackground {
  height: 80vh;
  background-color: hsl(48, 21%, 86%);
}

.notemessage {
  background-color: var(--white);
  border-radius: 10px;
  width: 93%;
  margin: auto;
  padding: 17px;
}

.addlibrary {
  width: 100%;
  margin-bottom: 59px;
}

.endbtn {
  padding-right: 50px;
}

.searchbar {
  height: 2rem;
}

.ok,
.clock {
  height: 1rem;
}

.border-none {
  border: none;
  background-color: var(--white);
}

.studyscheduleedit,
.edit {
  height: 1rem;
}

.print {
  height: 1rem;
}

.mainfile {
  height: 1rem;
}

.navprofile {
  height: 22px;
}

.profiler {
  margin-bottom: -20px;
  padding-top: 3px;
  margin-right: 5px;
}

.profiler1 {
  margin-bottom: -20px;
  padding-top: 3px;
  margin-right: -3px;
}

@media screen and (max-device-width: 575px) {
  .profiler1 {
    display: none;
  }
}
.client1icon,
.projectidicon {
  height: 1rem;
}

.client1,
.projectid,
.studyid {
  font-size: 12px;
  margin-right: 5px;
  margin-left: 3px;
}

.container-fluids {
  width: 98%;
  margin-left: 5px;
}

.usbjid {
  font-weight: lighter;
}

.m11 {
  background-color: hsl(97, 40%, 90%);
  line-height: 1.6;
}

.m11 a {
  text-decoration: none;
}

.margin {
  width: 99%;
  height: 100vh;
}

.sides {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.methodsidebg {
  background-color: hsl(0, 0%, 95%);
}

.methodsidefont {
  color: hsl(0, 0%, 0%);
}

@media screen and (max-device-width: 1600px) {
  .tbackground {
    height: 116vh;
  }
}
@media screen and (max-device-width: 1376px) {
  .tbackground {
    height: 120vh;
  }
}
@media screen and (max-device-width: 1127px) {
  .tbackground {
    height: 140vh;
  }
}
@media screen and (max-device-width: 844px) {
  .tbackground {
    height: 150vh;
  }
}
/* ............................................................. */
.btn-blue {
  background: var(--blue);
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  width: 100%;
  color: var(--white);
  margin: 0px;
  padding: 2px;
  border: 1px solid var(--blue) !important;
}
.btn-blue:hover {
  background: #134971;
  color: var(--white) !important;
  border: 1px solid var(--blue) !important;
}
.btn-blue:focus {
  background: #134971;
  color: var(--white) !important;
  border: 1px solid var(--blue) !important;
}

.border-blue {
  border-color: var(--blue) !important;
  border-width: 3px !important;
}

.border-info {
  border: 1px solid var(--blue) !important;
}

.rotate-up {
  transform: rotate(270deg);
}

.rotate-down {
  transform: rotate(90deg);
}

.activeclient {
  color: rgb(80, 193, 80) !important;
}

.disableColor {
  color: #afa7a7 !important;
}

.archievedusers {
  color: gray;
}

.frozenusers {
  color: #ddaf00;
}

.onBoardusers {
  color: blue;
}

.pendingclient {
  color: rgb(146, 113, 50);
}

.text-capitalize {
  text-transform: capitalize;
}

.accessManage {
  color: var(--blue);
}

.inactiveclient {
  color: hsl(359, 78%, 61%) !important;
}

.awaiting {
  color: hsl(200, 94%, 23%);
}

.ongoing {
  color: rgb(110, 183, 0);
}

.locked {
  color: hsl(149, 95%, 30%);
}

.completed {
  color: hsl(198, 33%, 52%);
}

.inactive {
  color: hsl(4, 80%, 66%);
}

.topbox {
  display: flex;
}

.clients,
.request,
.users {
  color: var(--blue);
}

.roles,
.audits {
  color: var(--blue);
}

.navcolap {
  padding-bottom: 13px;
}

.auditcolap {
  padding-left: 8px;
}

.rolescolap {
  padding-left: 25px;
}

.auditscolap {
  padding-left: 20px;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: black;
  background-color: hsl(48, 21%, 86%);
}

.genderselect {
  border-left: 1px solid #dee2e6;
  height: 35rem;
  width: 99.6%;
  margin-left: 5px;
}

.genderpane {
  display: flex;
}

.leftbox {
  width: 24.6%;
  border-right: 1px solid #dee2e6;
}

.leftbox1 {
  margin-top: 16px;
}

.htarea {
  width: 98%;
  border-radius: 10px;
}

.testinput {
  width: 45rem;
}

.testhead {
  background-color: hsl(205, 39%, 87%);
}

.testinput1 {
  height: 38px;
  margin-top: 4px;
  border-radius: 10px;
}

.testtablediv {
  width: 100%;
}

.testt1r {
  color: red;
}

.testt2r {
  color: green;
}

.testbtn {
  background-color: var(--white);
  width: 9rem;
  height: 35px;
  margin-top: 5px;
}

.testdatarow {
  background-color: hsl(202, 40%, 96%);
}

.models {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 68%;
  pointer-events: auto;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.6rem;
  outline: 0;
  height: 100%;
  min-height: 164px;
  background-color: hsl(24, 84%, 83%);
  padding-bottom: 1rem;
}

.modalcross {
  background-color: transparent;
  border: none;
  color: hsl(202, 56%, 53%);
}

.modals-body {
  position: relative;
  flex: 1 1 auto;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  display: flex;
  text-align: center;
  line-height: 1.6;
  font-size: 16px;
}

.modaltxt {
  color: hsl(30, 17%, 5%);
}

.historybg {
  background-color: #d1e0eb;
}

.historydatabg,
.historyheight {
  background-color: var(--white);
}

.hheighttable {
  height: 100vh;
}

.historytxt {
  color: #262626;
  font-weight: lighter;
}

.hrcolor {
  color: rgb(158, 162, 162);
  margin-bottom: 5px;
}

.testrule {
  margin-bottom: 6px;
  padding-top: 5px;
}

.testval {
  margin-top: 5px;
  margin-bottom: 5px;
}

.testsection {
  width: 97%;
  margin: auto;
}

.add {
  background-color: var(--white);
  width: 9rem;
  padding: 5px;
  border-radius: 8px;
  font-size: 14px;
}

.custom-table td.multiselectOption,
.query-table {
  padding: 0px !important;
}

.multiselectOption .multiSelectContainer .searchWrapper {
  border: 0;
  border-radius: 0;
}

.multiselectOption .displayBlock {
  position: fixed;
}

.multiselectOption .chip {
  border-radius: 3px;
  font-size: 11px;
  line-height: 10px;
  margin-bottom: 3px;
  margin-right: 2px;
  padding: 5px 10px;
}

.nav-link {
  color: #4c4c4c;
  padding: 3px 10px;
  font-size: 12px;
}
.nav-link:hover {
  background: var(--blue) !important;
  color: #fff !important;
}

.page-link {
  color: var(--blue);
}

.navcard {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
}

.navroles {
  background: transparent;
  border: none;
  color: var(--white) fff;
  text-decoration: none;
}

.drop-down02 {
  position: relative;
}

.drop-down02 .sub-menu02 {
  position: absolute !important;
  left: 100%;
  top: 0;
}

.drop-down02 .dropdown-toggle {
  padding: 0.25rem 1.1rem !important;
}

#sub-dropdown-menu {
  display: none;
  position: absolute;
  left: 260px;
  top: 10px;
}

.studyschedulehover:hover #sub-dropdown-menu {
  display: block;
}

@media screen and (max-width: 767px) {
  .drop-down02 .sub-menu02 {
    position: static !important;
  }
}
/* SCROLLBAR........................................... */
/* width */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.cursor-pointer {
  cursor: pointer;
}

.blank::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #b8cfdf;
}

.dropdown {
  background: transparent;
  border: none;
  padding-left: 0px;
}

.dropdowns {
  color: transparent;
}

.show > .btn-primary.dropdown-toggle {
  background-color: transparent;
}

.dropdown:hover {
  background: transparent;
  border: none;
  border-color: transparent;
}

.searchselector {
  background-color: var(--white);
  border: none;
  border-radius: 5px;
  width: 17px;
}

.searchmagnifier {
  margin-top: 7px;
  font-size: 12px;
  font-weight: bolder;
  color: black;
}

.navsearch {
  height: 24px;
  border: none;
  padding-left: 1px;
}

.navdropdown {
  margin-left: -24px;
}

.searchselectoption {
  color: black;
  background-color: var(--white);
}

.gaurav {
  margin-right: 9px;
  max-width: 23rem;
}

.adminLoggedIn {
  max-width: 20rem;
  margin-right: 20px;
}

.galaxbar {
  height: 34px;
}

section.middle-content {
  width: 100%;
}
section.middle-content .sidebar {
  width: 100%;
  border: 1px solid #e5e5e5;
  border-radius: 3px;
  overflow: hidden;
}
section.middle-content .sidebar .menus ul {
  display: flex;
  width: 100%;
  padding: 0;
  margin: 0;
  flex-wrap: wrap;
  justify-content: flex-start;
}
section.middle-content .sidebar .menus ul li {
  display: flex;
  padding: 5px;
  justify-content: space-between;
}
section.middle-content .sidebar-body {
  overflow: auto;
  max-height: calc(100vh - 114px);
  min-width: 250px;
}

a[aria-expanded=true] .fa-angle-right {
  transform: rotate(90deg);
  padding-right: 10px;
}

a[aria-expanded=false] .fa-chevron-down,
.react-datepicker-wrapper input {
  display: none;
}

.plane {
  color: black;
}

section.middle-content .sidebar .menus ul li .hr-line {
  width: 100%;
  height: 100%;
  border: 1px solid #e5e5e5;
}

section.middle-content .sidebar .menus ul li a {
  color: #000;
  text-decoration: none;
  font-weight: 500;
  font-size: 13px;
  text-wrap: nowrap;
}
section.middle-content .sidebar .menus ul li a:hover {
  text-decoration: none;
}

section.middle-content .inner-cont .home-line {
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding: 0px;
  height: 31px;
}
section.middle-content .inner-cont .home-line .slideRight {
  margin-left: auto;
}

.dedhome-line {
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px;
}

.home-line {
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
}

.grid {
  padding-left: 2px;
}

section.middle-content .inner-cont .home-line i {
  font-size: 0.9rem;
}

section.middle-content .inner-cont .home-line2 {
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding: 0px;
}

section.middle-content .inner-cont .home-line2 i {
  font-size: 1rem;
  cursor: pointer;
  margin: 0px 5px 0px 5px;
}

.dashboard-body {
  height: calc(100vh - 155px);
  width: 100%;
  overflow: auto;
}

.dashboard-body .dashboard_item {
  height: 100%;
}

.hovertablerow :hover {
  background-color: rgb(184, 184, 186);
}

.dashboard_item .list-group {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 11px;
  background: aliceblue;
  height: 100%;
}

.listgroup {
  margin-bottom: 22px;
}

.sov {
  width: 100.5%;
}

.homedash {
  height: calc(100vh - 37px);
}

@media screen and (max-device-width: 565px) {
  section.middle-content .sidebar .menus ul li {
    padding: 2px;
  }
}
@media screen and (max-device-width: 398px) {
  .vr {
    visibility: hidden;
  }
}
/* DASHBOARD RESPONSIVENESS............................ */
@media screen and (max-device-width: 1401px) {
  .list-group {
    margin-bottom: 23px;
  }
  .sov {
    width: 100.8%;
  }
  .homedash {
    height: 91%;
  }
}
@media screen and (max-device-width: 1380px) {
  .list-group {
    margin-bottom: 22px;
  }
  .homedash {
    height: 91%;
  }
}
@media screen and (max-device-width: 1339px) {
  .list-group {
    margin-bottom: 43px;
  }
}
@media screen and (max-device-width: 1205px) {
  .list-group {
    margin-bottom: 43px;
  }
}
@media screen and (max-device-width: 1176px) {
  .list-group {
    margin-bottom: 31px;
  }
}
@media screen and (max-device-width: 1140px) {
  .list-group {
    margin-bottom: 31px;
  }
}
@media screen and (max-device-width: 1132px) {
  .list-group {
    margin-bottom: 31px;
  }
}
@media screen and (max-device-width: 1110px) {
  .list-group {
    margin-bottom: -11px;
  }
}
@media screen and (max-device-width: 1090px) {
  .topbox {
    display: flex;
    flex-wrap: wrap;
  }
  .fbox {
    width: 99.5%;
  }
  .sbox {
    width: 100%;
    margin-top: 5px;
  }
  .tbox,
  .tbox1 {
    width: 100%;
  }
  .sov {
    width: 100%;
  }
}
@media screen and (max-device-width: 622px) {
  .fboxtab {
    display: flex;
    flex-direction: column;
  }
  .fbox622 {
    width: 100%;
    margin-bottom: 15px;
  }
  .sboxtab {
    display: flex;
    flex-direction: column;
  }
}
.dashboard_item .list-group .list-group-item {
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: transparent;
}

.dashboard_item .list-group .list-group-item span i {
  margin-right: 10px;
}

section.middle-content .client-collapse .card-body {
  border: none;
  padding: 0;
}

section.middle-content .client-collapse .card-body a {
  text-decoration: none;
  color: #000;
  padding: 6px 10px;
  text-wrap: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12px;
  border-bottom: 1px solid #e5e5e5;
}

section.middle-content .client-collapse .card-body a:hover,
.selectedMenu {
  background-color: #dbe6ef !important;
}

.nav-link-selected {
  background-color: rgba(16, 60, 94, 0.3411764706);
}

section.middle-content .collapse:not(.show) {
  display: none;
}

/* End Here */
.ace_editor {
  width: 100% !important;
  height: 100% !important;
}

span.ace_identifier,
.ace-monokai .ace_support.ace_constant,
.ace-monokai .ace_support.ace_function,
.ace_string {
  font-size: inherit;
}

.ace-monokai .ace_print-margin {
  visibility: hidden !important;
}

/* user form css */
.dashboard-body .form-section .form-button {
  text-align: end;
}

.dashboard-body .form-section .img-thumbnail {
  padding: 0.25rem;
  background-color: var(--white);
  border: 1px solid #0dcaf0;
  border-radius: 0.25rem;
  max-width: 100%;
  height: 100px;
}

.fa-eye {
  font-size: 10px;
}

/* user form css end */
.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: var(--white);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  height: 100%;
  min-height: 164px;
}

.updateProfiles_css {
  background: #103c5e;
  border: 1px solid transparent;
  color: var(--white);
  border-radius: 10px;
  font-weight: bold;
}
.updateProfiles_css:hover {
  background: transparent;
  border: 1px solid #103c5e !important;
  color: #103c5e;
}

.nav-tabs .nav-link.active {
  color: var(--white);
  background-color: var(--blue);
}

.nav-tabs .nav-link {
  background-color: #dedede;
}

.login-form .form-check-label {
  font-size: 20px;
}

.demomain {
  overflow-x: hidden;
}

.Resizer.horizontal {
  border-top: 1px solid var(--bs-border-color);
  border-bottom: 1px solid var(--bs-border-color);
  height: 4px;
  cursor: s-resize;
  transition: 0.2s;
}

.Resizer.vertical {
  border-left: 1px solid var(--bs-border-color);
  border-right: 1px solid var(--bs-border-color);
  width: 4px;
  cursor: e-resize;
  transition: 0.2s;
}

.Resizer.horizontal:hover,
.Resizer.vertical:hover {
  background: var(--bs-border-color);
}

.Pane.horizontal.Pane2 {
  overflow: auto;
}

.fixed_tab_button {
  position: sticky;
  top: 0;
  z-index: 99;
}

.Pane {
  overflow: auto;
}

.editor .Pane.Pane2 {
  overflow: hidden !important;
}

.Pane.vertical {
  padding: 0 0px;
}

.Pane.horizontal {
  display: block !important;
}

.resizable-x,
.resizable-y {
  display: flex;
}

.resizable-x {
  height: 100%;
  padding: 5px;
}

.resizable-y {
  flex-direction: column;
  width: -webkit-fill-available;
  width: -moz-available;
  border: 1px solid #eef2f7;
  border-radius: 3px;
  overflow-y: hidden;
  background: #eef2f7;
}

.resizer-x,
.resizer-y {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
  padding: 0px;
}

.resizer-x {
  z-index: 2;
  cursor: col-resize;
  width: 5px;
}

.resizer-x::before,
.resizer-x::after {
  content: "";
  width: 1px;
  height: 16px;
  margin: 1px;
  background: rgb(115, 115, 115);
}

.resizer-xHidden {
  z-index: 2;
  opacity: 0 !important;
  cursor: none !important;
  width: 5px;
}

.resizer-y {
  z-index: 1;
  cursor: col-resize;
  flex-direction: column;
}

.resizer-y::before,
.resizer-y::after {
  content: "";
  width: 16px;
  height: 2px;
  margin: 2px;
  background: var(--white);
}

.div0 {
  width: 300px;
}

.eventleft {
  width: 27%;
  height: 100vh;
  margin-top: 3px;
}

.eventfilter {
  background-color: transparent;
}

.eventright {
  height: 100vh;
  margin-top: 3px;
}

.question {
  height: 1.5rem;
}

#client-section,
#new-request-section,
#sent-request-section,
#new-user-section,
#demographic-section,
#demographic-2-section,
#study-schedule-section,
#study-randomization-section,
#study-site-section,
#visit-crf-martix-section,
#data-transfer-job-section {
  display: none;
}

/* end here */
/* login-form-css */
.login-form .form-check-label {
  font-size: 20px;
}

.newuserleft,
.newuserright {
  width: 50%;
}

/* NEW REQUEST......................................... */
.useremailmain {
  width: 100%;
}

.useremail {
  width: 7%;
}

.newreqemailid {
  width: 93%;
  height: 31px;
  border: 1px solid var(--blue);
}

.useremail,
.subject {
  opacity: 0.7;
  font-size: 0.8rem;
}

.subjectrequestmain {
  width: 100%;
}

.subject {
  width: 4.5%;
}

.subjectinput {
  width: 95.5%;
  height: 31px;
  border: 1px solid var(--blue);
}

.schedulemain {
  width: 99.9%;
}

.requesttypelabel {
  width: 34%;
}

.selectrequesttype {
  border: 1px solid var(--blue);
  width: 66%;
  height: 2.3rem;
}

.expected {
  width: 9rem;
}

.attach {
  width: 307px;
  height: 55px;
}

.attachleft {
  width: 90%;
  height: 100%;
  background-color: hsl(203, 69%, 88%);
}

.attachhr {
  margin-top: 3px;
  margin-bottom: 3px;
  margin-left: -8px;
  margin-right: -8px;
}

.newrequestbg {
  background-color: hsl(205, 40%, 94%);
  margin: 0px;
  padding-top: 15px;
  height: 100vh;
}

.projectidlabel {
  width: 25%;
}

.projectidinput {
  border: 1px solid var(--blue);
  width: 75%;
  height: 2.3rem;
}

.studyidlabel {
  width: 25%;
}

.studyidinput {
  width: 75%;
  border: 1px solid var(--blue);
  height: 2.3rem;
}

.clientlabel {
  width: 11.4%;
}

.clientname {
  height: 2.3rem;
  border-radius: 5px;
  border: 1px solid var(--blue);
  width: 89.3%;
  padding-left: 15px;
}

.clientnamediv {
  width: 100%;
}

.protocolversionlabel {
  width: 23%;
}

.protocol,
.enrollment {
  width: 50%;
}

.protocolversioninput {
  height: 2.3rem;
  border-radius: 5px;
  border: 1px solid var(--blue);
  width: 44%;
}

.expectedenrollmentlabel {
  width: 40%;
  padding-left: 10px;
  padding-top: 4px;
}

.expectedenrollmentinput {
  height: 2.3rem;
  border-radius: 5px;
  border: 1px solid var(--blue);
  width: 60%;
}

.clientnametextarea {
  width: 100%;
  border-radius: 7px;
  border: 1px solid var(--blue);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.clientnametextareas {
  width: 90%;
  border-radius: 7px;
  border: 1px solid var(--blue);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.herapeutic {
  height: 2.3rem;
  width: 60%;
  border: 1px solid var(--blue);
}

.studyphase {
  width: 40%;
}

.studytype {
  width: 13%;
}

.studytypes {
  width: 11.3%;
}

.herapeutics {
  width: 22%;
  height: 2.3rem;
  border: 1px solid var(--blue);
}

/* DATA TRANSFER JOB CREATION ........................*/
.creationmain {
  overflow-x: hidden;
}

.dataextract-dashboard-body {
  overflow: hidden;
}

.table-responsive-creation {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.datacreationleft {
  width: 66%;
}

.datacreationleft {
  margin: 0px;
}

.datacreationright {
  height: 100vh;
  width: 33.7%;
}

.datacreationright {
  border-left: 1px solid #dee2e6 !important;
  margin-left: 5px;
}

.datacreationleft,
.datacreationright {
  height: 100vh;
}

.creationinnerflex {
  width: 50%;
  margin-top: 10px;
}

.creationinnerflex1 {
  margin-top: 10px;
}

.creationlabel {
  width: 40%;
  padding-left: 10px;
}

.creationinput {
  border: 1px solid var(--blue);
  width: 60%;
  height: 2.3rem;
}

.dattransferid {
  width: 50%;
}

.projectidinputs {
  border: 1px solid var(--blue);
  width: 60%;
  height: 2.3rem;
}

.projectidlabels {
  width: 20%;
  padding-left: 56px;
}

.emailsingle {
  padding-left: 41px;
}

.projectidlabel1 {
  width: 25%;
}

.projectidinputs1 {
  border: 1px solid var(--blue);
  width: 80%;
  height: 2.3rem;
}

@media screen and (max-device-width: 1187px) {
  .creationinput,
  .creationlabel {
    width: 50%;
  }
  .projectidlabels {
    width: 25%;
  }
  .projectidinputs1 {
    width: 75%;
  }
}
@media screen and (max-device-width: 1053px) {
  .projectidlabel1 {
    width: 50%;
    padding-left: 4px;
  }
  .projectidinputs {
    width: 50%;
  }
  .projectidinputs1 {
    width: 75%;
  }
  .projectidlabels {
    width: 25%;
  }
}
@media screen and (max-device-width: 997px) {
  .creationtable {
    width: 130%;
  }
}
@media screen and (max-device-width: 972px) {
  .creationmain {
    display: flex;
    flex-direction: column;
  }
  .creationtable {
    width: 100%;
  }
  .datacreationright {
    border-left: none;
    margin-left: 0px;
  }
  .datacreationleft {
    height: 30vh;
    overflow: auto;
  }
  .table-responsive-creation {
    height: 37vh;
    overflow: auto;
    margin-top: 10px;
  }
  .datacreationleft,
  .datacreationright {
    width: 100%;
  }
  .creationlabel {
    width: 45%;
  }
  .creationlabel {
    width: 55%;
  }
  .projectidlabels {
    width: 26.4%;
  }
  .projectidinputs1 {
    width: 73.6%;
  }
}
@media screen and (max-device-width: 643px) {
  .creationflexmain {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .creationinnerflex {
    width: 100%;
  }
  .creationlabel,
  .projectidlabels {
    width: 35%;
    padding: 0px;
  }
  .creationinput,
  .projectidinputs1 {
    width: 65%;
  }
}
@media screen and (max-device-width: 467px) {
  .creationinnerflex,
  .creationinnerflex1 {
    display: flex;
    flex-direction: column;
  }
  .creationlabel,
  .projectidlabels,
  .creationinput,
  .projectidinputs1 {
    width: 100%;
  }
}
@media screen and (max-device-width: 336px) {
  .creationtable {
    width: 130%;
  }
}
/* ................................................... */
@media screen and (max-device-width: 1800px) {
  .useremail {
    width: 8%;
  }
  .newreqemailid {
    width: 92%;
  }
  .subject {
    width: 5.3%;
  }
  .subjectinput {
    width: 94.7%;
  }
}
@media screen and (max-device-width: 1690px) {
  .useremail {
    width: 9%;
  }
  .newreqemailid {
    width: 91%;
  }
  .subject {
    width: 6.3%;
  }
  .subjectinput {
    width: 93.7%;
  }
}
@media screen and (max-device-width: 1570px) {
  .subject {
    width: 6.1%;
  }
  .subjectinput {
    width: 93.9%;
  }
}
@media screen and (max-device-width: 1500px) {
  .useremail {
    width: 9.2%;
  }
  .newreqemailid {
    width: 90.8%;
  }
  .subject {
    width: 6.1%;
  }
  .subjectinput {
    width: 93.9%;
  }
}
@media screen and (max-device-width: 1500px) {
  .useremail {
    width: 10.3%;
  }
  .newreqemailid {
    width: 89.7%;
  }
  .subject {
    width: 7.1%;
  }
  .subjectinput {
    width: 92.9%;
  }
}
@media screen and (max-device-width: 1350px) {
  .useremail {
    width: 11.3%;
  }
  .newreqemailid {
    width: 88.7%;
  }
  .subject {
    width: 8.1%;
  }
  .subjectinput {
    width: 91.9%;
  }
}
@media screen and (max-device-width: 1143px) {
  .subject {
    width: 9.9%;
  }
  .subjectinput {
    width: 90.1%;
  }
  .useremail {
    width: 14%;
  }
  .newreqemailid {
    width: 86%;
  }
}
@media screen and (max-device-width: 1009px) {
  .subject {
    width: 10.9%;
  }
  .useremail {
    width: 15.1%;
  }
}
/* ......................................... */
/* DATA LOCK REQUEST........................... */
@media screen and (max-device-width: 1176px) {
  .projectidlabel {
    width: 35%;
  }
  .projectidinput {
    width: 65%;
  }
}
/* ............................................ */
/* SENT REQUEST........................................ */
@media screen and (min-device-width: 559px) and (max-width: 740px) {
  .sentrequesttable {
    width: 140%;
  }
}
@media screen and (max-device-width: 559px) {
  .sentrequesttable {
    width: 180%;
  }
}
@media screen and (max-device-width: 413px) {
  .sentrequesttable {
    width: 200%;
  }
  .sentdatafont {
    font-size: 12px;
  }
  .sentrequestfont {
    font-size: 12px;
  }
}
@media screen and (max-device-width: 413px) {
  .sentrequesttable {
    width: 220%;
  }
}
/* ............................................... */
@media screen and (max-width: 1284px) {
  .useremailid {
    width: 11%;
  }
  .topuseremail {
    width: 89%;
  }
}
@media screen and (max-width: 1236px) {
  .useremailid {
    width: 11%;
  }
  .topuseremail {
    width: 89%;
  }
}
@media screen and (max-width: 1236px) {
  .useremailid {
    width: 12%;
  }
  .topuseremail {
    width: 88%;
  }
}
@media screen and (max-width: 1100px) {
  .useremailid {
    width: 12%;
  }
  .topuseremail {
    width: 88%;
  }
}
@media screen and (max-width: 1084px) {
  .useremailid {
    width: 13%;
  }
  .topuseremail {
    width: 87%;
  }
}
@media screen and (max-width: 1007px) {
  .useremailid {
    width: 14%;
  }
  .topuseremail {
    width: 86%;
  }
}
@media screen and (max-width: 941px) {
  .useremailid {
    width: 16%;
  }
  .topuseremail {
    width: 84%;
  }
}
@media screen and (max-width: 883px) {
  .useremailid {
    width: 19%;
  }
  .topuseremail {
    width: 81%;
  }
}
@media screen and (max-width: 715px) {
  .useremailid {
    width: 22%;
  }
  .topuseremail {
    width: 78%;
  }
}
@media screen and (max-width: 715px) {
  .useremailid {
    width: 21%;
  }
  .topuseremail {
    width: 79%;
  }
}
@media screen and (max-width: 715px) {
  .useremailid {
    width: 22%;
  }
  .topuseremail {
    width: 78%;
  }
}
@media screen and (max-width: 628px) {
  .useremailid {
    width: 23%;
  }
  .topuseremail {
    width: 77%;
  }
}
@media screen and (max-width: 605px) {
  .useremailid {
    width: 26%;
  }
  .topuseremail {
    width: 74%;
  }
}
@media screen and (max-width: 540px) {
  .usertopbox {
    display: flex;
    flex-direction: column;
  }
  .useremailid {
    width: 100%;
    margin-bottom: 10px;
    padding: 0px;
  }
  .topuseremail {
    width: 100%;
  }
}
@media screen and (max-width: 650px) {
  .firstname,
  .middlename,
  .lastname,
  .address,
  .postalcode,
  .state,
  .userid,
  .city,
  .country,
  .mobilenumber,
  .officephone,
  .emailid,
  .designation {
    display: flex;
  }
  .inputborder {
    width: 100%;
  }
  .newusermaindiv {
    display: flex;
    flex-direction: column;
  }
  .avatarborder {
    height: 6rem;
  }
  .inputfonts,
  .avatarleft {
    width: 25%;
  }
  .inputborder,
  .countryoption {
    width: 75%;
  }
  .newuserleft,
  .newuserright {
    width: 100%;
  }
  .form-button {
    display: flex;
  }
  .bottombuttons {
    margin-top: 2rem;
  }
  .avatarleft {
    width: 25%;
  }
  .avatarright {
    width: 75%;
  }
  .uploadlabel {
    width: 80%;
  }
  .chooselogo {
    width: 20%;
  }
}
@media screen and (min-device-width: 1000px) and (max-width: 1110px) {
  .inputfonts,
  .avatarleft,
  .uploadlogo {
    width: 30%;
  }
  .inputborder {
    width: 70%;
  }
  .countryoption {
    width: 70%;
  }
  .chooselogo {
    width: 70%;
  }
  .bottombuttons {
    margin-top: 4rem;
  }
}
/* NEW CLIENT..................................... */
.form-section {
  overflow-y: auto;
  overflow-x: hidden;
}

.uploadlogofile {
  width: 25%;
}

.fill {
  border: 1px solid var(--blue);
  line-height: 1.5;
  width: 75%;
}

.fill::file-selector-button {
  background-color: var(--blue);
  color: var(--white);
  border: none;
  border-radius: 0.2em;
}

/* ................................................ */
@media screen and (max-width: 540px) {
  .firstname,
  .middlename,
  .lastname,
  .address,
  .postalcode,
  .state,
  .userid,
  .city,
  .country,
  .mobilenumber,
  .officephone,
  .emailid,
  .designation {
    display: flex;
    flex-direction: column;
  }
  .inputborder,
  .countryoption {
    width: 100%;
  }
  .avatarleft {
    width: 0%;
  }
  .inputfonts {
    width: 100%;
  }
  .uploadsection {
    display: flex;
    flex-direction: column;
  }
  .chooselogo,
  .uploadlogo {
    width: 100%;
  }
  .fill {
    width: 100%;
  }
}
/* CDASH................................................ */
.cdashmenuclose {
  background: transparent;
  border: none;
  padding: 0px;
}

.navigation_bar {
  font-size: 12px;
  padding: 5px 7px;
  margin: 0;
  color: var(--white);
  border-bottom: 1px solid #668298;
  background: #668298;
}

.cdashleft {
  width: 65%;
  height: 100vh;
  border-right: 1px solid #dee2e6 !important;
}

.Derived__veriable {
  width: 30%;
  height: 100vh;
  border-right: 1px solid #dee2e6 !important;
}

.cdashright {
  width: 34.7%;
  margin-left: 5px;
  height: 100vh;
  border-left: 1px solid #dee2e6 !important;
  position: relative;
}

.radiobar__chart__graph h2 {
  padding-left: 20px;
  font-size: 17px;
  font-weight: 800;
  text-align: center;
}
.radiobar__chart__graph p {
  margin: 0;
  font-size: 13px;
}

.Derived__veriable__right {
  width: 69.7%;
  margin-left: 5px;
  height: 100vh;
  border-left: 1px solid #dee2e6 !important;
  position: relative;
}

.table-responsive-cdashleft {
  max-height: calc(100vh - 165px);
  overflow-y: auto;
  position: relative;
}

.cdashrightbottom {
  margin-top: 8px;
}

.table-responsive-cdashrightbottom {
  position: relative;
}

@media screen and (max-width: 1226px) {
  .cdashrighttoptable {
    width: 130%;
  }
}
@media screen and (max-width: 1060px) {
  .cdashlefttable {
    width: 140%;
  }
}
@media screen and (max-width: 949px) {
  .cdashrighttoptable {
    width: 170%;
  }
}
@media screen and (max-width: 893px) {
  .cdashrightbottomtable {
    width: 120%;
  }
}
@media screen and (max-width: 800px) {
  .cdashmain {
    flex-wrap: wrap;
  }
  .cdashleft,
  .cdashright {
    width: 100%;
  }
  .cdashleft,
  .table-responsive-cdashleft,
  .table-responsive-cdashrightbottom,
  .table-responsive-cdashrighttop {
    max-height: 23vh;
    overflow: auto;
  }
  .cdashright {
    height: 50vh;
  }
  .cdashrightbottom {
    margin-top: 8px;
  }
  .cdashright {
    margin-top: 5px;
    margin-left: 0px;
    border: none;
  }
}
@media screen and (max-width: 738px) {
  .cdashmain {
    margin-top: 10px;
  }
  .cdashleft {
    height: auto;
  }
  .table-responsive-cdashleft,
  .table-responsive-cdashrighttop,
  .table-responsive-cdashrightbottom {
    max-height: 20vh;
    overflow: auto;
  }
}
@media screen and (max-width: 507px) {
  .cdashlefttable {
    width: 180%;
  }
}
@media screen and (max-width: 417px) {
  .cdashmain {
    margin-top: 8px;
  }
  .table-responsive-cdashleft,
  .table-responsive-cdashrighttop,
  .table-responsive-cdashrighttop {
    max-height: 18vh;
    overflow: auto;
  }
}
@media screen and (max-width: 399px) {
  .cdashlefttable {
    width: 260%;
  }
}
.wrapper {
  position: absolute;
  border: 1px solid #cecece;
  border-radius: 3px;
  width: 200px;
  background: var(--white);
  box-shadow: 3px 4px 7px #bababa;
  z-index: 1;
}

.middle-content {
  position: relative;
}

.contextmenuoptions li a {
  text-decoration: none;
}

.contextmenuoptions li {
  text-decoration: none;
  list-style-type: none;
}

@media screen and (max-width: 1587px) {
  .customrighttop {
    width: 130%;
  }
}
@media screen and (max-width: 1226px) {
  .customrighttop {
    width: 150%;
  }
}
@media screen and (max-width: 1066px) {
  .customrighttop {
    width: 180%;
  }
}
@media screen and (max-width: 991px) {
  .customhistory {
    width: 100%;
  }
}
@media screen and (max-width: 1226px) {
  .customrighttop {
    width: 210%;
  }
}
@media screen and (max-width: 982px) {
  .customhistory {
    width: 117%;
  }
}
@media screen and (max-width: 761px) {
  .data-transfer,
  .custommain {
    display: flex;
    flex-direction: column;
  }
  .customrighttop,
  .customleftinner {
    width: 100%;
  }
  .cdashsecondtable,
  .historytt {
    width: 301%;
  }
  .customlefttable,
  .customrighttable {
    width: 100%;
    height: 50%;
  }
}
@media screen and (max-width: 627px) {
  .custommain,
  .data-transfer {
    display: flex;
    flex-direction: column;
  }
  .customlefttable {
    height: 40%;
    width: 100%;
  }
  .customrighttable {
    width: 100%;
  }
}
@media screen and (max-width: 539px) {
  .customrighttop {
    width: 120%;
  }
}
@media screen and (max-width: 1221px) {
  .schedulehistory {
    width: 130%;
  }
}
@media screen and (max-width: 1221px) {
  .schedulelefttable {
    width: 120%;
  }
}
@media screen and (max-width: 499px) {
  .schedulelefttable {
    width: 155%;
  }
}
@media screen and (max-width: 761px) {
  .scheduleleft,
  .scheduleright {
    width: 100%;
  }
  .scheduleleft {
    height: 50%;
  }
}
@media screen and (max-width: 991px) {
  .edc-nav .navbar-toggler {
    background: var(--white);
    line-height: 1.4;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 7px;
    width: 35px;
    font-size: 14px;
  }
  button#navbarDropdown1 {
    margin-right: -166px;
    margin-top: 1px;
    margin-bottom: -40px;
  }
  .login {
    display: none;
  }
  .inputborder {
    width: 75%;
  }
  .countryoption {
    width: 75%;
  }
  .newuserleft,
  .newuserright {
    width: 100%;
  }
  .newusermaindiv {
    display: flex;
    flex-direction: column;
  }
  .bottombuttons {
    margin-top: 20px;
  }
  .inputfonts {
    width: 25%;
  }
  .filebars {
    justify-content: end;
    padding-left: 10px;
  }
  .filebar {
    margin-bottom: 8px;
  }
  .w-sm-100 {
    width: 100% !important;
  }
  /* navbar responsive css end*/
  /* body content responsive css*/
  section.middle-content {
    height: 100%;
  }
  section.middle-content .sidebar-body {
    overflow-y: scroll;
  }
  .dashboard-body {
    width: 100%;
  }
  .navbox {
    visibility: hidden;
  }
  /* body content responsive css end*/
}
@media screen and (max-width: 540px) {
  .inputborder,
  .inputsize,
  .countryoption,
  .inputfonts {
    width: 100%;
  }
}
@media screen and (max-width: 575px) {
  .profiler {
    display: none;
  }
  button#navbarDropdown1 {
    margin-top: -15px;
  }
}
/* Lab Parameters ....................................... */
.dbdlabparameter {
  overflow: hidden;
}

.table-responsiveheight-lab {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

@media screen and (max-width: 1214px) {
  .labparameterlefttable {
    width: 130%;
    height: 150%;
  }
  .labparameterrighttable {
    width: 130%;
  }
  .labparameters {
    width: 99.7%;
  }
}
@media screen and (max-width: 950px) {
  .table-responsiveheight-lab {
    height: 35vh;
    overflow: auto;
  }
  .labparameters {
    display: flex;
    flex-direction: column;
  }
  .labtableleft {
    height: 33vh;
    width: 100%;
    border: none;
    overflow: hidden;
  }
  .labtableright {
    width: 100%;
    margin: 0px;
  }
}
@media screen and (max-width: 636px) {
  .labtableleft {
    margin-top: 8px;
  }
}
@media screen and (max-width: 609px) {
  .table-responsiveheight-lab {
    height: 28vh;
    overflow: auto;
  }
}
@media screen and (max-width: 517px) {
  .labparameterlefttable {
    width: 160%;
  }
}
@media screen and (max-width: 424px) {
  .labparameterlefttable {
    width: 200%;
  }
}
@media screen and (max-width: 336px) {
  .labparameterlefttable {
    width: 250%;
  }
}
/* ...................................................... */
/* Study Site .......................................... */
.squaredots {
  height: 18px;
}

@media screen and (max-width: 1320px) {
  .studysitetable {
    width: 130%;
  }
}
@media screen and (max-width: 1016px) {
  .studysitetable {
    width: 170%;
  }
}
/* ..................................................... */
/* STUDY RANDOMISATION.................................. */
@media screen and (max-width: 1430px) {
  .studyrandomrighttoptable {
    width: 120%;
  }
}
@media screen and (max-width: 1202px) {
  .studyrandomrighttoptable {
    width: 150%;
  }
}
@media screen and (max-width: 1083px) {
  .studyrandomlefttable {
    width: 130%;
  }
}
@media screen and (max-width: 969px) {
  .studyrandomrighttoptable {
    width: 180%;
  }
}
@media screen and (max-width: 838px) {
  .studyrandomlefttable {
    width: 150%;
  }
}
@media screen and (max-width: 816px) {
  .studyrandomrighttoptable {
    width: 210%;
  }
}
@media screen and (max-width: 800px) {
  .studyrandomrighttoptable {
    width: 100%;
  }
}
@media screen and (max-width: 499px) {
  .studyrandomrighttoptable {
    width: 130%;
  }
}
@media screen and (max-width: 484px) {
  .studyrandomlefttable {
    width: 180%;
  }
}
@media screen and (max-width: 407px) {
  .studyrandomlefttable {
    width: 210%;
  }
}
@media screen and (max-width: 389px) {
  .studyrandomrighttoptable {
    width: 170%;
  }
}
@media screen and (max-width: 407px) {
  .studyrandomlefttable {
    width: 270%;
  }
}
@media screen and (max-width: 554px) {
  .rntable {
    width: 140%;
  }
}
/* ..................................................... */
/* VISIT CRF............................................ */
.visitmain {
  margin-top: 2px;
}

.visitleft {
  width: 50%;
  height: 100vh;
  border-right: 1px solid #dee2e6 !important;
}

.visitright {
  border-left: 1px solid #dee2e6 !important;
  width: 49.6%;
  height: 100vh;
  margin-left: 5px;
}

.table-responsive-visit {
  max-height: calc(100vh - 144px);
  overflow: auto;
  position: relative;
}

@media screen and (max-width: 1379px) {
  .visitlefttable {
    width: 140%;
  }
}
@media screen and (max-width: 995px) {
  .visitmain {
    display: flex;
    flex-direction: column;
  }
  .table-responsive-visit {
    max-height: 35vh;
    overflow: auto;
  }
  .visitleft,
  .visitright {
    max-height: 41vh;
    border: none;
    margin-left: 0px;
  }
  .visitleft,
  .visitright {
    width: 100%;
  }
}
@media screen and (max-width: 608px) {
  .visitleft {
    margin-top: 3px;
  }
}
@media screen and (max-width: 502px) {
  .visitlefttable {
    width: 160%;
  }
}
@media screen and (max-width: 435px) {
  .visitlefttable {
    width: 180%;
  }
  .visitrighttable {
    width: 140%;
  }
}
/* ..................................................... */
/* ADVERSE EVENT CODING................................. */
.custom_nav {
  position: relative;
  gap: 5px;
  padding-top: 2px;
}

.menuclose {
  position: absolute;
  right: 0px;
  top: 10px;
}

.eventmain {
  height: 100vh;
  margin-top: 2px;
}

.adverseeventverb {
  width: 27%;
}

.adverseeventcoding-dashboard-body {
  overflow: hidden;
}

.table-responsive-eventcodingleft {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.table-responsive-eventcodingrighttop {
  max-height: 35vh;
  overflow: auto;
  position: relative;
}

.table-responsive-eventcodingrightbottom {
  max-height: 29vh;
  overflow: auto;
  position: relative;
}

.adverseeventrightbottom {
  margin-top: 10px;
}

.adverseeventright {
  width: 72.8%;
}

.adverseeventlefttable {
  width: 110%;
}

@media screen and (max-width: 1636px) {
  .adverseeventlefttable {
    width: 130%;
  }
}
@media screen and (max-width: 1100px) {
  .adverseeventlefttable {
    width: 165%;
  }
}
@media screen and (max-width: 1027px) {
  .adverseeventlefttable {
    width: 200%;
  }
}
@media screen and (max-width: 991px) {
  .adverseeventhistorytable {
    width: 130%;
  }
}
@media screen and (max-width: 981px) {
  .adverseeventlefttable {
    width: 125%;
  }
}
@media screen and (max-width: 981px) {
  .adverseeventright,
  .adverseeventverb {
    width: 100%;
  }
  .table-responsive-eventcodingleft {
    height: 20vh;
    overflow: auto;
    margin-bottom: 8px;
  }
  .table-responsive-eventcodingrighttop {
    height: 23vh;
    margin-bottom: 14px;
  }
  .eventcodingtabbutton {
    padding: 5px;
  }
  .table-responsive-eventcodingrightbottom {
    height: 15vh;
    overflow: auto;
  }
  .adverseeventlefttable {
    width: 100%;
  }
  .eventmain {
    display: flex;
    flex-direction: column;
  }
  .eventleft {
    height: 50vh;
    width: 100%;
  }
  .adverseeventhistorytable {
    width: 100%;
  }
  .eventright {
    height: 60vh;
  }
  .eventtableleft {
    width: 100%;
  }
  .eventtableright {
    width: 130%;
  }
}
@media screen and (max-width: 808px) {
  .eventright {
    height: 80vh;
  }
}
@media screen and (max-width: 729px) {
  .adverseeventhistorytable {
    width: 130%;
  }
}
@media screen and (max-width: 659px) {
  .table-responsive-eventcodingleft {
    height: 15vh;
    overflow: auto;
    margin-bottom: 8px;
  }
}
@media screen and (max-width: 583px) {
  .adverseeventtermtable {
    width: 130%;
  }
}
@media screen and (max-width: 566px) {
  .adverseeventhistorytable {
    width: 160%;
  }
}
@media screen and (max-width: 454px) {
  .adverseeventhistorytable {
    width: 200%;
  }
}
@media screen and (max-width: 424px) {
  .adverseeventtermtable {
    width: 150%;
  }
}
@media screen and (max-width: 369px) {
  .adverseeventtermtable {
    width: 200%;
  }
  .adverseeventhistorytable {
    width: 300%;
  }
}
@media screen and (max-width: 355px) {
  .adverseeventtermtable {
    width: 200%;
  }
  .adverseeventhistorytable {
    width: 300%;
  }
  .adverseeventlefttable {
    width: 150%;
  }
}
/* ..................................................... */
/* BACKUP............................................... */
@media screen and (max-width: 1290px) {
  .backuprighttable {
    width: 140%;
  }
}
@media screen and (max-width: 950px) {
  .backuprighttable {
    width: 160%;
  }
}
@media screen and (max-width: 828px) {
  .backuprighttable {
    width: 170%;
  }
}
@media screen and (max-width: 774px) {
  .backupmain {
    display: flex;
    flex-direction: column;
  }
  .backupleft {
    width: 100%;
    height: 50vh;
  }
  .backuprightbottom {
    width: 100%;
    height: 50vh;
  }
  .backuprighttable {
    width: 100%;
    margin-left: 0px;
  }
}
@media screen and (max-width: 774px) {
  .backuprighttable {
    width: 130%;
  }
}
@media screen and (max-width: 479px) {
  .backuprighttable {
    width: 150%;
  }
}
/* ..................................................... */
/* USERS................................................ */
.table-responsive-userleftleft {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.table-responsive-userrightbottom {
  max-height: 29vh;
  overflow: auto;
  margin-top: 16px;
  position: relative;
}

.usersmain {
  display: flex;
}

.userright {
  border-left: 1px solid #dee2e6 !important;
  margin-left: 5px;
}

@media screen and (max-width: 1056px) {
  .userrightbottomtable {
    width: 130%;
  }
}
@media screen and (max-width: 981px) {
  .userlefttable {
    width: 150%;
  }
  .userrighttoptable {
    width: 130%;
  }
}
@media screen and (max-width: 853px) {
  .userlefttable {
    width: 170%;
  }
}
@media screen and (max-width: 810px) {
  .userrightbottomtable {
    width: 150%;
  }
}
@media screen and (max-width: 756px) {
  .usersmain {
    display: flex;
    flex-direction: column;
  }
  .userright {
    border-left: none;
    margin-left: 0px;
  }
  .table-responsive-userleftleft,
  .table-responsive-userrighttop {
    max-height: 25vh;
  }
  .table-responsive-userrightbottom {
    max-height: 20vh;
  }
  .table-responsive-userrightbottom {
    margin-top: 14px;
    height: 16vh;
  }
  .leftdiv {
    width: 100%;
    height: 25vh;
  }
  .userright {
    width: 100%;
  }
}
@media screen and (max-width: 560px) {
  .userrightbottomtable {
    width: 130%;
  }
}
@media screen and (max-width: 509px) {
  .userrighttoptable {
    width: 130%;
  }
}
@media screen and (max-width: 432px) {
  .userrightbottomtable {
    width: 230%;
  }
}
@media screen and (max-width: 396px) {
  .userrighttoptable {
    width: 160%;
  }
}
@media screen and (max-width: 365px) {
  .userlefttable {
    width: 180%;
  }
  .leftdiv {
    width: 100%;
    height: 22vh;
  }
  .table-responsive-userleftleft,
  .table-responsive-userrighttop {
    max-height: 22vh;
  }
}
@media screen and (max-width: 346px) {
  .userlefttable {
    width: 220%;
  }
}
@media screen and (max-width: 326px) {
  .userrighttoptable {
    width: 200%;
  }
}
/* ..................................................... */
/* TABLE RESIZE COLUMN................................... */
.resizer {
  position: absolute;
  top: 0;
  right: 0;
  width: 5px;
  cursor: col-resize;
  -webkit-user-select: none;
          user-select: none;
  cursor: e-resize;
}

.table > thead.thead-sticky {
  position: sticky !important;
  top: -1px;
  z-index: 99;
}

.table {
  --bs-table-bg: transparent !important;
  margin: 0;
}

#resizeMe thead,
#resizeMe1 thead,
#resizeMe2 thead,
#resizeMe3 thead,
#resizeMe4 thead,
#resizeMe5 thead,
#resizeMe6 thead {
  background-color: hsl(48, 21%, 86%);
}

#resizeMe tr,
#resizeMe1 tr,
#resizeMe2 tr,
#resizeMe3 tr,
#resizeMe4 tr,
#resizeMe5 tr,
#resizeMe6 tr {
  line-height: 13px;
}

#resizeMe th,
#resizeMe1 th,
#resizeMe2 th,
#resizeMe3 th,
#resizeMe4 th,
#resizeMe5 th,
#resizeMe6 th,
#resizeMe td,
#resizeMe1 td,
#resizeMe2 td,
#resizeMe3 td,
#resizeMe4 td,
#resizeMe5 td,
#resizeMe6 td {
  font-size: small;
  border-right: 1px solid var(--white);
  font-weight: initial;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: static;
}

.print_font td {
  font-size: small;
}

.react-contextmenu-wrapper {
  font-weight: initial;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ..................................................... */
/* COLUMN DELETE................................................ */
/* ..................................................... */
/* Client................................................ */
.clienttable-dashboard-body {
  overflow: hidden;
}

.clientleftdiv {
  width: 48%;
  height: 100vh;
}

.table-responsive-clienttablerighttop {
  max-height: 30vh;
  margin-bottom: 10px;
  overflow: auto;
  position: relative;
}

.table-responsive-clienttablebottom {
  max-height: 35vh;
  overflow: auto;
  position: relative;
}

.clientrighttop {
  margin-bottom: -10px;
}

.clientright {
  width: 52%;
  height: 100vh;
}

.table-responsive-clienttableleft {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.clientmain {
  margin-top: 2px;
}

@media screen and (max-width: 1285px) {
  .clientlefttable {
    width: 130%;
  }
}
@media screen and (max-width: 964px) {
  .clientrighttoptable {
    width: 130%;
    overflow: scroll;
  }
}
@media screen and (max-width: 916px) {
  .clientlefttable {
    width: 150%;
  }
}
@media screen and (max-width: 832px) {
  .clientrightbottomtable {
    width: 130%;
  }
}
.clientright {
  margin-left: 6px;
}

@media screen and (max-width: 787px) {
  .clientmain {
    display: flex;
    flex-direction: column;
  }
  .table-responsive-clienttable {
    max-height: 25vh;
    overflow: auto;
  }
  .table-responsive-clienttablebottom {
    height: 17vh;
    overflow: auto;
  }
  .clientleftdiv {
    height: 26vh;
  }
  .clientrighttop {
    margin-bottom: 7px;
  }
  .clientleftdiv,
  .clientright {
    width: 100%;
  }
  .clientleftdiv {
    height: 28vh;
  }
  .clientrighttoptable {
    width: 100%;
  }
  .clientright {
    margin-left: 0px;
  }
  .clientlefttable {
    width: 100%;
  }
}
@media screen and (max-width: 617px) {
  .clientmain {
    margin-top: 7px;
  }
  .table-responsive-clienttable {
    height: 20vh;
    overflow: auto;
  }
  .clientleftdiv {
    height: 21vh;
  }
}
@media screen and (max-width: 608px) {
  .clientmain {
    margin-top: 8px;
  }
  .table-responsive-clienttablebottom {
    margin-top: 15px;
    height: 19vh;
  }
  .clienttablepagination {
    margin-top: 2px;
  }
  .userspan {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
@media screen and (max-width: 572px) {
  .clientlefttable {
    width: 130%;
  }
}
@media screen and (max-width: 560px) {
  .userrightbottomtable {
    width: 130%;
  }
}
@media screen and (max-width: 509px) {
  .clientrighttoptable {
    width: 130%;
  }
}
@media screen and (max-width: 509px) {
  .clientlefttable {
    width: 150%;
  }
}
@media screen and (max-width: 396px) {
  .clientrighttoptable {
    width: 160%;
  }
}
@media screen and (max-width: 379px) {
  .clientlefttable {
    width: 200%;
  }
}
@media screen and (max-width: 358px) {
  .clientrightbottomtable {
    width: 170%;
  }
}
@media screen and (max-width: 326px) {
  .clientrighttoptable {
    width: 200%;
  }
}
@media screen and (max-width: 323px) {
  .clientmain {
    margin-top: 5px;
  }
}
/* ..................................................... */
/* ASSIGN STUDY......................................... */
.table-responsive-assignstudy {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.assignstudytable {
  margin-top: 2px;
}

@media screen and (max-width: 706px) {
  .assignstudytable {
    width: 130%;
  }
  .assignstudy {
    margin-top: 5px;
  }
}
@media screen and (max-width: 545px) {
  .assignstudytable {
    width: 150%;
  }
}
@media screen and (max-width: 474px) {
  .assignstudytable {
    width: 170%;
  }
}
@media screen and (max-width: 412px) {
  .assignstudytable {
    width: 200%;
  }
}
@media screen and (max-width: 353px) {
  .assignstudytable {
    width: 300%;
  }
}
/* ...................................................... */
/* ADVERSE EVENT......................................... */
/* ....................................................... */
/* ADVERSEEVENT1.......................................... */
@media screen and (max-width: 661px) {
  .eventtable1 {
    width: 130%;
  }
}
@media screen and (max-width: 511px) {
  .eventtable1 {
    width: 150%;
  }
}
@media screen and (max-width: 434px) {
  .eventtable1 {
    width: 180%;
  }
}
@media screen and (max-width: 434px) {
  .eventtable1 {
    width: 220%;
  }
}
/* ...................................................... */
/* CREATE ROLE.......................................... */
.createrolemain {
  margin-top: 3px;
}

@media screen and (max-width: 1287px) {
  .createrolerighttoptable {
    width: 130%;
  }
}
@media screen and (max-width: 1001px) {
  .createrolerighttoptable,
  .createrolerightbottomtable {
    width: 150%;
  }
}
@media screen and (max-width: 870px) {
  .createrolerighttoptable,
  .createrolerightbottomtable {
    width: 170%;
  }
}
@media screen and (max-width: 814px) {
  .createrolerighttoptable,
  .createrolerightbottomtable {
    width: 100%;
  }
  .createrolemain {
    display: flex;
    flex-direction: column;
  }
  .createroleleft,
  .createroleright {
    width: 100%;
  }
  .createroleleft,
  .createrolerightbottom,
  .createrolerighttop {
    width: 100%;
  }
}
@media screen and (max-width: 517px) {
  .createrolelefttable {
    width: 130%;
  }
}
@media screen and (max-width: 434px) {
  .createrolelefttable {
    width: 120%;
  }
}
@media screen and (max-width: 416px) {
  .createrolerighttoptable {
    width: 120%;
  }
}
@media screen and (max-width: 404px) {
  .createrolelefttable {
    width: 160%;
  }
}
@media screen and (max-width: 351px) {
  .createrolerighttoptable {
    width: 150%;
  }
}
@media screen and (max-width: 331px) {
  .createrolelefttable {
    width: 190%;
  }
}
@media screen and (max-width: 328px) {
  .createrolerightbottomtable {
    width: 120%;
  }
}
/* ..................................................... */
/* CREATEROLE2.......................................... */
@media screen and (max-width: 1152px) {
  .roletext {
    width: 20%;
  }
}
@media screen and (max-width: 1024px) {
  .rolename,
  .roledescription,
  .createroleselect {
    width: 37%;
  }
}
@media screen and (max-width: 720px) {
  .roleform {
    display: flex;
    flex-direction: column;
  }
  .rolename,
  .createroleselect {
    width: 55%;
  }
  .roledescription {
    width: 55%;
    height: 105px;
  }
  .roletext {
    width: 100%;
  }
  .createrolebuttons {
    margin-top: 1rem;
  }
}
/* ..................................................... */
@media screen and (max-device-width: 1143px) {
  .subject {
    width: 9.9%;
  }
  .clientnametextareas {
    width: 86%;
  }
  .subjectinput {
    width: 90.1%;
  }
  .useremail {
    width: 14%;
  }
  .newreqemailid {
    width: 86%;
  }
  .requesttypelabel {
    width: 40%;
  }
  .selectrequesttype {
    width: 60%;
  }
  .projectidlabel {
    width: 30%;
  }
  .projectidinput {
    width: 70%;
  }
  .studyidlabel {
    width: 25%;
  }
  .studyidinput {
    width: 75%;
  }
  .clientlabel {
    width: 14%;
  }
  .clientname {
    height: 2.3rem;
    border-radius: 5px;
    border: 1px solid hsl(195, 86%, 53%);
    width: 89.3%;
    padding-left: 15px;
  }
  .clientnamediv {
    width: 100%;
  }
  .protocolversionlabel {
    width: 26%;
  }
  .protocolversioninput {
    width: 44%;
  }
  .expectedenrollmentlabel {
    width: 49%;
  }
  .expectedenrollmentinput {
    height: 2.3rem;
    border-radius: 5px;
    border: 1px solid hsl(195, 86%, 53%);
    width: 60%;
  }
  .studytypes {
    width: 13.6%;
  }
  .herapeutics {
    width: 20%;
  }
}
/* DATABSE LOCK REQUEST.................... */
@media screen and (max-device-width: 1033px) {
  .lockclientname {
    width: 65%;
  }
  .lockclientnamee {
    width: 35%;
  }
}
@media screen and (max-device-width: 966px) {
  .lockproject {
    width: 35%;
  }
  .lockprojectid {
    width: 65%;
  }
  .lockusermail,
  .locksubject {
    display: flex;
    flex-direction: column;
  }
  .locksubject {
    padding-left: 0px;
  }
  .lockmailinput,
  .locksubjectinput,
  .locksubjects,
  .lockmaillabel {
    width: 100%;
  }
  .attach {
    width: 236px;
    height: 46px;
  }
  .cdadraft {
    font-size: 11px;
  }
  .lockreqtype {
    display: flex;
    flex-direction: column;
  }
  .lockrequesttypelabel,
  .lockclientnamee,
  .lockproject,
  .lockstudyidlabel,
  .lockrequestdetaillabel,
  .lockstatuslabel {
    width: 20%;
  }
  .lockselectrequesttype,
  .lockclientname,
  .lockprojectid,
  .lockstudyidselect,
  .locktextarea {
    width: 80%;
  }
  .lockprojectid {
    margin-top: 5px;
  }
  .lockreq {
    width: 100%;
  }
  .lockrequesttype {
    padding-left: 9px;
  }
  .lockstudyid {
    padding-left: 33px;
  }
  textarea.clientnametextareas.form-control.locktextarea,
  .lockstatusselect {
    width: 79%;
    margin-left: 7px;
  }
  .lockformsection {
    height: 80vh;
  }
}
@media screen and (max-device-width: 672px) {
  .lockrequesttype,
  .lockreq,
  .locktextareacontainer,
  .lockstatus {
    display: flex;
    flex-direction: column;
  }
  .lockselectrequesttype,
  .lockclientname,
  .lockprojectid,
  .lockstudyidselect,
  .locktextarea,
  .lockstatusselect,
  .lockstatuslabel {
    width: 100%;
  }
  textarea.clientnametextareas.form-control.locktextarea {
    width: 99%;
    margin-top: -20px;
  }
  .lockrequestdetaillabel {
    padding-left: 10px;
    width: 100%;
  }
  .lockrequesttypelabel,
  .lockclientnamee,
  .lockproject,
  .lockstudyidlabel,
  .lockrequestdetaillabel {
    width: 100%;
  }
  .lockformsection {
    height: 120vh;
  }
  .lockstatuslabel {
    padding-left: 10px;
  }
}
/* ......................................... */
/* DEMOGRAPHIC2............................. */
tr.demodemo {
  background: transparent;
}

.table-responsive-demographic2 {
  max-height: 36vh;
  overflow: auto;
  position: relative;
}

.demographiccancelbutton,
.demographicsubmitbutton {
  background-color: var(--blue);
  color: var(--white);
  border: 1px solid var(--blue) !important;
  padding: 1px 10px 2px;
  transition: 0.5s;
}
.demographiccancelbutton:hover,
.demographicsubmitbutton:hover {
  background: transparent !important;
  border: 1px solid var(--blue) !important;
  color: var(--blue);
}

@media screen and (max-device-width: 1627px) {
  .demo2genderflex {
    display: flex;
    flex-direction: column;
    height: 53vh;
  }
}
@media screen and (max-device-width: 1100px) {
  .demographiccancelbutton,
  .demographicsubmitbutton {
    background-color: var(--blue);
    color: var(--white);
    width: 65px;
    height: 29px;
    padding: 2px;
    font-size: 13px;
  }
}
@media screen and (max-device-width: 1014px) {
  .table-responsive-demographic2 {
    height: 26vh;
    overflow: auto;
  }
}
@media screen and (max-device-width: 981px) {
  .querytable {
    width: 200%;
  }
}
@media screen and (max-device-width: 1627px) {
  .demo2genderflex {
    height: 48vh;
  }
}
@media screen and (max-device-width: 813px) {
  .querytable {
    width: 250%;
  }
}
@media screen and (max-device-width: 680px) {
  .demo2genderflex {
    display: flex;
    flex-direction: row;
  }
  .demo2genderflex {
    height: 5vh;
  }
  .demographic2main {
    display: flex;
    flex-direction: column;
  }
  .demo2left {
    width: 100%;
    padding-left: 25px;
    padding-bottom: 10px;
  }
  .demographic2column {
    width: 100%;
    margin-left: 0px;
    border: none;
  }
  .demographic2main {
    width: 100%;
    height: calc(100vh - 182px);
    overflow-x: hidden;
    overflow-y: auto;
  }
}
td {
  vertical-align: middle;
}

.demo2table th,
.demo2table td {
  font-weight: 400 !important;
}

@media screen and (max-device-width: 813px) {
  .querytable {
    width: 300%;
  }
}
@media screen and (max-device-width: 369px) {
  .querytable {
    width: 400%;
  }
}
@media screen and (max-device-width: 535px) {
  .demohistorytable {
    width: 130%;
  }
}
@media screen and (max-device-width: 513px) {
  .demo2table {
    width: 150%;
  }
}
@media screen and (max-device-width: 459px) {
  .demo2table {
    width: 170%;
  }
}
@media screen and (max-device-width: 417px) {
  .demohistorytable {
    width: 180%;
  }
}
@media screen and (max-device-width: 361px) {
  .demo2table {
    width: 190%;
  }
}
@media screen and (max-device-width: 326px) {
  .demo2table {
    width: 230%;
  }
}
@media screen and (max-device-width: 323px) {
  .demo2genderflex {
    height: 10vh;
  }
}
/* ......................................... */
/* Demographic.............................. */
.crfBirth {
  width: 223px;
}

.demographicbyear,
.demographicspace,
.demographicc200,
.demographicbirth {
  width: 25%;
}

.demographicbottomsection {
  width: 97%;
  margin: auto;
  padding-top: 20px;
}

.striped-border {
  border-bottom: dashed 2px #dee2e6 !important;
}

.demographicfloatbutton {
  background-color: transparent;
  border: none;
}

.crfleftpills {
  display: flex;
  flex-direction: column;
}

.vheightleft {
  width: 50%;
}

.vheightright {
  width: 50%;
}

.vheightright {
  height: calc(100vh - 182px);
  overflow: auto;
}

.vheightselect {
  margin-bottom: 10px;
}

.vselectlabel {
  width: 25%;
}

.vselectselect {
  width: 75%;
}

.vheightleft {
  border-right: 1px solid #dee2e6;
  height: 100vh;
}

.tvbutton {
  background-color: var(--blue);
  color: var(--white);
  width: 35%;
  padding: 0px;
  height: 30px;
  border-radius: 6px;
}

.vheight,
.vadd {
  background-color: var(--blue);
  color: var(--white);
  width: 70px;
  padding: 0px;
  height: 30px;
  border-radius: 6px;
}

.tvalidationtext {
  border: 2px solid var(--blue);
  width: 70%;
  margin-right: 10px;
  height: 30px;
  border-radius: 6px;
}

.vbutton {
  background-color: transparent;
  border: none;
}

.addvariable {
  background-color: var(--blue);
  border: none;
  border-radius: 6px;
  color: var(--white);
  width: 100%;
  margin: auto;
}

.sedright {
  width: 40%;
  border-left: 1px solid #dee2e6;
  margin-left: 5px;
  height: 100vh;
}

.sedleft {
  width: 60%;
  border-right: 1px solid #dee2e6;
  height: 100vh;
}

.sdvlabel {
  width: 30%;
}

.sdvselect {
  border: 2px solid var(--blue);
  border-radius: 6px;
  width: 70%;
}

.crfnav {
  border-bottom: 1px solid #dee2e6;
}

.venter {
  width: 95%;
  margin: auto;
}

.vheightform {
  height: 58vh;
}

.vselectselect {
  border: 2px solid var(--blue);
  border-radius: 6px;
  height: 28px;
  padding-top: 0px;
  padding-bottom: 0px;
}

.vheightbottom {
  background: hsl(0, 0%, 95%);
  padding-top: 10px;
  padding-bottom: 20px;
}

.vheighttop {
  height: 50vh;
}

.leftbox {
  padding-top: 10px;
}

.table-responsive-sedleft {
  max-height: calc(100vh - 220px);
  overflow: auto;
  position: relative;
}

.table-responsive-demoeditor {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.table-responsive-historyweight {
  height: 65vh;
  overflow: auto;
  position: relative;
}

@media screen and (max-device-width: 1239px) {
  .sdvlabel {
    width: 35%;
  }
  .sdvselect {
    width: 65%;
  }
}
@media screen and (max-device-width: 1072px) {
  .sdvlabel {
    width: 40%;
  }
  .sdvselect {
    width: 60%;
  }
}
@media screen and (max-device-width: 947px) {
  .sdvlabel {
    width: 45%;
  }
  .sdvselect {
    width: 55%;
  }
}
@media screen and (max-device-width: 940px) {
  .sdvlabel {
    width: 100%;
  }
  .sdvselect {
    width: 100%;
  }
}
@media screen and (max-device-width: 1244px) {
  .vselectlabel {
    width: 30%;
  }
  .vselectselect {
    width: 70%;
  }
}
@media screen and (max-device-width: 1088px) {
  .vselectlabel {
    width: 35%;
  }
  .vselectselect {
    width: 65%;
  }
}
@media screen and (max-device-width: 1027px) {
  .vselectlabel {
    width: 40%;
  }
  .vselectselect {
    width: 60%;
  }
}
@media screen and (max-device-width: 940px) {
  .vheightselect {
    display: flex;
    flex-direction: column;
  }
  .vheightform {
    height: 90vh;
  }
  .vheightright {
    height: calc(100vh - 182px);
    overflow: auto;
  }
  .vselectlabel {
    width: 100%;
  }
  .vselectselect {
    width: 100%;
  }
}
@media screen and (max-device-width: 896px) {
  .table-responsive-demoeditor {
    height: 40vh;
    overflow: auto;
  }
}
@media screen and (max-device-width: 869px) {
  .crfmain {
    display: flex;
    flex-direction: column;
  }
  .table-responsive-historyweight {
    height: 55vh;
  }
  .genderselect {
    border: none;
    margin-left: 0px;
  }
  .crfleft,
  .rightbox,
  .leftbox {
    width: 100%;
  }
  .crfleftpills {
    display: flex;
    flex-direction: row;
    padding-left: 10px;
    padding-bottom: 10px;
  }
}
@media screen and (max-device-width: 859px) {
  .demoeditortable {
    width: 130%;
  }
}
@media screen and (max-device-width: 851px) {
  .deographic-tab {
    padding: 5px 10px 5px 10px;
  }
  .vheightright {
    height: 64vh;
    overflow: auto;
  }
  .vheighttop {
    height: 43vh;
    overflow: auto;
  }
}
@media screen and (max-device-width: 759px) {
  .vheighttop {
    height: 39vh;
    overflow: auto;
  }
  .deographic-tab {
    padding: 4px 6px 4px 8px;
  }
  .vheightright {
    height: 60vh;
    overflow: auto;
  }
  .leftbox {
    padding-top: 7px;
  }
}
@media screen and (max-device-width: 714px) {
  .vheightright {
    height: 55vh;
    overflow: auto;
  }
  .table-responsive-historyweight {
    height: 50vh;
  }
  .table-responsive-sedleft {
    max-height: calc(100vh - 242px);
    overflow: auto;
  }
}
@media screen and (max-device-width: 658px) {
  .testtablediv {
    width: 100%;
  }
  .testtable {
    width: 130%;
  }
}
@media screen and (max-device-width: 559px) {
  .sedtable {
    width: 130%;
  }
}
@media screen and (max-device-width: 547px) {
  .historyweighttable {
    width: 130%;
  }
}
@media screen and (max-device-width: 514px) {
  .vheight {
    display: block;
    margin-bottom: 5px;
  }
  .vheightright {
    height: 50vh;
    overflow: auto;
  }
}
@media screen and (max-device-width: 511px) {
  .testtablediv {
    width: 100%;
  }
  .testtable {
    width: 180%;
  }
}
@media screen and (max-device-width: 505px) {
  .vheighttop {
    height: 33vh;
    overflow: auto;
  }
  .table-responsive-historyweight {
    height: 46vh;
  }
}
@media screen and (max-device-width: 438px) {
  .sedtable {
    width: 180%;
  }
}
@media screen and (max-device-width: 426px) {
  .historyweighttable {
    width: 170%;
  }
}
@media screen and (max-device-width: 424px) {
  .table-responsive-sedleft {
    max-height: calc(100vh - 280px);
    overflow: auto;
  }
  .table-responsive-historyweight {
    height: 41vh;
  }
  .vheightright {
    height: 45vh;
    overflow: auto;
  }
}
@media screen and (max-device-width: 418px) {
  .vheightright {
    height: 40vh;
    overflow: auto;
  }
}
@media screen and (max-device-width: 336px) {
  .table-responsive-historyweight {
    height: 39vh;
  }
}
@media screen and (max-device-width: 330px) {
  .historyweighttable {
    width: 210%;
  }
}
@media screen and (max-device-width: 328px) {
  .sedtable {
    width: 230%;
  }
}
/* ............................................ */
/* DATAENTRY DEMOGRAPHICS....................... */
.dataentryleft {
  width: 20%;
}

.dataentrydemographicright {
  width: 78%;
  margin-left: 15px;
}

@media screen and (max-device-width: 686px) {
  .dataentryleft {
    width: 30%;
  }
  .dataentrydemographicright {
    width: 68%;
  }
}
@media screen and (max-device-width: 680px) {
  .demographicscreaterolebuttons {
    padding-top: 2px;
  }
}
@media screen and (max-device-width: 555px) {
  .dataentryleft {
    width: 40%;
  }
  .dataentrydemographicright {
    width: 58%;
  }
}
/* ............................................ */
@media screen and (max-device-width: 608px) {
  .jobcreationpagination {
    margin-top: -3px;
  }
}
/* DATA SETTING ................................... */
.datasettingmain {
  margin-top: 2px;
}

@media screen and (max-device-width: 1462px) {
  .datasettingtable {
    width: 130%;
  }
}
@media screen and (max-device-width: 1127px) {
  .datasettingtable {
    width: 150%;
  }
}
@media screen and (max-device-width: 978px) {
  .datasettingtable {
    width: 170%;
  }
}
@media screen and (max-device-width: 866px) {
  .datasettingtable {
    width: 200%;
  }
}
@media screen and (max-device-width: 736px) {
  .datasettingtable {
    width: 250%;
  }
}
@media screen and (max-device-width: 591px) {
  .datasettingtable {
    width: 300%;
  }
}
@media screen and (max-device-width: 495px) {
  .datasettingtable {
    width: 400%;
  }
}
@media screen and (max-device-width: 374px) {
  .datasettingtable {
    width: 500%;
  }
}
/* ................................................. */
/* METHODS.......................................... */
.methodbottoms {
  height: 15vh;
  overflow: auto;
}

.table-responsive-methodleft {
  height: 45vh;
  overflow: auto;
  position: relative;
}

.methodtopleft {
  width: 60%;
}

.methodtopright {
  width: 40%;
}

.methodrightform {
  height: 45vh;
  overflow: auto;
}

.home-lines {
  width: 100%;
  border-top: 1px solid #e5e5e5;
}

.methodrights {
  display: flex;
  flex-direction: column;
  width: 84.6%;
  margin-left: 5px;
  border-left: 1px solid #dee2e6;
}

.methodleft,
.methodleftside {
  width: 15%;
  height: 100vh;
}

.methodflex {
  display: flex;
  flex-direction: column;
}

.methodright {
  width: 100%;
  height: 45vh;
}

.methodmain {
  margin-top: 2px;
}

.methodrighttable {
  width: 100%;
}

.methodselect {
  width: 95px;
  display: inline;
  height: 27px;
  padding-left: 3px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-top: 0px;
  margin-bottom: 2px;
}

.methodselectspantext {
  padding-left: 5px;
  padding-right: 0px;
}

@media screen and (max-device-width: 1453px) {
  .methodrighttable {
    width: 150%;
  }
}
@media screen and (max-device-width: 1166px) {
  .methodrighttable {
    width: 170%;
  }
}
@media screen and (max-device-width: 1032px) {
  .methodrighttable {
    width: 190%;
  }
}
@media screen and (max-device-width: 925px) {
  .methodrighttable {
    width: 230%;
  }
}
@media screen and (max-device-width: 768px) {
  .methodrighttable {
    width: 260%;
  }
}
@media screen and (max-device-width: 682px) {
  .methodrighttable {
    width: 290%;
  }
}
@media screen and (max-device-width: 616px) {
  .methodmain {
    flex-wrap: wrap;
  }
  .methodleftside {
    width: 100%;
    height: 4vh;
  }
  .methodflex {
    display: flex;
    padding-bottom: 5px;
    flex-direction: row;
  }
  .methodleft,
  .methodrights {
    width: 100%;
  }
  .methodright {
    height: 30vh;
  }
  .methodrights {
    margin-left: 0px;
    border: none;
  }
  .methodrightform {
    height: 27vh;
    overflow: auto;
  }
  .table-responsive-methodleft {
    height: 27vh;
    overflow: auto;
  }
}
/* .................................................. */
/* CLIENT BACKUP TABLE............................ */
.clientbackuptablemain {
  height: 100vh;
}

.clientbackuptableleft {
  width: 60%;
}

.clientbackuptableright {
  width: 39.6%;
  margin-left: 5px;
}

@media screen and (max-device-width: 1202px) {
  .clientbackuptablerighttable {
    width: 130%;
  }
}
@media screen and (max-device-width: 931px) {
  .clientbackuptablerighttable {
    width: 150%;
  }
}
@media screen and (max-device-width: 905px) {
  .clientbackuptablelefttable {
    width: 130%;
  }
}
@media screen and (max-device-width: 808px) {
  .clientbackuptablerighttable {
    width: 170%;
  }
}
@media screen and (max-device-width: 716px) {
  .clientbackuptablemain {
    display: flex;
    flex-direction: column;
  }
  .clientbackuptableleft,
  .clientbackuptableright {
    width: 100%;
  }
  .clientbackuptablerighttable,
  .clientbackuptablelefttable {
    width: 100%;
  }
}
@media screen and (max-device-width: 549px) {
  .clientbackuptablelefttable,
  .clientbackuptablerighttable {
    width: 130%;
  }
}
@media screen and (max-device-width: 387px) {
  .clientbackuptablelefttable,
  .clientbackuptablerighttable {
    width: 170%;
  }
}
/* ................................................ */
/* BACKUP.......................................... */
.backuptoptions {
  width: 100%;
}

.backuplabels {
  width: 11%;
  padding-top: 5px;
  text-align: right;
}

.backupoptions {
  width: 20%;
  height: 32px;
}

@media screen and (max-device-width: 1552px) {
  .backuplabels {
    width: 12%;
  }
}
@media screen and (max-device-width: 1429px) {
  .backuplabels {
    width: 13%;
  }
}
@media screen and (max-device-width: 1324px) {
  .backuplabels {
    width: 14%;
  }
}
@media screen and (max-device-width: 1235px) {
  .backuplabels {
    width: 15%;
  }
}
@media screen and (max-device-width: 1157px) {
  .backuplabels {
    width: 16%;
  }
  .backupoptions {
    width: 23%;
  }
}
@media screen and (max-device-width: 1090px) {
  .backuplabels {
    width: 17%;
  }
  .backupoptions {
    width: 23%;
  }
}
@media screen and (max-device-width: 1030px) {
  .backuplabels {
    width: 18%;
  }
  .backupoptions {
    width: 25%;
  }
}
@media screen and (max-device-width: 976px) {
  .backuplabels {
    width: 19%;
  }
  .backupoptions {
    width: 25%;
  }
}
@media screen and (max-device-width: 929px) {
  .backuplabels {
    width: 21%;
  }
  .backupoptions {
    width: 28%;
  }
}
@media screen and (max-device-width: 847px) {
  .backuplabels {
    width: 23%;
  }
  .backupoptions {
    width: 31%;
  }
}
@media screen and (max-device-width: 780px) {
  .backuplabels {
    width: 26%;
  }
  .backupoptions {
    width: 35%;
  }
}
@media screen and (max-device-width: 698px) {
  .backuplabels {
    width: 30%;
  }
  .backupoptions {
    width: 40%;
  }
}
@media screen and (max-device-width: 615px) {
  .backuptoptions {
    display: flex;
  }
  .backuplabels {
    width: 35%;
    text-align: left;
  }
  .backupoptions {
    width: 65%;
  }
  .backupdashboard {
    height: 100vh;
  }
}
@media screen and (max-device-width: 547px) {
  .backuptoptions {
    display: flex;
  }
  .backuplabels {
    width: 42%;
    text-align: left;
  }
  .backupoptions {
    width: 58%;
  }
  .backupdashboard {
    height: 100vh;
  }
}
@media screen and (max-device-width: 470px) {
  .backuptoptions {
    display: flex;
    flex-direction: column;
  }
  .backuplabels {
    width: 100%;
    text-align: left;
  }
  .backupoptions {
    width: 100%;
  }
  .backupdashboard {
    height: 100vh;
  }
}
/* ................................................. */
/* QUERY MANAGEMENT................................. */
.querymodel {
  position: relative;
  pointer-events: auto;
  background-clip: padding-box;
  border: 2px solid var(--blue);
  outline: 0;
  height: 100%;
  min-height: 164px;
  background-color: var(--white);
  padding-bottom: 1rem;
}

.modalcross {
  background-color: transparent;
  border: none;
  color: hsl(202, 56%, 53%);
}

.querymodals-body {
  position: relative;
  flex: 1 1 auto;
  padding: 0 20px;
  align-items: center;
  display: flex;
  text-align: center;
  line-height: 1.6;
  font-size: 16px;
}

.queryselectvisit,
.queryselectsubject,
.queryselectsite {
  display: flex;
  width: 33.33%;
}

.queryvisitlabel,
.querysubjectlabel,
.querysitelabel {
  width: 30%;
  padding-top: 10px;
  padding-left: 3px;
  padding-right: 5px;
  text-align: right;
}

.queryvisit,
.querysite,
.querysubject {
  width: 70%;
  height: 32px;
  border: 1px solid var(--blue);
}

.querysecondhr {
  margin-top: 81px;
  margin-bottom: 5px;
}

.querytableselect {
  border: none;
  background-color: transparent;
  opacity: 0.8;
  width: 85px;
  cursor: pointer;
}

.querypopup1hr {
  margin: 0px;
}

.popupcross {
  font-size: 21px;
}

.querypopuptablemain {
  height: 50vh;
}

.querymodaldropdowns {
  padding-top: 10px;
}

@media screen and (max-device-width: 1644px) {
  .querypopuptablemain {
    height: 43vh;
  }
}
@media screen and (max-device-width: 1026px) {
  .querypopuptablemain {
    height: 40vh;
  }
  .queryvisitlabel,
  .querysubjectlabel,
  .querysitelabel {
    width: 40%;
  }
  .queryvisit,
  .querysite,
  .querysubject {
    width: 60%;
  }
}
@media screen and (max-device-width: 783px) {
  .queryvisitlabel,
  .querysubjectlabel,
  .querysitelabel {
    width: 50%;
  }
  .queryvisit,
  .querysite,
  .querysubject {
    width: 50%;
  }
}
@media screen and (max-device-width: 722px) {
  .querypopuptable {
    width: 130%;
  }
}
@media screen and (max-device-width: 636px) {
  .querypopuptable {
    width: 130%;
  }
  .querypopuptablemain {
    height: 30vh;
  }
  .queryselectvisit,
  .queryselectsubject,
  .queryselectsite {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
  .queryvisitlabel,
  .querysubjectlabel,
  .querysitelabel {
    width: 100%;
    text-align: left;
  }
  .queryvisit,
  .querysite,
  .querysubject {
    width: 95%;
  }
}
@media screen and (max-device-width: 564px) {
  .querypopuptable {
    width: 150%;
  }
}
@media screen and (max-device-width: 491px) {
  .querypopuptable {
    width: 180%;
  }
}
@media screen and (max-device-width: 412px) {
  .querypopuptable {
    width: 200%;
  }
}
/* ................................................. */
/*  CONTEXT MENU.................................... */
.contextmenuoptions {
  position: absolute;
  border: 1px solid #cecece;
  border-radius: 3px;
  background: var(--white);
  box-shadow: 3px 4px 7px #bababa;
  z-index: 1;
  transition: opacity 0.5s linear;
}

.contextmenuoptions {
  padding: 0px;
  margin: 0px;
  min-width: 150px;
  list-style: none;
}

.contextmenuoptions li {
  padding-bottom: 7px;
  padding-top: 7px;
  border: 1px solid black;
}

.contextmenuoptions li a {
  text-decoration: none;
  color: black;
}

.contextmenuoptions li:hover {
  background: darkgray;
}

/* ............. */
.menu {
  background-color: var(--color-bg-secondary);
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(64, 64, 64, 0.0823529412);
}

.menu-list {
  margin: 0;
  display: block;
  width: 100%;
  padding: 0px;
}

.menu-list + .menu-list {
  border-top: 1px solid #ddd;
}

.menu-sub-list:hover {
  display: flex;
}

li.menu-item:hover {
  background-color: var(--blue);
  color: var(--white);
}

button.menu-button:hover {
  color: var(--white);
}

button.menu-button {
  padding: 5px 5px 5px 12px;
}

.menu-sub-list {
  display: none;
  padding: 0px;
  background-color: var(--color-bg-secondary);
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(64, 64, 64, 0.15);
  position: absolute;
  left: 100%;
  right: 0;
  z-index: 100;
  width: 100%;
  top: 0;
  flex-direction: column;
}

.sub-left .menu-sub-list {
  left: -100%;
  right: 0;
}

.menu-item {
  position: relative;
}

.menu-button:hover {
  background-color: var(--color-bg-primary-offset);
}

.menu-button:hover + .menu-sub-list {
  display: flex;
}

.menu-button:hover svg {
  stroke: var(--color-text-primary);
}

.menu-button {
  font: inherit;
  border: 0;
  width: 100%;
  border-radius: 8px;
  display: flex;
  align-items: center;
  position: relative;
  background-color: var(--color-bg-secondary);
}

.menu-button svg {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  stroke: var(--color-text-primary-offset);
}

.menu-button:nth-of-type(2) {
  margin-right: 0;
  position: absolute;
  right: 8px;
}

.containerx {
  position: absolute;
  width: 165px;
  border: 1px solid rgb(236, 227, 227);
  border-radius: 5px;
  background: var(--white);
  align-items: center;
  justify-content: center;
  z-index: 1;
}

ul {
  list-style: none;
}

/* ................................................. */
/* MONITORING VISIT........................................... */
.addvisitbtn {
  background-color: var(--blue);
  border: none;
  border-radius: 5px;
  font-size: 14px;
  margin-top: 2px;
  margin-right: 10px;
  width: 110px;
}

.monitoringtbrow {
  height: 105px;
  border-bottom: 2px solid #bfc3c7;
}

.monitoringtbhead {
  border-right: 2px solid #bfc3c7;
  font-weight: lighter;
}

.saturday {
  font-weight: lighter;
}

.monitormain {
  margin-top: 2px;
  height: 105vh;
}

.mx01 {
  background-color: var(--blue);
  border: none;
  border-radius: 5px;
  color: var(--white);
  padding: 5px;
  margin-top: 3px;
}

/* ........................................................... */
.adverseeventrightbottom {
  width: 100%;
}

/* SITE STATUS.................................. */
.sitestatus-dashboard-body {
  overflow: hidden;
}

.table-responsive-sitestatus {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.sitestatustable {
  width: 200%;
}

.sitestatusmain {
  margin-top: 2px;
}

@media screen and (max-device-width: 1574px) {
  .sitestatustable {
    width: 200%;
  }
}
@media screen and (max-device-width: 1301px) {
  .sitestatustable {
    width: 250%;
  }
}
@media screen and (max-device-width: 1043px) {
  .sitestatustable {
    width: 280%;
  }
}
@media screen and (max-device-width: 932px) {
  .sitestatustable {
    width: 310%;
  }
}
@media screen and (max-device-width: 843px) {
  .sitestatustable {
    width: 350%;
  }
}
@media screen and (max-device-width: 748px) {
  .sitestatustable {
    width: 400%;
  }
}
@media screen and (max-device-width: 656px) {
  .sitestatustable {
    width: 450%;
  }
}
@media screen and (max-device-width: 627px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .sitestatustable {
    width: 450%;
  }
  .table-responsive-sitestatus {
    height: 65vh;
    overflow: auto;
  }
}
@media screen and (max-device-width: 584px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .sitestatustable {
    width: 500%;
  }
}
@media screen and (max-device-width: 527px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .sitestatustable {
    width: 550%;
  }
}
@media screen and (max-device-width: 480px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .sitestatustable {
    width: 600%;
  }
}
@media screen and (max-device-width: 441px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .sitestatustable {
    width: 800%;
  }
}
@media screen and (max-device-width: 333px) {
  .table-responsive-sitestatus {
    height: 60vh;
    overflow: auto;
  }
}
/* ............................................. */
/* SUBJECT STATUS.................................. */
.subjectstatustable {
  width: 250%;
}

.subjectstatusmain {
  margin-top: 2px;
}

@media screen and (max-device-width: 1416px) {
  .subjectstatustable {
    width: 280%;
  }
}
@media screen and (max-device-width: 1265px) {
  .subjectstatustable {
    width: 310%;
  }
}
@media screen and (max-device-width: 1144px) {
  .subjectstatustable {
    width: 350%;
  }
}
@media screen and (max-device-width: 1014px) {
  .subjectstatustable {
    width: 380%;
  }
}
@media screen and (max-device-width: 935px) {
  .subjectstatustable {
    width: 450%;
  }
}
@media screen and (max-device-width: 791px) {
  .subjectstatustable {
    width: 500%;
  }
}
@media screen and (max-device-width: 713px) {
  .subjectstatustable {
    width: 560%;
  }
}
@media screen and (max-device-width: 638px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .subjectstatustable {
    width: 620%;
  }
}
@media screen and (max-device-width: 577px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .subjectstatustable {
    width: 670%;
  }
}
@media screen and (max-device-width: 535px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .subjectstatustable {
    width: 850%;
  }
}
@media screen and (max-device-width: 424px) {
  .subjectstatusmain {
    margin-top: 6px;
  }
  .subjectstatustable {
    width: 970%;
  }
}
@media screen and (max-device-width: 373px) {
  .subjectstatusmain {
    margin-top: 6px;
  }
  .subjectstatustable {
    width: 1200%;
  }
}
/* ............................................. */
/* SUBJECT FROM STATUS.................................. */
.SubjectFormStatustable {
  width: 165%;
}

.SubjectFormStatusmain {
  margin-top: 2px;
}

@media screen and (max-device-width: 1574px) {
  .SubjectFormStatustable {
    width: 200%;
  }
}
@media screen and (max-device-width: 1301px) {
  .SubjectFormStatustable {
    width: 250%;
  }
}
@media screen and (max-device-width: 1043px) {
  .SubjectFormStatustable {
    width: 280%;
  }
}
@media screen and (max-device-width: 932px) {
  .SubjectFormStatustable {
    width: 310%;
  }
}
@media screen and (max-device-width: 843px) {
  .SubjectFormStatustable {
    width: 350%;
  }
}
@media screen and (max-device-width: 748px) {
  .SubjectFormStatustable {
    width: 400%;
  }
}
@media screen and (max-device-width: 656px) {
  .SubjectFormStatustable {
    width: 450%;
  }
}
@media screen and (max-device-width: 627px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .SubjectFormStatustable {
    width: 450%;
  }
}
@media screen and (max-device-width: 584px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .SubjectFormStatustable {
    width: 500%;
  }
}
@media screen and (max-device-width: 527px) {
  .sitestatusmain {
    margin-top: 6px;
  }
  .SubjectFormStatustable {
    width: 550%;
  }
}
@media screen and (max-device-width: 480px) {
  .SubjectFormStatusmain {
    margin-top: 6px;
  }
  .SubjectFormStatustable {
    width: 600%;
  }
}
@media screen and (max-device-width: 441px) {
  .SubjectFormStatusmain {
    margin-top: 6px;
  }
  .SubjectFormStatustable {
    width: 800%;
  }
}
/* ............................................. */
/* COMPARE DATA................................ */
.comparedataleft {
  width: 35%;
  height: 100vh;
}

.table-responsive-comparerighttop {
  max-height: 35vh;
  overflow: auto;
  position: relative;
}

.table-responsive-comparerightbottom {
  max-height: 35vh;
  overflow: auto;
  margin-top: 4px;
  position: relative;
}

.comparedataright {
  width: 65%;
  height: 100vh;
}

.uploadsourceinput {
  width: 500px;
  background-color: var(--blue);
}

.compareupload {
  width: 95%;
  margin: auto;
}

.comparelabel {
  width: 50%;
}

.compareuploadchoose {
  width: 100%;
}

.compareinput {
  width: 50%;
}

.comparebutton {
  padding-top: 280px;
}

@media screen and (max-device-width: 1036px) {
  .comparebottomtable {
    width: 130%;
  }
}
@media screen and (max-device-width: 919px) {
  .comparelabel {
    width: 75%;
  }
}
@media screen and (max-device-width: 804px) {
  .comparebottomtable {
    width: 160%;
  }
}
@media screen and (max-device-width: 769px) {
  .compareupload {
    display: flex;
    flex-direction: column;
    padding-left: 10px;
  }
  .comparelabel {
    width: 100%;
  }
  .comparebutton {
    padding-top: 200px;
  }
  .compareinput {
    width: 100%;
  }
}
@media screen and (max-device-width: 659px) {
  .comparebottomtable {
    width: 200%;
  }
}
@media screen and (max-device-width: 533px) {
  .comparebottomtable {
    width: 250%;
  }
}
@media screen and (max-device-width: 517px) {
  .comparelabel {
    width: 100%;
    font-size: 12px;
  }
}
@media screen and (max-device-width: 514px) {
  .comparebutton {
    padding-top: 150px;
    padding-left: 30px;
  }
}
@media screen and (max-device-width: 517px) {
  .comparelabel {
    width: 100%;
    font-size: 11px;
  }
}
@media screen and (max-device-width: 485px) {
  .comparetoptable {
    width: 130%;
  }
}
@media screen and (max-device-width: 432px) {
  .comparebottomtable {
    width: 310%;
  }
}
@media screen and (max-device-width: 380px) {
  .comparetoptable {
    width: 170%;
  }
}
@media screen and (max-device-width: 354px) {
  .comparebottomtable {
    width: 360%;
  }
}
/* ............................................. */
/* DISPOSITION............................. */
.dispositiontable {
  margin-top: 9px;
}

@media screen and (max-device-width: 711px) {
  .dispositiontable {
    width: 130%;
  }
}
@media screen and (max-device-width: 549px) {
  .dispositiontable {
    width: 170%;
  }
}
@media screen and (max-device-width: 423px) {
  .dispositiontable {
    width: 210%;
  }
}
/* ......................................... */
/* CREATE ARCHIVE........................... */
.carchivelabel {
  width: 12%;
  text-align: right;
}

.carchiveselect {
  width: 20%;
  border-radius: 8px;
  border: 1px solid var(--blue);
  height: 2rem;
}

@media screen and (max-device-width: 1312px) {
  .carchivelabel {
    width: 15%;
  }
  .carchiveselect {
    width: 25%;
  }
}
@media screen and (max-device-width: 1064px) {
  .carchivelabel {
    width: 18%;
  }
  .carchiveselect {
    width: 28%;
  }
}
@media screen and (max-device-width: 899px) {
  .carchivelabel {
    width: 25%;
  }
  .carchiveselect {
    width: 35%;
  }
}
@media screen and (max-device-width: 667px) {
  .carchivelabel {
    width: 35%;
  }
  .carchiveselect {
    width: 45%;
  }
}
@media screen and (max-device-width: 550px) {
  .carchivemain {
    display: flex;
    flex-direction: column;
  }
  .carchivelabel {
    width: 100%;
    text-align: left;
  }
  .carchiveselect {
    width: 100%;
  }
}
/* ......................................... */
/* CLIENT ARCHIVE........................... */
@media screen and (max-device-width: 864px) {
  .carchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 667px) {
  .carchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 579px) {
  .carchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 485px) {
  .carchivetable {
    width: 210%;
  }
}
@media screen and (max-device-width: 417px) {
  .carchivetable {
    width: 250%;
  }
}
@media screen and (max-device-width: 352px) {
  .carchivetable {
    width: 300%;
  }
}
/* ......................................... */
/* STUDY ARCHIVE........................... */
.sarchivetable {
  margin-top: 2px;
}

@media screen and (max-device-width: 985px) {
  .sarchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 760px) {
  .sarchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 660px) {
  .sarchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 552px) {
  .sarchivetable {
    width: 210%;
  }
}
@media screen and (max-device-width: 475px) {
  .sarchivetable {
    width: 250%;
  }
}
@media screen and (max-device-width: 400px) {
  .sarchivetable {
    width: 300%;
  }
}
@media screen and (max-device-width: 336px) {
  .sarchivetable {
    width: 330%;
  }
}
/* ......................................... */
/* USER ARCHIVE........................... */
@media screen and (max-device-width: 864px) {
  .uarchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 667px) {
  .uarchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 579px) {
  .uarchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 485px) {
  .uarchivetable {
    width: 210%;
  }
}
@media screen and (max-device-width: 417px) {
  .uarchivetable {
    width: 250%;
  }
}
@media screen and (max-device-width: 352px) {
  .uarchivetable {
    width: 300%;
  }
}
/* ......................................... */
/* ROLE ARCHIVE........................... */
@media screen and (max-device-width: 738px) {
  .rarchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 570px) {
  .rarchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 496px) {
  .rarchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 415px) {
  .rarchivetable {
    width: 220%;
  }
}
@media screen and (max-device-width: 341px) {
  .rarchivetable {
    width: 260%;
  }
}
/* ......................................... */
/* CRFS ARCHIVE........................... */
@media screen and (max-device-width: 985px) {
  .crfsarchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 760px) {
  .crfsarchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 660px) {
  .crfsarchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 552px) {
  .crfsarchivetable {
    width: 210%;
  }
}
@media screen and (max-device-width: 475px) {
  .crfsarchivetable {
    width: 250%;
  }
}
@media screen and (max-device-width: 400px) {
  .crfsarchivetable {
    width: 300%;
  }
}
@media screen and (max-device-width: 336px) {
  .crfsarchivetable {
    width: 330%;
  }
}
/* ......................................... */
/* STUDY SCHEMA ARCHIVE........................... */
@media screen and (max-device-width: 985px) {
  .studyschemaarchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 760px) {
  .studyschemaarchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 660px) {
  .studyschemaarchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 552px) {
  .studyschemaarchivetable {
    width: 210%;
  }
}
@media screen and (max-device-width: 475px) {
  .studyschemaarchivetable {
    width: 250%;
  }
}
@media screen and (max-device-width: 400px) {
  .studyschemaarchivetable {
    width: 300%;
  }
}
@media screen and (max-device-width: 336px) {
  .studyschemaarchivetable {
    width: 330%;
  }
}
/* ......................................... */
/* PARAMETER ARCHIVE........................... */
@media screen and (max-device-width: 985px) {
  .parchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 760px) {
  .parchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 660px) {
  .parchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 552px) {
  .parchivetable {
    width: 210%;
  }
}
@media screen and (max-device-width: 475px) {
  .parchivetable {
    width: 250%;
  }
}
@media screen and (max-device-width: 400px) {
  .parchivetable {
    width: 300%;
  }
}
@media screen and (max-device-width: 336px) {
  .parchivetable {
    width: 330%;
  }
}
/* ......................................... */
/* TERM ARCHIVE........................... */
@media screen and (max-device-width: 985px) {
  .tarchivetable {
    width: 130%;
  }
}
@media screen and (max-device-width: 760px) {
  .tarchivetable {
    width: 150%;
  }
}
@media screen and (max-device-width: 660px) {
  .tarchivetable {
    width: 180%;
  }
}
@media screen and (max-device-width: 552px) {
  .tarchivetable {
    width: 210%;
  }
}
@media screen and (max-device-width: 475px) {
  .tarchivetable {
    width: 250%;
  }
}
@media screen and (max-device-width: 400px) {
  .tarchivetable {
    width: 300%;
  }
}
@media screen and (max-device-width: 336px) {
  .tarchivetable {
    width: 330%;
  }
}
/* ......................................... */
/* STUDY BACKUP TABLE....................... */
@media screen and (max-device-width: 1183px) {
  .studybackuptablelefttable {
    width: 130%;
  }
}
@media screen and (max-device-width: 1060px) {
  .studybackuptablelefttable {
    width: 130%;
  }
}
@media screen and (max-device-width: 995px) {
  .clientbackuptablerighttable,
  .studybackuptablelefttable {
    width: 100%;
  }
}
@media screen and (max-device-width: 821px) {
  .studybackuptablelefttable {
    width: 150%;
  }
}
@media screen and (max-device-width: 448px) {
  .clientbackuptablerighttable {
    width: 120%;
  }
}
@media screen and (max-device-width: 434px) {
  .studybackuptablelefttable {
    width: 180%;
  }
}
@media screen and (max-device-width: 375px) {
  .clientbackuptablerighttable {
    width: 145%;
  }
}
@media screen and (max-device-width: 348px) {
  .studybackuptablelefttable {
    width: 230%;
  }
}
/* ......................................... */
/* LOGIN PAGE................................. */
.wtogalax {
  background-color: hsl(0, 0%, 95%);
  text-align: center;
}

.loggin-bottom {
  background-color: hsl(0, 0%, 95%);
  padding-top: 10px;
  padding-bottom: 30px;
}

.login-historyhr {
  padding: 1px;
}

.select-application-button {
  padding-left: 10px;
  padding-right: 20px;
  padding-top: 4px;
}

.select-application-label {
  padding-top: 6px;
}

.loginbutton {
  background-color: var(--blue);
  color: var(--white);
  margin-right: 26px;
  width: 100px;
  height: 32px;
  padding: 0px;
}

.welcome-to-galax {
  margin: 0px;
}

.login-history {
  padding-top: 5px;
  padding-bottom: 5px;
}

.login-selectbox,
.login-innerselectbox {
  padding-top: 5px;
  padding-bottom: 5px;
}

.login-history-label {
  width: 7%;
}

.login-history-select {
  width: 30%;
  border: 1px solid var(--blue);
}

.login-text {
  width: 62%;
  margin-left: 15px;
  border: 1px solid var(--blue);
}

@media screen and (max-device-width: 1250px) {
  .login-history-label {
    width: 8%;
  }
  .login-history-select {
    width: 29%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 61.5%;
    margin-left: 15px;
  }
}
@media screen and (max-device-width: 1100px) {
  .login-history-label {
    width: 9%;
  }
  .login-history-select {
    width: 28%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 61.5%;
    margin-left: 15px;
  }
}
@media screen and (max-device-width: 990px) {
  .login-history-label {
    width: 10%;
  }
  .login-history-select {
    width: 27%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 61.5%;
    margin-left: 15px;
  }
}
@media screen and (max-device-width: 870px) {
  .login-history-label {
    width: 11%;
  }
  .login-history-select {
    width: 26%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 61.5%;
    margin-left: 15px;
  }
}
@media screen and (max-device-width: 780px) {
  .login-history-label {
    width: 14%;
  }
  .login-history-select {
    width: 30%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 54%;
    margin-left: 15px;
  }
}
@media screen and (max-device-width: 630px) {
  .login-history-label {
    width: 17%;
  }
  .login-history-select {
    width: 33%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 47%;
    margin-left: 15px;
  }
}
@media screen and (max-device-width: 588px) {
  .loggin-bottom {
    flex-wrap: wrap;
  }
  .login-button {
    width: 500px;
  }
}
@media screen and (max-device-width: 520px) {
  .login-history-label {
    width: 22%;
  }
  .login-history-select {
    width: 36%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 39%;
    margin-left: 15px;
  }
}
@media screen and (max-device-width: 462px) {
  .login-bottoms {
    flex-wrap: wrap;
  }
  .select-app {
    justify-content: center;
  }
}
@media screen and (max-device-width: 425px) {
  .login-innerselectbox,
  .login-history {
    padding-top: 5px;
    padding-bottom: 5px;
    display: flex;
    flex-wrap: wrap;
  }
  .login-history-label {
    width: 100%;
  }
  .login-history-select {
    width: 100%;
    border: 1px solid var(--blue);
  }
  .login-text {
    width: 100%;
    margin-left: 0px;
    margin-top: 10px;
  }
}
/* .......................................... */
/* Sr. BD EXECUTIVE................................. */
@media screen and (max-device-width: 1121px) {
  .sbdeassignstudytable {
    width: 130%;
  }
}
@media screen and (max-device-width: 865px) {
  .sbdeassignstudytable {
    width: 150%;
  }
}
@media screen and (max-device-width: 751px) {
  .sbdeassignstudytable {
    width: 190%;
  }
}
@media screen and (max-device-width: 595px) {
  .sbdeassignstudytable {
    width: 240%;
  }
}
@media screen and (max-device-width: 474px) {
  .sbdeassignstudytable {
    width: 290%;
  }
}
@media screen and (max-device-width: 394px) {
  .sbdeassignstudytable {
    width: 350%;
  }
}
@media screen and (max-device-width: 328px) {
  .sbdeassignstudytable {
    width: 400%;
  }
}
/* .......................................... */
/* DBD PROTOCOL .............................. */
.dbdprotocol {
  height: 65vh;
  margin-top: -5px;
}

.dbprotocoltable {
  overflow: scroll;
}

@media screen and (max-width: 706px) {
  .dbprotocoltable {
    width: 130%;
  }
  .assignstudy {
    margin-top: 5px;
  }
}
@media screen and (max-width: 545px) {
  .dbprotocoltable {
    width: 150%;
  }
}
@media screen and (max-width: 474px) {
  .dbprotocoltable {
    width: 170%;
  }
}
@media screen and (max-width: 421px) {
  .dbprotocoltable {
    width: 210%;
  }
}
@media screen and (max-width: 343px) {
  .dbprotocoltable {
    width: 260%;
  }
}
/* ........................................... */
/* PROTOCOL METADATA.......................... */
.table-responsive-protocol {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

@media screen and (max-width: 706px) {
  .protocoltable {
    width: 130%;
  }
  .assignstudy {
    margin-top: 5px;
  }
}
@media screen and (max-width: 545px) {
  .protocoltable {
    width: 150%;
  }
}
@media screen and (max-width: 474px) {
  .protocoltable {
    width: 170%;
  }
}
@media screen and (max-width: 412px) {
  .protocoltable {
    width: 210%;
  }
}
@media screen and (max-width: 337px) {
  .protocoltable {
    width: 260%;
  }
}
/* ........................................... */
/* DBD LABPARAMETER........................... */
.labparameters {
  margin-top: 2px;
}

/* ........................................... */
/* PROGRAMMING EDITOR.............................. */
.ones {
  width: 48px;
  border-right: 1px solid #dee2e6 !important;
}

.table-responsive-program {
  height: 40vh;
  overflow: auto;
  position: relative;
}

.programright {
  height: 42vh;
}

.programbottom {
  height: 20vh;
  overflow: auto;
}

.programtab {
  padding-top: 2px;
  padding-bottom: 2px;
}

.program_custom_nav {
  border-bottom: 1px solid #dee2e6 !important;
}

/* ....................................... */
/* DATA TABLE VIEW............................ */
.datatableviewmain {
  margin-top: 2px;
}

@media screen and (max-width: 1365px) {
  .datatableviewtable {
    width: 150%;
  }
}
@media screen and (max-width: 919px) {
  .datatableviewtable {
    width: 180%;
  }
}
@media screen and (max-width: 768px) {
  .datatableviewtable {
    width: 250%;
  }
}
@media screen and (max-width: 560px) {
  .datatableviewtable {
    width: 300%;
  }
}
@media screen and (max-width: 473px) {
  .datatableviewtable {
    width: 400%;
  }
}
@media screen and (max-width: 360px) {
  .datatableviewtable {
    width: 500%;
  }
}
/* ....................................... */
/* ACCESS MANAGEMENT....................... */
.accessmain {
  height: calc(100vh - 180px);
  display: flex;
}

.accessleft {
  width: 40%;
  height: calc(100vh - 180px);
}

.accessright {
  height: calc(100vh - 180px);
  width: 100%;
  border-left: 1px solid #dee2e6 !important;
  margin-left: 5px;
}

.table-responsive-accessright {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

.accesslabel {
  font-weight: lighter;
  font-size: small;
}

.table-responsive-accessleft {
  max-height: calc(100vh - 182px);
  overflow: auto;
  position: relative;
}

/* ....................................... */
.bold {
  font-weight: 600;
}

/* ....................................... */
.labelTitle {
  font-size: 0.8rem;
}

.fa-solid,
.fa-regular,
.cursorPointer,
.CP,
.textUser,
.fa-folder,
.fa-home-alt,
.sort {
  cursor: pointer;
}

.CD {
  cursor: default !important;
}

.move {
  cursor: move !important;
}

.rotateChevron {
  transform: rotate(270deg);
}

.green {
  color: #40c057;
}

.dropdown-item.active {
  background: #165483;
}

.dropdown-item:active {
  background: transparent;
  color: #165483;
}

.requiredStar {
  fill: #ff0000;
  font-size: 7px;
  margin-bottom: 10px;
}

.homeLineIcon {
  color: var(--blue);
  cursor: pointer;
}

.fiftyVh {
  height: 25vh;
}

.modal-form-section {
  height: calc(100vh - 64px);
  overflow-y: auto;
  overflow-x: hidden;
}

.form-button {
  display: flex;
  justify-content: flex-end;
}

.modal-form-body {
  overflow: hidden !important;
}

.profileImage {
  object-fit: cover;
}

.showEntriesData {
  max-height: 44vh;
  overflow: auto;
}

.tableRightContent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 182px);
}

.crfHight {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 191px);
}

.transferrightThree {
  width: 150%;
}

.subjectstatustable1 {
  width: 100%;
  text-wrap: nowrap;
}

.sitestatustable1 {
  width: 100%;
  text-wrap: nowrap;
}

.queryField_input_size {
  width: 607px !important;
}

.wide {
  width: 100% !important;
}

.mid {
  display: flex;
  justify-content: center;
  align-items: center;
}

.button--checked {
  background-color: transparent;
  color: var(--blue);
  border: 1px solid var(--blue) !important;
}

.data-item {
  width: 33.33%;
  padding: 10px;
  box-sizing: border-box;
}

.datSetHead {
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  margin: 10px 0;
}

nav.react-contextmenu {
  min-width: 180px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.74);
  z-index: 999;
  color: var(--white);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
}
nav.react-contextmenu .react-contextmenu-item {
  font-size: 13px;
  display: block;
  text-decoration: none;
  padding: 5px 15px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: 0.2s;
  position: relative;
  margin-bottom: 2px;
  font-weight: 500;
  display: flex;
  align-items: center;
  outline: none;
  color: var(--white);
}
nav.react-contextmenu .react-contextmenu-item:hover {
  background: #000;
}
nav.react-contextmenu .react-contextmenu-item span {
  margin-left: 10px;
}
nav.react-contextmenu .react-contextmenu-item svg {
  font-size: 14px;
}
nav.react-contextmenu .react-contextmenu-item .edit {
  color: rgb(80, 193, 80);
}
nav.react-contextmenu .react-contextmenu-item .lock {
  color: gray;
}
nav.react-contextmenu .react-contextmenu-item .delete {
  color: #e94e51;
}
nav.react-contextmenu .react-contextmenu-item .history {
  color: rgb(80, 193, 80);
}

.dropend.btn-group button {
  background: none;
  border: none;
  font-size: 13px;
  padding: 0 10px;
  width: 196px;
  text-align: left;
}

.capitalize {
  text-transform: capitalize !important;
}

.dropend > div {
  border: none;
  transform: translate3d(190px, -8px, 0px) !important;
  background-color: rgba(0, 0, 0, 0.74);
  border-radius: 4px;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
}
.dropend > div .dropdown-item {
  padding: 5px;
}
.dropend > div .dropdown-item:hover {
  background: #000;
}

.dropend .dropdown-toggle::after {
  position: absolute;
  right: 0;
  top: 10px;
}

.tab_header .tabbing_heading {
  margin: 0;
}

.ql-snow .ql-picker {
  height: auto !important;
}

.ql-toolbar.ql-snow {
  padding: 0 !important;
  background-color: var(--bs-border-color);
}

.ql-toolbar.ql-snow .ql-formats {
  margin-right: 0px !important;
  padding: 5px;
  border-right: 1px solid rgb(204, 204, 204) !important;
}

.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button,
.ql-snow .ql-picker {
  border-radius: 0;
}

.ql-snow.ql-toolbar button,
.ql-snow .ql-toolbar button {
  width: 40px !important;
  display: flex !important;
  margin: 0 auto;
  justify-content: center;
}

#queryWrapper > :last-child {
  display: none;
}

#queryWrapper.switched > :last-child {
  display: block;
}

#queryWrapper.switched > :first-child {
  display: none;
}

.outputSection {
  display: flex;
  align-items: center;
  gap: 20px;
}

.outputSection p {
  border: 1px solid #dee2e6;
  padding: 2px 20px;
  margin: 5px 0 5px 10px;
  font-size: 12px;
}

.queryResponse {
  border: 1px solid #dee2e6;
  border-radius: 5px;
  height: 50px;
}

.add_puls {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

span.CP.mt-1.ps-3.small {
  padding: 4px 2px;
  display: flex;
  width: 100%;
  align-items: center;
  text-wrap: nowrap;
  overflow: hidden;
  font-size: 13px;
  border-bottom: 1px solid #e5e5e5;
}
span.CP.mt-1.ps-3.small:hover {
  background: #e3e0d4;
}
span.CP.mt-1.ps-3.small:active {
  background: #e3e0d4;
  border-radius: 4px;
}

span.linkClass {
  padding: 6px 2px;
  display: flex;
  width: 100%;
  align-items: center;
  text-wrap: nowrap;
  overflow: hidden;
  font-size: 12px;
  border-bottom: 1px solid #e5e5e5;
}
span.linkClass:hover {
  background-color: rgba(16, 60, 94, 0.3411764706);
}
span.linkClass:active {
  background-color: rgba(16, 60, 94, 0.3411764706);
  border-radius: 4px;
}

.querymodel button {
  height: 20px;
}

.validInfo h1 {
  font-size: 15px;
  text-align: center;
  margin-top: 20px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.4705882353);
}

.validInfo p {
  font-size: 12px;
  text-align: justify;
  color: rgba(0, 0, 0, 0.4705882353);
  padding-right: 15px;
  height: 30vh;
  overflow: auto;
  margin: 0;
}

.highlighted {
  background-color: #ccd6dd !important;
}

a.mt-1.small {
  padding: 2px;
  transition: 1s;
}
a.mt-1.small:hover {
  background: #e3e0d4;
  border-radius: 5px;
}

.manag_section {
  overflow: auto;
  height: calc(100vh - 220px);
}
.manag_section .Management_section p {
  font-size: 12px;
  font-weight: 600;
}

#react-select-7-placeholder {
  font-size: 13px;
  font-weight: 300;
}

#react-select-6-placeholder {
  font-size: 13px;
  font-weight: 300;
}

#react-select-5-placeholder {
  font-size: 13px;
  font-weight: 300;
}

#react-select-4-placeholder {
  font-size: 13px;
  font-weight: 300;
}

#react-select-3-placeholder {
  font-size: 13px;
  font-weight: 300;
}

#react-select-2-placeholder {
  font-size: 13px;
  font-weight: 300;
}

.css-1dimb5e-singleValue {
  font-size: 13px;
  font-weight: 300;
}

.css-qbdosj-Input {
  margin: 0 !important;
}

.radio_check input {
  margin: 0 10px 0 0;
}

.all_promices {
  border: 1px dashed #e9ecef;
  padding: 5px 14px 0px;
}

.View_Full_Chart {
  background: #ee9e23;
  padding: 0 10px;
  border-radius: 3px;
  color: var(--white);
  font-weight: 700;
  cursor: pointer;
}

.trueClass {
  background-color: rgba(16, 60, 94, 0.3411764706);
}

.Open__query__icon {
  background: rgb(0, 143, 251) !important;
  color: rgb(0, 143, 251);
  height: 12px;
  width: 12px;
  left: 0px;
  top: 0px;
  border-width: 0px;
  border-color: rgb(255, 255, 255);
  border-radius: 2px;
  display: inline-block;
}

.Answered__query__icon {
  background: rgb(0, 227, 150) !important;
  color: rgb(0, 227, 150);
  height: 12px;
  width: 12px;
  left: 0px;
  top: 0px;
  border-width: 0px;
  border-color: rgb(255, 255, 255);
  border-radius: 2px;
  display: inline-block;
}

.Cancelled__query__icon {
  background: rgb(254, 176, 25) !important;
  color: rgb(254, 176, 25);
  height: 12px;
  width: 12px;
  left: 0px;
  top: 0px;
  border-width: 0px;
  border-color: rgb(255, 255, 255);
  border-radius: 2px;
  display: inline-block;
}

.Closed__query__icon {
  background: rgb(255, 69, 96) !important;
  color: rgb(255, 69, 96);
  height: 12px;
  width: 12px;
  left: 0px;
  top: 0px;
  border-width: 0px;
  border-color: rgb(255, 255, 255);
  border-radius: 2px;
  display: inline-block;
}

foreignObject {
  position: relative;
}

.apexcharts-legend.apexcharts-align-center.apx-legend-position-bottom {
  margin-top: 0;
}

.query_statuis_code_wrap {
  height: calc(100vh - 323px);
  overflow: auto;
}

.Assign_Permission_button {
  position: absolute;
  bottom: 174px;
  width: 100%;
  padding: 5px;
  background: var(--white);
}

.list_of_Role {
  height: calc(100vh - 230px);
  overflow: auto;
}

.all___buton_style .freeze {
  background: gray;
}
.all___buton_style .unfreeze,
.all___buton_style .lock,
.all___buton_style .unlock,
.all___buton_style .freeze {
  font-size: 12px;
  border-radius: 3px;
  border: none;
  color: green;
  padding: 2px 12px;
}
.all___buton_style .unfreeze,
.all___buton_style .unlock {
  background: #f8f9fa;
}
.all___buton_style .lock {
  background: red;
}

button.saveScreen {
  background: #103c5e;
  border: none;
  border-radius: 4px;
  font-size: 12px;
  padding: 2px 12px;
  color: var(--white);
}

.remark__modal textarea {
  width: 100%;
  height: 150px;
  border: 1px solid #e6e5e5;
  border-radius: 4px;
  resize: none;
  font-size: 11px;
  padding: 5px;
}

div#chart {
  padding: 15px;
  position: relative;
}

.center__data__chart {
  margin: 0 auto;
  position: absolute;
  top: 55%;
  left: 40%;
  transform: translate(-50%, -50%);
}

.table-responsive-dashboard {
  overflow-x: hidden;
  height: calc(100vh - 143px);
}

.user__info {
  background: #103c5e;
  color: var(--white);
  padding: 10px;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}

.activity__section {
  background: var(--white);
  margin-bottom: 5px;
  padding: 10px;
}

.activity__portal {
  height: calc(100vh - 342px);
  overflow: auto;
}
.activity__portal p {
  font-size: 12px;
}

.leftHeightOfSection {
  height: calc(100vh - 270px);
  overflow: auto;
  border-right: 1px solid rgba(128, 128, 128, 0.1411764706);
}

.activity__portal-study {
  height: calc(100vh - 231px);
  overflow: auto;
}
.activity__portal-study p {
  font-size: 12px;
}

.chart__overview h4 {
  font-size: 13px;
}

.doughtnutClass {
  border-radius: 4px;
}
.doughtnutClass .chart_yaxis_legend {
  position: relative;
}
.doughtnutClass .chart_yaxis_legend p {
  transform: rotate(-90deg);
  text-wrap: nowrap;
  margin: 25px;
  margin-top: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.doughtnutClass .chart_xaxis_legend p {
  text-align: center;
}

.substatus {
  text-align: right;
}

.substatus p {
  font-size: 13px;
  margin: 0;
}

.substatus p i[data-tooltip]:hover::before {
  content: attr(data-tooltip);
  position: absolute;
  background-color: #333;
  color: var(--white);
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.2s;
  z-index: 1;
}

.substatus p i[data-tooltip]:hover::after {
  content: "";
  position: absolute;
  border-style: solid;
  border-width: 5px;
  border-color: transparent transparent #333 transparent;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 0;
  transition: opacity 0.2s;
}

.substatus p i[data-tooltip]:hover::before,
.substatus p i[data-tooltip]:hover::after {
  opacity: 1;
}

.addUnit__source {
  padding: 5px;
  font-size: 30px;
  border-radius: 4px;
  cursor: pointer;
  transition: 1s;
}

svg.addUnit__source:hover {
  background: gray;
  color: var(--white);
}

.dbp__mode__color {
  color: #d1a213;
}

.qc__mode__color {
  color: #d82d2d;
}

.live__mode__color {
  color: #40c057;
  font-size: 12px;
}

.error__log span {
  font-size: 12px;
  color: red;
}

.selectrowcolor {
  background: rgb(204, 214, 221);
  cursor: pointer;
}

.withoutcolorrow {
  cursor: pointer;
}

.cdashShortleft {
  width: 40%;
  height: 100vh;
  border-right: 1px solid #dee2e6 !important;
}

.table-responsive-cdashLongleft {
  overflow-y: auto;
  position: relative;
}

span.keyButton {
  padding: 4px 10px;
  font-size: 10px;
  font-weight: bold;
  margin: 4px;
  border: 1px solid #000;
  display: flex;
  justify-content: center;
  border-radius: 4px;
}

span.keyButton:hover {
  background: rgba(0, 0, 0, 0.1411764706);
  cursor: pointer;
}

.keyboard {
  display: flex;
  justify-content: center;
}

.textKeyButton {
  font-size: 12px;
}

.enterKeyButton {
  padding: 8px;
  margin: 4px;
  border: 1px solid #103c5e;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  font-size: 12px;
  color: var(--white);
  width: 25%;
  background-color: #103c5e;
  cursor: pointer;
}

.enterKeyButton:hover {
  border: 1px solid #103c5e;
  color: #103c5e;
  background-color: var(--white);
  transition: 0.5s;
  font-weight: 600;
}

.cleanKeyButton {
  padding: 8px;
  margin: 4px;
  border: 1px solid #103c5e;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  font-size: 12px;
  width: 25%;
  color: #103c5e;
  background-color: var(--white);
  cursor: pointer;
}

.cleanKeyButton:hover {
  border: 1px solid #103c5e;
  color: var(--white);
  background-color: #103c5e;
  transition: 0.5s;
  font-weight: 600;
}

.keyBoardButtonTitle {
  cursor: pointer;
  border: 1px solid #103c5e;
  padding: 3px 18px;
  font-size: 12px;
  font-weight: 600;
  border-radius: 3px;
  color: #103c5e;
  transition: 1s;
}
.keyBoardButtonTitle:hover {
  background-color: #103c5e;
  color: var(--white);
  border: 1px solid #103c5e;
}

.keyBoardButtonTitleActive {
  background-color: #103c5e;
  color: var(--white);
  border: 1px solid #103c5e;
}

.letDataClass {
  font-size: 14px;
  margin-left: 60px;
}

button.clearButton {
  background-color: #103c5e;
  color: var(--white);
  border-radius: 3px;
  font-size: 12px;
  padding: 2px 15px;
  margin-top: 12px;
}

button.clearButton:hover {
  transition: 0.3s;
  background-color: var(--white) fff;
  color: #103c5e;
  border: 1px solid #103c5e;
  font-weight: 600;
}

.accessTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  padding: 15px;
}

.environmentinput {
  border: 1px solid #cacccd;
  width: 100%;
  height: 2.3rem;
}

.cursorPointer {
  cursor: pointer;
}

.details_of_forms_sign h4 {
  font-size: 17px;
  font-weight: 600;
}
.details_of_forms_sign p {
  font-size: 12px;
}
.details_of_forms_sign img {
  width: 100px;
}
.details_of_forms_sign span {
  color: red;
}
.details_of_forms_sign .date__box__ {
  border: 1px solid #e5e5e5;
  padding: 7px;
  border-radius: 4px;
  margin: 0;
}

.Header_Title p {
  font-size: 12px;
}
.Header_Title img {
  width: 100px;
}

.report_form {
  height: calc(100vh - 190px);
  overflow: auto;
  width: 65%;
  margin: 5px auto;
}

.sample_report_form .report_form_heading h6 {
  background: #eee;
  padding: 10px 0;
  text-align: center;
  font-weight: 600;
}
.sample_report_form .report_form_heading p {
  text-align: center;
  font-size: 12px;
}

.box__sign_ {
  border: 2px solid #e5e5e5;
  border-radius: 10px;
  padding: 20px 20px 10px;
  margin-bottom: 10px;
}

.formate_input input {
  width: 30px;
  margin: 0;
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 12px;
  height: 32px;
  border: 1px solid #dee2e6;
}
.formate_input .form-select {
  font-size: 12px;
  border-radius: 0;
}

.dd_formate input {
  display: flex;
  align-items: center;
  text-align: center;
  width: 100px;
  border: 1px solid #dee2e6;
  height: 32px;
  font-size: 12px;
}

.handle___print button {
  position: absolute;
  bottom: -50px;
  left: 6px;
}

button.updateProfile.print___extract_button {
  position: absolute;
  bottom: -51px;
  right: 40px;
}

.button____group button {
  background: none;
  transition: 1s;
}
.button____group button:hover {
  background: rgba(108, 117, 125, 0.368627451);
}
.button____group .activeChartType {
  background: rgba(108, 117, 125, 0.368627451);
}

.image_chart_image {
  border-bottom: 1px solid #e5e5e5;
  padding: 10px;
}
.image_chart_image img {
  width: 60px;
}

.inputText__Chart {
  padding: 10px;
}

button.button_group_year {
  margin: 0;
  background: var(--white);
  color: #000;
  border-color: #dee2e6;
  font-size: 14px;
  padding: 7px;
}

.graph__title__border {
  padding: 10px;
}

.btn:focus-visible {
  box-shadow: none !important;
}

button.button_group_year_active {
  background-color: #103c5e;
  color: var(--white);
}

/* LineNumberTextarea.css */
.editor {
  display: flex;
}

.line-numbers {
  width: 40px;
  padding: 4px;
  color: #103c5e;
  font-weight: 600;
}

.codeEditor {
  flex: 1 1;
  font-size: 14px;
  line-height: 1.4;
  border: 1px solid #ccc;
  resize: vertical;
  overflow: hidden;
  min-height: 243px;
}

:focus-visible {
  outline: none !important;
  box-shadow: none !important;
}

.tab_pane_height {
  height: calc(100vh - 508px);
  overflow: auto;
}

.tab_pane_height > div {
  cursor: pointer;
}

.tab_pane_height > div:hover {
  background: #efefef;
}

.reset_password__sections {
  width: 60%;
  margin: 0 auto;
  border: 1px solid #1f537a;
  border-radius: 10px;
}

.disablebutton {
  background: #918f8f !important;
  color: var(--white) !important;
  border: 1px solid transparent !important;
}

.chart_design_port {
  display: flex;
  justify-content: center;
  text-align: center;
  height: 320px;
}

.title_bar_items {
  border-radius: 4px;
  position: relative;
  padding: 9px;
}
.title_bar_items h6 {
  font-size: 13px;
  margin: 0;
  font-weight: 600;
}

.ForMDataInput {
  border-radius: 4px;
  position: relative;
}
.ForMDataInput h6 {
  font-size: 13px;
  margin: 0;
  font-weight: 600;
}

.title_bar_scroll_height {
  height: calc(100vh - 250px);
  overflow-x: hidden;
  width: 350px;
}

.title__bar_content {
  padding: 10px;
  border-radius: 4px;
  width: 328px;
  position: relative;
}
.title__bar_content .study__icon i {
  font-size: 9px;
  margin-right: 6px;
}

.lightGreenColor {
  color: #40c057;
}

.title__bar_value1 {
  border-radius: 3px;
  width: 100%;
}

.title__bar_value,
.title__bar_values {
  background: var(--white);
  border-radius: 3px;
}

.title__bar_value:hover,
.title__bar_value_active:hover {
  background-color: rgba(16, 60, 94, 0.3411764706);
}

.title__bar_value_active {
  background-color: rgba(16, 60, 94, 0.3411764706) !important;
  border-radius: 3px;
}

.Chart1 > div,
.Chart2 > div,
.Chart3 > div {
  width: 39px;
}

.graph_position {
  margin-right: 30px;
}

.threedots:after {
  content: "⠇";
  font-size: 16px;
}

.dropdown a {
  text-decoration: none;
  color: #262626;
  font-size: 13px;
}

.threedots:hover {
  background-color: grey;
  padding: 4px 2px 2px 6px;
  border-radius: 4px;
}

.dropdown_menus_tableview {
  min-width: 180px;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.74);
  z-index: 999;
  color: var(--white);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;
  overflow: hidden;
  line-height: 24px;
}
.dropdown_menus_tableview .dropdown-item:hover {
  background-color: rgba(0, 0, 0, 0.74) !important;
}

.data__justification {
  display: flex;
  overflow: auto;
}

.subject__idenetity i {
  font-size: 20px;
}

.subject__idenetity img {
  width: 18px;
  height: 18px;
}

.css-1jqq78o-placeholder {
  font-size: 12px;
}

.subject__details_need {
  height: calc(100vh - 340px);
  overflow: auto;
}
.subject__details_need p {
  line-height: 30px;
  white-space: nowrap;
}

.icon__bg {
  display: grid;
  gap: 2px;
}

.icon__bg i {
  background: #f0f0f0;
  padding: 4px;
  border-radius: 4px;
  font-size: 10px;
}

label.form-check-label,
.form-check {
  font-size: 12px;
}

.overview_left_section img {
  width: 100px;
}
.overview_left_section span {
  margin-bottom: 10px;
  padding: 4px 32px;
  text-align: center;
}
.overview_left_section p {
  font-size: 12px;
  margin: 0;
}

.titmeline__border {
  border-left: 1px solid #efefef;
}
.titmeline__border .timeline__section {
  background: #e0e0e0;
  height: calc(100vh - 170px);
  overflow: auto;
}

.timeline {
  padding: 10px;
}
.timeline .tl-content .tl-header {
  padding-left: 25.6px;
  border-left: 2px solid rgb(190, 172, 11);
  height: 80px;
  align-items: center;
}
.timeline .tl-contents .tl-header {
  padding-right: 25.6px;
  border-right: 2px solid rgb(190, 172, 11);
  text-align: end;
  align-items: center;
  height: 80px;
}
.timeline .tl-header {
  position: relative;
  display: grid;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.timeline .tl-header p {
  margin: 0;
}
.timeline .tl-header .tl-title {
  font-size: 12px;
  font-weight: 400;
}
.timeline .tl-header .tl-titles {
  font-size: 12px;
  font-weight: 400;
  white-space: nowrap;
}
.timeline .tl-header .tl-marker {
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%/50%;
  background: rgb(7, 230, 22);
  left: -15px;
  top: 50%;
  transform: translate(50%, -50%);
}
.timeline .tl-header .tl-marker-gray {
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%/50%;
  background: rgb(126, 131, 127);
  left: -15px;
  top: 50%;
  transform: translate(50%, -50%);
}
.timeline .tl-header .tl-marker-gray i {
  font-size: 11px;
  top: 2px;
  position: absolute;
  left: 2.5px;
}
.timeline .tl-header .tl-marker-red {
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%/50%;
  background: rgb(245, 6, 6);
  left: -15px;
  top: 50%;
  transform: translate(50%, -50%);
}
.timeline .tl-header .tl-marker-red i {
  font-size: 11px;
  top: 2px;
  position: absolute;
  left: 4px;
  color: var(--white);
}
.timeline .tl-header .tl-markers {
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%/50%;
  background: rgb(7, 230, 22);
  right: -0.9px;
  top: 50%;
  transform: translate(50%, -50%);
}
.timeline .tl-header .tl-markers-gray {
  display: block;
  position: absolute;
  width: 15px;
  height: 15px;
  border-radius: 50%/50%;
  background: rgb(126, 131, 127);
  right: -0.9px;
  top: 50%;
  transform: translate(50%, -50%);
}

.study_overview__rightsection {
  height: calc(100vh - 158px);
  overflow-x: hidden;
}

.forn_value__section p {
  margin: 0;
  font-size: 12px;
  padding: 5px;
}

#total-counter {
  counter-reset: totalPages;
}

#total-counter span {
  counter-increment: totalPages;
}

.page-counter:after {
  counter-increment: page;
  content: "Page " counter(page) " / " counter();
}

.graph__title img {
  cursor: pointer;
}

.studyvisitPlanData {
  height: calc(100vh - 143px);
  overflow: auto;
}

.subjectMileStoneData {
  height: calc(100vh - 170px);
  overflow: auto;
}

.border_body_box {
  margin: 10px;
  border-radius: 8px;
  border: 1px solid #dee2e6;
  padding: 5px;
}
.border_body_box p {
  font-size: 12px;
  margin: 0;
}

.Scorll___Query {
  overflow: auto;
  height: 340px;
}

.scroll__site_subject {
  overflow: auto;
  max-height: calc(100vh - 105px);
}

.border__right_query {
  border-right: 1px solid #dee2e6;
  max-height: calc(100vh - 105px);
  overflow: auto;
}

button#dropdown-split-basic {
  color: #000;
  padding: 0 9px;
}

.noHaveDropdown {
  margin-right: 25px;
}

td.green {
  color: green !important;
  font-weight: 600 !important;
}

td.red {
  color: red !important;
  font-weight: 600 !important;
}

.title_bar_items .btn.show:focus,
.title_bar_items .btn:focus,
.ForMDataInput .btn.show:focus,
.ForMDataInput .btn:focus,
.nombering__point .btn.show:focus,
.nombering__point .btn:focus {
  box-shadow: none !important;
  background-color: #ccc !important;
}

.nombering__point ul {
  margin: 0;
  padding: 0;
}

.nombering__point ul li {
  padding: 6px 12px;
  font-size: 12px;
  background: #f0f0f0;
  border-radius: 3px;
  margin: 10px 0px 0 5px;
}

.title_bar_items .dropdown-toggle::after,
.ForMDataInput .dropdown-toggle::after,
.nombering__point .dropdown-toggle::after {
  content: "⠇";
  border: none !important;
}

.nombering__point {
  padding: 5px;
  min-width: 100px;
}

.nombering__point button {
  padding: 0px;
}

.table-responsive-dashboard-study {
  height: calc(100vh - 155px);
  overflow-x: hidden;
}

#breadcrumb {
  list-style: none;
  display: inline-block;
  padding: 0;
  margin: 0px 0px;
}
#breadcrumb li {
  float: left;
}
#breadcrumb li a {
  color: var(--white);
  display: block;
  background: var(--blue);
  text-decoration: none;
  position: relative;
  height: 19px;
  line-height: 18px;
  padding: 0 10px 0 5px;
  margin-right: 23px;
  font-size: 12px;
}
#breadcrumb li:nth-child(even) a {
  background-color: var(--blue);
}
#breadcrumb li:nth-child(even) a:before {
  border-color: var(--blue);
  border-left-color: transparent;
}
#breadcrumb li:nth-child(even) a:after {
  border-left-color: var(--blue);
}
#breadcrumb li:first-child a {
  padding-left: 15px;
}
#breadcrumb li:first-child a:before {
  border: none;
}
#breadcrumb li:last-child a {
  padding-right: 15px;
}
#breadcrumb li:last-child a:after {
  border: none;
}
#breadcrumb li a:before, #breadcrumb li a:after {
  content: "";
  position: absolute;
  top: 0;
  border: 0 solid var(--blue);
  border-width: 10px 11px;
  width: 0;
  height: 0;
}
#breadcrumb li a:before {
  left: -20px;
  border-left-color: transparent;
}
#breadcrumb li a:after {
  left: 100%;
  border-color: transparent;
  border-left-color: var(--blue);
}
#breadcrumb li a:hover {
  background-color: #b8cfdf;
  color: #000;
}
#breadcrumb li a:hover:before {
  border-color: #b8cfdf;
  border-left-color: transparent;
}
#breadcrumb li a:hover:after {
  border-left-color: #b8cfdf;
}
#breadcrumb li a:active {
  background-color: #b8cfdf;
}
#breadcrumb li a:active:before {
  border-color: #b8cfdf;
  border-left-color: transparent;
}
#breadcrumb li a:active:after {
  border-left-color: #b8cfdf;
}

.twoFactor {
  display: flex;
  justify-content: center;
  font-size: 95px;
  color: limegreen;
}

.twoFATitle {
  justify-content: center;
  display: flex;
  font-weight: 600;
}

.qr__imag {
  display: flex;
  justify-content: center;
}

.study_icopn i,
.study_icopn svg {
  background: var(--white);
  width: 40px;
  height: 40px;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--blue);
}

.chart__overview .card {
  border-radius: 4px;
}
.chart__overview .card .card-title {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
.chart__overview .card .card-text:last-child {
  font-size: 13px;
}

.assign_icopn span {
  background: var(--white);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  color: green;
}

.height-home {
  height: calc(100vh - 150px);
  overflow: auto;
}

.progress-bar {
  background-color: #103c5e;
}

.fade.modal-backdrop {
  display: none !important;
}

.fade.modal.show {
  background: rgba(0, 0, 0, 0.3411764706) !important;
}

.tree_menu {
  font-size: 12px;
}

.toolbar i {
  border-radius: 2px;
  cursor: pointer;
  font-size: 12px;
  padding: 5px;
}

.toolbar .breadcrumb {
  margin: 0;
  font-size: 12px;
  height: 33px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}

.toolbar .sync {
  cursor: pointer;
  border-radius: 2px;
  font-size: 7px;
  padding: 5px;
  padding-top: 8px;
}

.table > thead.fixed-DocumentList-header {
  position: sticky;
  top: 0;
  z-index: 1;
}

.tableLibrary.custom-table th:last-child {
  width: 100% !important;
  table-layout: fixed;
}

.tableLibrary.custom-table {
  width: auto;
  max-width: max-content;
}

.custom-table {
  width: 100%;
  table-layout: fixed;
}

.custom-table.resizing {
  width: 100%;
  max-width: fit-content;
}

.tenderSwollan tr,
.tenderSwollan th,
.tenderSwollan td {
  overflow: inherit !important;
}

.custom-table th,
.custom-table td,
.query-table th,
.query-table td,
.data-table th,
.data-table td,
.signTable th,
.signTable td {
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  font-size: 11px !important;
}
.custom-table th,
.query-table th,
.data-table th,
.signTable th {
  resize: horizontal;
  background-color: #b8cfdf !important;
}

.custom-table th,
.custom-table td {
  padding: 5px !important;
}

.activeTabButton {
  background-color: #b8cfdf !important;
}

.table_final td {
  font-size: 13px;
  padding: 5px;
}

.action__buttons button {
  background: transparent;
  border: 1px solid var(--blue);
  height: 17px;
  padding: 4px;
  transition: 1s;
  width: 17px;
}
.action__buttons i {
  align-items: center;
  color: var(--blue);
  display: flex;
  font-size: 8px;
  justify-content: center;
}

.action__buttons button:hover i,
.close_circle i {
  color: var(--white) !important;
}

.close_circle {
  background: red !important;
  border: 1px solid red !important;
  transition: 1s;
}
.close_circle:hover {
  background: red !important;
  border: 1px solid red !important;
  color: var(--white) !important;
}

.buttonForTabs {
  background: #dedede;
  border-radius: 3px 3px 0 0;
  color: #000;
  font-size: 12px;
  min-width: 90px;
  padding: 3.4px 10px;
  text-align: center;
  transition: 1s;
  border: 0;
}
.buttonForTabs:hover {
  background: #b8cfdf;
}
.buttonForTabs.activee {
  background: var(--blue);
  color: var(--white);
}

.resizer-x,
.resizer-y {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 0;
  padding: 0;
  position: relative;
  transition: 1s;
}

.resizer-y {
  border-bottom: 1px solid var(--bs-border-color);
  border-top: 1px solid var(--bs-border-color);
  cursor: row-resize;
  flex-direction: column;
  z-index: 1;
}

.resizer-y:after,
.resizer-y:before {
  height: 1px;
  width: 16px;
}

.resizer-x:after,
.resizer-x:before,
.resizer-y:after,
.resizer-y:before {
  background: #737373;
  content: "";
  margin: 1px;
}

.custom-table input {
  border: 0;
  outline: none !important;
  padding: 6px;
}

.saperate_action_button {
  background: var(--white);
  border-radius: 20px;
  box-shadow: -10px 13px 60px 12px rgba(0, 0, 0, 0.2392156863);
  display: flex;
  padding: 2px 4px;
  position: absolute;
  right: 45px;
  gap: 3px;
}

.toolbar i.activee, .toolbar i:hover,
.sync.activee,
.sync:hover {
  background: var(--blue);
  color: var(--white);
  transition: 1s;
}

.form-check-input:checked {
  background-color: var(--blue) !important;
  border-color: var(--blue) !important;
}

.form-switch .form-check-input {
  width: 30px !important;
}

.form-check-input:focus {
  box-shadow: none !important;
}

.sidebar .link__tab {
  border-bottom: 1px solid var(--bs-border-color);
  transition: 1s;
}

.sidebar .link__tab .hstack .false {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sidebar__active {
  background: #ccd6dd;
}

.sidebar .link__tab .tab_url {
  font-size: 12px;
  text-decoration: none;
  color: var(--inactive_menu_color);
  padding: 7px 10px;
  white-space: nowrap;
  border-left: 4px solid transparent;
  cursor: pointer;
}

#resizeMe {
  table-layout: fixed;
  width: 100%;
}

#resizeMe th {
  resize: horizontal;
}

#resizeMe th,
#resizeMe td {
  border: 1px solid var(--border_color);
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
}

.rpv-open-button,
.rpv-open__input-wrapper,
[aria-describedby=rpv-core__tooltip-body-theme-switch],
[aria-describedby=rpv-core__tooltip-body-print],
[aria-describedby=rpv-core__tooltip-body-get-file],
[data-testid=properties__menu],
.rpv-core__menu-divider:last-child {
  display: none !important;
}

.rpv-core__tooltip-body {
  font-size: 12px !important;
  padding: 0px !important;
}

.rpv-default-layout__sidebar--opened {
  width: 200px !important;
}

.rpv-attachment__empty,
.rpv-bookmark__empty {
  padding: 20px !important;
  display: flex !important;
  align-items: center !important;
}

.rpv-page-navigation__current-page-input input {
  height: auto;
  padding: 2px 10px;
}

.rpv-core__menu-item {
  font-size: 11px;
}

.rpv-core__popover-body,
.rpv-core__textbox {
  font-size: 12px !important;
  border: 1px solid var(--bs-border-color) !important;
}

.rpv-core__arrow {
  border-bottom: 1px solid var(--bs-border-color) !important;
  border-right: 1px solid var(--bs-border-color) !important;
}

.rpv-default-layout__toolbar {
  border-top: 0;
  border-bottom: 1px solid var(--bs-border-color) !important;
}

.rpv-default-layout__sidebar-content--ltr {
  border-left: 1px solid var(--bs-border-color) !important;
}

.rpv-default-layout__sidebar--ltr {
  border-right: 1px solid var(--bs-border-color) !important;
}

.rpv-default-layout__container {
  border: 0 !important;
}

.rpv-default-layout__sidebar-headers,
.rpv-default-layout__toolbar {
  background-color: #f8f9fa !important;
}

button svg {
  width: 15px;
  height: 13px;
}

.efafdropdownmwnuList {
  padding: 0;
  font-size: 13px;
}

.efafdropdownmwnuList > div {
  cursor: pointer;
}

.efafdropdownmwnuList > div:hover {
  background: var(--border_color);
}

.efafdropdownmwnuList a:active,
.rpv-core__menu-item:focus,
.rpv-core__menu-item:hover {
  background: var(--blue) !important;
  color: white !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  margin: 0;
}

.dropdownbutton_access {
  border: none;
  padding: 3px 20px;
  font-size: 13px;
  font-weight: 600;
  border-radius: 3px;
  background: var(--blue) !important;
}

.redCross {
  font-size: 8px;
  padding: 1px;
  width: 16px;
}

.workFlowTableHeight {
  height: calc(100vh - 147px);
  overflow: auto;
}

a {
  cursor: pointer;
  border: none;
  outline: none;
  -webkit-user-select: none;
  user-select: none;
  background: none;
  box-shadow: none;
  text-decoration: none;
}

.btn-check:focus + .btn,
.btn:focus,
.btn-check:active + .btn:focus,
.btn-check:checked + .btn:focus,
.btn.active:focus,
.btn.show:focus,
.btn:active:focus {
  box-shadow: none;
}

.user_filter button {
  height: 30px;
  padding: 0px 10px;
  border-radius: 3px;
  background: transparent;
  border: 1px solid var(--blue);
  transition: 1s;
}

.user_filter button i,
.user_filter button p {
  font-size: 13px;
  color: var(--blue);
  background: transparent;
}

.user_filter input {
  border-radius: 3px 0px 0px 3px;
  border-right: 0 !important;
  height: 30px;
  font-size: 12px;
  border: 1px solid #00619a;
}

.user_filter input {
  width: 125px;
}

.user_filter button:hover i {
  color: var(--white);
}

.action__buttons button:hover,
.user_filter button:hover {
  border: 1px solid var(--blue) !important;
  background: var(--blue) !important;
}

.enevelop_image img {
  width: 141px !important;
  height: 121px !important;
  margin: 4px 0 !important;
  margin-left: 18px !important;
  border: none !important;
}

.enevelop_image p {
  top: 24%;
  left: 34%;
  color: var(--white);
  font-size: 12px;
}

.randomization-container {
  border-radius: 5px;
  padding: 20px;
  max-width: 600px;
  margin: 20px auto;
}

.randomization-title {
  background-color: #1f537a;
  padding: 10px;
  color: var(--white);
  border-radius: 5px 5px 0 0;
  margin: -20px -20px 20px -20px;
  font-size: 17px;
  font-weight: bold;
  text-align: center;
}

.randomization-details {
  display: flex;
  flex-direction: column;
}

.detail-item {
  padding: 5px 0;
}

.treatment {
  color: red;
  font-weight: bold;
}

.randomizer-link:hover {
  text-decoration: underline !important;
  color: red !important;
}

.trial-design-container {
  border: 1px solid #d1d1d1;
  border-radius: 4px;
  overflow: hidden;
  margin: 20px;
}

.trial-design-header {
  background-color: #1f537a;
  padding: 10px;
  color: var(--white);
  font-size: 13px;
  font-weight: bold;
}

.trial-design-options a {
  color: #007bff;
  text-decoration: none;
}

.trial-design-options a:hover {
  text-decoration: underline;
}

.trial-design-footer {
  border-top: 1px solid #d1d1d1;
}

.parameters {
  background-color: #f8f8f8;
  margin-right: 4px;
  width: 33%;
  margin-top: 7px;
  padding: 0;
}

.parameters button {
  background-color: transparent;
  color: initial;
  border: none;
  padding: 10px;
  cursor: pointer;
  font-size: 13px;
}

.parameters button.active {
  background-color: #1f537a;
  color: var(--white);
  border-radius: 4px;
  font-size: 13px;
}

.factor_modal {
  max-height: calc(75vh - 142px);
  overflow: auto;
}

.parameter_data {
  height: calc(100vh - 170px);
  overflow: auto;
}

.parameter_data .form-label {
  font-size: 12px;
  font-weight: 600;
}

.allTreatmentClass {
  border-bottom: 1px solid #d1d1d1;
  font-size: 13px;
  font-weight: bold;
}

.add_sponsor_field .input-group-text {
  font-size: 11px;
  background-color: #dedede;
  padding: 5px;
  border-radius: 3px;
  border-color: #dedede;
}

.selected-row {
  background-color: #ccd6dd !important;
}

.green-selected-row {
  background-color: #ccddce !important;
}

.chat {
  font-size: 1.6rem;
  background-color: #fff;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.receiverSays {
  display: flex;
  align-items: end;
  gap: 1.3rem;
}

.text-box-receiver .text p {
  background-color: #eff3f6;
  padding: 10px;
  width: fit-content;
  max-width: 250px;
  border-radius: 3px;
  font-size: 11px;
  margin: 0;
}

.text-box-receiver img,
.userSays img {
  width: 25px;
  height: 25px;
}

.text-box-receiver .text p:not(.text-box-receiver .text p:nth-of-type(1)) {
  margin-top: 0.5rem;
}

.userSays {
  margin-top: 0.5rem;
}

.userSays .text {
  display: flex;
  flex-direction: column;
  align-items: end;
}

.userSays .text p {
  background-color: #dff4fc;
  padding: 10px;
  width: fit-content;
  max-width: 250px;
  border-radius: 3px;
  font-size: 11px;
  margin: 0;
}

.userSays .text span,
.receiverSays .text span {
  font-size: 10px;
}

.userSays .text p:not(.userSays .text p:nth-of-type(1)) {
  margin-top: 0.5rem;
}

.userSays .text {
  text-align: -webkit-right;
}

.defaultFileHeight {
  height: calc(100vh - 162px);
  overflow: auto;
}

.dropzone {
  border: 1px dashed var(--bs-border-color);
  border-radius: 4px;
  text-align: center;
  cursor: pointer;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  height: 150px;
  width: 100%;
  justify-content: center;
  transition: 1s;
  background: var(--bs-body-bg);
}

.dropzone p {
  font-size: 10px;
  cursor: pointer;
  margin: 0;
}

.dropzone p.text-danger {
  z-index: 999;
}

.dropzone i {
  font-size: 40px;
  opacity: 0.4;
}

.overlay input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  z-index: 9;
}

.overlay .form-control:disabled {
  opacity: 0;
}

.GridItem {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.GridItem .GridBoxItem {
  width: 150px;
  text-align: left;
  margin: 5px 0px 0px 5px;
}
.GridItem .GridBoxItem p {
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  --webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
  margin-top: 7px;
  margin-bottom: 0;
}
.GridItem .GridBoxItem .gridBox {
  width: 150px;
  height: 125px;
  position: relative;
}
.GridItem .GridBoxItem .gridBox .details i {
  font-size: 40px;
  margin-bottom: 15px;
}
.GridItem .GridBoxItem .gridBox .details p {
  margin: 0;
  font-size: 10px;
}
.GridItem .GridBoxItem .gridBox .statusPower {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 25px;
  height: 25px;
  margin-top: 0px;
  transition: 1s;
  border-radius: 50%;
}
.GridItem .GridBoxItem .gridBox .statusPower i {
  padding: 2px;
  font-size: 12px;
}
.GridItem .GridBoxItem .gridBox .statusPower:hover {
  background: #dedede;
}
.GridItem .GridBoxItem .gridBox .viewPower {
  position: absolute;
  top: 30px;
  right: 2px;
  width: 25px;
  height: 25px;
  margin-top: 0px;
  transition: 1s;
  border-radius: 50%;
}
.GridItem .GridBoxItem .gridBox .viewPower i {
  padding: 2px;
  font-size: 12px;
}
.GridItem .GridBoxItem .gridBox .viewPower:hover {
  background: #dedede;
}
.GridItem .GridBoxItem .gridBox .disabled {
  opacity: 0.3;
  pointer-events: none;
  cursor: no-drop;
}
.GridItem .GridBoxItem .gridBox .deletePower {
  position: absolute;
  top: 82px;
  right: 2px;
  width: 25px;
  height: 25px;
  margin-top: 0px;
  transition: 1s;
  border-radius: 50%;
}
.GridItem .GridBoxItem .gridBox .deletePower i {
  padding: 2px;
  font-size: 12px;
}
.GridItem .GridBoxItem .gridBox .deletePower:hover {
  background: #dedede;
}
.GridItem .GridBoxItem .gridBox .downloadPower {
  position: absolute;
  top: 55px;
  right: 2px;
  width: 25px;
  height: 25px;
  margin-top: 0px;
  transition: 1s;
  border-radius: 50%;
}
.GridItem .GridBoxItem .gridBox .downloadPower i {
  padding: 2px;
  font-size: 12px;
}
.GridItem .GridBoxItem .gridBox .downloadPower:hover {
  background: #dedede;
}

.left-circle {
  position: relative;
  top: 20px;
  left: -20px;
  width: 40px;
  height: 40px;
  border: 1px dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.left-circle label {
  font-weight: 700;
  margin-top: 10px;
  opacity: 0.8;
}

.grid-wrap-left {
  padding: 20px;
  border-left: 1px dashed;
  border-bottom: 1px dashed;
  border-bottom-left-radius: 20px;
}
.grid-wrap-left p {
  font-size: 12px;
  margin-bottom: 5px;
  opacity: 0.8;
}

.right-circle {
  position: relative;
  top: -20px;
  left: 96%;
  width: 40px;
  height: 40px;
  border: 1px dashed;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.right-circle label {
  font-weight: 700;
  margin-top: 10px;
  opacity: 0.8;
}

.grid-wrap-right {
  display: grid;
  padding: 20px;
  margin: -40px auto;
  grid-gap: 0;
  border-right: 1px dashed;
  border-bottom: 1px dashed;
  border-bottom-right-radius: 20px;
}
.grid-wrap-right p {
  font-size: 12px;
  margin-bottom: 5px;
  opacity: 0.8;
}

.assignButton:hover {
  background: var(--blue) !important;
}

.tooltips .tooltiptext {
  z-index: 9999 !important;
}

.Apps .Apps_dd {
  min-width: 200px;
  position: absolute;
  top: 29px;
  background: #fff;
  z-index: 999;
  border-radius: 5px;
}
.Apps .Apps_dd label {
  color: var(--blue);
  padding: 6px 15px 0;
  border-bottom: 1px solid rgba(128, 128, 128, 0.1882352941);
  width: 100%;
  margin: 0;
  font-size: 13px;
}
.Apps .Apps_dd ul li {
  border-bottom: 1px solid rgba(128, 128, 128, 0.1882352941);
}
.Apps .Apps_dd ul li a {
  display: block;
  padding: 6px 15px;
  position: relative;
  font-weight: 500;
  font-size: 11px;
  color: var(--blue);
  text-decoration: none;
}
.Apps .Apps_dd ul li a:hover {
  color: var(--blue);
  background: rgba(16, 60, 94, 0.3411764706);
}
.Apps .Apps_dd ul li:last-child {
  border-bottom: 0;
}
.Apps .Apps_dd .Apps_ul {
  padding: 0;
  overflow: hidden;
  margin: 0;
  max-height: 0;
  transition: max-height 0.5s ease-in-out;
}
.Apps .icon_wrap .title_name {
  font-size: 14px;
}
.Apps .icon_wrap .title_name i {
  font-size: 14px;
  margin-top: 1px;
}

.AppsNameActive,
.title_name:hover {
  background: #fff;
  border-radius: 4px;
  color: var(--blue);
  transition: 1s;
}

.dotsNameActive,
.title_name_dots:hover {
  background: #e2e3e5;
  color: var(--blue);
  transition: 1s;
}

.Apps.active .Apps_ul {
  max-height: 300px;
  transition: max-height 0.5s ease-in-out;
  overflow: hidden;
}

.custom-checkbox .form-check-input {
  transform: scale(0.8);
  margin-right: 10px;
}

.custom-checkbox {
  display: flex;
  align-items: center;
}

.apexcharts-legend {
  right: 20px !important;
}

.tableLoader {
  height: 21px;
  aspect-ratio: 2.5;
  --_g: no-repeat radial-gradient(farthest-side, #103c5e 90%, #0080);
  background: var(--_g), var(--_g), var(--_g), var(--_g);
  background-size: 20% 50%;
  animation: l43 1s infinite linear;
}

@keyframes l43 {
  0% {
    background-position: 0% 50%, 33.3333333333% 50%, 66.6666666667% 50%, 100% 50%;
  }
  16.67% {
    background-position: 0% 0, 33.3333333333% 50%, 66.6666666667% 50%, 100% 50%;
  }
  33.33% {
    background-position: 0% 100%, 33.3333333333% 0, 66.6666666667% 50%, 100% 50%;
  }
  50% {
    background-position: 0% 50%, 33.3333333333% 100%, 66.6666666667% 0, 100% 50%;
  }
  66.67% {
    background-position: 0% 50%, 33.3333333333% 50%, 66.6666666667% 100%, 100% 0;
  }
  83.33% {
    background-position: 0% 50%, 33.3333333333% 50%, 66.6666666667% 50%, 100% 100%;
  }
  100% {
    background-position: 0% 50%, 33.3333333333% 50%, 66.6666666667% 50%, 100% 50%;
  }
}
.Profile_img label {
  font-weight: 700;
  margin-bottom: 5px;
}

.avatar-upload {
  position: relative;
  max-width: 190px;
  margin: 0px auto;
}

.avatar-upload .avatar-edit {
  position: absolute;
  right: 40px;
  z-index: 1;
  top: 10px;
}

.avatar-upload .avatar-edit input {
  display: none;
}

.avatar-upload .avatar-edit input + label {
  display: inline-block;
  width: 34px;
  height: 34px;
  margin-bottom: 0;
  border-radius: 50%;
  background: var(--bg-100);
  border: 1px solid transparent;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.avatar-upload .avatar-edit input + label:hover {
  background: var(--bg-300);
  border-color: var(--bg-300);
}

.avatar-upload .avatar-edit input + label:after {
  content: "\\f040";
  color: var(--text-100);
  position: absolute;
  top: 5px;
  left: 0;
  right: 0;
  text-align: center;
  margin: auto;
}

.avatar-upload .avatar-preview {
  width: 155px;
  position: relative;
  border-radius: 100%;
  border: 1px solid var(--border-color);
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}

.avatar-upload .avatar-preview img {
  border-radius: 50%;
  object-fit: cover;
  height: 155px;
}

.tabbars > svg {
  background: var(--bs-border-color);
  width: 25px;
  height: 27px;
  padding: 3px;
  cursor: pointer;
  border-radius: 3px 3px 0 0;
  transition: 1s;
}

.tablist {
  background: var(--bs-border-color);
  border-radius: 3px 3px 0 0;
  cursor: pointer;
}

.tabbars > svg:hover,
.tabButtons:hover,
.activee {
  background: var(--blue) !important;
  fill: #fff;
  color: #fff;
}

.tablist svg:hover {
  background: rgb(209, 217, 224);
  fill: var(--blue);
}

.timeline-card {
  display: flex;
  justify-content: center;
  align-items: baseline;
  position: relative;
}

.timeline-card-last {
  display: flex;
  align-items: baseline;
  justify-content: center;
  position: relative;
}

.timeline-card:first-of-type::before {
  content: "";
  width: 2px;
  height: 70px;
  background: #dfdfdf;
  position: absolute;
}

.circle-custom {
  font-size: 0.5rem !important;
}

.timeline-item {
  align-content: center;
  justify-items: start;
}

.subcard {
  position: relative;
  padding: 0.5em 1.5em;
  background: #fdfdfd;
  color: black;
}

.eSignDesignWrapper {
  display: grid;
  align-items: center;
  width: 100%;
  grid-auto-flow: column;
  justify-content: space-between;
}

.eSignDesign {
  position: relative;
  border: 2px solid green;
  border-right: 0px;
  border-radius: 4px 0 0 4px;
}

.esign {
  position: absolute;
  top: -8px;
  background-color: #fff;
  padding: 0 5px;
  font-size: 10px;
  width: 100%;
}

.esignId {
  position: absolute;
  bottom: -8px;
  background-color: #fff;
  padding: 0 5px;
  font-size: 10px;
  width: 100%;
}

@media screen {
  .print-only {
    display: none;
  }
}
.form-check-input[type=radio] {
  border: var(--bs-border-width) solid var(--blue);
}

.content .form-check-input[type=radio],
.radioMap .form-check-input[type=radio] {
  font-size: 13px;
  margin-top: 8px;
  border: var(--bs-border-width) solid var(--blue);
}

.h-285 {
  max-height: 285px !important;
}

.selectValues > div {
  text-align: center;
  width: 45px;
  justify-content: center;
  display: flex;
  transition: 0.5s;
  height: 26px;
}
.selectValues > div:hover, .selectValues > div.active {
  background: #ccd6dd;
}

.time_picker_container .wrapper {
  width: 100%;
  box-shadow: none;
  border: 0;
}
.time_picker_container .time_picker_preview {
  height: 32px;
}
.time_picker_container .react_times_button {
  box-shadow: none;
  border: 0;
}
.time_picker_container .time_picker_preview:not(.disabled).active,
.time_picker_container .time_picker_preview:not(.disabled):active {
  box-shadow: none;
}
.time_picker_container .time_picker_modal_header span {
  font-size: smaller;
}
.time_picker_container .time_picker_modal_header,
.time_picker_container .time_picker_modal_footer,
.time_picker_container .timezone_picker_modal_header {
  height: 35px;
  line-height: 30px;
  margin-bottom: 20px;
  background-color: #ccd6dd;
  color: #000000;
  font-size: larger;
  border-radius: 2px 2px 0 0;
}
.time_picker_container .preview_container {
  height: 35px;
  line-height: 30px;
  position: relative;
}
.time_picker_container .preview_container svg {
  width: 30px;
  height: 21px;
  top: 5px;
}
.time_picker_container .buttons_wrapper {
  display: none;
}

.scaleTemparature {
  width: 70px;
  height: 30px;
  border: 1px solid #ededed;
  transition: background-color 0.3s ease;
}

.cardHoverAdd {
  transition: 0.5s;
}

.cardHoverAdd:hover {
  background-color: rgba(0, 0, 0, 0.2) !important;
}

.step {
  font-size: 12px;
  display: contents;
  position: relative;
}

.step::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #ddd;
  z-index: -1;
}

.step.active > div {
  color: #fff;
  background-color: var(--blue) !important;
  border: 1px solid var(--blue) !important;
}

.step.active::before {
  background-color: var(--blue);
}

.envelope {
  position: relative;
  width: 95px;
  height: 50px;
  background-color: #b12a3d;
  transform-style: preserve-3d;
  transition: all 0.5s ease;
  perspective: 1000px;
  cursor: pointer;
}

.envelope .flap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background-color: rgba(70, 9, 9, 0.4784313725);
  clip-path: polygon(50% 51%, 100% 0%, 0% 0%);
  transform-origin: top;
  transform: rotateX(0deg);
  transition: transform 0.6s ease;
  box-shadow: inset 0px -5px 10px rgba(0, 0, 0, 0.3);
}

.envelope.open .flap {
  transform: rotateX(160deg);
}

.envelope .card_enevelop {
  position: absolute;
  top: 25%;
  left: 10%;
  right: 10%;
  width: 80%;
  height: 60%;
  background-color: white;
  color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  transform: translateY(100%);
  opacity: 0;
  transition: transform 0.6s ease, opacity 0.6s ease;
}

.envelope.open .card_enevelop {
  transform: translateY(0%);
  opacity: 1;
}

.card_enevelop p {
  margin: 0;
  font-size: 10px;
  text-align: center;
}

.envelope::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  transition: all 0.5s ease;
}

.envelope.open::before {
  opacity: 0;
}

.full-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: white;
}

.uploadLogo button {
  overflow: hidden;
  width: max-content;
  position: relative;
  cursor: pointer;
}

.uploadLogo button input {
  opacity: 0;
  cursor: pointer;
  position: absolute;
}

.uploadLogoPreview {
  border: 1px dashed var(--blue);
  border-radius: 3px;
  padding: 10px;
  width: 150px;
  height: 150px;
  overflow: hidden;
}

.rpv-core__page-layer::after {
  box-shadow: none !important;
  border: 1px solid var(--border_color);
}

.hover_actions {
  display: none;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}

.pageMapRender > div:hover .hover_actions {
  display: block;
  opacity: 1;
}

.hover-icon .hover-icon-visible {
  display: none;
}

.hover-icon .default-icon {
  display: inline;
}

.hover-icon:hover .default-icon {
  display: none;
}

.hover-icon:hover .hover-icon-visible {
  display: inline;
}

.showToolbar {
  display: none;
}

.showtextBox:hover .showToolbar {
  display: block;
}

.group-start {
  border-top: 2px solid black !important;
}

.group-end {
  border-bottom: 2px solid black !important;
}

/* General Rules For Range Slider */
.custom-rangeslider {
  position: relative;
  margin-top: 50px;
}

.custom-rangeInput,
.custom-rangeInputDisabled {
  width: 100%;
  background-color: transparent;
  height: 4px;
}

.custom-rangeInput::-webkit-slider-thumb {
  background-color: var(--blue);
  outline: 2px solid #fff;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: move;
  cursor: grab;
  margin-top: -8px;
}

.custom-rangeInputDisabled::-webkit-slider-thumb {
  background-color: transparent;
  outline: 2px solid transparent;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: default;
  margin-top: -8px;
}

.custom-rangeInput::-webkit-slider-thumb:active {
  cursor: grabbing;
}

.custom-rangeInput::-webkit-slider-runnable-track {
  height: 5px;
  width: 100%;
  cursor: pointer;
  border: none;
  padding: 0;
  margin: 0;
  background: transparent;
}

.custom-rangeInput:focus,
.custom-rangeInput:active {
  outline: none;
}

.custom-rangeslider__tooltip {
  position: absolute;
  width: 40px;
  padding: 3px;
  background-color: #fff;
  border: 1px solid var(--blue);
  top: -40px;
  text-align: center;
  border-radius: 3px;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
}

.custom-rangeslider__tooltip:after {
  display: block;
  content: " ";
  background: #fff;
  position: absolute;
  border: 1px solid var(--blue);
  border-top: 0;
  border-left: 0;
  width: 10px;
  height: 10px;
  left: calc(50% - 6px);
  bottom: -6px;
  transform: rotate(45deg);
}

.custom-rangeslider__label {
  width: 100%;
  display: block;
}

.custom-rangeslider__label span {
  display: block;
}

.custom-rangeslider__label-min {
  float: left;
}

.custom-rangeslider__label-max {
  float: right;
}

.custom-rangeslider__label:after {
  content: "";
  display: table;
  clear: both;
}

.Apps .Apps_dd ul li p {
  display: block;
  padding: 6px 15px;
  position: relative;
  font-weight: 500;
  font-size: 11px;
  color: var(--blue);
  text-decoration: none;
}

.innerHTML p {
  margin: 0;
  white-space: normal;
  width: 100%;
}

.rotate360 {
  animation: rotate 2s linear infinite;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.calendar-weekdays,
.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  text-align: center;
  padding: 5px;
}

.calendar-day {
  transition: 0.2s ease;
  border-radius: 50%;
}

.calendar-day:hover,
.clock-number:hover {
  background-color: var(--bg-blue-subtle);
  border: 1px solid var(--bs-border-color);
}

.calendar-day.today {
  border: 1px solid var(--bgGold);
}

.calendar-day.selected,
.clock-number.selected {
  background-color: var(--bgGold);
  font-weight: bold;
  border: 1px solid var(--bs-border-color);
  color: var(--textColor);
}

.headPrint {
  display: none;
}

@media print {
  body::before {
    content: "Confidential";
    position: fixed;
    top: 40%;
    left: 5%;
    font-size: 120px;
    color: rgba(150, 150, 150, 0.2);
    transform: rotate(-30deg);
    z-index: -1;
    white-space: nowrap;
  }
  @page {
    size: A4 !important;
    margin: 0.3in 0.5in 1in !important;
    @bottom-left {
      content: "This is an electronically authenticated report generated by Galax CTMS System";
      font-family: "Nunito", sans-serif !important;
      font-size: 12px;
    }
    @bottom-right {
      content: "Page " counter(page) " of " counter(pages);
      font-family: "Nunito", sans-serif !important;
      font-size: 12px;
    }
  }
  .headPrint {
    display: block;
  }
  .page-break {
    page-break-before: always;
    break-before: page;
  }
  table,
  thead,
  tbody,
  tr,
  td,
  th {
    break-inside: avoid;
    page-break-inside: avoid;
  }
  .actionBtn {
    display: none;
  }
  .crfHeader {
    width: 100% !important;
  }
}
.borderLight {
  border: 1px solid rgba(107, 107, 107, 0.1098039216) !important;
  border-bottom: 0px !important;
}

.borderLight:last-child {
  border-bottom: 1px solid rgba(107, 107, 107, 0.1098039216) !important;
}

.bg-blue-subtle {
  background-color: #f9fcfe !important;
}

.bg-purple-subtle {
  background-color: #daa6f7 !important;
}

.bg-purple {
  background-color: #c681ed !important;
}

.text-purple {
  color: #c681ed !important;
}

.border-purple {
  border-color: #c681ed !important;
}

.rsw-editor span,
.rsw-ce {
  font-size: 12px !important;
}

.rsw-dd {
  border: 0 !important;
  font-size: 12px !important;
  background-color: transparent !important;
}

.rsw-editor {
  border-radius: 3px !important;
}

.rsw-btn {
  font-size: 13px !important;
}

.rsw-btn svg {
  width: 15px !important;
  height: 15px !important;
  margin-top: 2px;
}

.rsw-ce:focus {
  outline: 1px solid transparent !important;
}

.fs-14 {
  font-size: 14px !important;
}

.swal2-shown {
  padding: 0px !important;
}

.ql-editor {
  min-height: 150px !important;
}

.folder-drag-over {
  background-color: #dbe6ef !important;
  animation: folderGlow 0.5s ease-in-out infinite alternate;
}

@keyframes folderGlow {
  from {
    box-shadow: 0 0 5px #7cc2fa;
  }
  to {
    box-shadow: 0 0 15px #62b1f1;
  }
}
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm),
div:where(.swal2-container) .swal2-input,
div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel) {
  font-size: 12px;
}

div:where(.swal2-container) div:where(.swal2-actions) {
  margin: 1em auto 0;
}

div:where(.swal2-container) h2:where(.swal2-title) {
  font-size: 18px;
  padding: 0.3em 1.6em 0.3em;
}

div:where(.swal2-container) div:where(.swal2-html-container) {
  font-size: 15px;
  padding: 0.3em 1.6em 0.3em;
}

div:where(.swal2-icon) .swal2-icon-content {
  font-size: 2.75em;
}

div:where(.swal2-icon) {
  width: 3em;
  height: 3em;
}

div:where(.swal2-container) div:where(.swal2-popup) {
  width: 20em;
}

.margin-view-overlays .line-numbers {
  font-size: 12px;
}

.decorationsOverviewRuler,
.scrollbar {
  width: 6px !important;
  height: 6px !important;
}

.log_change {
  background-color: #f5f5f5;
  background-size: 100%;
  border: 1px solid #d4d4d4;
  display: block;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 10px;
  overflow: visible;
  overflow-y: hidden;
  padding: 0 0 0 4px;
}

.step::before {
  display: none;
}

.builder-main {
  display: flex;
  flex: 1 1;
  overflow: hidden;
  position: relative;
}

/* Loading Animation */
@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}
.loading {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: shimmer 2s infinite;
}

/* Responsive Canvas */
@media (max-width: 1024px) {
  .builder-main {
    flex-direction: column;
  }
}
.elementor-sidebar {
  width: 320px;
  background: white;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);
}

.tab-btn.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #667eea;
}

.sidebar-content {
  overflow-y: auto;
  padding: 20px;
  height: calc(100vh - 210px);
}

/* Sections Library */
.sections-library h3,
.widgets-library h3 {
  font-size: 16px;
  margin-bottom: 16px;
  color: #333;
}

.sections-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Elementor-Style Icons */
.section-template svg,
.widget-item svg {
  width: 24px;
  height: 24px;
  stroke: currentColor;
  stroke-width: 1.5;
  transition: all 0.2s ease;
}

.section-template:hover svg,
.widget-item:hover svg {
  transform: scale(1.05);
  color: #667eea;
}

/* Icon container styling */
.template-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.widget-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  margin: 0 auto 8px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.0823529412) 0%, rgba(118, 75, 162, 0.0823529412) 100%);
  border-radius: 6px;
}

/* Category header icons */
.widget-category h4::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 16px;
  background: #667eea;
  margin-right: 8px;
  border-radius: 2px;
  vertical-align: middle;
}

/* Animation for icons */
@keyframes iconPop {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.section-template:active svg,
.widget-item:active svg {
  animation: iconPop 0.2s ease;
}

.section-template {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-template:hover {
  background: #e9ecef;
  transform: translateX(4px);
  border-color: #667eea;
}

.template-preview {
  width: 48px;
  height: 48px;
  background: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #ddd;
}

.preview-icon {
  font-size: 24px;
}

.template-info {
  flex: 1 1;
}

.template-info h4 {
  font-size: 14px;
  margin-bottom: 4px;
  color: #333;
}

.template-info p {
  font-size: 12px;
  color: #666;
  margin: 0;
}

/* Widgets Library */
.widget-category {
  margin-bottom: 24px;
}

.widget-category h4 {
  font-size: 13px;
  text-transform: uppercase;
  color: #999;
  margin-bottom: 12px;
  letter-spacing: 0.5px;
}

.widgets-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

.widget-item {
  background: #f8f9fa;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;
  cursor: grab;
  transition: all 0.2s ease;
  text-align: center;
  -webkit-user-select: none;
          user-select: none;
}

.widget-item:hover {
  background: #e9ecef;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-color: #667eea;
}

.widget-item:active {
  cursor: grabbing;
}

.widget-icon {
  font-size: 24px;
  display: block;
  margin-bottom: 8px;
}

.widget-name {
  font-size: 12px;
  color: #555;
  font-weight: 500;
}

/* Responsive */
@media (max-width: 1024px) {
  .elementor-sidebar {
    width: 280px;
  }
}
@media (max-width: 768px) {
  .elementor-sidebar {
    position: fixed;
    left: -100%;
    top: 0;
    height: 100%;
    z-index: 1000;
    transition: left 0.3s ease;
    width: 280px;
  }
  .elementor-sidebar.open {
    left: 0;
  }
}
.elementor-canvas {
  flex: 1 1;
  overflow-y: auto;
  padding: 10px 10px 0;
  transition: all 0.3s ease;
  height: calc(100vh - 182px);
}

.canvas-container {
  max-width: 1200px;
  margin: 0 auto;
}

/* Builder Section */
.builder-section {
  background: white;
  border-radius: 8px;
  margin-bottom: 10px;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
}

.builder-section:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
}

.builder-section.selected {
  outline: 2px solid #667eea;
  outline-offset: 2px;
}

.section-controls {
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  gap: 8px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
}

.builder-section:hover .section-controls {
  opacity: 1;
}

.section-control {
  padding: 4px 10px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.section-control:hover {
  background: #5a67d8;
  transform: translateY(-1px);
}

.section-control.delete {
  background: #fc8181;
}

.section-control.delete:hover {
  background: #f56565;
}

.section-drag-handle {
  padding: 4px 10px;
  background: #718096;
  color: white;
  border-radius: 4px;
  cursor: grab;
  font-size: 16px;
  -webkit-user-select: none;
          user-select: none;
}

.section-drag-handle:active {
  cursor: grabbing;
}

.section-content {
  padding: 20px;
  transition: all 0.3s ease;
}

/* Columns Container */
.columns-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.builder-column {
  flex: 1 1;
  min-width: 0;
  position: relative;
  transition: all 0.3s ease;
  border-radius: 6px;
}

.builder-column:hover {
  background: rgba(102, 126, 234, 0.05);
}

.column-header {
  position: absolute;
  top: -25px;
  left: 25;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.builder-column:hover .column-header {
  opacity: 1;
}

.column-label {
  font-size: 11px;
  color: #667eea;
  background: white;
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #667eea;
  font-weight: 500;
}

/* Widgets Container */
.widgets-container {
  min-height: 100px;
  padding: 10px;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.widgets-container.drag-over {
  background: rgba(102, 126, 234, 0.1);
  border: 2px dashed #667eea;
}

.empty-column {
  text-align: center;
  padding: 40px;
  color: #999;
  border: 2px dashed #ddd;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.empty-column:hover {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.05);
}

.empty-column p {
  margin: 0;
  font-size: 14px;
}

/* Empty Canvas */
.empty-canvas {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 182px);
}

.empty-message {
  text-align: center;
  padding: 60px;
}

.empty-icon {
  font-size: 80px;
  margin-bottom: 20px;
  opacity: 0.5;
}

.empty-message h3 {
  font-size: 24px;
  margin-bottom: 12px;
  color: #333;
}

.empty-message p {
  color: #666;
  font-size: 16px;
}

/* Responsive Columns */
@media (max-width: 768px) {
  .elementor-canvas {
    padding: 20px;
  }
  .columns-container {
    flex-direction: column;
    gap: 20px;
  }
  .builder-column {
    width: 100% !important;
  }
  .section-controls {
    top: -35px;
  }
  .section-control {
    padding: 4px 10px;
    font-size: 11px;
  }
}
/* Tablet View */
@media (max-width: 1024px) and (min-width: 769px) {
  .builder-section {
    margin-bottom: 25px;
  }
  .columns-container {
    gap: 15px;
  }
}
/* Drag and Drop Animation */
.dragging {
  opacity: 0.5;
  cursor: grabbing;
}

/* Animation for new elements */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.builder-section {
  animation: slideIn 0.3s ease;
}

.widget-renderer {
  position: relative;
  margin-bottom: 15px;
  padding: 15px;
  background: white;
  border: 2px solid transparent;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
}

.widget-renderer:hover {
  border-color: #ddd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.widget-renderer.selected {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

/* Widget Controls */
.widget-controls {
  position: absolute;
  top: -30px;
  right: 0;
  display: flex;
  gap: 6px;
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 10;
}

.widget-renderer:hover .widget-controls {
  opacity: 1;
}

.widget-control {
  padding: 4px 8px;
  background: #667eea;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.widget-control:hover {
  background: #5a67d8;
  transform: translateY(-1px);
}

.widget-control.delete {
  background: #fc8181;
}

.widget-control.delete:hover {
  background: #f56565;
}

.widget-drag-handle {
  padding: 4px 8px;
  background: #718096;
  color: white;
  border-radius: 4px;
  cursor: grab;
  font-size: 12px;
  -webkit-user-select: none;
          user-select: none;
}

.widget-drag-handle:active {
  cursor: grabbing;
}

/* Widget Editor */
.widget-editor {
  margin-bottom: 10px;
}

.widget-editor input,
.widget-editor textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  font-family: inherit;
  transition: all 0.2s ease;
}

.widget-editor input:focus,
.widget-editor textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.widget-editor textarea {
  min-height: 100px;
  resize: vertical;
}

/* Widget Content */
.widget-content {
  word-wrap: break-word;
}

/* Heading Widget */
.widget-heading {
  margin: 0;
  line-height: 1.2;
}

.widget-heading h1,
.widget-heading h2,
.widget-heading h3,
.widget-heading h4 {
  margin: 0;
}

/* Text Widget */
.widget-text {
  line-height: 1.6;
  color: #4a5568;
}

/* Button Widget */
.widget-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  transition: all 0.2s ease;
  cursor: pointer;
}

.widget-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.button-icon {
  font-size: 1.2em;
}

/* Image Widget */
.widget-image {
  text-align: center;
}

.widget-image img {
  max-width: 100%;
  height: auto;
  border-radius: 4px;
}

.image-caption {
  margin-top: 8px;
  font-size: 14px;
  color: #718096;
  text-align: center;
}

/* Video Widget */
.widget-video {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
}

.widget-video iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 8px;
}

/* Icon Widget */
.widget-icon {
  display: inline-block;
}

.widget-icon span {
  display: inline-block;
  transition: all 0.2s ease;
}

.widget-icon span:hover {
  transform: scale(1.1);
}

/* Divider Widget */
.widget-divider {
  margin: 20px 0;
}

/* Spacer Widget */
.widget-spacer {
  width: 100%;
}

/* Counter Widget */
.widget-counter {
  text-align: center;
}

.counter-number {
  font-size: 48px;
  font-weight: bold;
  margin-bottom: 10px;
}

.counter-title {
  font-size: 18px;
  color: #718096;
}

/* Progress Bar Widget */
.widget-progress {
  margin: 10px 0;
}

.progress-title {
  margin-bottom: 8px;
  font-weight: 500;
}

.progress-bar-container {
  background: #e2e8f0;
  border-radius: 4px;
  overflow: hidden;
}

.progress-bar-fill {
  position: relative;
  height: 30px;
  background: #667eea;
  transition: width 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 10px;
}

.progress-percentage {
  color: white;
  font-size: 12px;
  font-weight: 500;
}

/* Gallery Widget */
.widget-gallery {
  display: grid;
  gap: 10px;
}

.gallery-image {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  transition: transform 0.2s ease;
}

.gallery-image:hover {
  transform: scale(1.05);
}

/* Animation Classes */
.widget-renderer {
  animation: fadeInUp 0.3s ease;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
/* Responsive Widgets */
@media (max-width: 768px) {
  .widget-renderer {
    padding: 12px;
  }
  .widget-controls {
    top: -25px;
  }
  .widget-control {
    padding: 3px 6px;
    font-size: 10px;
  }
  .counter-number {
    font-size: 36px;
  }
  .progress-bar-fill {
    height: 25px;
  }
}
.settings-panel {
  display: flex;
  flex-direction: column;
  width: 300px;
  animation: slideInRight 0.3s ease;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 10px;
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;
}

.settings-header h3 {
  font-size: 18px;
  margin: 0;
  color: #333;
}

.close-btn {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}

.close-btn:hover {
  background: #e0e0e0;
  color: #333;
}

/* Settings Tabs */
.settings-tabs {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
  background: white;
}

.settings-tabs .tab {
  padding: 12px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #666;
  transition: all 0.2s ease;
  position: relative;
}

.settings-tabs .tab:hover {
  color: #667eea;
}

.settings-tabs .tab.active {
  color: #667eea;
}

.settings-tabs .tab.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background: #667eea;
}

/* Settings Content */
.settings-content {
  overflow: auto;
  padding: 20px;
  height: calc(100vh - 270px);
}

.settings-group {
  margin-bottom: 24px;
}

.settings-group h4 {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 16px;
  color: #333;
  padding-bottom: 8px;
  border-bottom: 1px solid #e0e0e0;
}

.setting-field {
  margin-bottom: 16px;
}

.setting-field label {
  display: block;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #555;
}

.setting-field input[type=text],
.setting-field input[type=number],
.setting-field input[type=url],
.setting-field select,
.setting-field textarea {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  transition: all 0.2s ease;
  font-family: inherit;
}

.setting-field input:focus,
.setting-field select:focus,
.setting-field textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);
}

.setting-field input[type=color] {
  width: 60px;
  height: 40px;
  padding: 2px;
  cursor: pointer;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.setting-field input[type=range] {
  width: 100%;
  margin: 10px 0;
}

/* Spacing Controls */
.spacing-controls {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
}

.spacing-field {
  text-align: center;
}

.spacing-field label {
  display: block;
  font-size: 11px;
  margin-bottom: 4px;
  color: #999;
}

.spacing-field input {
  width: 100%;
  padding: 6px;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 12px;
}

/* Checkbox and Radio */
.setting-field input[type=checkbox],
.setting-field input[type=radio] {
  margin-right: 8px;
  cursor: pointer;
}

.setting-field .checkbox-label,
.setting-field .radio-label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  margin-right: 16px;
}

/* Responsive */
@media (max-width: 1024px) {
  .spacing-controls {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 768px) {
  .settings-header {
    padding: 16px;
  }
  .settings-content {
    padding: 16px;
  }
}
/* Settings Animations */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.settings-group {
  animation: slideDown 0.3s ease;
}

/* Tooltips */
.setting-field {
  position: relative;
}

.tooltip {
  position: absolute;
  right: 0;
  top: 0;
  cursor: help;
}

.tooltip:hover::after {
  content: attr(data-tip);
  position: absolute;
  right: 0;
  top: 20px;
  background: #333;
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 100;
}

/* Loading State */
.settings-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
}

.settings-loading::after {
  content: "";
  width: 30px;
  height: 30px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.preview-mode {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, sans-serif;
  padding: 0;
  margin: 0;
  background: white;
}

.preview-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e0e0e0;
  padding: 16px 24px;
  position: sticky;
  top: 0;
  z-index: 100;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
}

.preview-header h1 {
  margin: 0;
  font-size: 24px;
  color: #333;
}

.preview-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.preview-section {
  margin-bottom: 40px;
}

.preview-section:last-child {
  margin-bottom: 0;
}

.preview-columns {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.preview-column {
  flex: 1 1;
  min-width: 0;
}

.preview-widget {
  margin-bottom: 20px;
}

/* Responsive Preview */
@media (max-width: 768px) {
  .preview-columns {
    flex-direction: column;
    gap: 20px;
  }
  .preview-content {
    padding: 20px;
  }
  .preview-header h1 {
    font-size: 20px;
  }
}
/* Print Styles */
@media print {
  .preview-header {
    display: none;
  }
  .preview-section {
    page-break-inside: avoid;
  }
}
.app-card {
  transition: all 0.3s ease;
  border: 1px solid #dee2e6;
}

.app-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 30px rgba(37, 99, 235, 0.15) !important;
  border-color: var(--blue) !important;
}

/* Analytics icon */
.study_icopn {
  transition: all 0.3s ease;
}

.study_icopn:hover {
  transform: scale(1.05);
}

.study_icopn img {
  transition: all 0.3s ease;
}

.study_icopn:hover img {
  transform: rotate(3deg);
}

/* Login Button */
.updateProfile {
  transition: all 0.3s ease;
}

.updateProfile:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.2);
}

.thin-toggle .form-check-input {
  width: 1.8rem !important;
  height: 13px !important;
  min-height: 13px !important;
  border-width: 1px;
}

.crfHeader {
  width: 100% !important;
  border: 1px solid rgba(107, 107, 107, 0.1098039216);
}

.crfTop {
  background: #1d426c;
  padding: 22px 30px;
}

.crfInfoRow {
  grid-template-columns: repeat(3, 1fr);
  background: #214c75;
}

.crfInfoRow.light {
  background: #fff;
}

.crfCell {
  padding: 5px 26px;
  border-right: 1px solid rgba(255, 255, 255, 0.15);
}

.crfInfoRow.light .crfCell {
  border-right: 1px solid #d9dfe6;
}

.crfCell:last-child {
  border-right: none;
}

.cellLabel {
  color: #b8d0e6;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.btn-link {
  text-decoration: none !important;
  color: #000 !important;
}

/* ============================================================
   DOCUMENT MANAGEMENT STYLES
   ============================================================ */
/* -------- Layout -------- */
.doc-mgmt {
  padding: 0;
}

.doc-mgmt-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
}

.doc-mgmt-header-left {
  flex: 1 1;
  min-width: 200px;
}

.doc-mgmt-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.doc-mgmt-crumb {
  font-family: "IBM Plex Mono", monospace;
  font-size: 11px;
  color: #7A909A;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  margin-bottom: 4px;
}

.doc-mgmt-title {
  font-size: 19px;
  font-weight: 700;
  letter-spacing: -0.2px;
  margin: 0;
}

.doc-mgmt-sub {
  font-size: 12.5px;
  color: #7A909A;
  margin: 2px 0 0 0;
}

.doc-mgmt-count {
  font-family: "IBM Plex Mono", monospace;
  font-size: 11.5px;
  color: #7A909A;
}

/* -------- Buttons -------- */
.btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  border-radius: 8px;
  border: 1px solid #C3D1D6;
  background: #FFFFFF;
  color: #15262C;
  font-size: 12.5px;
  font-weight: 600;
  padding: 7px 13px;
  cursor: pointer;
  transition: background 0.15s, filter 0.15s;
  white-space: nowrap;
  font-family: inherit;
}

.btn:hover {
  background: #EFF3F4;
}

.btn-sm {
  padding: 4px 9px;
  font-size: 11.5px;
  border-radius: 6px;
}

.btn-bad {
  background: #B42323;
  border-color: #B42323;
  color: #fff;
}

.btn-bad:hover {
  background: #8E1F1F;
}

/* -------- Panel -------- */
.doc-mgmt-panel {
  background: #FFFFFF;
  border: 1px solid #DCE5E8;
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(21, 38, 44, 0.06), 0 4px 14px rgba(21, 38, 44, 0.06);
  margin-bottom: 18px;
  overflow: hidden;
}

/* -------- Filters -------- */
.doc-mgmt-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid #DCE5E8;
  background: #FAFCFC;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.filter-group label {
  font-size: 10.5px;
  font-family: "IBM Plex Mono", monospace;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #7A909A;
  font-weight: 600;
}

.filter-group select,
.filter-group input {
  border: 1px solid #C3D1D6;
  border-radius: 7px;
  padding: 6px 9px;
  background: #fff;
  outline: none;
  font-size: 13px;
  font-family: inherit;
}

.filter-group select:focus,
.filter-group input:focus {
  border-color: #0E6E7E;
  box-shadow: 0 0 0 2px #E2F0F2;
}

.filter-checks {
  display: flex;
  gap: 14px;
  align-items: center;
  grid-column: 1/-1;
  flex-wrap: wrap;
}

.filter-checks label {
  display: flex;
  gap: 6px;
  align-items: center;
  font-size: 12.5px;
  color: #48606A;
  font-weight: 500;
  cursor: pointer;
}

.filter-spacer {
  flex: 1 1;
}

/* -------- Search Box -------- */
.search-box {
  position: relative;
  flex: 1 1;
  min-width: 220px;
}

.search-box input {
  width: 100%;
  border: 1px solid #C3D1D6;
  border-radius: 8px;
  padding: 8px 12px 8px 34px;
  background: #fff;
  outline: none;
  font-size: 13px;
  font-family: inherit;
}

.search-box input:focus {
  border-color: #0E6E7E;
  box-shadow: 0 0 0 2px #E2F0F2;
}

.search-box svg {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #7A909A;
}

/* -------- Table -------- */
.doc-mgmt-table-wrap {
  overflow-x: auto;
}

.doc-mgmt-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;
  min-width: 1100px;
}

.doc-mgmt-table thead th {
  position: sticky;
  top: 0;
  background: #F4F8F9;
  color: #48606A;
  font-size: 10.5px;
  font-family: "IBM Plex Mono", monospace;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
  text-align: left;
  padding: 9px 12px;
  border-bottom: 1px solid #C3D1D6;
  white-space: nowrap;
}

.doc-mgmt-table tbody td {
  padding: 9px 12px;
  border-bottom: 1px solid #DCE5E8;
  vertical-align: middle;
  white-space: nowrap;
}

.doc-mgmt-table tbody tr:hover {
  background: #F6FAFA;
}

.doc-mgmt-table tbody tr:last-child td {
  border-bottom: none;
}

.doc-deleted {
  opacity: 0.5;
}

.cell-strong {
  font-weight: 600;
}

.cell-sub {
  display: block;
  font-size: 11px;
  color: #7A909A;
}

.mono {
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
}

.file-cell {
  font-size: 11px;
}

.meta-badge {
  margin-left: 4px;
  font-size: 9px !important;
  padding: 1px 5px !important;
}

.action-cell {
  white-space: nowrap;
}

.action-cell .btn {
  margin-right: 4px;
}

.action-cell .btn:last-child {
  margin-right: 0;
}

.doc-mgmt-empty {
  padding: 34px;
  text-align: center;
  color: #7A909A;
  font-size: 13px;
}

/* -------- Badges -------- */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  padding: 2.5px 9px;
  white-space: nowrap;
  letter-spacing: 0.1px;
}

.badge-ok {
  background: #DCF3E6;
  color: #177245;
}

.badge-warn {
  background: #FCEFD4;
  color: #A05E03;
}

.badge-bad {
  background: #FBE2E2;
  color: #B42323;
}

.badge-info {
  background: #DFEAFB;
  color: #1D5FBF;
}

.badge-auth {
  background: #ECE4FA;
  color: #6633B8;
}

.badge-neutral {
  background: #E7EDEF;
  color: #5A6E77;
}

/* -------- Form -------- */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 13px;
}

.form-grid .full {
  grid-column: 1/-1;
}

.fg {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.fg label {
  font-size: 11.5px;
  font-weight: 600;
  color: #48606A;
}

.fg label .req {
  color: #B42323;
}

.fg input,
.fg select,
.fg textarea {
  border: 1px solid #C3D1D6;
  border-radius: 8px;
  padding: 8px 10px;
  outline: none;
  background: #fff;
  font-size: 13px;
  font-family: inherit;
}

.fg input:focus,
.fg select:focus,
.fg textarea:focus {
  border-color: #0E6E7E;
  box-shadow: 0 0 0 2px #E2F0F2;
}

/* -------- Animations -------- */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes pop {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: none;
    opacity: 1;
  }
}
/* -------- Responsive -------- */
@media (max-width: 920px) {
  .doc-mgmt-header {
    flex-direction: column;
    align-items: flex-start;
  }
  .doc-mgmt-header-right {
    width: 100%;
    justify-content: flex-start;
  }
  .doc-mgmt-filters {
    grid-template-columns: 1fr 1fr;
  }
  .filter-checks {
    grid-column: 1/-1;
  }
  .form-grid {
    grid-template-columns: 1fr;
  }
  .form-grid .full {
    grid-column: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/Styles/Style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB;EACE,4CAAA;AACF;;AAEA;EACE,gBAAA;EACA,uBAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,sCAAA;EAEA,wBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;EACA,2BAAA;EACA,kCAAA;AAAF;;AAGA;EACE,6BAAA;AAAF;;AAGA;EACE,2BAAA;EACA,eAAA;EACA,6BAAA;EACA,oBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;AAEE;EACE,aAAA;AAAJ;;AAIA;EACE,2BAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,8BAAA;AADF;;AAIA;EACE,wCAAA;EACA,wCAAA;AADF;;AAIA;EACE,mCAAA;AADF;;AAIA;EACE,eAAA;EACA,8BAAA;AADF;;AAIA;EACE,yBAAA;EACA,+BAAA;AADF;;AAIA;;EAEE,oCAAA;EACA,gCAAA;EACA,4CAAA;AADF;;AAIA;EACE,2BAAA;EACA,mCAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;AADF;;AAIA;EACE,+BAAA;AADF;AAII;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;AAFN;;AAOA;;EAEE,wBAAA;EACA,kCAAA;EACA,wCAAA;EACA,qCAAA;EACA,sBAAA;AAJF;AAME;;;;EAEE,eAAA;EACA,WAAA;AAFJ;AAKE;;EACE,0DAAA;AAFJ;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,kBAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,aAAA;AAHF;;AAMA;EACE,UAAA;AAHF;;AAMA;EACE,yBAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,eAAA;AAHF;;AAMA;EACE,uBAAA;AAHF;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,WAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,YAAA;AAHF;;AAMA,uEAAA;AAEA;;EAEE,uBAAA;EACA,UAAA;AAJF;;AAOA;EACE,iBAAA;EACA,8BAAA;EACA,kBAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AAJF;;AAOA;EACE,kBAAA;EACA,UAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;AAJF;;AAOA;EACE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAJF;;AAOA;EACE,iBAAA;AAJF;;AAOA;EACE,sBAAA;AAJF;;AAOA,4BAAA;AAEA;;EAEE,YAAA;EACA,8BAAA;EACA,yBAAA;AALF;;AAQA;;EAEE,UAAA;AALF;;AAQA;;EAEE,YAAA;EACA,mBAAA;EACA,eAAA;EACA,MAAA;AALF;;AAQA;;EAEE,wCAAA;AALF;;AAQA;;EAEE,2BAAA;AALF;;AAQA;EACE,+CAAA;AALF;;AAQA;;EAEE,iBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA,gDAAA;AAEA;EACE,YAAA;EACA,WAAA;AANF;;AASA;EACE,eAAA;EACA,YAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,iBAAA;EACA,kBAAA;AANF;;AASA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AANF;;AASA;EACE,SAAA;EACA,mBAAA;EACA,eAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;;EAEE,eAAA;AANF;;AASA;;;;;EAKE,0BAAA;EACA,6BAAA;AANF;;AASA;EACE,eAAA;AANF;;AASA;EACE,qBAAA;AANF;;AASA;;;;EAIE,eAAA;AANF;;AASA;EACE,4BAAA;AANF;;AASA;EACE,kCAAA;AANF;;AASA;EACE,kCAAA;EACA,8BAAA;EACA,eAAA;AANF;;AASA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,wBAAA;AANF;;AASA;EACE,YAAA;EACA,cAAA;AANF;;AASA;EACE,2BAAA;EACA,cAAA;AANF;;AASA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,2BAAA;AANF;;AASA;EACE,QAAA;AANF;;AASA;EACE,qBAAA;AANF;;AASA;EACE,gBAAA;EACA,QAAA;EACA,WAAA;AANF;;AASA;EACE,uBAAA;EACA,eAAA;AANF;;AASA;EACE,kCAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,WAAA;EACA,4BAAA;EACA,4BAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,YAAA;EACA,iBAAA;AANF;;AASA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;AANF;;AASA;EACE,UAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;AANF;;AASA;EACE,kBAAA;AANF;;AASA;EACE,cAAA;EACA,gBAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,cAAA;AANF;;AASA;EACE,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AANF;;AASA;EACE,6BAAA;AANF;;AASA;EACE,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AANF;;AASA;EACE,yBAAA;EACA,gBAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;EACE,YAAA;AANF;;AASA;EACE,6BAAA;EACA,UAAA;AANF;;AASA;;;EAGE,iBAAA;EACA,UAAA;EACA,YAAA;AANF;;AASA;EACE,iBAAA;EACA,UAAA;EACA,YAAA;AANF;;AASA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AANF;;AASA;EACE,mBAAA;AANF;;AASA;;EAEE,cAAA;EACA,gBAAA;AANF;;AASA;EACE,mBAAA;EACA,UAAA;AANF;;AASA;EACE,gBAAA;AANF;;AASA;EACE,4BAAA;EACA,8BAAA;EACA,YAAA;EACA,eAAA;AANF;;AASA;;EAEE,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;EACA,cAAA;AANF;AAQE;;EACE,mBAAA;EACA,YAAA;EACA,yBAAA;AALJ;;AASA;EACE,uBAAA;AANF;;AASA;;;;;;;;;EASE,+CAAA;AANF;;AASA;EACE,0BAAA;AANF;;AASA;EACE,uBAAA;EACA,gCAAA;EACA,UAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,cAAA;AANF;AAQE;EACE,eAAA;EACA,YAAA;EACA,qBAAA;AANJ;;AAUA;EACE,2BAAA;EACA,gBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,WAAA;EACA,2BAAA;EACA,aAAA;AAPF;AASE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAPJ;;AAWA;EACE,aAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,kCAAA;AARF;;AAWA;EACE,2BAAA;EACA,6CAAA;EACA,6CAAA;EACA,sBAAA;AARF;;AAWA;EACE,cAAA;EACA,4BAAA;AARF;;AAWA;EACE,cAAA;EACA,6BAAA;EACA,0BAAA;EACA,gCAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AARF;;AAWA;EACE,4BAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;;;EAGE,aAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,iBAAA;AARF;;AAWA;EACE,UAAA;EACA,gBAAA;EACA,aAAA;AARF;;AAWA;EACE,8BAAA;EACA,mCAAA;EACA,WAAA;AARF;;AAWA;EACE,6BAAA;EACA,UAAA;EACA,YAAA;AARF;;AAWA;EACE,6BAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,eAAA;AARF;;AAWA;EACE,oCAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,UAAA;EACA,iBAAA;EACA,aAAA;AARF;;AAWA;EACE,6BAAA;EACA,UAAA;EACA,YAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,YAAA;EACA,UAAA;AARF;;AAWA;EACE,WAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;EACA,YAAA;AARF;;AAWA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;AARF;;AAWA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AARF;;AAWA;EACE,qBAAA;EACA,UAAA;EACA,WAAA;AARF;;AAWA;;;;;EAKE,gBAAA;AARF;;AAWA;EACE,mBAAA;EACA,eAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,eAAA;AARF;;AAWA;;EAEE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,kBAAA;AARF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mCAAA;AARF;;AAWA;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,mCAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,sBAAA;AARF;;AAWA;EACE,6BAAA;EACA,mBAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE,sBAAA;AARF;;AAWA;EACE,sBAAA;AARF;;AAWA;EACE,qCAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AARF;;AAWA;EACE,cAAA;EACA,eAAA;EACA,YAAA;AARF;;AAWA;EACE,qBAAA;AARF;;AAWA;EACE,cAAA;AARF;;AAWA;EACE,eAAA;EACA,gBAAA;AARF;;AAWA;EACE,gBAAA;AARF;;AAWA;EACE,UAAA;EACA,aAAA;EACA,yCAAA;EACA,gBAAA;AARF;;AAWA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;AARF;;AAWA;EACE,YAAA;AARF;;AAWA;EACE;IACE,iBAAA;IACA,gBAAA;EARF;AACF;AAWA,yDAAA;AAEA;EACE,eAAA;AAVF;;AAoBA;EAmBE;IACE,WAAA;EAnCF;AACF;AAiDA;EACE;;IAEE,WAAA;EA/CF;EAkDA;IACE,WAAA;EAhDF;AACF;AAmDA;EACE;IACE,WAAA;EAjDF;EAoDA;IACE,WAAA;EAlDF;AACF;AAqDA;EACE;IACE,WAAA;EAnDF;AACF;AAsDA;EACE;;;;IAIE,WAAA;EApDF;EAuDA;IACE,eAAA;EArDF;AACF;AAwDA;EACE;IACE,WAAA;EAtDF;AACF;AAyDA;EACE;IACE,WAAA;EAvDF;AACF;AA0DA;EACE;IACE,WAAA;EAxDF;AACF;AA2DA;EACE;IACE,WAAA;EAzDF;AACF;AA4DA;EACE;IACE,WAAA;EA1DF;AACF;AA6DA;EACE;IACE,WAAA;EA3DF;EA8DA;IACE,WAAA;EA5DF;AACF;AA+DA,0DAAA;AAEA,2DAAA;AAEA;EACE,WAAA;EACA,eAAA;AA/DF;;AAkEA;EACE;IACE,WAAA;EA/DF;AACF;AAkEA;EACE;IACE,WAAA;EAhEF;AACF;AAmEA;EACE;IACE,WAAA;EAjEF;AACF;AAoEA;EACE;IACE,WAAA;EAlEF;AACF;AAqEA;EACE;IACE,WAAA;EAnEF;AACF;AAsEA;EACE;IACE,WAAA;EApEF;AACF;AAuEA;EACE;IACE,WAAA;EArEF;AACF;AAwEA,2DAAA;AAEA,2DAAA;AAEA;EACE,aAAA;AAxEF;;AA2EA;EACE,UAAA;AAxEF;;AA2EA;EACE,YAAA;EACA,gBAAA;AAxEF;;AA2EA;EACE;IACE,WAAA;EAxEF;AACF;AA2EA;EACE;IACE,WAAA;EAzEF;AACF;AA4EA;EACE;IACE,WAAA;EA1EF;EA6EA;IACE,WAAA;EA3EF;AACF;AA8EA;EACE;IACE,WAAA;EA5EF;EA+EA;IACE,WAAA;EA7EF;AACF;AAgFA;EACE;IACE,WAAA;EA9EF;EAiFA;IACE,WAAA;EA/EF;AACF;AAkFA;EACE;IACE,WAAA;EAhFF;EAmFA;IACE,WAAA;EAjFF;AACF;AAoFA;EACE;IACE,aAAA;IACA,sBAAA;EAlFF;EAqFA;;;;IAIE,WAAA;EAnFF;AACF;AAsFA;EACE;IACE,WAAA;EApFF;AACF;AAuFA;EACE;IACE,WAAA;EArFF;EAwFA;IACE,WAAA;EAtFF;AACF;AAyFA;EACE;IACE,WAAA;EAvFF;EA0FA;IACE,WAAA;EAxFF;AACF;AA2FA;EACE;IACE,WAAA;EAzFF;EA4FA;IACE,WAAA;EA1FF;AACF;AA6FA;EACE;IACE,WAAA;EA3FF;EA8FA;IACE,WAAA;EA5FF;AACF;AA+FA;EACE;IACE,WAAA;EA7FF;EAgGA;IACE,WAAA;EA9FF;AACF;AAiGA,2DAAA;AAEA,2DAAA;AAEA;EACE,UAAA;AAjGF;;AAoGA;EACE,YAAA;EACA,gBAAA;AAjGF;;AAoGA;EACE,WAAA;AAjGF;;AAoGA;EACE;IACE,WAAA;EAjGF;AACF;AAoGA;EACE;IACE,WAAA;EAlGF;AACF;AAqGA;EACE;IACE,WAAA;EAnGF;AACF;AAsGA;EACE;IACE,WAAA;EApGF;AACF;AAuGA;EACE;IACE,WAAA;EArGF;AACF;AAwGA;EACE;IACE,WAAA;EAtGF;AACF;AAyGA;EACE;IACE,WAAA;EAvGF;AACF;AA0GA;EACE;IACE,aAAA;IACA,sBAAA;EAxGF;EA2GA;;;IAGE,WAAA;IACA,WAAA;EAzGF;AACF;AA4GA;EACE;IACE,WAAA;EA1GF;EA6GA;IACE,WAAA;EA3GF;AACF;AA8GA;EACE;IACE,WAAA;EA5GF;EA+GA;IACE,WAAA;EA7GF;AACF;AAgHA;EACE;IACE,WAAA;EA9GF;EAiHA;IACE,WAAA;EA/GF;AACF;AAkHA;EACE;IACE,WAAA;EAhHF;EAmHA;IACE,WAAA;EAjHF;AACF;AAoHA;EACE;IACE,WAAA;EAlHF;EAqHA;IACE,WAAA;EAnHF;AACF;AAsHA,2DAAA;AAEA;EACE,UAAA;EACA,gBAAA;EACA,aAAA;AArHF;;AAwHA;EACE,WAAA;EACA,kBAAA;AArHF;;AAwHA;EACE,WAAA;EACA,YAAA;AArHF;;AAwHA;EACE,UAAA;AArHF;;AAwHA;EACE,kBAAA;AArHF;;AAwHA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AArHF;;AAwHA;EACE,uBAAA;EACA,YAAA;AArHF;;AAwHA;EACE,iCAAA;EACA,YAAA;AArHF;;AAwHA;EACE,UAAA;AArHF;;AAwHA;EAME,aAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;AA1HF;;AA6HA;EACE,yBAAA;AA1HF;;AA6HA;;EAEE,oCAAA;AA1HF;;AA6HA;EACE,yBAAA;AA1HF;;AA6HA;EACE,yBAAA;EACA,oBAAA;AA1HF;;AA6HA;EACE,sBAAA;AA1HF;;AA6HA;EACE,iCAAA;AA1HF;;AA6HA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;AA1HF;;AA6HA;EACE,qCAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;AA1HF;;AA6HA;EAEE,gBAAA;EACA,iBAAA;AA3HF;;AA8HA;EACE,YAAA;EACA,iBAAA;EACA,aAAA;AA3HF;;AA8HA;EACE,aAAA;AA3HF;;AA8HA;EACE,aAAA;AA3HF;;AA8HA;EACE,aAAA;AA3HF;;AA8HA;EACE,iCAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AA3HF;;AA8HA;EACE,WAAA;EACA,YAAA;EACA,WAAA;AA3HF;;AA8HA;EACE,WAAA;EACA,YAAA;AA3HF;;AA8HA;EACE,iBAAA;EACA,UAAA;AA3HF;;AA8HA;EACE,kBAAA;AA3HF;;AA8HA;EACE,kBAAA;AA3HF;;AA8HA;EACE,iBAAA;AA3HF;;AA8HA;EACE,iBAAA;AA3HF;;AA8HA;;;EAGE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;AA3HF;;AA8HA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AA3HF;;AA8HA;EACE,oBAAA;AA3HF;;AA8HA;EACE,kBAAA;AA3HF;;AA8HA;EACE,oBAAA;AA3HF;;AA8HA;EACE,mBAAA;AA3HF;;AA8HA;EACE,UAAA;EACA,kBAAA;AA3HF;;AA8HA;EACE,UAAA;AA3HF;;AA8HA;EACE,UAAA;AA3HF;;AA8HA;EACE,cAAA;AA3HF;;AA8HA;EACE,yBAAA;AA3HF;;AA8HA;EACE,yBAAA;AA3HF;;AA8HA;EACE,UAAA;EACA,aAAA;EACA,cAAA;AA3HF;;AA8HA;EACE,aAAA;AA3HF;;AA8HA;EACE,aAAA;EACA,YAAA;EACA,gBAAA;AA3HF;;AA8HA;EACE,yBAAA;AA3HF;;AA8HA;EACE,YAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;AA3HF;;AA8HA;EACE,aAAA;AA3HF;;AA8HA;EACE,mCAAA;AA3HF;;AA8HA;EACE,aAAA;AA3HF;;AA8HA;;EAEE,WAAA;EACA,eAAA;AA3HF;;AA8HA;EACE,YAAA;AA3HF;;AA8HA;EACE,8BAAA;AA3HF;;AA8HA;EACE,UAAA;EACA,aAAA;AA3HF;;AA8HA;EACE,UAAA;EACA,aAAA;AA3HF;;AA8HA;EACE,yBAAA;EACA,YAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;AA3HF;;AA8HA;EACE,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AA3HF;;AA8HA;EACE,YAAA;EACA,mCAAA;AA3HF;;AA8HA;EACE,8BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;AA3HF;;AA8HA;EACE,WAAA;EACA,mBAAA;AA3HF;;AA8HA;EACE,mBAAA;AA3HF;;AA8HA;EACE,YAAA;AA3HF;;AA8HA;;EAEE,YAAA;AA3HF;;AA8HA;EACE,YAAA;EACA,8BAAA;AA3HF;;AA8HA;;EAEE,YAAA;AA3HF;;AA8HA;EACE,YAAA;AA3HF;;AA8HA;EACE,YAAA;AA3HF;;AA8HA;EACE,YAAA;AA3HF;;AA8HA;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;AA3HF;;AA8HA;EACE,oBAAA;EACA,gBAAA;EACA,kBAAA;AA3HF;;AA8HA;EACE;IACE,aAAA;EA3HF;AACF;AA8HA;;EAEE,YAAA;AA5HF;;AA+HA;;;EAGE,eAAA;EACA,iBAAA;EACA,gBAAA;AA5HF;;AA+HA;EACE,UAAA;EACA,gBAAA;AA5HF;;AA+HA;EACE,oBAAA;AA5HF;;AA+HA;EACE,mCAAA;EACA,gBAAA;AA5HF;;AA+HA;EACE,qBAAA;AA5HF;;AA+HA;EACE,UAAA;EACA,aAAA;AA5HF;;AA+HA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AA5HF;;AA+HA;EACE,iCAAA;AA5HF;;AA+HA;EACE,qBAAA;AA5HF;;AA+HA;EACE;IACE,aAAA;EA5HF;AACF;AA+HA;EACE;IACE,aAAA;EA7HF;AACF;AAgIA;EACE;IACE,aAAA;EA9HF;AACF;AAiIA;EACE;IACE,aAAA;EA/HF;AACF;AAkIA,kEAAA;AAEA;EACE,uBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,wCAAA;AAjIF;AAmIE;EACE,mBAAA;EACA,8BAAA;EACA,wCAAA;AAjIJ;AAoIE;EACE,mBAAA;EACA,8BAAA;EACA,wCAAA;AAlIJ;;AAsIA;EACE,oCAAA;EACA,4BAAA;AAnIF;;AAsIA;EACE,wCAAA;AAnIF;;AAsIA;EACE,yBAAA;AAnIF;;AAsIA;EACE,wBAAA;AAnIF;;AAsIA;EACE,kCAAA;AAnIF;;AAsIA;EACE,yBAAA;AAnIF;;AAsIA;EACE,WAAA;AAnIF;;AAsIA;EACE,cAAA;AAnIF;;AAsIA;EACE,WAAA;AAnIF;;AAsIA;EACE,wBAAA;AAnIF;;AAsIA;EACE,0BAAA;AAnIF;;AAsIA;EACE,kBAAA;AAnIF;;AAsIA;EACE,oCAAA;AAnIF;;AAsIA;EACE,yBAAA;AAnIF;;AAsIA;EACE,uBAAA;AAnIF;;AAsIA;EACE,yBAAA;AAnIF;;AAsIA;EACE,yBAAA;AAnIF;;AAsIA;EACE,uBAAA;AAnIF;;AAsIA;EACE,aAAA;AAnIF;;AAsIA;;;EAGE,kBAAA;AAnIF;;AAsIA;;EAEE,kBAAA;AAnIF;;AAsIA;EACE,oBAAA;AAnIF;;AAsIA;EACE,iBAAA;AAnIF;;AAsIA;EACE,kBAAA;AAnIF;;AAsIA;EACE,kBAAA;AAnIF;;AAsIA;;EAEE,YAAA;EACA,mCAAA;AAnIF;;AAsIA;EACE,8BAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;AAnIF;;AAsIA;EACE,aAAA;AAnIF;;AAsIA;EACE,YAAA;EACA,+BAAA;AAnIF;;AAsIA;EACE,gBAAA;AAnIF;;AAsIA;EACE,UAAA;EACA,mBAAA;AAnIF;;AAsIA;EACE,YAAA;AAnIF;;AAsIA;EACE,oCAAA;AAnIF;;AAsIA;EACE,YAAA;EACA,eAAA;EACA,mBAAA;AAnIF;;AAsIA;EACE,WAAA;AAnIF;;AAsIA;EACE,UAAA;AAnIF;;AAsIA;EACE,YAAA;AAnIF;;AAsIA;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAnIF;;AAsIA;EACE,oCAAA;AAnIF;;AAsIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,oBAAA;EACA,4BAAA;EACA,oCAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,mCAAA;EACA,oBAAA;AAnIF;;AAsIA;EACE,6BAAA;EACA,YAAA;EACA,yBAAA;AAnIF;;AAsIA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAnIF;;AAsIA;EACE,uBAAA;AAnIF;;AAsIA;EACE,yBAAA;AAnIF;;AAsIA;;EAEE,8BAAA;AAnIF;;AAsIA;EACE,aAAA;AAnIF;;AAsIA;EACE,cAAA;EACA,oBAAA;AAnIF;;AAsIA;EACE,yBAAA;EACA,kBAAA;AAnIF;;AAsIA;EACE,kBAAA;EACA,gBAAA;AAnIF;;AAsIA;EACE,eAAA;EACA,kBAAA;AAnIF;;AAsIA;EACE,UAAA;EACA,YAAA;AAnIF;;AAsIA;EACE,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAnIF;;AAsIA;;EAEE,uBAAA;AAnIF;;AAsIA;EACE,SAAA;EACA,gBAAA;AAnIF;;AAsIA;EACE,eAAA;AAnIF;;AAsIA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;AAnIF;;AAsIA;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AAnIF;AAqIE;EACE,kCAAA;EACA,sBAAA;AAnIJ;;AAuIA;EACE,kBAAA;AApIF;;AAuIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;EACA,2BAAA;AApIF;;AAuIA;EACE,uBAAA;EACA,YAAA;EACA,uBAAA;EACA,qBAAA;AApIF;;AAuIA;EACE,kBAAA;AApIF;;AAuIA;EACE,6BAAA;EACA,UAAA;EACA,MAAA;AApIF;;AAuIA;EACE,kCAAA;AApIF;;AAuIA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;AApIF;;AAuIA;EACE,cAAA;AApIF;;AAuIA;EACE;IACE,2BAAA;EApIF;AACF;AAuIA,yDAAA;AAEA,UAAA;AACA;EACE,UAAA;EACA,WAAA;AAtIF;;AAyIA;EACE,eAAA;AAtIF;;AAyIA;EACE,UAAA;EACA,WAAA;AAtIF;;AAyIA,WAAA;AACA;EACE,mBAAA;AAtIF;;AAyIA;EACE,uBAAA;EACA,YAAA;EACA,iBAAA;AAtIF;;AAyIA;EACE,kBAAA;AAtIF;;AAyIA;EACE,6BAAA;AAtIF;;AAyIA;EACE,uBAAA;EACA,YAAA;EACA,yBAAA;AAtIF;;AAyIA;EACE,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAtIF;;AAyIA;EACE,eAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAtIF;;AAyIA;EACE,YAAA;EACA,YAAA;EACA,iBAAA;AAtIF;;AAyIA;EACE,kBAAA;AAtIF;;AAyIA;EACE,YAAA;EACA,8BAAA;AAtIF;;AAyIA;EACE,iBAAA;EACA,gBAAA;AAtIF;;AAyIA;EACE,gBAAA;EACA,kBAAA;AAtIF;;AAyIA;EACE,YAAA;AAtIF;;AAyIA;EACE,WAAA;AAtIF;AAwIE;EACE,WAAA;EAEA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAvIJ;AA0IM;EACE,aAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,2BAAA;AAxIR;AA0IQ;EACE,aAAA;EACA,YAAA;EACA,8BAAA;AAxIV;AA8IE;EACE,cAAA;EACA,+BAAA;EACA,gBAAA;AA5IJ;;AAgJA;EACE,wBAAA;EACA,mBAAA;AA7IF;;AAgJA;;EAEE,aAAA;AA7IF;;AAgJA;EACE,YAAA;AA7IF;;AAgJA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AA7IF;;AAgJA;EACE,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA7IF;AA+IE;EACE,qBAAA;AA7IJ;;AAiJA;EACE,WAAA;EACA,gCAAA;EACA,YAAA;EACA,YAAA;AA9IF;AAgJE;EACE,iBAAA;AA9IJ;;AAkJA;EACE,WAAA;EACA,gCAAA;EACA,aAAA;AA/IF;;AAkJA;EACE,WAAA;EACA,gCAAA;AA/IF;;AAkJA;EACE,iBAAA;AA/IF;;AAkJA;EACE,iBAAA;AA/IF;;AAkJA;EACE,WAAA;EACA,gCAAA;EACA,YAAA;AA/IF;;AAkJA;EACE,eAAA;EACA,eAAA;EACA,uBAAA;AA/IF;;AAkJA;EACE,2BAAA;EACA,WAAA;EACA,cAAA;AA/IF;;AAkJA;EACE,YAAA;AA/IF;;AAkJA;EACE,oCAAA;AA/IF;;AAkJA;EACE,sCAAA;EACA,aAAA;EACA,qBAAA;EACA,YAAA;AA/IF;;AAkJA;EACE,mBAAA;AA/IF;;AAkJA;EACE,aAAA;AA/IF;;AAkJA;EACE,0BAAA;AA/IF;;AAkJA;EACE;IACE,YAAA;EA/IF;AACF;AAkJA;EACE;IACE,kBAAA;EAhJF;AACF;AAmJA,yDAAA;AAEA;EACE;IACE,mBAAA;EAlJF;EAqJA;IACE,aAAA;EAnJF;EAsJA;IACE,WAAA;EApJF;AACF;AAuJA;EACE;IACE,mBAAA;EArJF;EAwJA;IACE,WAAA;EAtJF;AACF;AAyJA;EACE;IACE,mBAAA;EAvJF;AACF;AA0JA;EACE;IACE,mBAAA;EAxJF;AACF;AA2JA;EACE;IACE,mBAAA;EAzJF;AACF;AA4JA;EACE;IACE,mBAAA;EA1JF;AACF;AA6JA;EACE;IACE,mBAAA;EA3JF;AACF;AA8JA;EACE;IACE,oBAAA;EA5JF;AACF;AA+JA;EACE;IACE,aAAA;IACA,eAAA;EA7JF;EAgKA;IACE,YAAA;EA9JF;EAiKA;IACE,WAAA;IACA,eAAA;EA/JF;EAkKA;;IAEE,WAAA;EAhKF;EAmKA;IACE,WAAA;EAjKF;AACF;AAoKA;EACE;IACE,aAAA;IACA,sBAAA;EAlKF;EAqKA;IACE,WAAA;IACA,mBAAA;EAnKF;EAsKA;IACE,aAAA;IACA,sBAAA;EApKF;AACF;AAuKA;EACE,6CAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;AArKF;;AAwKA;EACE,kBAAA;AArKF;;AAwKA;EACE,YAAA;EACA,UAAA;AArKF;;AAwKA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,gCAAA;AArKF;;AAwKA;;EAEE,oCAAA;AArKF;;AAwKA;EAEE,gDAAA;AAtKF;;AAyKA;EACE,aAAA;AAtKF;;AAyKA,aAAA;AACA;EACE,sBAAA;EACA,uBAAA;AAtKF;;AAyKA;;;;EAIE,kBAAA;AAtKF;;AAyKA;EACE,6BAAA;AAtKF;;AAyKA,kBAAA;AAEA;EACE,eAAA;AAvKF;;AA0KA;EACE,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;AAvKF;;AA0KA;EACE,eAAA;AAvKF;;AA0KA,sBAAA;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,8BAAA;EACA,4BAAA;EACA,oCAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,iBAAA;AAxKF;;AA2KA;EACE,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AAxKF;AA0KE;EACE,uBAAA;EACA,oCAAA;EACA,cAAA;AAxKJ;;AA4KA;EACE,mBAAA;EACA,6BAAA;AAzKF;;AA4KA;EACE,yBAAA;AAzKF;;AA4KA;EACE,eAAA;AAzKF;;AA4KA;EACE,kBAAA;AAzKF;;AA4KA;EACE,4CAAA;EACA,+CAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAzKF;;AA4KA;EACE,6CAAA;EACA,8CAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;AAzKF;;AA4KA;;EAEE,kCAAA;AAzKF;;AA4KA;EACE,cAAA;AAzKF;;AA4KA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;AAzKF;;AA4KA;EACE,cAAA;AAzKF;;AA6KA;EACE,2BAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF;;AA6KA;EACE,yBAAA;AA1KF;;AA6KA;;EAEE,aAAA;AA1KF;;AA6KA;EACE,YAAA;EACA,YAAA;AA1KF;;AA6KA;EACE,sBAAA;EACA,6BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;AA1KF;;AA6KA;;EAEE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA1KF;;AA6KA;EACE,UAAA;EACA,kBAAA;EACA,UAAA;AA1KF;;AA6KA;;EAEE,WAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;AA1KF;;AA6KA;EACE,UAAA;EACA,qBAAA;EACA,uBAAA;EACA,UAAA;AA1KF;;AA6KA;EACE,UAAA;EACA,kBAAA;EACA,sBAAA;AA1KF;;AA6KA;;EAEE,WAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;AA1KF;;AA6KA;EACE,YAAA;AA1KF;;AA6KA;EACE,UAAA;EACA,aAAA;EACA,eAAA;AA1KF;;AA6KA;EACE,6BAAA;AA1KF;;AA6KA;EACE,aAAA;EACA,eAAA;AA1KF;;AA6KA;EACE,cAAA;AA1KF;;AA6KA;;;;;;;;;;;EAWE,aAAA;AA1KF;;AA6KA,aAAA;AAEA,mBAAA;AAEA;EACE,eAAA;AA5KF;;AA+KA;;EAEE,UAAA;AA5KF;;AA+KA,yDAAA;AAEA;EACE,WAAA;AA7KF;;AAgLA;EACE,SAAA;AA7KF;;AAgLA;EACE,UAAA;EACA,YAAA;EACA,6BAAA;AA7KF;;AAgLA;;EAEE,YAAA;EACA,iBAAA;AA7KF;;AAgLA;EACE,WAAA;AA7KF;;AAgLA;EACE,WAAA;AA7KF;;AAgLA;EACE,YAAA;EACA,YAAA;EACA,6BAAA;AA7KF;;AAgLA;EACE,YAAA;AA7KF;;AAgLA;EACE,UAAA;AA7KF;;AAgLA;EACE,6BAAA;EACA,UAAA;EACA,cAAA;AA7KF;;AAgLA;EACE,WAAA;AA7KF;;AAgLA;EACE,YAAA;EACA,YAAA;AA7KF;;AAgLA;EACE,UAAA;EACA,YAAA;EACA,oCAAA;AA7KF;;AAgLA;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AA7KF;;AAgLA;EACE,oCAAA;EACA,WAAA;EACA,iBAAA;EACA,aAAA;AA7KF;;AAgLA;EACE,UAAA;AA7KF;;AAgLA;EACE,6BAAA;EACA,UAAA;EACA,cAAA;AA7KF;;AAgLA;EACE,UAAA;AA7KF;;AAgLA;EACE,UAAA;EACA,6BAAA;EACA,cAAA;AA7KF;;AAgLA;EACE,YAAA;AA7KF;;AAgLA;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,kBAAA;AA7KF;;AAgLA;EACE,WAAA;AA7KF;;AAgLA;EACE,UAAA;AA7KF;;AAgLA;;EAEE,UAAA;AA7KF;;AAgLA;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;AA7KF;;AAgLA;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;AA7KF;;AAgLA;EACE,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,UAAA;AA7KF;;AAgLA;EACE,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,wEACE;AA9KJ;;AAkLA;EACE,UAAA;EACA,kBAAA;EACA,6BAAA;EACA,wEACE;AAhLJ;;AAoLA;EACE,cAAA;EACA,UAAA;EACA,6BAAA;AAjLF;;AAoLA;EACE,UAAA;AAjLF;;AAoLA;EACE,UAAA;AAjLF;;AAoLA;EACE,YAAA;AAjLF;;AAoLA;EACE,UAAA;EACA,cAAA;EACA,6BAAA;AAjLF;;AAoLA,uDAAA;AAEA;EACE,kBAAA;AAlLF;;AAqLA;EACE,gBAAA;AAlLF;;AAqLA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AAlLF;;AAqLA;EACE,UAAA;AAlLF;;AAqLA;EACE,WAAA;AAlLF;;AAqLA;EACE,aAAA;EACA,YAAA;AAlLF;;AAqLA;EACE,yCAAA;EACA,gBAAA;AAlLF;;AAqLA;;EAEE,aAAA;AAlLF;;AAqLA;EACE,UAAA;EACA,gBAAA;AAlLF;;AAqLA;EACE,gBAAA;AAlLF;;AAqLA;EACE,UAAA;EACA,kBAAA;AAlLF;;AAqLA;EACE,6BAAA;EACA,UAAA;EACA,cAAA;AAlLF;;AAqLA;EACE,UAAA;AAlLF;;AAqLA;EACE,6BAAA;EACA,UAAA;EACA,cAAA;AAlLF;;AAqLA;EACE,UAAA;EACA,kBAAA;AAlLF;;AAqLA;EACE,kBAAA;AAlLF;;AAqLA;EACE,UAAA;AAlLF;;AAqLA;EACE,6BAAA;EACA,UAAA;EACA,cAAA;AAlLF;;AAqLA;EACE;;IAEE,UAAA;EAlLF;EAqLA;IACE,UAAA;EAnLF;EAsLA;IACE,UAAA;EApLF;AACF;AAuLA;EACE;IACE,UAAA;IACA,iBAAA;EArLF;EAwLA;IACE,UAAA;EAtLF;EAyLA;IACE,UAAA;EAvLF;EA0LA;IACE,UAAA;EAxLF;AACF;AA2LA;EACE;IACE,WAAA;EAzLF;AACF;AA4LA;EACE;IACE,aAAA;IACA,sBAAA;EA1LF;EA6LA;IACE,WAAA;EA3LF;EA8LA;IACE,iBAAA;IACA,gBAAA;EA5LF;EA+LA;IACE,YAAA;IACA,cAAA;EA7LF;EAgMA;IACE,YAAA;IACA,cAAA;IACA,gBAAA;EA9LF;EAiMA;;IAEE,WAAA;EA/LF;EAkMA;IACE,UAAA;EAhMF;EAmMA;IACE,UAAA;EAjMF;EAoMA;IACE,YAAA;EAlMF;EAqMA;IACE,YAAA;EAnMF;AACF;AAsMA;EACE;IACE,aAAA;IACA,sBAAA;IACA,WAAA;EApMF;EAuMA;IACE,WAAA;EArMF;EAwMA;;IAEE,UAAA;IACA,YAAA;EAtMF;EAyMA;;IAEE,UAAA;EAvMF;AACF;AA0MA;EACE;;IAEE,aAAA;IACA,sBAAA;EAxMF;EA2MA;;;;IAIE,WAAA;EAzMF;AACF;AA4MA;EACE;IACE,WAAA;EA1MF;AACF;AA6MA,wDAAA;AAEA;EACE;IACE,SAAA;EA5MF;EA+MA;IACE,UAAA;EA7MF;EAgNA;IACE,WAAA;EA9MF;EAiNA;IACE,YAAA;EA/MF;AACF;AAkNA;EACE;IACE,SAAA;EAhNF;EAmNA;IACE,UAAA;EAjNF;EAoNA;IACE,WAAA;EAlNF;EAqNA;IACE,YAAA;EAnNF;AACF;AAsNA;EACE;IACE,WAAA;EApNF;EAuNA;IACE,YAAA;EArNF;AACF;AAwNA;EACE;IACE,WAAA;EAtNF;EAyNA;IACE,YAAA;EAvNF;EA0NA;IACE,WAAA;EAxNF;EA2NA;IACE,YAAA;EAzNF;AACF;AA4NA;EACE;IACE,YAAA;EA1NF;EA6NA;IACE,YAAA;EA3NF;EA8NA;IACE,WAAA;EA5NF;EA+NA;IACE,YAAA;EA7NF;AACF;AAgOA;EACE;IACE,YAAA;EA9NF;EAiOA;IACE,YAAA;EA/NF;EAkOA;IACE,WAAA;EAhOF;EAmOA;IACE,YAAA;EAjOF;AACF;AAoOA;EACE;IACE,WAAA;EAlOF;EAqOA;IACE,YAAA;EAnOF;EAsOA;IACE,UAAA;EApOF;EAuOA;IACE,UAAA;EArOF;AACF;AAwOA;EACE;IACE,YAAA;EAtOF;EAyOA;IACE,YAAA;EAvOF;AACF;AA0OA,8CAAA;AAEA,iDAAA;AAEA;EACE;IACE,UAAA;EA1OF;EA6OA;IACE,UAAA;EA3OF;AACF;AA8OA,iDAAA;AAEA,yDAAA;AAEA;EACE;IACE,WAAA;EA9OF;AACF;AAiPA;EACE;IACE,WAAA;EA/OF;AACF;AAkPA;EACE;IACE,WAAA;EAhPF;EAmPA;IACE,eAAA;EAjPF;EAoPA;IACE,eAAA;EAlPF;AACF;AAqPA;EACE;IACE,WAAA;EAnPF;AACF;AAsPA,oDAAA;AAEA;EACE;IACE,UAAA;EArPF;EAwPA;IACE,UAAA;EAtPF;AACF;AAyPA;EACE;IACE,UAAA;EAvPF;EA0PA;IACE,UAAA;EAxPF;AACF;AA2PA;EACE;IACE,UAAA;EAzPF;EA4PA;IACE,UAAA;EA1PF;AACF;AA6PA;EACE;IACE,UAAA;EA3PF;EA8PA;IACE,UAAA;EA5PF;AACF;AA+PA;EACE;IACE,UAAA;EA7PF;EAgQA;IACE,UAAA;EA9PF;AACF;AAiQA;EACE;IACE,UAAA;EA/PF;EAkQA;IACE,UAAA;EAhQF;AACF;AAmQA;EACE;IACE,UAAA;EAjQF;EAoQA;IACE,UAAA;EAlQF;AACF;AAqQA;EACE;IACE,UAAA;EAnQF;EAsQA;IACE,UAAA;EApQF;AACF;AAuQA;EACE;IACE,UAAA;EArQF;EAwQA;IACE,UAAA;EAtQF;AACF;AAyQA;EACE;IACE,UAAA;EAvQF;EA0QA;IACE,UAAA;EAxQF;AACF;AA2QA;EACE;IACE,UAAA;EAzQF;EA4QA;IACE,UAAA;EA1QF;AACF;AA6QA;EACE;IACE,UAAA;EA3QF;EA8QA;IACE,UAAA;EA5QF;AACF;AA+QA;EACE;IACE,UAAA;EA7QF;EAgRA;IACE,UAAA;EA9QF;AACF;AAiRA;EACE;IACE,aAAA;IACA,sBAAA;EA/QF;EAkRA;IACE,WAAA;IACA,mBAAA;IACA,YAAA;EAhRF;EAmRA;IACE,WAAA;EAjRF;AACF;AAoRA;EACE;;;;;;;;;;;;;IAaE,aAAA;EAlRF;EAqRA;IACE,WAAA;EAnRF;EAsRA;IACE,aAAA;IACA,sBAAA;EApRF;EAuRA;IACE,YAAA;EArRF;EAwRA;;IAEE,UAAA;EAtRF;EAyRA;;IAEE,UAAA;EAvRF;EA0RA;;IAEE,WAAA;EAxRF;EA2RA;IACE,aAAA;EAzRF;EA4RA;IACE,gBAAA;EA1RF;EAkSA;IACE,UAAA;EAhSF;EAmSA;IACE,UAAA;EAjSF;EAoSA;IACE,UAAA;EAlSF;EAqSA;IACE,UAAA;EAnSF;AACF;AAsSA;EACE;;;IAGE,UAAA;EApSF;EAuSA;IACE,UAAA;EArSF;EAwSA;IACE,UAAA;EAtSF;EAySA;IACE,UAAA;EAvSF;EA0SA;IACE,gBAAA;EAxSF;AACF;AA2SA,oDAAA;AAEA;EACE,gBAAA;EACA,kBAAA;AA1SF;;AA6SA;EACE,UAAA;AA1SF;;AA6SA;EACE,6BAAA;EACA,gBAAA;EACA,UAAA;AA1SF;;AA6SA;EACE,6BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AA1SF;;AA6SA,qDAAA;AAEA;EACE;;;;;;;;;;;;;IAaE,aAAA;IACA,sBAAA;EA3SF;EA8SA;;IAEE,WAAA;EA5SF;EA+SA;IACE,SAAA;EA7SF;EAgTA;IACE,WAAA;EA9SF;EAiTA;IACE,aAAA;IACA,sBAAA;EA/SF;EAkTA;;IAEE,WAAA;EAhTF;EAmTA;IACE,WAAA;EAjTF;AACF;AAoTA,0DAAA;AAEA;EACE,uBAAA;EACA,YAAA;EACA,YAAA;AAnTF;;AA0TA;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,mBAAA;AAvTF;;AA0TA;EACE,UAAA;EACA,aAAA;EACA,0CAAA;AAvTF;;AA0TA;EACE,UAAA;EACA,aAAA;EACA,0CAAA;AAvTF;;AA0TA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,yCAAA;EACA,kBAAA;AAvTF;;AA2TE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAxTJ;AA2TE;EACE,SAAA;EACA,eAAA;AAzTJ;;AAmUA;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,yCAAA;EACA,kBAAA;AAhUF;;AAmUA;EACE,+BAAA;EACA,gBAAA;EACA,kBAAA;AAhUF;;AAyUA;EACE,eAAA;AAtUF;;AAyUA;EAGE,kBAAA;AAxUF;;AA2UA;EACE;IACE,WAAA;EAxUF;AACF;AA2UA;EACE;IACE,WAAA;EAzUF;AACF;AA4UA;EACE;IACE,WAAA;EA1UF;AACF;AA6UA;EACE;IACE,WAAA;EA3UF;AACF;AA8UA;EACE;IACE,eAAA;EA5UF;EA+UA;;IAEE,WAAA;EA7UF;EAgVA;;;;IAIE,gBAAA;IACA,cAAA;EA9UF;EAiVA;IACE,YAAA;EA/UF;EAkVA;IACE,eAAA;EAhVF;EAmVA;IACE,eAAA;IACA,gBAAA;IACA,YAAA;EAjVF;AACF;AAoVA;EACE;IACE,gBAAA;EAlVF;EAqVA;IACE,YAAA;EAnVF;EAsVA;;;IAGE,gBAAA;IACA,cAAA;EApVF;AACF;AAuVA;EACE;IACE,WAAA;EArVF;AACF;AAwVA;EACE;IACE,eAAA;EAtVF;EAyVA;;;IAGE,gBAAA;IACA,cAAA;EAvVF;AACF;AA0VA;EACE;IACE,WAAA;EAxVF;AACF;AA2VA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,wBAAA;EACA,+BAAA;EACA,UAAA;AAzVF;;AA4VA;EACE,kBAAA;AAzVF;;AA4VA;EACE,qBAAA;AAzVF;;AA4VA;EACE,qBAAA;EACA,qBAAA;AAzVF;;AA4VA;EACE;IACE,WAAA;EAzVF;AACF;AA4VA;EACE;IACE,WAAA;EA1VF;AACF;AA6VA;EACE;IACE,WAAA;EA3VF;AACF;AA8VA;EACE;IACE,WAAA;EA5VF;AACF;AA+VA;EACE;IACE,WAAA;EA7VF;AACF;AAgWA;EACE;IACE,WAAA;EA9VF;AACF;AAiWA;EACE;;IAEE,aAAA;IACA,sBAAA;EA/VF;EAkWA;;IAEE,WAAA;EAhWF;EAmWA;;IAEE,WAAA;EAjWF;EAoWA;;IAEE,WAAA;IACA,WAAA;EAlWF;AACF;AAqWA;EACE;;IAEE,aAAA;IACA,sBAAA;EAnWF;EAsWA;IACE,WAAA;IACA,WAAA;EApWF;EAuWA;IACE,WAAA;EArWF;AACF;AAwWA;EACE;IACE,WAAA;EAtWF;AACF;AAyWA;EACE;IACE,WAAA;EAvWF;AACF;AA0WA;EACE;IACE,WAAA;EAxWF;AACF;AA2WA;EACE;IACE,WAAA;EAzWF;AACF;AA4WA;EACE;;IAEE,WAAA;EA1WF;EA6WA;IACE,WAAA;EA3WF;AACF;AA8WA;EACE;IACE,wBAAA;IACA,gBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,eAAA;IACA,WAAA;IACA,eAAA;EA5WF;EA+WA;IACE,oBAAA;IACA,eAAA;IACA,oBAAA;EA7WF;EAgXA;IACE,aAAA;EA9WF;EAiXA;IACE,UAAA;EA/WF;EAkXA;IACE,UAAA;EAhXF;EAmXA;;IAEE,WAAA;EAjXF;EAoXA;IACE,aAAA;IACA,sBAAA;EAlXF;EAqXA;IACE,gBAAA;EAnXF;EAsXA;IACE,UAAA;EApXF;EAuXA;IACE,oBAAA;IACA,kBAAA;EArXF;EAwXA;IACE,kBAAA;EAtXF;EAyXA;IACE,sBAAA;EAvXF;EA0XA,6BAAA;EAEA,+BAAA;EAEA;IACE,YAAA;EA1XF;EA6XA;IACE,kBAAA;EA3XF;EA8XA;IACE,WAAA;EA5XF;EA+XA;IACE,kBAAA;EA7XF;EAgYA,mCAAA;AA9XF;AAiYA;EACE;;;;IAIE,WAAA;EA/XF;AACF;AAkYA;EACE;IACE,aAAA;EAhYF;EAmYA;IACE,iBAAA;EAjYF;AACF;AAoYA,2DAAA;AAEA;EACE,gBAAA;AAnYF;;AAsYA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AAnYF;;AAsYA;EACE;IACE,WAAA;IACA,YAAA;EAnYF;EAsYA;IACE,WAAA;EApYF;EAuYA;IACE,YAAA;EArYF;AACF;AAwYA;EACE;IACE,YAAA;IACA,cAAA;EAtYF;EAyYA;IACE,aAAA;IACA,sBAAA;EAvYF;EA0YA;IACE,YAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;EAxYF;EA2YA;IACE,WAAA;IACA,WAAA;EAzYF;AACF;AA4YA;EACE;IACE,eAAA;EA1YF;AACF;AA6YA;EACE;IACE,YAAA;IACA,cAAA;EA3YF;AACF;AA8YA;EACE;IACE,WAAA;EA5YF;AACF;AA+YA;EACE;IACE,WAAA;EA7YF;AACF;AAgZA;EACE;IACE,WAAA;EA9YF;AACF;AAiZA,2DAAA;AAEA,0DAAA;AAEA;EACE,YAAA;AAjZF;;AAoZA;EACE;IACE,WAAA;EAjZF;AACF;AAoZA;EACE;IACE,WAAA;EAlZF;AACF;AAqZA,0DAAA;AAEA,0DAAA;AAEA;EACE;IACE,WAAA;EArZF;AACF;AAwZA;EACE;IACE,WAAA;EAtZF;AACF;AAyZA;EACE;IACE,WAAA;EAvZF;AACF;AA0ZA;EACE;IACE,WAAA;EAxZF;AACF;AA2ZA;EACE;IACE,WAAA;EAzZF;AACF;AA4ZA;EACE;IACE,WAAA;EA1ZF;AACF;AA6ZA;EACE;IACE,WAAA;EA3ZF;AACF;AA8ZA;EACE;IACE,WAAA;EA5ZF;AACF;AA+ZA;EACE;IACE,WAAA;EA7ZF;AACF;AAgaA;EACE;IACE,WAAA;EA9ZF;AACF;AAiaA;EACE;IACE,WAAA;EA/ZF;AACF;AAkaA;EACE;IACE,WAAA;EAhaF;AACF;AAmaA;EACE;IACE,WAAA;EAjaF;AACF;AAoaA,0DAAA;AAEA,0DAAA;AAEA;EACE,eAAA;AApaF;;AAuaA;EACE,UAAA;EACA,aAAA;EACA,0CAAA;AApaF;;AAuaA;EACE,yCAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AApaF;;AAuaA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AApaF;;AAuaA;EACE;IACE,WAAA;EApaF;AACF;AAuaA;EACE;IACE,aAAA;IACA,sBAAA;EAraF;EAwaA;IACE,gBAAA;IACA,cAAA;EAtaF;EAyaA;;IAEE,gBAAA;IACA,YAAA;IACA,gBAAA;EAvaF;EA0aA;;IAEE,WAAA;EAxaF;AACF;AA2aA;EACE;IACE,eAAA;EAzaF;AACF;AA4aA;EACE;IACE,WAAA;EA1aF;AACF;AA6aA;EACE;IACE,WAAA;EA3aF;EA8aA;IACE,WAAA;EA5aF;AACF;AA+aA,0DAAA;AAEA,0DAAA;AAEA;EACE,kBAAA;EACA,QAAA;EACA,gBAAA;AA/aF;;AAkbA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;AA/aF;;AAkbA;EACE,aAAA;EACA,eAAA;AA/aF;;AAkbA;EACE,UAAA;AA/aF;;AAkbA;EACE,gBAAA;AA/aF;;AAkbA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA/aF;;AAkbA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AA/aF;;AAkbA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AA/aF;;AAkbA;EACE,gBAAA;AA/aF;;AAkbA;EACE,YAAA;AA/aF;;AAkbA;EACE,WAAA;AA/aF;;AAkbA;EACE;IACE,WAAA;EA/aF;AACF;AAkbA;EACE;IACE,WAAA;EAhbF;AACF;AAmbA;EACE;IACE,WAAA;EAjbF;AACF;AAobA;EACE;IACE,WAAA;EAlbF;AACF;AAqbA;EACE;IACE,WAAA;EAnbF;AACF;AAsbA;EACE;;IAEE,WAAA;EApbF;EAubA;IACE,YAAA;IACA,cAAA;IACA,kBAAA;EArbF;EAwbA;IACE,YAAA;IACA,mBAAA;EAtbF;EAybA;IACE,YAAA;EAvbF;EA0bA;IACE,YAAA;IACA,cAAA;EAxbF;EA2bA;IACE,WAAA;EAzbF;EA4bA;IACE,aAAA;IACA,sBAAA;EA1bF;EA6bA;IACE,YAAA;IACA,WAAA;EA3bF;EA8bA;IACE,WAAA;EA5bF;EA+bA;IACE,YAAA;EA7bF;EAgcA;IACE,WAAA;EA9bF;EAicA;IACE,WAAA;EA/bF;AACF;AAkcA;EACE;IACE,YAAA;EAhcF;AACF;AAmcA;EACE;IACE,WAAA;EAjcF;AACF;AAocA;EACE;IACE,YAAA;IACA,cAAA;IACA,kBAAA;EAlcF;AACF;AAqcA;EACE;IACE,WAAA;EAncF;AACF;AAscA;EACE;IACE,WAAA;EApcF;AACF;AAucA;EACE;IACE,WAAA;EArcF;AACF;AAwcA;EACE;IACE,WAAA;EAtcF;AACF;AAycA;EACE;IACE,WAAA;EAvcF;EA0cA;IACE,WAAA;EAxcF;AACF;AA2cA;EACE;IACE,WAAA;EAzcF;EA4cA;IACE,WAAA;EA1cF;EA6cA;IACE,WAAA;EA3cF;AACF;AA8cA,0DAAA;AAEA,0DAAA;AAEA;EACE;IACE,WAAA;EA9cF;AACF;AAidA;EACE;IACE,WAAA;EA/cF;AACF;AAkdA;EACE;IACE,WAAA;EAhdF;AACF;AAmdA;EACE;IACE,aAAA;IACA,sBAAA;EAjdF;EAodA;IACE,WAAA;IACA,YAAA;EAldF;EAqdA;IACE,WAAA;IACA,YAAA;EAndF;EAsdA;IACE,WAAA;IACA,gBAAA;EApdF;AACF;AAudA;EACE;IACE,WAAA;EArdF;AACF;AAwdA;EACE;IACE,WAAA;EAtdF;AACF;AAydA,0DAAA;AAEA,0DAAA;AAEA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AAzdF;;AA4dA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAzdF;;AA4dA;EACE,aAAA;AAzdF;;AA4dA;EACE,yCAAA;EACA,gBAAA;AAzdF;;AAkeA;EACE;IACE,WAAA;EA/dF;AACF;AAkeA;EACE;IACE,WAAA;EAheF;EAmeA;IACE,WAAA;EAjeF;AACF;AAoeA;EACE;IACE,WAAA;EAleF;AACF;AAqeA;EACE;IACE,WAAA;EAneF;AACF;AAseA;EACE;IACE,aAAA;IACA,sBAAA;EApeF;EAueA;IACE,iBAAA;IACA,gBAAA;EAreF;EAweA;;IAEE,gBAAA;EAteF;EAyeA;IACE,gBAAA;EAveF;EA0eA;IACE,gBAAA;IACA,YAAA;EAxeF;EA2eA;IACE,WAAA;IACA,YAAA;EAzeF;EA4eA;IACE,WAAA;EA1eF;AACF;AA6eA;EACE;IACE,WAAA;EA3eF;AACF;AA8eA;EACE;IACE,WAAA;EA5eF;AACF;AA+eA;EACE;IACE,WAAA;EA7eF;AACF;AAgfA;EACE;IACE,WAAA;EA9eF;AACF;AAifA;EACE;IACE,WAAA;EA/eF;EAkfA;IACE,WAAA;IACA,YAAA;EAhfF;EAmfA;;IAEE,gBAAA;EAjfF;AACF;AAofA;EACE;IACE,WAAA;EAlfF;AACF;AAqfA;EACE;IACE,WAAA;EAnfF;AACF;AAsfA,0DAAA;AAEA,2DAAA;AAEA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;AAtfF;;AAyfA;EACE,2BAAA;EACA,SAAA;EACA,WAAA;AAtfF;;AAyfA;EACE,qCAAA;EACA,SAAA;AAtfF;;AAyfA;;;;;;;EAOE,mCAAA;AAtfF;;AAyfA;;;;;;;EAOE,iBAAA;AAtfF;;AAyfA;;;;;;;;;;;;;;EAcE,gBAAA;EACA,oCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AAtfF;;AAyfA;EACE,gBAAA;AAtfF;;AAyfA;EACE,oBAAA;EACA,kBAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAvfF;;AA8fA,0DAAA;AAEA,kEAAA;AAEA,0DAAA;AAEA,2DAAA;AAEA;EACE,gBAAA;AA/fF;;AAkgBA;EACE,UAAA;EACA,aAAA;AA/fF;;AAkgBA;EACE,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;AA/fF;;AAkgBA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AA/fF;;AAkgBA;EACE,oBAAA;AA/fF;;AAkgBA;EACE,UAAA;EACA,aAAA;AA/fF;;AAkgBA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA/fF;;AAkgBA;EACE,eAAA;AA/fF;;AAkgBA;EACE;IACE,WAAA;EA/fF;AACF;AAkgBA;EACE;IACE,WAAA;IACA,gBAAA;EAhgBF;AACF;AAmgBA;EACE;IACE,WAAA;EAjgBF;AACF;AAogBA;EACE;IACE,WAAA;EAlgBF;AACF;AAqgBA;EACE,gBAAA;AAngBF;;AAsgBA;EACE;IACE,aAAA;IACA,sBAAA;EAngBF;EAsgBA;IACE,gBAAA;IACA,cAAA;EApgBF;EAugBA;IACE,YAAA;IACA,cAAA;EArgBF;EAwgBA;IACE,YAAA;EAtgBF;EAygBA;IACE,kBAAA;EAvgBF;EA0gBA;;IAEE,WAAA;EAxgBF;EA2gBA;IACE,YAAA;EAzgBF;EA4gBA;IACE,WAAA;EA1gBF;EA6gBA;IACE,gBAAA;EA3gBF;EA8gBA;IACE,WAAA;EA5gBF;AACF;AA+gBA;EACE;IACE,eAAA;EA7gBF;EAghBA;IACE,YAAA;IACA,cAAA;EA9gBF;EAihBA;IACE,YAAA;EA/gBF;AACF;AAkhBA;EACE;IACE,eAAA;EAhhBF;EAmhBA;IACE,gBAAA;IACA,YAAA;EAjhBF;EAohBA;IACE,eAAA;EAlhBF;EAqhBA;IACE,eAAA;IACA,kBAAA;EAnhBF;AACF;AAshBA;EACE;IACE,WAAA;EAphBF;AACF;AAuhBA;EACE;IACE,WAAA;EArhBF;AACF;AAwhBA;EACE;IACE,WAAA;EAthBF;AACF;AAyhBA;EACE;IACE,WAAA;EAvhBF;AACF;AA0hBA;EACE;IACE,WAAA;EAxhBF;AACF;AA2hBA;EACE;IACE,WAAA;EAzhBF;AACF;AA4hBA;EACE;IACE,WAAA;EA1hBF;AACF;AA6hBA;EACE;IACE,WAAA;EA3hBF;AACF;AA8hBA;EACE;IACE,eAAA;EA5hBF;AACF;AA+hBA,0DAAA;AAEA,0DAAA;AAEA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA/hBF;;AAkiBA;EACE,eAAA;AA/hBF;;AAkiBA;EACE;IACE,WAAA;EA/hBF;EAkiBA;IACE,eAAA;EAhiBF;AACF;AAmiBA;EACE;IACE,WAAA;EAjiBF;AACF;AAoiBA;EACE;IACE,WAAA;EAliBF;AACF;AAqiBA;EACE;IACE,WAAA;EAniBF;AACF;AAsiBA;EACE;IACE,WAAA;EApiBF;AACF;AAuiBA,2DAAA;AAEA,2DAAA;AAMA,4DAAA;AAEA,4DAAA;AAEA;EACE;IACE,WAAA;EA7iBF;AACF;AAgjBA;EACE;IACE,WAAA;EA9iBF;AACF;AAijBA;EACE;IACE,WAAA;EA/iBF;AACF;AAkjBA;EACE;IACE,WAAA;EAhjBF;AACF;AAmjBA,2DAAA;AAEA,0DAAA;AAEA;EACE,eAAA;AAnjBF;;AAsjBA;EACE;IACE,WAAA;EAnjBF;AACF;AAsjBA;EACE;;IAEE,WAAA;EApjBF;AACF;AAujBA;EACE;;IAEE,WAAA;EArjBF;AACF;AAwjBA;EACE;;IAEE,WAAA;EAtjBF;EAyjBA;IACE,aAAA;IACA,sBAAA;EAvjBF;EA0jBA;;IAEE,WAAA;EAxjBF;EA2jBA;;;IAGE,WAAA;EAzjBF;AACF;AA4jBA;EACE;IACE,WAAA;EA1jBF;AACF;AA6jBA;EACE;IACE,WAAA;EA3jBF;AACF;AA8jBA;EACE;IACE,WAAA;EA5jBF;AACF;AA+jBA;EACE;IACE,WAAA;EA7jBF;AACF;AAgkBA;EACE;IACE,WAAA;EA9jBF;AACF;AAikBA;EACE;IACE,WAAA;EA/jBF;AACF;AAkkBA;EACE;IACE,WAAA;EAhkBF;AACF;AAmkBA,0DAAA;AAEA,0DAAA;AAEA;EACE;IACE,UAAA;EAnkBF;AACF;AAskBA;EACE;;;IAGE,UAAA;EApkBF;AACF;AAukBA;EACE;IACE,aAAA;IACA,sBAAA;EArkBF;EAwkBA;;IAEE,UAAA;EAtkBF;EAykBA;IACE,UAAA;IACA,aAAA;EAvkBF;EA0kBA;IACE,WAAA;EAxkBF;EA2kBA;IACE,gBAAA;EAzkBF;AACF;AA4kBA,0DAAA;AAEA;EACE;IACE,WAAA;EA3kBF;EA8kBA;IACE,UAAA;EA5kBF;EA+kBA;IACE,YAAA;EA7kBF;EAglBA;IACE,UAAA;EA9kBF;EAilBA;IACE,UAAA;EA/kBF;EAklBA;IACE,UAAA;EAhlBF;EAmlBA;IACE,UAAA;EAjlBF;EAolBA;IACE,UAAA;EAllBF;EAqlBA;IACE,UAAA;EAnlBF;EAslBA;IACE,UAAA;EAplBF;EAulBA;IACE,UAAA;EArlBF;EAwlBA;IACE,UAAA;EAtlBF;EAylBA;IACE,cAAA;IACA,kBAAA;IACA,oCAAA;IACA,YAAA;IACA,kBAAA;EAvlBF;EA0lBA;IACE,WAAA;EAxlBF;EA2lBA;IACE,UAAA;EAzlBF;EA4lBA;IACE,UAAA;EA1lBF;EA6lBA;IACE,UAAA;EA3lBF;EA8lBA;IACE,cAAA;IACA,kBAAA;IACA,oCAAA;IACA,UAAA;EA5lBF;EA+lBA;IACE,YAAA;EA7lBF;EAgmBA;IACE,UAAA;EA9lBF;AACF;AAimBA,6CAAA;AAEA;EACE;IACE,UAAA;EAhmBF;EAmmBA;IACE,UAAA;EAjmBF;AACF;AAomBA;EACE;IACE,UAAA;EAlmBF;EAqmBA;IACE,UAAA;EAnmBF;EAsmBA;;IAEE,aAAA;IACA,sBAAA;EApmBF;EAumBA;IACE,iBAAA;EArmBF;EAwmBA;;;;IAIE,WAAA;EAtmBF;EAymBA;IACE,YAAA;IACA,YAAA;EAvmBF;EA0mBA;IACE,eAAA;EAxmBF;EA2mBA;IACE,aAAA;IACA,sBAAA;EAzmBF;EA4mBA;;;;;;IAME,UAAA;EA1mBF;EA6mBA;;;;;IAKE,UAAA;EA3mBF;EA8mBA;IACE,eAAA;EA5mBF;EA+mBA;IACE,WAAA;EA7mBF;EAgnBA;IACE,iBAAA;EA9mBF;EAinBA;IACE,kBAAA;EA/mBF;EAknBA;;IAEE,UAAA;IACA,gBAAA;EAhnBF;EAmnBA;IACE,YAAA;EAjnBF;AACF;AAonBA;EACE;;;;IAIE,aAAA;IACA,sBAAA;EAlnBF;EAqnBA;;;;;;;IAOE,WAAA;EAnnBF;EAsnBA;IACE,UAAA;IACA,iBAAA;EApnBF;EAunBA;IACE,kBAAA;IACA,WAAA;EArnBF;EAwnBA;;;;;IAKE,WAAA;EAtnBF;EAynBA;IACE,aAAA;EAvnBF;EA0nBA;IACE,kBAAA;EAxnBF;AACF;AA2nBA,8CAAA;AAEA,8CAAA;AAEA;EACE,uBAAA;AA3nBF;;AA8nBA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AA3nBF;;AA8nBA;;EAEE,6BAAA;EACA,mBAAA;EACA,wCAAA;EACA,qBAAA;EACA,gBAAA;AA3nBF;AA6nBE;;EACE,kCAAA;EACA,wCAAA;EACA,kBAAA;AA1nBJ;;AA8nBA;EACE;IACE,aAAA;IACA,sBAAA;IACA,YAAA;EA3nBF;AACF;AA8nBA;EACE;;IAEE,6BAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IACA,eAAA;EA5nBF;AACF;AA+nBA;EACE;IACE,YAAA;IACA,cAAA;EA7nBF;AACF;AAgoBA;EACE;IACE,WAAA;EA9nBF;AACF;AAioBA;EACE;IACE,YAAA;EA/nBF;AACF;AAkoBA;EACE;IACE,WAAA;EAhoBF;AACF;AAmoBA;EACE;IACE,aAAA;IACA,mBAAA;EAjoBF;EAooBA;IACE,WAAA;EAloBF;EAqoBA;IACE,aAAA;IACA,sBAAA;EAnoBF;EAsoBA;IACE,WAAA;IACA,kBAAA;IACA,oBAAA;EApoBF;EAuoBA;IACE,WAAA;IACA,gBAAA;IACA,YAAA;EAroBF;EAwoBA;IACE,WAAA;IACA,2BAAA;IACA,kBAAA;IACA,gBAAA;EAtoBF;AACF;AAipBA;EACE,sBAAA;AA/oBF;;AAmpBE;;EAEE,2BAAA;AAhpBJ;;AAopBA;EACE;IACE,WAAA;EAjpBF;AACF;AAopBA;EACE;IACE,WAAA;EAlpBF;AACF;AAqpBA;EACE;IACE,WAAA;EAnpBF;AACF;AAspBA;EACE;IACE,WAAA;EAppBF;AACF;AAupBA;EACE;IACE,WAAA;EArpBF;AACF;AAwpBA;EACE;IACE,WAAA;EAtpBF;AACF;AAypBA;EACE;IACE,WAAA;EAvpBF;AACF;AA0pBA;EACE;IACE,WAAA;EAxpBF;AACF;AA2pBA;EACE;IACE,YAAA;EAzpBF;AACF;AA4pBA,8CAAA;AAEA,8CAAA;AAEA;EACE,YAAA;AA5pBF;;AA+pBA;;;;EAIE,UAAA;AA5pBF;;AA+pBA;EACE,UAAA;EACA,YAAA;EACA,iBAAA;AA5pBF;;AA+pBA;EACE,4CAAA;AA5pBF;;AA+pBA;EACE,6BAAA;EACA,YAAA;AA5pBF;;AA+pBA;EACE,aAAA;EACA,sBAAA;AA5pBF;;AA+pBA;EACE,UAAA;AA5pBF;;AA+pBA;EACE,UAAA;AA5pBF;;AA+pBA;EACE,2BAAA;EACA,cAAA;AA5pBF;;AA+pBA;EACE,mBAAA;AA5pBF;;AA+pBA;EACE,UAAA;AA5pBF;;AA+pBA;EACE,UAAA;AA5pBF;;AA+pBA;EACE,+BAAA;EACA,aAAA;AA5pBF;;AA+pBA;EACE,6BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA5pBF;;AA+pBA;;EAEE,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;AA5pBF;;AA+pBA;EACE,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AA5pBF;;AA+pBA;EACE,6BAAA;EACA,YAAA;AA5pBF;;AA+pBA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AA5pBF;;AA+pBA;EACE,UAAA;EACA,8BAAA;EACA,gBAAA;EACA,aAAA;AA5pBF;;AA+pBA;EACE,UAAA;EACA,+BAAA;EACA,aAAA;AA5pBF;;AA+pBA;EACE,UAAA;AA5pBF;;AA+pBA;EACE,6BAAA;EACA,kBAAA;EACA,UAAA;AA5pBF;;AA+pBA;EACE,gCAAA;AA5pBF;;AA+pBA;EACE,UAAA;EACA,YAAA;AA5pBF;;AA+pBA;EACE,YAAA;AA5pBF;;AA+pBA;EACE,6BAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;AA5pBF;;AA+pBA;EACE,2BAAA;EACA,iBAAA;EACA,oBAAA;AA5pBF;;AA+pBA;EACE,YAAA;AA5pBF;;AA+pBA;EACE,iBAAA;AA5pBF;;AA+pBA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA5pBF;;AA+pBA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA5pBF;;AA+pBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AA5pBF;;AA+pBA;EACE;IACE,UAAA;EA5pBF;EA+pBA;IACE,UAAA;EA7pBF;AACF;AAgqBA;EACE;IACE,UAAA;EA9pBF;EAiqBA;IACE,UAAA;EA/pBF;AACF;AAkqBA;EACE;IACE,UAAA;EAhqBF;EAmqBA;IACE,UAAA;EAjqBF;AACF;AAoqBA;EACE;IACE,WAAA;EAlqBF;EAqqBA;IACE,WAAA;EAnqBF;AACF;AAsqBA;EACE;IACE,UAAA;EApqBF;EAuqBA;IACE,UAAA;EArqBF;AACF;AAwqBA;EACE;IACE,UAAA;EAtqBF;EAyqBA;IACE,UAAA;EAvqBF;AACF;AA0qBA;EACE;IACE,UAAA;EAxqBF;EA2qBA;IACE,UAAA;EAzqBF;AACF;AA4qBA;EACE;IACE,aAAA;IACA,sBAAA;EA1qBF;EA6qBA;IACE,YAAA;EA3qBF;EA8qBA;IACE,2BAAA;IACA,cAAA;EA5qBF;EA+qBA;IACE,WAAA;EA7qBF;EAgrBA;IACE,WAAA;EA9qBF;AACF;AAirBA;EACE;IACE,YAAA;IACA,cAAA;EA/qBF;AACF;AAkrBA;EACE;IACE,aAAA;IACA,sBAAA;EAhrBF;EAmrBA;IACE,YAAA;EAjrBF;EAorBA;IACE,YAAA;IACA,gBAAA;EAlrBF;EAqrBA;;;IAGE,WAAA;EAnrBF;EAsrBA;IACE,aAAA;IACA,mBAAA;IACA,kBAAA;IACA,oBAAA;EAprBF;AACF;AAurBA;EACE;IACE,WAAA;EArrBF;AACF;AAwrBA;EACE;IACE,0BAAA;EAtrBF;EAyrBA;IACE,YAAA;IACA,cAAA;EAvrBF;EA0rBA;IACE,YAAA;IACA,cAAA;EAxrBF;AACF;AA2rBA;EACE;IACE,YAAA;IACA,cAAA;EAzrBF;EA4rBA;IACE,wBAAA;EA1rBF;EA6rBA;IACE,YAAA;IACA,cAAA;EA3rBF;EA8rBA;IACE,gBAAA;EA5rBF;AACF;AA+rBA;EACE;IACE,YAAA;IACA,cAAA;EA7rBF;EAgsBA;IACE,YAAA;EA9rBF;EAisBA;IACE,+BAAA;IACA,cAAA;EA/rBF;AACF;AAksBA;EACE;IACE,WAAA;EAhsBF;EAmsBA;IACE,WAAA;EAjsBF;AACF;AAosBA;EACE;IACE,WAAA;EAlsBF;AACF;AAqsBA;EACE;IACE,WAAA;EAnsBF;AACF;AAssBA;EACE;IACE,cAAA;IACA,kBAAA;EApsBF;EAusBA;IACE,YAAA;IACA,cAAA;EArsBF;AACF;AAwsBA;EACE;IACE,WAAA;EAtsBF;EAysBA;IACE,WAAA;EAvsBF;AACF;AA0sBA;EACE;IACE,YAAA;IACA,cAAA;EAxsBF;EA2sBA;IACE,YAAA;EAzsBF;AACF;AA4sBA;EACE;IACE,WAAA;EA1sBF;AACF;AA6sBA;EACE;IACE,WAAA;EA3sBF;AACF;AA8sBA;EACE;IACE,+BAAA;IACA,cAAA;EA5sBF;EA+sBA;IACE,YAAA;EA7sBF;EAgtBA;IACE,YAAA;IACA,cAAA;EA9sBF;AACF;AAitBA;EACE;IACE,YAAA;IACA,cAAA;EA/sBF;AACF;AAktBA;EACE;IACE,YAAA;EAhtBF;AACF;AAmtBA;EACE;IACE,WAAA;EAjtBF;AACF;AAotBA;EACE;IACE,WAAA;EAltBF;AACF;AAqtBA,iDAAA;AAEA,kDAAA;AAEA;EACE,UAAA;AArtBF;;AAwtBA;EACE,UAAA;EACA,iBAAA;AArtBF;;AAwtBA;EACE;IACE,UAAA;EArtBF;EAwtBA;IACE,UAAA;EAttBF;AACF;AAytBA;EACE;IACE,gBAAA;EAvtBF;AACF;AA0tBA;EACE;IACE,UAAA;EAxtBF;EA2tBA;IACE,UAAA;EAztBF;AACF;AA4tBA,iDAAA;AAEA;EACE;IACE,gBAAA;EA3tBF;AACF;AA8tBA,qDAAA;AAEA;EACE,eAAA;AA7tBF;;AAguBA;EACE;IACE,WAAA;EA7tBF;AACF;AAguBA;EACE;IACE,WAAA;EA9tBF;AACF;AAiuBA;EACE;IACE,WAAA;EA/tBF;AACF;AAkuBA;EACE;IACE,WAAA;EAhuBF;AACF;AAmuBA;EACE;IACE,WAAA;EAjuBF;AACF;AAouBA;EACE;IACE,WAAA;EAluBF;AACF;AAquBA;EACE;IACE,WAAA;EAnuBF;AACF;AAsuBA;EACE;IACE,WAAA;EApuBF;AACF;AAuuBA,sDAAA;AAEA,sDAAA;AAEA;EACE,YAAA;EACA,cAAA;AAvuBF;;AA0uBA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AAvuBF;;AA0uBA;EACE,UAAA;AAvuBF;;AA0uBA;EACE,UAAA;AAvuBF;;AA0uBA;EACE,YAAA;EACA,cAAA;AAvuBF;;AA0uBA;EACE,WAAA;EACA,6BAAA;AAvuBF;;AA0uBA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,gBAAA;EACA,8BAAA;AAxuBF;;AA2uBA;;EAEE,UAAA;EACA,aAAA;AAxuBF;;AA2uBA;EACE,aAAA;EACA,sBAAA;AAxuBF;;AA2uBA;EACE,WAAA;EACA,YAAA;AAxuBF;;AA2uBA;EACE,eAAA;AAxuBF;;AA2uBA;EACE,WAAA;AAxuBF;;AA2uBA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAxuBF;;AA2uBA;EACE,iBAAA;EACA,kBAAA;AAxuBF;;AA2uBA;EACE;IACE,WAAA;EAxuBF;AACF;AA2uBA;EACE;IACE,WAAA;EAzuBF;AACF;AA4uBA;EACE;IACE,WAAA;EA1uBF;AACF;AA6uBA;EACE;IACE,WAAA;EA3uBF;AACF;AA8uBA;EACE;IACE,WAAA;EA5uBF;AACF;AA+uBA;EACE;IACE,WAAA;EA7uBF;AACF;AAgvBA;EACE;IACE,eAAA;EA9uBF;EAivBA;IACE,WAAA;IACA,WAAA;EA/uBF;EAkvBA;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;EAhvBF;EAmvBA;;IAEE,WAAA;EAjvBF;EAovBA;IACE,YAAA;EAlvBF;EAqvBA;IACE,gBAAA;IACA,YAAA;EAnvBF;EAsvBA;IACE,YAAA;IACA,cAAA;EApvBF;EAuvBA;IACE,YAAA;IACA,cAAA;EArvBF;AACF;AAwvBA,uDAAA;AAEA,oDAAA;AAEA;EACE,aAAA;AAxvBF;;AA2vBA;EACE,UAAA;AAxvBF;;AA2vBA;EACE,YAAA;EACA,gBAAA;AAxvBF;;AA2vBA;EACE;IACE,WAAA;EAxvBF;AACF;AA2vBA;EACE;IACE,WAAA;EAzvBF;AACF;AA4vBA;EACE;IACE,WAAA;EA1vBF;AACF;AA6vBA;EACE;IACE,WAAA;EA3vBF;AACF;AA8vBA;EACE;IACE,aAAA;IACA,sBAAA;EA5vBF;EA+vBA;;IAEE,WAAA;EA7vBF;EAgwBA;;IAEE,WAAA;EA9vBF;AACF;AAiwBA;EACE;;IAEE,WAAA;EA/vBF;AACF;AAkwBA;EACE;;IAEE,WAAA;EAhwBF;AACF;AAmwBA,qDAAA;AAEA,qDAAA;AAEA;EACE,WAAA;AAnwBF;;AAswBA;EACE,UAAA;EACA,gBAAA;EACA,iBAAA;AAnwBF;;AAswBA;EACE,UAAA;EACA,YAAA;AAnwBF;;AAswBA;EACE;IACE,UAAA;EAnwBF;AACF;AAswBA;EACE;IACE,UAAA;EApwBF;AACF;AAuwBA;EACE;IACE,UAAA;EArwBF;AACF;AAwwBA;EACE;IACE,UAAA;EAtwBF;AACF;AAywBA;EACE;IACE,UAAA;EAvwBF;EA0wBA;IACE,UAAA;EAxwBF;AACF;AA2wBA;EACE;IACE,UAAA;EAzwBF;EA4wBA;IACE,UAAA;EA1wBF;AACF;AA6wBA;EACE;IACE,UAAA;EA3wBF;EA8wBA;IACE,UAAA;EA5wBF;AACF;AA+wBA;EACE;IACE,UAAA;EA7wBF;EAgxBA;IACE,UAAA;EA9wBF;AACF;AAixBA;EACE;IACE,UAAA;EA/wBF;EAkxBA;IACE,UAAA;EAhxBF;AACF;AAmxBA;EACE;IACE,UAAA;EAjxBF;EAoxBA;IACE,UAAA;EAlxBF;AACF;AAqxBA;EACE;IACE,UAAA;EAnxBF;EAsxBA;IACE,UAAA;EApxBF;AACF;AAuxBA;EACE;IACE,UAAA;EArxBF;EAwxBA;IACE,UAAA;EAtxBF;AACF;AAyxBA;EACE;IACE,aAAA;EAvxBF;EA0xBA;IACE,UAAA;IACA,gBAAA;EAxxBF;EA2xBA;IACE,UAAA;EAzxBF;EA4xBA;IACE,aAAA;EA1xBF;AACF;AA6xBA;EACE;IACE,aAAA;EA3xBF;EA8xBA;IACE,UAAA;IACA,gBAAA;EA5xBF;EA+xBA;IACE,UAAA;EA7xBF;EAgyBA;IACE,aAAA;EA9xBF;AACF;AAiyBA;EACE;IACE,aAAA;IACA,sBAAA;EA/xBF;EAkyBA;IACE,WAAA;IACA,gBAAA;EAhyBF;EAmyBA;IACE,WAAA;EAjyBF;EAoyBA;IACE,aAAA;EAlyBF;AACF;AAqyBA,sDAAA;AAEA,sDAAA;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EAEA,UAAA;EACA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,oBAAA;AAtyBF;;AAyyBA;EACE,6BAAA;EACA,YAAA;EACA,yBAAA;AAtyBF;;AAyyBA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AAtyBF;;AAyyBA;;;EAGE,aAAA;EACA,aAAA;AAtyBF;;AAyyBA;;;EAGE,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAtyBF;;AAyyBA;;;EAGE,UAAA;EACA,YAAA;EACA,6BAAA;AAtyBF;;AAyyBA;EACE,gBAAA;EACA,kBAAA;AAtyBF;;AAyyBA;EACE,YAAA;EACA,6BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;AAtyBF;;AAyyBA;EAEE,WAAA;AAvyBF;;AA0yBA;EACE,eAAA;AAvyBF;;AA0yBA;EACE,YAAA;AAvyBF;;AA0yBA;EACE,iBAAA;AAvyBF;;AA0yBA;EACE;IACE,YAAA;EAvyBF;AACF;AA0yBA;EACE;IACE,YAAA;EAxyBF;EA2yBA;;;IAGE,UAAA;EAzyBF;EA4yBA;;;IAGE,UAAA;EA1yBF;AACF;AA6yBA;EACE;;;IAGE,UAAA;EA3yBF;EA8yBA;;;IAGE,UAAA;EA5yBF;AACF;AA+yBA;EACE;IACE,WAAA;EA7yBF;AACF;AAgzBA;EACE;IACE,WAAA;EA9yBF;EAizBA;IACE,YAAA;EA/yBF;EAkzBA;;;IAGE,aAAA;IACA,sBAAA;IACA,WAAA;EAhzBF;EAmzBA;;;IAGE,WAAA;IACA,gBAAA;EAjzBF;EAozBA;;;IAGE,UAAA;EAlzBF;AACF;AAqzBA;EACE;IACE,WAAA;EAnzBF;AACF;AAszBA;EACE;IACE,WAAA;EApzBF;AACF;AAuzBA;EACE;IACE,WAAA;EArzBF;AACF;AAwzBA,sDAAA;AAEA,sDAAA;AAEA;EACE,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wBAAA;EACA,+BAAA;EACA,UAAA;EACA,+BAAA;AAxzBF;;AA2zBA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAxzBF;;AA2zBA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;AAxzBF;;AA2zBA;EACE,qBAAA;EACA,YAAA;AAxzBF;;AA2zBA;EACE,oBAAA;AAxzBF;;AA2zBA,kBAAA;AAEA;EACE,2CAAA;EACA,mBAAA;EACA,sDAAA;AAzzBF;;AA4zBA;EACE,SAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;AAzzBF;;AA4zBA;EACE,0BAAA;AAzzBF;;AA4zBA;EACE,aAAA;AAzzBF;;AA4zBA;EACE,6BAAA;EACA,mBAAA;AAzzBF;;AA4zBA;EACE,mBAAA;AAzzBF;;AA4zBA;EACE,yBAAA;AAzzBF;;AA4zBA;EACE,aAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,8CAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,MAAA;EACA,sBAAA;AAzzBF;;AA4zBA;EACE,WAAA;EACA,QAAA;AAzzBF;;AA4zBA;EACE,kBAAA;AAzzBF;;AA4zBA;EACE,gDAAA;AAzzBF;;AA4zBA;EACE,aAAA;AAzzBF;;AA4zBA;EACE,iCAAA;AAzzBF;;AA4zBA;EACE,aAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,2CAAA;AAzzBF;;AA4zBA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;AAzzBF;;AA4zBA;EACE,eAAA;EACA,kBAAA;EACA,UAAA;AAzzBF;;AA4zBA;EACE,kBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;AAzzBF;;AA4zBA;EACE,gBAAA;AAzzBF;;AA4zBA,sDAAA;AAEA,gEAAA;AAEA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;AA3zBF;;AA8zBA;EACE,aAAA;EACA,gCAAA;AA3zBF;;AA8zBA;EACE,+BAAA;EACA,oBAAA;AA3zBF;;AA8zBA;EACE,oBAAA;AA3zBF;;AA8zBA;EACE,eAAA;EACA,aAAA;AA3zBF;;AA8zBA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;AA3zBF;;AA8zBA,gEAAA;AAEA;EACE,WAAA;AA5zBF;;AA+zBA,kDAAA;AAEA;EACE,gBAAA;AA7zBF;;AAg0BA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA7zBF;;AAg0BA;EACE,WAAA;AA7zBF;;AAg0BA;EACE,eAAA;AA7zBF;;AAg0BA;EACE;IACE,WAAA;EA7zBF;AACF;AAg0BA;EACE;IACE,WAAA;EA9zBF;AACF;AAi0BA;EACE;IACE,WAAA;EA/zBF;AACF;AAk0BA;EACE;IACE,WAAA;EAh0BF;AACF;AAm0BA;EACE;IACE,WAAA;EAj0BF;AACF;AAo0BA;EACE;IACE,WAAA;EAl0BF;AACF;AAq0BA;EACE;IACE,WAAA;EAn0BF;AACF;AAs0BA;EACE;IACE,eAAA;EAp0BF;EAu0BA;IACE,WAAA;EAr0BF;EAw0BA;IACE,YAAA;IACA,cAAA;EAt0BF;AACF;AAy0BA;EACE;IACE,eAAA;EAv0BF;EA00BA;IACE,WAAA;EAx0BF;AACF;AA20BA;EACE;IACE,eAAA;EAz0BF;EA40BA;IACE,WAAA;EA10BF;AACF;AA60BA;EACE;IACE,eAAA;EA30BF;EA80BA;IACE,WAAA;EA50BF;AACF;AA+0BA;EACE;IACE,eAAA;EA70BF;EAg1BA;IACE,WAAA;EA90BF;AACF;AAi1BA;EACE;IACE,YAAA;IACA,cAAA;EA/0BF;AACF;AAk1BA,kDAAA;AAEA,qDAAA;AAEA;EACE,WAAA;AAl1BF;;AAq1BA;EACE,eAAA;AAl1BF;;AAq1BA;EACE;IACE,WAAA;EAl1BF;AACF;AAq1BA;EACE;IACE,WAAA;EAn1BF;AACF;AAs1BA;EACE;IACE,WAAA;EAp1BF;AACF;AAu1BA;EACE;IACE,WAAA;EAr1BF;AACF;AAw1BA;EACE;IACE,WAAA;EAt1BF;AACF;AAy1BA;EACE;IACE,WAAA;EAv1BF;AACF;AA01BA;EACE;IACE,WAAA;EAx1BF;AACF;AA21BA;EACE;IACE,eAAA;EAz1BF;EA41BA;IACE,WAAA;EA11BF;AACF;AA61BA;EACE;IACE,eAAA;EA31BF;EA81BA;IACE,WAAA;EA51BF;AACF;AA+1BA;EACE;IACE,eAAA;EA71BF;EAg2BA;IACE,WAAA;EA91BF;AACF;AAi2BA;EACE;IACE,eAAA;EA/1BF;EAk2BA;IACE,WAAA;EAh2BF;AACF;AAm2BA;EACE;IACE,eAAA;EAj2BF;EAo2BA;IACE,YAAA;EAl2BF;AACF;AAq2BA,kDAAA;AAEA,0DAAA;AAEA;EACE,WAAA;AAr2BF;;AAw2BA;EACE,eAAA;AAr2BF;;AAw2BA;EACE;IACE,WAAA;EAr2BF;AACF;AAw2BA;EACE;IACE,WAAA;EAt2BF;AACF;AAy2BA;EACE;IACE,WAAA;EAv2BF;AACF;AA02BA;EACE;IACE,WAAA;EAx2BF;AACF;AA22BA;EACE;IACE,WAAA;EAz2BF;AACF;AA42BA;EACE;IACE,WAAA;EA12BF;AACF;AA62BA;EACE;IACE,WAAA;EA32BF;AACF;AA82BA;EACE;IACE,eAAA;EA52BF;EA+2BA;IACE,WAAA;EA72BF;AACF;AAg3BA;EACE;IACE,eAAA;EA92BF;EAi3BA;IACE,WAAA;EA/2BF;AACF;AAk3BA;EACE;IACE,eAAA;EAh3BF;EAm3BA;IACE,WAAA;EAj3BF;AACF;AAo3BA;EACE;IACE,eAAA;EAl3BF;EAq3BA;IACE,WAAA;EAn3BF;AACF;AAs3BA;EACE;IACE,eAAA;EAp3BF;EAu3BA;IACE,WAAA;EAr3BF;AACF;AAw3BA,kDAAA;AAEA,iDAAA;AAEA;EACE,UAAA;EACA,aAAA;AAx3BF;;AA23BA;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;AAx3BF;;AA23BA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAx3BF;;AA23BA;EACE,UAAA;EACA,aAAA;AAx3BF;;AA23BA;EACE,YAAA;EACA,6BAAA;AAx3BF;;AA23BA;EACE,UAAA;EACA,YAAA;AAx3BF;;AA23BA;EACE,UAAA;AAx3BF;;AA23BA;EACE,WAAA;AAx3BF;;AA23BA;EACE,UAAA;AAx3BF;;AA23BA;EACE,kBAAA;AAx3BF;;AA23BA;EACE;IACE,WAAA;EAx3BF;AACF;AA23BA;EACE;IACE,UAAA;EAz3BF;AACF;AA43BA;EACE;IACE,WAAA;EA13BF;AACF;AA63BA;EACE;IACE,aAAA;IACA,sBAAA;IACA,kBAAA;EA33BF;EA83BA;IACE,WAAA;EA53BF;EA+3BA;IACE,kBAAA;EA73BF;EAg4BA;IACE,WAAA;EA93BF;AACF;AAi4BA;EACE;IACE,WAAA;EA/3BF;AACF;AAk4BA;EACE;IACE,WAAA;EAh4BF;AACF;AAm4BA;EACE;IACE,WAAA;IACA,eAAA;EAj4BF;AACF;AAo4BA;EACE;IACE,kBAAA;IACA,kBAAA;EAl4BF;AACF;AAq4BA;EACE;IACE,WAAA;IACA,eAAA;EAn4BF;AACF;AAs4BA;EACE;IACE,WAAA;EAp4BF;AACF;AAu4BA;EACE;IACE,WAAA;EAr4BF;AACF;AAw4BA;EACE;IACE,WAAA;EAt4BF;AACF;AAy4BA;EACE;IACE,WAAA;EAv4BF;AACF;AA04BA,kDAAA;AAEA,6CAAA;AAEA;EACE,eAAA;AA14BF;;AA64BA;EACE;IACE,WAAA;EA14BF;AACF;AA64BA;EACE;IACE,WAAA;EA34BF;AACF;AA84BA;EACE;IACE,WAAA;EA54BF;AACF;AA+4BA,8CAAA;AAEA,8CAAA;AAEA;EACE,UAAA;EACA,iBAAA;AA/4BF;;AAk5BA;EACE,UAAA;EACA,kBAAA;EACA,6BAAA;EACA,YAAA;AA/4BF;;AAk5BA;EACE;IACE,UAAA;EA/4BF;EAk5BA;IACE,UAAA;EAh5BF;AACF;AAm5BA;EACE;IACE,UAAA;EAj5BF;EAo5BA;IACE,UAAA;EAl5BF;AACF;AAq5BA;EACE;IACE,UAAA;EAn5BF;EAs5BA;IACE,UAAA;EAp5BF;AACF;AAu5BA;EACE;IACE,UAAA;EAr5BF;EAw5BA;IACE,UAAA;EAt5BF;AACF;AAy5BA;EACE;IACE,aAAA;IACA,sBAAA;EAv5BF;EA05BA;IACE,WAAA;IACA,gBAAA;EAx5BF;EA25BA;IACE,WAAA;EAz5BF;AACF;AA45BA,8CAAA;AAEA,8CAAA;AAEA;EACE;IACE,WAAA;EA55BF;AACF;AA+5BA;EACE;IACE,WAAA;EA75BF;AACF;AAg6BA;EACE;IACE,WAAA;EA95BF;AACF;AAi6BA;EACE;IACE,WAAA;EA/5BF;AACF;AAk6BA;EACE;IACE,WAAA;EAh6BF;AACF;AAm6BA;EACE;IACE,WAAA;EAj6BF;AACF;AAo6BA,8CAAA;AAEA,6CAAA;AAEA;EACE,eAAA;AAp6BF;;AAu6BA;EACE;IACE,WAAA;EAp6BF;AACF;AAu6BA;EACE;IACE,WAAA;EAr6BF;AACF;AAw6BA;EACE;IACE,WAAA;EAt6BF;AACF;AAy6BA;EACE;IACE,WAAA;EAv6BF;AACF;AA06BA;EACE;IACE,WAAA;EAx6BF;AACF;AA26BA;EACE;IACE,WAAA;EAz6BF;AACF;AA46BA;EACE;IACE,WAAA;EA16BF;AACF;AA66BA,8CAAA;AAEA,4CAAA;AAEA;EACE;IACE,WAAA;EA76BF;AACF;AAg7BA;EACE;IACE,WAAA;EA96BF;AACF;AAi7BA;EACE;IACE,WAAA;EA/6BF;AACF;AAk7BA;EACE;IACE,WAAA;EAh7BF;AACF;AAm7BA;EACE;IACE,WAAA;EAj7BF;AACF;AAo7BA;EACE;IACE,WAAA;EAl7BF;AACF;AAq7BA,8CAAA;AAEA,4CAAA;AAEA;EACE;IACE,WAAA;EAr7BF;AACF;AAw7BA;EACE;IACE,WAAA;EAt7BF;AACF;AAy7BA;EACE;IACE,WAAA;EAv7BF;AACF;AA07BA;EACE;IACE,WAAA;EAx7BF;AACF;AA27BA;EACE;IACE,WAAA;EAz7BF;AACF;AA47BA,8CAAA;AAEA,4CAAA;AAEA;EACE;IACE,WAAA;EA57BF;AACF;AA+7BA;EACE;IACE,WAAA;EA77BF;AACF;AAg8BA;EACE;IACE,WAAA;EA97BF;AACF;AAi8BA;EACE;IACE,WAAA;EA/7BF;AACF;AAk8BA;EACE;IACE,WAAA;EAh8BF;AACF;AAm8BA;EACE;IACE,WAAA;EAj8BF;AACF;AAo8BA;EACE;IACE,WAAA;EAl8BF;AACF;AAq8BA,8CAAA;AAEA,oDAAA;AAEA;EACE;IACE,WAAA;EAr8BF;AACF;AAw8BA;EACE;IACE,WAAA;EAt8BF;AACF;AAy8BA;EACE;IACE,WAAA;EAv8BF;AACF;AA08BA;EACE;IACE,WAAA;EAx8BF;AACF;AA28BA;EACE;IACE,WAAA;EAz8BF;AACF;AA48BA;EACE;IACE,WAAA;EA18BF;AACF;AA68BA;EACE;IACE,WAAA;EA38BF;AACF;AA88BA,8CAAA;AAEA,iDAAA;AAEA;EACE;IACE,WAAA;EA98BF;AACF;AAi9BA;EACE;IACE,WAAA;EA/8BF;AACF;AAk9BA;EACE;IACE,WAAA;EAh9BF;AACF;AAm9BA;EACE;IACE,WAAA;EAj9BF;AACF;AAo9BA;EACE;IACE,WAAA;EAl9BF;AACF;AAq9BA;EACE;IACE,WAAA;EAn9BF;AACF;AAs9BA;EACE;IACE,WAAA;EAp9BF;AACF;AAu9BA,8CAAA;AAEA,4CAAA;AAEA;EACE;IACE,WAAA;EAv9BF;AACF;AA09BA;EACE;IACE,WAAA;EAx9BF;AACF;AA29BA;EACE;IACE,WAAA;EAz9BF;AACF;AA49BA;EACE;IACE,WAAA;EA19BF;AACF;AA69BA;EACE;IACE,WAAA;EA39BF;AACF;AA89BA;EACE;IACE,WAAA;EA59BF;AACF;AA+9BA;EACE;IACE,WAAA;EA79BF;AACF;AAg+BA,8CAAA;AAEA,8CAAA;AAEA;EACE;IACE,WAAA;EAh+BF;AACF;AAm+BA;EACE;IACE,WAAA;EAj+BF;AACF;AAo+BA;EACE;;IAEE,WAAA;EAl+BF;AACF;AAq+BA;EACE;IACE,WAAA;EAn+BF;AACF;AAs+BA;EACE;IACE,WAAA;EAp+BF;AACF;AAu+BA;EACE;IACE,WAAA;EAr+BF;AACF;AAw+BA;EACE;IACE,WAAA;EAt+BF;AACF;AAy+BA;EACE;IACE,WAAA;EAv+BF;AACF;AA0+BA,8CAAA;AAEA,gDAAA;AAEA;EACE,iCAAA;EACA,kBAAA;AA1+BF;;AA6+BA;EACE,iCAAA;EACA,iBAAA;EACA,oBAAA;AA1+BF;;AA6+BA;EACE,YAAA;AA1+BF;;AA6+BA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;AA1+BF;;AA6+BA;EACE,gBAAA;AA1+BF;;AA6+BA;EACE,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;AA1+BF;;AA6+BA;EACE,WAAA;AA1+BF;;AA6+BA;EACE,gBAAA;EACA,mBAAA;AA1+BF;;AA6+BA;;EAEE,gBAAA;EACA,mBAAA;AA1+BF;;AA6+BA;EACE,SAAA;AA1+BF;;AA6+BA;EACE,UAAA;EACA,6BAAA;AA1+BF;;AA6+BA;EACE,UAAA;EACA,iBAAA;EACA,6BAAA;AA1+BF;;AA6+BA;EACE;IACE,SAAA;EA1+BF;EA6+BA;IACE,UAAA;IACA,6BAAA;EA3+BF;EA8+BA;IACE,YAAA;IACA,iBAAA;EA5+BF;AACF;AA++BA;EACE;IACE,SAAA;EA7+BF;EAg/BA;IACE,UAAA;IACA,6BAAA;EA9+BF;EAi/BA;IACE,YAAA;IACA,iBAAA;EA/+BF;AACF;AAk/BA;EACE;IACE,UAAA;EAh/BF;EAm/BA;IACE,UAAA;IACA,6BAAA;EAj/BF;EAo/BA;IACE,YAAA;IACA,iBAAA;EAl/BF;AACF;AAq/BA;EACE;IACE,UAAA;EAn/BF;EAs/BA;IACE,UAAA;IACA,6BAAA;EAp/BF;EAu/BA;IACE,YAAA;IACA,iBAAA;EAr/BF;AACF;AAw/BA;EACE;IACE,UAAA;EAt/BF;EAy/BA;IACE,UAAA;IACA,6BAAA;EAv/BF;EA0/BA;IACE,UAAA;IACA,iBAAA;EAx/BF;AACF;AA2/BA;EACE;IACE,UAAA;EAz/BF;EA4/BA;IACE,UAAA;IACA,6BAAA;EA1/BF;EA6/BA;IACE,UAAA;IACA,iBAAA;EA3/BF;AACF;AA8/BA;EACE;IACE,eAAA;EA5/BF;EA+/BA;IACE,YAAA;EA7/BF;AACF;AAggCA;EACE;IACE,UAAA;EA9/BF;EAigCA;IACE,UAAA;IACA,6BAAA;EA//BF;EAkgCA;IACE,UAAA;IACA,iBAAA;EAhgCF;AACF;AAmgCA;EACE;IACE,eAAA;EAjgCF;EAogCA;IACE,uBAAA;EAlgCF;AACF;AAqgCA;EACE;;IAEE,gBAAA;IACA,mBAAA;IACA,aAAA;IACA,eAAA;EAngCF;EAsgCA;IACE,WAAA;EApgCF;EAugCA;IACE,WAAA;IACA,6BAAA;EArgCF;EAwgCA;IACE,WAAA;IACA,gBAAA;IACA,gBAAA;EAtgCF;AACF;AAygCA,+CAAA;AAEA,sDAAA;AAEA;EACE;IACE,WAAA;EAzgCF;AACF;AA4gCA;EACE;IACE,WAAA;EA1gCF;AACF;AA6gCA;EACE;IACE,WAAA;EA3gCF;AACF;AA8gCA;EACE;IACE,WAAA;EA5gCF;AACF;AA+gCA;EACE;IACE,WAAA;EA7gCF;AACF;AAghCA;EACE;IACE,WAAA;EA9gCF;AACF;AAihCA;EACE;IACE,WAAA;EA/gCF;AACF;AAkhCA,+CAAA;AAEA,gDAAA;AAEA;EACE,YAAA;EACA,gBAAA;AAlhCF;;AAqhCA;EACE,gBAAA;AAlhCF;;AAqhCA;EACE;IACE,WAAA;EAlhCF;EAqhCA;IACE,eAAA;EAnhCF;AACF;AAshCA;EACE;IACE,WAAA;EAphCF;AACF;AAuhCA;EACE;IACE,WAAA;EArhCF;AACF;AAwhCA;EACE;IACE,WAAA;EAthCF;AACF;AAyhCA;EACE;IACE,WAAA;EAvhCF;AACF;AA0hCA,gDAAA;AAEA,gDAAA;AAEA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA1hCF;;AA6hCA;EACE;IACE,WAAA;EA1hCF;EA6hCA;IACE,eAAA;EA3hCF;AACF;AA8hCA;EACE;IACE,WAAA;EA5hCF;AACF;AA+hCA;EACE;IACE,WAAA;EA7hCF;AACF;AAgiCA;EACE;IACE,WAAA;EA9hCF;AACF;AAiiCA;EACE;IACE,WAAA;EA/hCF;AACF;AAkiCA,gDAAA;AAEA,gDAAA;AAEA;EACE,eAAA;AAliCF;;AAqiCA,gDAAA;AACA,qDAAA;AAEA;EACE,WAAA;EACA,0CAAA;AAniCF;;AAsiCA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AAniCF;;AAsiCA;EACE,YAAA;AAniCF;;AAsiCA;EACE,YAAA;EACA,cAAA;AAniCF;;AAsiCA;EACE,gBAAA;EACA,mBAAA;AAniCF;;AAsiCA;EACE,2CAAA;AAniCF;;AAsiCA,4CAAA;AAEA,gDAAA;AAEA;EACE,eAAA;AAriCF;;AAwiCA;EACE;IACE,WAAA;EAriCF;AACF;AAwiCA;EACE;IACE,WAAA;EAtiCF;AACF;AAyiCA;EACE;IACE,WAAA;EAviCF;AACF;AA0iCA;EACE;IACE,WAAA;EAxiCF;AACF;AA2iCA;EACE;IACE,WAAA;EAziCF;AACF;AA4iCA;EACE;IACE,WAAA;EA1iCF;AACF;AA6iCA,4CAAA;AAEA,6CAAA;AAEA;EACE,2BAAA;EACA,aAAA;AA7iCF;;AAgjCA;EACE,UAAA;EACA,2BAAA;AA7iCF;;AAgjCA;EACE,2BAAA;EACA,WAAA;EACA,yCAAA;EACA,gBAAA;AA7iCF;;AAgjCA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA7iCF;;AAgjCA;EACE,oBAAA;EACA,gBAAA;AA7iCF;;AAgjCA;EACE,+BAAA;EACA,cAAA;EACA,kBAAA;AA7iCF;;AAgjCA,4CAAA;AAEA;EACE,gBAAA;AA9iCF;;AAijCA,4CAAA;AAEA;EACE,iBAAA;AA/iCF;;AAsjCA;;;;;;;;EAQE,eAAA;AAnjCF;;AAsjCA;EACE,0BAAA;AAnjCF;;AAsjCA;EACE,uBAAA;AAnjCF;;AAsjCA;EACE,yBAAA;AAnjCF;;AAsjCA;EACE,cAAA;AAnjCF;;AAsjCA;EACE,mBAAA;AAnjCF;;AAsjCA;EACE,uBAAA;EACA,cAAA;AAnjCF;;AAwjCA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;AArjCF;;AA0jCA;EACE,kBAAA;EACA,eAAA;AAvjCF;;AA4jCA;EACE,YAAA;AAzjCF;;AA4jCA;EACE,0BAAA;EACA,gBAAA;EACA,kBAAA;AAzjCF;;AA4jCA;EACE,aAAA;EACA,yBAAA;AAzjCF;;AA4jCA;EACE,2BAAA;AAzjCF;;AA4jCA;EACE,iBAAA;AAzjCF;;AA4jCA;EACE,gBAAA;EACA,cAAA;AAzjCF;;AA4jCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AAzjCF;;AA4jCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;AAzjCF;;AA4jCA;EACE,WAAA;AAzjCF;;AA4jCA;EACE,WAAA;EACA,iBAAA;AAzjCF;;AA4jCA;EACE,WAAA;EACA,iBAAA;AAzjCF;;AA4jCA;EACE,uBAAA;AAzjCF;;AA4jCA;EACE,sBAAA;AAzjCF;;AA4jCA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAzjCF;;AA4jCA;EACE,6BAAA;EACA,kBAAA;EACA,wCAAA;AAzjCF;;AA4jCA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;AAzjCF;;AA4jCA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAzjCF;;AA4jCA;EACE,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,YAAA;EACA,mBAAA;EACA,kFACE;AA1jCJ;AA6jCE;EACE,eAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AA3jCJ;AA6jCI;EACE,gBAAA;AA3jCN;AA8jCI;EACE,iBAAA;AA5jCN;AA+jCI;EACE,eAAA;AA7jCN;AAgkCI;EACE,uBAAA;AA9jCN;AAikCI;EACE,WAAA;AA/jCN;AAkkCI;EACE,cAAA;AAhkCN;AAmkCI;EACE,uBAAA;AAjkCN;;AAukCE;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AApkCJ;;AAwkCA;EACE,qCAAA;AArkCF;;AAwkCA;EACE,YAAA;EACA,mDAAA;EACA,qCAAA;EACA,kBAAA;EACA,kFACE;AAtkCJ;AAykCE;EACE,YAAA;AAvkCJ;AAykCI;EACE,gBAAA;AAvkCN;;AA4kCA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAzkCF;;AA6kCE;EACE,SAAA;AA1kCJ;;AA8kCA;EACE,uBAAA;AA3kCF;;AA8kCA;EACE,qBAAA;EACA,wCAAA;AA3kCF;;AA8kCA;EACE,4BAAA;EACA,YAAA;EACA,qDAAA;AA3kCF;;AA8kCA;;;EAGE,gBAAA;AA3kCF;;AA8kCA;;EAEE,sBAAA;EACA,wBAAA;EACA,cAAA;EACA,uBAAA;AA3kCF;;AA8kCA;EACE,aAAA;AA3kCF;;AA8kCA;EACE,cAAA;AA3kCF;;AA8kCA;EACE,aAAA;AA3kCF;;AA8kCA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA3kCF;;AA8kCA;EACE,yBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;AA3kCF;;AA8kCA;EACE,yBAAA;EACA,kBAAA;EACA,YAAA;AA3kCF;;AA8kCA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AA3kCF;;AA8kCA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AA3kCF;AA6kCE;EACE,mBAAA;AA3kCJ;AA8kCE;EACE,mBAAA;EACA,kBAAA;AA5kCJ;;AAglCA;EACE,gBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,gCAAA;AA7kCF;AA+kCE;EACE,gDAAA;AA7kCJ;AAglCE;EACE,gDAAA;EACA,kBAAA;AA9kCJ;;AAklCA;EACE,YAAA;AA/kCF;;AAklCA;EACE,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kCAAA;AA/kCF;;AAklCA;EACE,eAAA;EACA,mBAAA;EACA,kCAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,SAAA;AA/kCF;;AAklCA;EACE,oCAAA;AA/kCF;;AAklCA;EACE,YAAA;EACA,cAAA;AA/kCF;AAilCE;EACE,mBAAA;EACA,kBAAA;AA/kCJ;;AAwlCA;EACE,cAAA;EACA,2BAAA;AArlCF;AAwlCI;EACE,eAAA;EACA,gBAAA;AAtlCN;;AA2lCA;EACE,eAAA;EACA,gBAAA;AAxlCF;;AA2lCA;EACE,eAAA;EACA,gBAAA;AAxlCF;;AA2lCA;EACE,eAAA;EACA,gBAAA;AAxlCF;;AA2lCA;EACE,eAAA;EACA,gBAAA;AAxlCF;;AA2lCA;EACE,eAAA;EACA,gBAAA;AAxlCF;;AA2lCA;EACE,eAAA;EACA,gBAAA;AAxlCF;;AA2lCA;EACE,eAAA;EACA,gBAAA;AAxlCF;;AA2lCA;EACE,oBAAA;AAxlCF;;AA2lCA;EACE,kBAAA;AAxlCF;;AA2lCA;EACE,0BAAA;EACA,qBAAA;AAxlCF;;AA2lCA;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAxlCF;;AA2lCA;EACE,gDAAA;AAxlCF;;AA2lCA;EACE,uCAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;AAxlCF;;AA2lCA;EACE,uCAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;AAxlCF;;AA2lCA;EACE,wCAAA;EACA,wBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;AAxlCF;;AA2lCA;EACE,uCAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,gCAAA;EACA,kBAAA;EACA,qBAAA;AAxlCF;;AA2lCA;EACE,kBAAA;AAxlCF;;AA2lCA;EACE,aAAA;AAxlCF;;AA2lCA;EACE,2BAAA;EACA,cAAA;AAxlCF;;AA2lCA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;AAxlCF;;AA2lCA;EACE,2BAAA;EACA,cAAA;AAxlCF;;AA4lCE;EACE,gBAAA;AAzlCJ;AA4lCE;;;;EAIE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AA1lCJ;AA6lCE;;EAEE,mBAAA;AA3lCJ;AA8lCE;EACE,eAAA;AA5lCJ;;AAgmCA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AA7lCF;;AAgmCA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;AA7lCF;;AAgmCA;EAEE,aAAA;EACA,kBAAA;AA9lCF;;AAkmCA;EACE,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;AA/lCF;;AAkmCA;EACE,kBAAA;EACA,2BAAA;AA/lCF;;AAkmCA;EACE,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA/lCF;;AAkmCA;EACE,wBAAA;EACA,kBAAA;EAGA,aAAA;AAjmCF;;AAqmCA;EACE,2BAAA;EACA,cAAA;AAlmCF;AAomCE;EACE,eAAA;AAlmCJ;;AAsmCA;EACE,2BAAA;EACA,cAAA;EACA,yDAAA;AAnmCF;;AAsmCA;EACE,2BAAA;EACA,cAAA;AAnmCF;AAqmCE;EACE,eAAA;AAnmCJ;;AAwmCE;EACE,eAAA;AArmCJ;;AAymCA;EAEE,kBAAA;AAvmCF;AA0mCE;EACE,kBAAA;AAxmCJ;AA0mCI;EACE,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAxmCN;AA6mCI;EACE,kBAAA;AA3mCN;;AAgnCA;EACE,iBAAA;AA7mCF;;AAgnCA;EACE,eAAA;EACA,SAAA;AA7mCF;;AAgnCA;EACE,2BAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,wBAAA;EACA,UAAA;AA7mCF;;AAgnCA;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,sDAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,wBAAA;AA7mCF;;AAgnCA;;EAEE,UAAA;AA7mCF;;AAgnCA;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;AA7mCF;;AAgnCA;EACE,gBAAA;EACA,mBAAA;AA7mCF;;AAgnCA;EACE,cAAA;AA7mCF;;AAgnCA;EACE,cAAA;AA7mCF;;AAgnCA;EACE,cAAA;EACA,eAAA;AA7mCF;;AAgnCA;EACE,eAAA;EACA,UAAA;AA7mCF;;AAgnCA;EACE,8BAAA;EACA,eAAA;AA7mCF;;AAgnCA;EACE,eAAA;AA7mCF;;AAgnCA;EACE,UAAA;EACA,aAAA;EACA,0CAAA;AA7mCF;;AAgnCA;EACE,gBAAA;EACA,kBAAA;AA7mCF;;AAinCA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;AA9mCF;;AAinCA;EACE,uCAAA;EACA,eAAA;AA9mCF;;AAinCA;EACE,aAAA;EACA,uBAAA;AA9mCF;;AAinCA;EACE,eAAA;AA9mCF;;AAinCA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,yBAAA;EACA,eAAA;AA9mCF;;AAinCA;EACE,yBAAA;EACA,cAAA;EACA,8BAAA;EACA,gBAAA;EACA,gBAAA;AA9mCF;;AAinCA;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;AA9mCF;;AAinCA;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AA9mCF;;AAinCA;EACE,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AA9mCF;AAgnCE;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;AA9mCJ;;AAknCA;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;AA/mCF;;AAknCA;EACE,eAAA;EACA,iBAAA;AA/mCF;;AAknCA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AA/mCF;;AAknCA;EACE,gBAAA;EACA,kCAAA;EACA,cAAA;EACA,yBAAA;EACA,gBAAA;AA/mCF;;AAknCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;AA/mCF;;AAknCA;EACE,yBAAA;EACA,WAAA;EACA,cAAA;AA/mCF;;AAknCA;EACE,eAAA;AA/mCF;;AAmnCE;EACE,eAAA;EACA,gBAAA;AAhnCJ;AAmnCE;EACE,eAAA;AAjnCJ;AAonCE;EACE,YAAA;AAlnCJ;AAqnCE;EACE,UAAA;AAnnCJ;AAsnCE;EACE,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AApnCJ;;AAynCE;EACE,eAAA;AAtnCJ;AAynCE;EACE,YAAA;AAvnCJ;;AA2nCA;EACE,2BAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;AAxnCF;;AA6nCI;EACE,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AA1nCN;AA6nCI;EACE,kBAAA;EACA,eAAA;AA3nCN;;AAgoCA;EACE,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA7nCF;;AAioCE;EACE,WAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;AA9nCJ;AAioCE;EACE,eAAA;EACA,gBAAA;AA/nCJ;;AAooCE;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;AAjoCJ;;AAqoCA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;AAloCF;;AAirCA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AA9qCF;;AAkrCE;EACE,gBAAA;EACA,cAAA;AA/qCJ;AAirCI;EACE,4CAAA;AA/qCN;AAmrCE;EACE,4CAAA;AAjrCJ;;AAqrCA;EACE,gCAAA;EACA,aAAA;AAlrCF;AAorCE;EACE,WAAA;AAlrCJ;;AAsrCA;EACE,aAAA;AAnrCF;;AAsrCA;EACE,SAAA;EACA,wBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AAnrCF;;AAsrCA;EAGE,aAAA;AArrCF;;AAwrCA;EACE,2BAAA;AArrCF;;AAwrCA;EACE,yBAAA;EACA,mBAAA;AArrCF;;AAwrCA,2BAAA;AAEA;EACE,aAAA;AAtrCF;;AAyrCA;EACE,WAAA;EAEA,YAAA;EACA,cAAA;EAEA,gBAAA;AAxrCF;;AA2rCA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAxrCF;;AA2rCA;EACE,wBAAA;EACA,2BAAA;AAxrCF;;AA2rCA;EACE,2BAAA;EACA,cAAA;AAxrCF;;AA2rCA;EACE,eAAA;AAxrCF;;AA2rCA;EACE,mBAAA;AAxrCF;;AA2rCA;EACE,UAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;AAxrCF;;AA2rCA;EACE,8BAAA;EACA,8BAAA;EACA,wCAAA;AAxrCF;;AA2rCA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;AAxrCF;;AA2rCA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;AAxrCF;AA2rCE;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AAzrCJ;;AA6rCA;EACE,kBAAA;EACA,kBAAA;AA1rCF;AA4rCE;EACE,eAAA;EACA,SAAA;EACA,gBAAA;AA1rCJ;;AA8rCA;EACE,2BAAA;EACA,kBAAA;EACA,YAAA;AA3rCF;;AA8rCA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AA3rCF;AA8rCI;EACE,cAAA;EACA,iBAAA;AA5rCN;;AAisCA;EACE,cAAA;AA9rCF;;AAisCA;EACE,kBAAA;EACA,WAAA;AA9rCF;;AAusCA;;EAEE,wBAAA;EACA,kBAAA;AApsCF;;AA8sCA;;EAEE,gDAAA;AA3sCF;;AA8sCA;EACE,2DAAA;EACA,kBAAA;AA3sCF;;AAqtCA;;;EAGE,WAAA;AAltCF;;AAqtCA;EACE,kBAAA;AAltCF;;AAuuCA;EACE,YAAA;EACA,eAAA;AApuCF;;AAuuCA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;AApuCF;;AA6uCA;EACE,sBAAA;EACA,wBAAA;EACA,kBAAA;AA1uCF;;AA6uCA;EACE,gBAAA;EACA,kBAAA;EACA,qCAAA;EACA,YAAA;EACA,mBAAA;EACA,kFACE;EAEF,gBAAA;EACA,iBAAA;AA5uCF;AA8uCE;EACE,gDAAA;AA5uCJ;;AAgvCA;EACE,aAAA;EACA,cAAA;AA7uCF;;AAgvCA;EACE,eAAA;AA7uCF;;AAgvCA;EACE,WAAA;EACA,YAAA;AA7uCF;;AAgvCA;EACE,eAAA;AA7uCF;;AAgvCA;EACE,2BAAA;EACA,cAAA;AA7uCF;AA+uCE;EACE,iBAAA;EACA,mBAAA;AA7uCJ;;AAivCA;EACE,aAAA;EACA,QAAA;AA9uCF;;AAivCA;EACE,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AA9uCF;;AAivCA;;EAEE,eAAA;AA9uCF;;AAkvCE;EACE,YAAA;AA/uCJ;AAkvCE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;AAhvCJ;AAmvCE;EACE,eAAA;EACA,SAAA;AAjvCJ;;AAqvCA;EACE,8BAAA;AAlvCF;AAovCE;EACE,mBAAA;EACA,2BAAA;EACA,cAAA;AAlvCJ;;AAsvCA;EACE,aAAA;AAnvCF;AAqvCE;EACE,oBAAA;EACA,wCAAA;EACA,YAAA;EACA,mBAAA;AAnvCJ;AAsvCE;EACE,qBAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AApvCJ;AAuvCE;EACE,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,oBAAA;AArvCJ;AAuvCI;EACE,SAAA;AArvCN;AAwvCI;EACE,eAAA;EACA,gBAAA;AAtvCN;AAyvCI;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAvvCN;AA0vCI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,WAAA;EACA,QAAA;EACA,+BAAA;AAxvCN;AA2vCI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,WAAA;EACA,QAAA;EACA,+BAAA;AAzvCN;AA2vCM;EACE,eAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AAzvCR;AA6vCI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,0BAAA;EACA,WAAA;EACA,QAAA;EACA,+BAAA;AA3vCN;AA6vCM;EACE,eAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;AA3vCR;AA+vCI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,QAAA;EACA,+BAAA;AA7vCN;AAgwCI;EACE,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,QAAA;EACA,+BAAA;AA9vCN;;AAmwCA;EACE,2BAAA;EACA,kBAAA;AAhwCF;;AAowCE;EACE,SAAA;EACA,eAAA;EACA,YAAA;AAjwCJ;;AAqwCA;EACE,yBAAA;AAlwCF;;AAqwCA;EACE,6BAAA;AAlwCF;;AAqwCA;EACE,uBAAA;EACA,8CAAA;AAlwCF;;AAqwCA;EACE,eAAA;AAlwCF;;AAqwCA;EACE,2BAAA;EACA,cAAA;AAlwCF;;AAqwCA;EACE,2BAAA;EACA,cAAA;AAlwCF;;AAqwCA;EACE,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAlwCF;AAowCE;EACE,eAAA;EACA,SAAA;AAlwCJ;;AAswCA;EACE,cAAA;EACA,aAAA;AAnwCF;;AAswCA;EACE,cAAA;EACA,+BAAA;AAnwCF;;AAswCA;EACE,+BAAA;EACA,+BAAA;EACA,cAAA;AAnwCF;;AAswCA;EACE,WAAA;EACA,cAAA;AAnwCF;;AAswCA;EACE,kBAAA;AAnwCF;;AAswCA;EACE,uBAAA;EACA,2BAAA;AAnwCF;;AAswCA;EACE,qBAAA;EACA,2BAAA;AAnwCF;;AAswCA;;;;;;EAME,2BAAA;EACA,iCAAA;AAnwCF;;AAswCA;EACE,SAAA;EACA,UAAA;AAnwCF;;AAswCA;EACE,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;AAnwCF;;AAswCA;;;EAGE,YAAA;EACA,uBAAA;AAnwCF;;AAswCA;EACE,YAAA;EACA,gBAAA;AAnwCF;;AAswCA;EACE,YAAA;AAnwCF;;AAswCA;EACE,2BAAA;EACA,kBAAA;AAnwCF;;AAwwCA;EACE,gBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;AArwCF;AAuwCE;EACE,WAAA;AArwCJ;AAuwCI;EACE,mBAAA;EACA,cAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AArwCN;AAywCM;EACE,6BAAA;AAvwCR;AAywCQ;EACE,yBAAA;EACA,8BAAA;AAvwCV;AA0wCQ;EACE,8BAAA;AAxwCV;AA8wCM;EACE,kBAAA;AA5wCR;AA8wCQ;EACE,YAAA;AA5wCV;AAkxCM;EACE,mBAAA;AAhxCR;AAkxCQ;EACE,YAAA;AAhxCV;AAsxCM;EAEE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,2BAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;AArxCR;AAwxCM;EACE,WAAA;EACA,8BAAA;AAtxCR;AAyxCM;EACE,UAAA;EACA,yBAAA;EACA,8BAAA;AAvxCR;AA0xCM;EACE,yBAAA;EACA,WAAA;AAxxCR;AA0xCQ;EACE,qBAAA;EACA,8BAAA;AAxxCV;AA2xCQ;EACE,0BAAA;AAzxCV;AA6xCM;EACE,yBAAA;AA3xCR;AA6xCQ;EACE,qBAAA;EACA,8BAAA;AA3xCV;AA8xCQ;EACE,0BAAA;AA5xCV;;AAmyCA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;AAhyCF;;AAmyCA;EACE,uBAAA;EACA,aAAA;EACA,gBAAA;AAhyCF;;AAmyCA;EACE,aAAA;EACA,uBAAA;AAhyCF;;AAmyCA;;EAEE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAhyCF;;AAmyCA;EACE,kBAAA;AAhyCF;AAkyCE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAhyCJ;AAmyCE;EACE,eAAA;AAjyCJ;;AAqyCA;EACE,wBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,2CAAA;EACA,YAAA;AAlyCF;;AAqyCA;EACE,2BAAA;EACA,cAAA;AAlyCF;;AAqyCA;EACE,yBAAA;AAlyCF;;AAqyCA;EACE,wBAAA;AAlyCF;;AAqyCA;EACE,kDAAA;AAlyCF;;AAyyCA;EACE,eAAA;AAtyCF;;AA0yCE;EACE,kBAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;AAvyCJ;;AA2yCA;EACE,SAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAxyCF;;AA4yCE;EACE,eAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;AAzyCJ;;AA+yCI;EAEE,gBAAA;EACA,MAAA;EACA,UAAA;AA5yCN;;AAizCA;EACE,sBAAA;EACA,mBAAA;AA9yCF;;AAizCA;EACE,WAAA;EACA,sBAAA;AA9yCF;;AAizCA;EACE,WAAA;EACA,mBAAA;AA9yCF;;AAizCA;EACE,WAAA;EACA,sBAAA;AA9yCF;;AAkzCE;;;EAGE,4BAAA;AA/yCJ;;AAuzCE;;;;;;;;EAEE,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;EACA,0BAAA;AA9yCJ;AAizCE;;;;EACE,kBAAA;EACA,oCAAA;AA5yCJ;;AAizCE;;EAEE,uBAAA;AA9yCJ;;AAkzCA;EACE,oCAAA;AA/yCF;;AAkzCA;EACE,eAAA;EACA,YAAA;AA/yCF;;AAmzCE;EACE,uBAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;AAhzCJ;AAmzCE;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;AAjzCJ;;AAqzCA;;EAEE,8BAAA;AAlzCF;;AAqzCA;EACE,0BAAA;EACA,gCAAA;EACA,cAAA;AAlzCF;AAozCE;EACE,0BAAA;EACA,gCAAA;EACA,8BAAA;AAlzCJ;;AAszCA;EACE,mBAAA;EACA,0BAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;AAnzCF;AAqzCE;EACE,mBAAA;AAnzCJ;AAuzCE;EACE,uBAAA;EACA,mBAAA;AArzCJ;;AAyzCA;;EAEE,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,cAAA;AAtzCF;;AAyzCA;EACE,+CAAA;EACA,4CAAA;EACA,kBAAA;EACA,sBAAA;EACA,UAAA;AAtzCF;;AAyzCA;;EAEE,WAAA;EACA,WAAA;AAtzCF;;AAyzCA;;;;EAIE,mBAAA;EACA,WAAA;EACA,WAAA;AAtzCF;;AAyzCA;EACE,SAAA;EACA,wBAAA;EACA,YAAA;AAtzCF;;AAyzCA;EACE,wBAAA;EACA,mBAAA;EACA,4DAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;AAtzCF;;AA2zCE;;;EAEE,uBAAA;EACA,mBAAA;EACA,cAAA;AAvzCJ;;AA4zCE;EACE,wCAAA;EACA,oCAAA;AAzzCJ;;AA6zCA;EACE,sBAAA;AA1zCF;;AA6zCA;EACE,2BAAA;AA1zCF;;AA6zCA;EACE,+CAAA;EACA,cAAA;AA1zCF;;AA6zCA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1zCF;;AA6zCA;EACE,mBAAA;AA1zCF;;AA6zCA;EACE,eAAA;EACA,qBAAA;EACA,iCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,eAAA;AA1zCF;;AA6zCA;EACE,mBAAA;EACA,WAAA;AA1zCF;;AA6zCA;EACE,kBAAA;AA1zCF;;AA6zCA;;EAEE,qCAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,sBAAA;AA1zCF;;AA6zCA;;;;;;;EAOE,wBAAA;AA1zCF;;AA6zCA;EACE,0BAAA;EACA,uBAAA;AA1zCF;;AA6zCA;EACE,uBAAA;AA1zCF;;AA6zCA;;EAEE,wBAAA;EACA,wBAAA;EACA,8BAAA;AA1zCF;;AA6zCA;EACE,YAAA;EACA,iBAAA;AA1zCF;;AA6zCA;EACE,eAAA;AA1zCF;;AA6zCA;;EAEE,0BAAA;EACA,mDAAA;AA1zCF;;AA6zCA;EACE,0DAAA;EACA,yDAAA;AA1zCF;;AA6zCA;EACE,aAAA;EACA,0DAAA;AA1zCF;;AA6zCA;EACE,wDAAA;AA1zCF;;AA6zCA;EACE,yDAAA;AA1zCF;;AA6zCA;EACE,oBAAA;AA1zCF;;AA6zCA;;EAEE,oCAAA;AA1zCF;;AA6zCA;EACE,WAAA;EACA,YAAA;AA1zCF;;AA6zCA;EACE,UAAA;EACA,eAAA;AA1zCF;;AA6zCA;EACE,eAAA;AA1zCF;;AA6zCA;EACE,+BAAA;AA1zCF;;AA6zCA;;;EAGE,kCAAA;EACA,uBAAA;AA1zCF;;AA6zCA;;EAGE,SAAA;AA3zCF;;AA8zCA;EACE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;AA3zCF;;AA8zCA;EACE,cAAA;EACA,YAAA;EACA,WAAA;AA3zCF;;AA8zCA;EACE,2BAAA;EACA,cAAA;AA3zCF;;AA8zCA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AA3zCF;;AA8zCA;;;;;;;EAOE,gBAAA;AA3zCF;;AAg0CA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,cAAA;AA7zCF;;AAg0CA;;EAEE,eAAA;EACA,kBAAA;EACA,uBAAA;AA7zCF;;AAg0CA;EACE,8BAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;AA7zCF;;AAg0CA;EACE,YAAA;AA7zCF;;AAg0CA;EACE,mBAAA;AA7zCF;;AAg0CA;;EAEE,wCAAA;EACA,kCAAA;AA7zCF;;AAg0CA;EACE,uBAAA;EACA,wBAAA;EACA,wBAAA;EACA,4BAAA;EACA,uBAAA;AA7zCF;;AAg0CA;EACE,QAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AA7zCF;;AAk0CA;EAEE,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;AAh0CF;;AAo0CA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAj0CF;;AAo0CA;EACE,aAAA;EACA,sBAAA;AAj0CF;;AAo0CA;EACE,cAAA;AAj0CF;;AAo0CA;EACE,UAAA;EACA,iBAAA;AAj0CF;;AAo0CA;EACE,qCAAA;EACA,qBAAA;AAj0CF;;AAs0CA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAn0CF;;AAs0CA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAn0CF;;AAs0CA;EACE,cAAA;EACA,qBAAA;AAn0CF;;AAs0CA;EACE,0BAAA;AAn0CF;;AAs0CA;EACE,6BAAA;AAn0CF;;AAs0CA;EACE,yBAAA;EACA,iBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AAn0CF;;AAs0CA;EACE,6BAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;AAn0CF;;AAs0CA;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAn0CF;;AAs0CA;EACE,8BAAA;EACA,cAAA;AAn0CF;;AAs0CA;EACE,2BAAA;EACA,cAAA;AAn0CF;;AAs0CA;EACE,eAAA;EACA,gBAAA;AAn0CF;;AAs0CA;EACE,gCAAA;EACA,eAAA;EACA,iBAAA;AAn0CF;;AAs0CA;EACE,eAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AAn0CF;;AAs0CA;EACE,oCAAA;AAn0CF;;AAs0CA;EACE,oCAAA;AAn0CF;;AAw0CA;EACE,iBAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAr0CF;;AAw0CA;EACE,aAAA;EACA,gBAAA;EACA,WAAA;AAr0CF;;AAw0CA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAr0CF;;AAw0CA;;EAEE,WAAA;EACA,YAAA;AAr0CF;;AAw0CA;EACE,kBAAA;AAr0CF;;AAw0CA;EACE,kBAAA;AAr0CF;;AAw0CA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;AAr0CF;;AAw0CA;EACE,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAr0CF;;AAw0CA;;EAEE,eAAA;AAr0CF;;AAw0CA;EACE,kBAAA;AAr0CF;;AAw0CA;EACE,yBAAA;AAr0CF;;AAw0CA;EACE,2BAAA;EACA,cAAA;AAr0CF;;AAw0CA;EACE,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,cAAA;EACA,6BAAA;AAr0CF;;AAw0CA;EACE,eAAA;EACA,eAAA;EACA,SAAA;AAr0CF;;AAw0CA;EACE,YAAA;AAr0CF;;AAw0CA;EACE,eAAA;EACA,YAAA;AAr0CF;;AAw0CA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,UAAA;AAr0CF;;AAw0CA;EACE,UAAA;AAr0CF;;AAy0CA;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAt0CF;AAw0CE;EACE,YAAA;EACA,gBAAA;EACA,uBAAA;AAt0CJ;AAw0CI;EACE,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;AAt0CN;AAy0CI;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAv0CN;AA00CQ;EACE,eAAA;EACA,mBAAA;AAx0CV;AA20CQ;EACE,SAAA;EACA,eAAA;AAz0CV;AA60CM;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AA30CR;AA60CQ;EACE,YAAA;EACA,eAAA;AA30CV;AA80CQ;EACE,mBAAA;AA50CV;AAg1CM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AA90CR;AAg1CQ;EACE,YAAA;EACA,eAAA;AA90CV;AAi1CQ;EACE,mBAAA;AA/0CV;AAm1CM;EACE,YAAA;EACA,oBAAA;EACA,eAAA;AAj1CR;AAo1CM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAl1CR;AAo1CQ;EACE,YAAA;EACA,eAAA;AAl1CV;AAq1CQ;EACE,mBAAA;AAn1CV;AAs1CM;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AAp1CR;AAs1CQ;EACE,YAAA;EACA,eAAA;AAp1CV;AAu1CQ;EACE,mBAAA;AAr1CV;;AA81CA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA31CF;AA61CE;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;AA31CJ;;AA+1CA;EACE,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,+BAAA;AA51CF;AA81CE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AA51CJ;;AAg2CA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA71CF;AA+1CE;EACE,gBAAA;EACA,gBAAA;EACA,YAAA;AA71CJ;;AAi2CA;EACE,aAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,yBAAA;EACA,gCAAA;AA91CF;AAg2CE;EACE,eAAA;EACA,kBAAA;EACA,YAAA;AA91CJ;;AAk2CA;EACE,kCAAA;AA/1CF;;AAk2CA;EACE,wBAAA;AA/1CF;;AAm2CE;EACE,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAh2CJ;AAk2CI;EACE,kBAAA;EACA,mBAAA;EACA,0DAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;AAh2CN;AAo2CM;EACE,0DAAA;AAl2CR;AAo2CQ;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAl2CV;AAo2CU;EACE,kBAAA;EACA,0CAAA;AAl2CZ;AAs2CQ;EACE,gBAAA;AAp2CV;AAy2CI;EACE,UAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,uCAAA;AAv2CN;AA42CI;EACE,eAAA;AA12CN;AA42CM;EACE,eAAA;EACA,eAAA;AA12CR;;AAg3CA;;EAEE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AA72CF;;AAg3CA;;EAEE,mBAAA;EACA,kBAAA;EACA,cAAA;AA72CF;;AAg3CA;EACE,iBAAA;EACA,uCAAA;EACA,gBAAA;AA72CF;;AAg3CA;EACE,qBAAA;EACA,kBAAA;AA72CF;;AAg3CA;EACE,aAAA;EACA,mBAAA;AA72CF;;AAg3CA;EACE,sBAAA;AA72CF;;AAo3CA;EACE,YAAA;EACA,iBAAA;EACA,kEAAA;EACA,sDAAA;EACA,wBAAA;EACA,iCAAA;AAj3CF;;AAo3CA;EACE;IACE,6EACE;EAl3CJ;EAw3CA;IACE,2EACE;EAv3CJ;EA63CA;IACE,4EACE;EA53CJ;EAk4CA;IACE,4EACE;EAj4CJ;EAu4CA;IACE,4EACE;EAt4CJ;EA44CA;IACE,8EACE;EA34CJ;EAi5CA;IACE,6EACE;EAh5CJ;AACF;AAs5CA;EACE,gBAAA;EACA,kBAAA;AAp5CF;;AAu5CA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AAp5CF;;AAu5CA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAp5CF;;AAu5CA;EACE,aAAA;AAp5CF;;AAu5CA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,6BAAA;EACA,+CAAA;EACA,eAAA;EACA,gCAAA;AAp5CF;;AAu5CA;EACE,yBAAA;EACA,2BAAA;AAp5CF;;AAu5CA;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;AAp5CF;;AAu5CA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,qCAAA;EACA,8CAAA;AAp5CF;;AAu5CA;EACE,kBAAA;EACA,iBAAA;EACA,aAAA;AAp5CF;;AAu5CA;EACE,kCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;EACA,cAAA;AAp5CF;;AAu5CA;EACE,kCAAA;EACA,0BAAA;EACA,eAAA;AAp5CF;;AAu5CA;;;EAGE,kCAAA;EACA,UAAA;EACA,WAAA;AAp5CF;;AAu5CA;EACE,8BAAA;EACA,iBAAA;AAp5CF;;AAu5CA;EACE,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,kBAAA;AAp5CF;;AAu5CA;EACE,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,kBAAA;AAp5CF;;AAu5CA;EACE,WAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;AAp5CF;;AAu5CA;EACE,4BAAA;AAp5CF;;AAu5CA;EACE,qBAAA;EACA,oBAAA;AAp5CF;;AAu5CA;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,YAAA;AAp5CF;;AAu5CA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;EACA,8BAAA;AAp5CF;;AAu5CA;EACE,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,0BAAA;AAp5CF;;AAu5CA;EACE,kBAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AAp5CF;;AAu5CA;EACE,kBAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;AAp5CF;;AA45CA;EACE;IACE,aAAA;EAz5CF;AACF;AA45CA;EACE,gDAAA;AA15CF;;AA65CA;;EAEE,eAAA;EACA,eAAA;EACA,gDAAA;AA15CF;;AAo6CA;EACE,4BAAA;AAj6CF;;AAo6CA;EACE,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,YAAA;AAj6CF;AAm6CE;EAEE,mBAAA;AAl6CJ;;AAu6CE;EACE,WAAA;EACA,gBAAA;EACA,SAAA;AAp6CJ;AAu6CE;EACE,YAAA;AAr6CJ;AAw6CE;EACE,gBAAA;EACA,SAAA;AAt6CJ;AAy6CE;;EAEE,gBAAA;AAv6CJ;AA06CE;EACE,kBAAA;AAx6CJ;AA26CE;;;EAGE,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,0BAAA;AAz6CJ;AA46CE;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;AA16CJ;AA46CI;EACE,WAAA;EACA,YAAA;EACA,QAAA;AA16CN;AA86CE;EACE,aAAA;AA56CJ;;AAg7CA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,sCAAA;AA76CF;;AAg7CA;EACE,gBAAA;AA76CF;;AAg7CA;EACE,+CAAA;AA76CF;;AAg7CA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;AA76CF;;AAg7CA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,sBAAA;EACA,WAAA;AA76CF;;AAg7CA;EACE,WAAA;EACA,wCAAA;EACA,wCAAA;AA76CF;;AAg7CA;EACE,6BAAA;AA76CF;;AA27CA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;AAx7CF;;AA27CA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EAEA,8CAAA;EACA,2CAAA;EACA,qBAAA;EACA,wBAAA;EACA,+BAAA;EACA,kDAAA;AAz7CF;;AA47CA;EACE,0BAAA;AAz7CF;;AA47CA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,kDACE;AA17CJ;;AA87CA;EACE,yBAAA;EACA,UAAA;AA37CF;;AA87CA;EACE,SAAA;EACA,eAAA;EACA,kBAAA;AA37CF;;AA87CA;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,8CAAA;EACA,yBAAA;AA37CF;;AA+7CA;EACE,UAAA;AA57CF;;AA+7CA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;AA57CF;;AA+7CA;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA57CF;;AA+7CA;EACE,UAAA;EACA,eAAA;EACA,kBAAA;AA57CF;;AA+7CA;EACE,8BAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;AA57CF;;AA+7CA;EACE,2BAAA;EACA,qCAAA;AA57CF;;AA+7CA;EACE,aAAA;EACA,UAAA;EACA,oCAAA;AA57CF;;AA+7CA;EACE,cAAA;EACA,UAAA;AA57CF;;AA+7CA;EACE,aAAA;AA57CF;;AA+7CA;EACE,eAAA;AA57CF;;AA+7CA;EACE,aAAA;AA57CF;;AA+7CA;EACE,eAAA;AA57CF;;AA+7CA;EACE,aAAA;AA57CF;;AA+7CA;EACE,cAAA;AA57CF;;AA+7CA;EACE,sCAAA;AA57CF;;AA+7CA;EACE,yCAAA;AA57CF;;AA+7CA,mCAAA;AACA;EACE,kBAAA;EACA,gBAAA;AA57CF;;AA+7CA;;EAEE,WAAA;EAEA,6BAAA;EACA,WAAA;AA77CF;;AAg8CA;EAEE,6BAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AA97CF;;AAi8CA;EAEE,6BAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AA/7CF;;AAk8CA;EACE,gBAAA;AA/7CF;;AAk8CA;EAEE,WAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;AAh8CF;;AAm8CA;;EAEE,aAAA;AAh8CF;;AAm8CA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;AAh8CF;;AAm8CA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,wBAAA;AAh8CF;;AAm8CA;EACE,WAAA;EACA,cAAA;AAh8CF;;AAm8CA;EACE,cAAA;AAh8CF;;AAm8CA;EACE,WAAA;AAh8CF;;AAm8CA;EACE,YAAA;AAh8CF;;AAm8CA;EACE,WAAA;EACA,cAAA;EACA,WAAA;AAh8CF;;AAm8CA;EACE,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;AAh8CF;;AAm8CA;EACE,SAAA;EACA,mBAAA;EACA,WAAA;AAh8CF;;AA69CA;EACE,oCAAA;AA19CF;;AA69CA;EACE;IACE,uBAAA;EA19CF;EA49CA;IACE,yBAAA;EA19CF;AACF;AA69CA;;EAEE,aAAA;EACA,qCAAA;EACA,kBAAA;EACA,YAAA;AA39CF;;AA89CA;EACE,qBAAA;EACA,kBAAA;AA39CF;;AA89CA;;EAEE,uCAAA;EACA,wCAAA;AA39CF;;AA89CA;EACE,+BAAA;AA39CF;;AA89CA;;EAEE,+BAAA;EACA,iBAAA;EACA,wCAAA;EACA,uBAAA;AA39CF;;AA89CA;EACE,aAAA;AA39CF;;AA89CA;EACE;IACE,uBAAA;IACA,eAAA;IACA,QAAA;IACA,QAAA;IACA,gBAAA;IACA,+BAAA;IACA,yBAAA;IACA,WAAA;IACA,mBAAA;EA39CF;EA69CA;IACE,mBAAA;IACA,kCAAA;IAEA;MACE,wFAAA;MACA,4CAAA;MACA,eAAA;IA59CF;IAs+CA;MACE,oDAAA;MACA,4CAAA;MACA,eAAA;IAp+CF;EACF;EAu+CA;IACE,cAAA;EAr+CF;EAw+CA;IACE,yBAAA;IACA,kBAAA;EAt+CF;EAy+CA;;;;;;IAME,mBAAA;IACA,wBAAA;EAv+CF;EA0+CA;IACE,aAAA;EAx+CF;EA2+CA;IACE,sBAAA;EAz+CF;AACF;AA4+CA;EACE,8DAAA;EACA,6BAAA;AA1+CF;;AA4+CA;EACE,qEAAA;AAz+CF;;AA4+CA;EACE,oCAAA;AAz+CF;;AA4+CA;EACE,oCAAA;AAz+CF;;AA4+CA;EACE,oCAAA;AAz+CF;;AA4+CA;EACE,yBAAA;AAz+CF;;AA4+CA;EACE,gCAAA;AAz+CF;;AA4+CA;;EAEE,0BAAA;AAz+CF;;AA4+CA;EACE,oBAAA;EACA,0BAAA;EACA,wCAAA;AAz+CF;;AA4+CA;EACE,6BAAA;AAz+CF;;AA4+CA;EACE,0BAAA;AAz+CF;;AA4+CA;EACE,sBAAA;EACA,uBAAA;EACA,eAAA;AAz+CF;;AA4+CA;EACE,yCAAA;AAz+CF;;AA4+CA;EACE,0BAAA;AAz+CF;;AA4+CA;EACE,uBAAA;AAz+CF;;AA4+CA;EACE,4BAAA;AAz+CF;;AA4+CA;EACE,oCAAA;EACA,yDAAA;AAz+CF;;AA4+CA;EACE;IACE,2BAAA;EAz+CF;EA2+CA;IACE,4BAAA;EAz+CF;AACF;AA8+CA;;;EAGE,eAAA;AA5+CF;;AA++CA;EACE,kBAAA;AA5+CF;;AA++CA;EACE,eAAA;EACA,0BAAA;AA5+CF;;AA8+CA;EACE,eAAA;EACA,0BAAA;AA3+CF;;AA8+CA;EACE,iBAAA;AA3+CF;;AA8+CA;EACE,UAAA;EACA,WAAA;AA3+CF;;AA8+CA;EACE,WAAA;AA3+CF;;AA8+CA;EACE,eAAA;AA3+CF;;AA8+CA;;EAEE,qBAAA;EACA,sBAAA;AA3+CF;;AAk/CA;EACE,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AA/+CF;;AAk/CA;EACE,aAAA;AA/+CF;;AAk/CA;EACE,aAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;AA/+CF;;AAk/CA,sBAAA;AACA;EACE;IACE,8BAAA;EA/+CF;EAi/CA;IACE,6BAAA;EA/+CF;AACF;AAk/CA;EACE,yEAAA;EACA,4BAAA;EACA,8BAAA;AAh/CF;;AAm/CA,sBAAA;AACA;EACE;IACE,sBAAA;EAh/CF;AACF;AAm/CA;EACE,YAAA;EACA,iBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,yCAAA;AAj/CF;;AAo/CA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AAj/CF;;AAo/CA;EACE,gBAAA;EACA,aAAA;EACA,2BAAA;AAj/CF;;AAo/CA,qBAAA;AACA;;EAEE,eAAA;EACA,mBAAA;EACA,WAAA;AAj/CF;;AAo/CA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAj/CF;;AAo/CA,0BAAA;AACA;;EAEE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,iBAAA;EACA,yBAAA;AAj/CF;;AAo/CA;;EAEE,sBAAA;EACA,cAAA;AAj/CF;;AAo/CA,2BAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,kBAAA;EACA,yBAAA;AAj/CF;;AAo/CA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gHAAA;EACA,kBAAA;AAj/CF;;AAo/CA,0BAAA;AACA;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAj/CF;;AAo/CA,wBAAA;AACA;EACE;IACE,mBAAA;EAj/CF;EAm/CA;IACE,qBAAA;EAj/CF;EAm/CA;IACE,mBAAA;EAj/CF;AACF;AAo/CA;;EAEE,4BAAA;AAl/CF;;AAq/CA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAl/CF;;AAq/CA;EACE,mBAAA;EACA,0BAAA;EACA,qBAAA;AAl/CF;;AAq/CA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAl/CF;;AAq/CA;EACE,eAAA;AAl/CF;;AAq/CA;EACE,SAAA;AAl/CF;;AAq/CA;EACE,eAAA;EACA,kBAAA;EACA,WAAA;AAl/CF;;AAq/CA;EACE,eAAA;EACA,WAAA;EACA,SAAA;AAl/CF;;AAq/CA,oBAAA;AACA;EACE,mBAAA;AAl/CF;;AAq/CA;EACE,eAAA;EACA,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;AAl/CF;;AAq/CA;EACE,aAAA;EACA,qCAAA;EACA,SAAA;AAl/CF;;AAq/CA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;UAAA,iBAAA;AAl/CF;;AAq/CA;EACE,mBAAA;EACA,2BAAA;EACA,wCAAA;EACA,qBAAA;AAl/CF;;AAq/CA;EACE,gBAAA;AAl/CF;;AAq/CA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAl/CF;;AAq/CA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAl/CF;;AAq/CA,eAAA;AACA;EACE;IACE,YAAA;EAl/CF;AACF;AAq/CA;EACE;IACE,eAAA;IACA,WAAA;IACA,MAAA;IACA,YAAA;IACA,aAAA;IACA,0BAAA;IACA,YAAA;EAn/CF;EAs/CA;IACE,OAAA;EAp/CF;AACF;AAu/CA;EACE,SAAA;EACA,gBAAA;EACA,oBAAA;EAEA,yBAAA;EACA,2BAAA;AAt/CF;;AAy/CA;EACE,iBAAA;EACA,cAAA;AAt/CF;;AAy/CA,oBAAA;AACA;EACE,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yCAAA;AAt/CF;;AAy/CA;EACE,0CAAA;AAt/CF;;AAy/CA;EACE,0BAAA;EACA,mBAAA;AAt/CF;;AAy/CA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;EACA,WAAA;AAt/CF;;AAy/CA;EACE,UAAA;AAt/CF;;AAy/CA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AAt/CF;;AAy/CA;EACE,mBAAA;EACA,2BAAA;AAt/CF;;AAy/CA;EACE,mBAAA;AAt/CF;;AAy/CA;EACE,mBAAA;AAt/CF;;AAy/CA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAt/CF;;AAy/CA;EACE,gBAAA;AAt/CF;;AAy/CA;EACE,aAAA;EACA,yBAAA;AAt/CF;;AAy/CA,sBAAA;AACA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AAt/CF;;AAy/CA;EACE,SAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAt/CF;;AAy/CA;EACE,qCAAA;AAt/CF;;AAy/CA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;AAt/CF;;AAy/CA;EACE,UAAA;AAt/CF;;AAy/CA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;AAt/CF;;AAy/CA,sBAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAt/CF;;AAy/CA;EACE,oCAAA;EACA,0BAAA;AAt/CF;;AAy/CA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;AAt/CF;;AAy/CA;EACE,qBAAA;EACA,qCAAA;AAt/CF;;AAy/CA;EACE,SAAA;EACA,eAAA;AAt/CF;;AAy/CA,iBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;AAt/CF;;AAy/CA;EACE,kBAAA;EACA,aAAA;AAt/CF;;AAy/CA;EACE,eAAA;EACA,mBAAA;EACA,YAAA;AAt/CF;;AAy/CA;EACE,eAAA;EACA,mBAAA;EACA,WAAA;AAt/CF;;AAy/CA;EACE,WAAA;EACA,eAAA;AAt/CF;;AAy/CA,uBAAA;AACA;EACE;IACE,aAAA;EAt/CF;EAy/CA;IACE,sBAAA;IACA,SAAA;EAv/CF;EA0/CA;IACE,sBAAA;EAx/CF;EA2/CA;IACE,UAAA;EAz/CF;EA4/CA;IACE,iBAAA;IACA,eAAA;EA1/CF;AACF;AA6/CA,gBAAA;AACA;EACE;IACE,mBAAA;EA3/CF;EA8/CA;IACE,SAAA;EA5/CF;AACF;AA+/CA,4BAAA;AACA;EACE,YAAA;EACA,gBAAA;AA7/CF;;AAggDA,+BAAA;AACA;EACE;IACE,UAAA;IACA,2BAAA;EA7/CF;EA+/CA;IACE,UAAA;IACA,wBAAA;EA7/CF;AACF;AAggDA;EACE,4BAAA;AA9/CF;;AAggDA;EACE,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AA7/CF;;AAggDA;EACE,kBAAA;EACA,yCAAA;AA7/CF;;AAggDA;EACE,qBAAA;EACA,8CAAA;AA7/CF;;AAggDA,oBAAA;AACA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,6BAAA;EACA,WAAA;AA7/CF;;AAggDA;EACE,UAAA;AA7/CF;;AAggDA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AA7/CF;;AAggDA;EACE,mBAAA;EACA,2BAAA;AA7/CF;;AAggDA;EACE,mBAAA;AA7/CF;;AAggDA;EACE,mBAAA;AA7/CF;;AAggDA;EACE,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AA7/CF;;AAggDA;EACE,gBAAA;AA7/CF;;AAggDA,kBAAA;AACA;EACE,mBAAA;AA7/CF;;AAggDA;;EAEE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;AA7/CF;;AAggDA;;EAEE,aAAA;EACA,qBAAA;EACA,8CAAA;AA7/CF;;AAggDA;EACE,iBAAA;EACA,gBAAA;AA7/CF;;AAggDA,mBAAA;AACA;EACE,qBAAA;AA7/CF;;AAggDA,mBAAA;AACA;EACE,SAAA;EACA,gBAAA;AA7/CF;;AAggDA;;;;EAIE,SAAA;AA7/CF;;AAggDA,gBAAA;AACA;EACE,gBAAA;EACA,cAAA;AA7/CF;;AAggDA,kBAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,yBAAA;EACA,eAAA;AA7/CF;;AAggDA;EACE,2BAAA;EACA,0CAAA;AA7/CF;;AAggDA;EACE,gBAAA;AA7/CF;;AAggDA,iBAAA;AACA;EACE,kBAAA;AA7/CF;;AAggDA;EACE,eAAA;EACA,YAAA;EACA,kBAAA;AA7/CF;;AAggDA;EACE,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;AA7/CF;;AAggDA,iBAAA;AACA;EACE,kBAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AA7/CF;;AAggDA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA7/CF;;AAggDA,gBAAA;AACA;EACE,qBAAA;AA7/CF;;AAggDA;EACE,qBAAA;EACA,yBAAA;AA7/CF;;AAggDA;EACE,qBAAA;AA7/CF;;AAggDA,mBAAA;AACA;EACE,cAAA;AA7/CF;;AAggDA,kBAAA;AACA;EACE,WAAA;AA7/CF;;AAggDA,mBAAA;AACA;EACE,kBAAA;AA7/CF;;AAggDA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;AA7/CF;;AAggDA;EACE,eAAA;EACA,cAAA;AA7/CF;;AAggDA,wBAAA;AACA;EACE,cAAA;AA7/CF;;AAggDA;EACE,kBAAA;EACA,gBAAA;AA7/CF;;AAggDA;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;AA7/CF;;AAggDA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AA7/CF;;AAggDA;EACE,YAAA;EACA,eAAA;EACA,gBAAA;AA7/CF;;AAggDA,mBAAA;AACA;EACE,aAAA;EACA,SAAA;AA7/CF;;AAggDA;EACE,WAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;AA7/CF;;AAggDA;EACE,sBAAA;AA7/CF;;AAggDA,sBAAA;AACA;EACE,6BAAA;AA7/CF;;AAggDA;EACE;IACE,UAAA;IACA,2BAAA;EA7/CF;EA+/CA;IACE,UAAA;IACA,wBAAA;EA7/CF;AACF;AAggDA,uBAAA;AACA;EACE;IACE,aAAA;EA9/CF;EAigDA;IACE,UAAA;EA//CF;EAkgDA;IACE,gBAAA;IACA,eAAA;EAhgDF;EAmgDA;IACE,eAAA;EAjgDF;EAogDA;IACE,YAAA;EAlgDF;AACF;AAqgDA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,iCAAA;AAngDF;;AAsgDA;EACE;IACE,UAAA;IACA,2BAAA;EAngDF;EAqgDA;IACE,UAAA;IACA,wBAAA;EAngDF;AACF;AAsgDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AApgDF;;AAugDA;EACE,eAAA;EACA,SAAA;EACA,WAAA;AApgDF;;AAugDA;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AApgDF;;AAugDA;EACE,mBAAA;EACA,WAAA;AApgDF;;AAugDA,kBAAA;AACA;EACE,aAAA;EACA,gCAAA;EACA,iBAAA;AApgDF;;AAugDA;EACE,kBAAA;EACA,uBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AApgDF;;AAugDA;EACE,cAAA;AApgDF;;AAugDA;EACE,cAAA;AApgDF;;AAugDA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,mBAAA;AApgDF;;AAugDA,qBAAA;AACA;EAEE,cAAA;EACA,aAAA;EACA,2BAAA;AArgDF;;AAwgDA;EACE,mBAAA;AArgDF;;AAwgDA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gCAAA;AArgDF;;AAwgDA;EACE,mBAAA;AArgDF;;AAwgDA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AArgDF;;AAwgDA;;;;;EAKE,WAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AArgDF;;AAwgDA;;;EAGE,aAAA;EACA,qBAAA;EACA,8CAAA;AArgDF;;AAwgDA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AArgDF;;AAwgDA;EACE,WAAA;EACA,cAAA;AArgDF;;AAwgDA,qBAAA;AACA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;AArgDF;;AAwgDA;EACE,kBAAA;AArgDF;;AAwgDA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AArgDF;;AAwgDA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AArgDF;;AAwgDA,uBAAA;AACA;;EAEE,iBAAA;EACA,eAAA;AArgDF;;AAwgDA;;EAEE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AArgDF;;AAwgDA,eAAA;AACA;EACE;IACE,qCAAA;EArgDF;AACF;AAwgDA;EACE;IACE,aAAA;EAtgDF;EAygDA;IACE,aAAA;EAvgDF;AACF;AA0gDA,wBAAA;AACA;EACE;IACE,UAAA;IACA,4BAAA;EAxgDF;EA0gDA;IACE,UAAA;IACA,wBAAA;EAxgDF;AACF;AA2gDA;EACE,8BAAA;AAzgDF;;AA4gDA,aAAA;AACA;EACE,kBAAA;AAzgDF;;AA4gDA;EACE,kBAAA;EACA,QAAA;EACA,MAAA;EACA,YAAA;AAzgDF;;AA4gDA;EACE,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;AAzgDF;;AA4gDA,kBAAA;AACA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAzgDF;;AA4gDA;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;AAzgDF;;AA4gDA;EACE;IACE,uBAAA;EAzgDF;EA2gDA;IACE,yBAAA;EAzgDF;AACF;AA4gDA;EACE,8FACE;EAEF,UAAA;EACA,SAAA;EACA,iBAAA;AA5gDF;;AA+gDA;EACE,mBAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,MAAA;EACA,YAAA;EACA,2BAAA;EACA,qCAAA;AA5gDF;;AA+gDA;EACE,SAAA;EACA,eAAA;EACA,WAAA;AA5gDF;;AA+gDA;EACE,iBAAA;EACA,cAAA;EACA,kBAAA;AA5gDF;;AA+gDA;EACE,mBAAA;AA5gDF;;AA+gDA;EACE,gBAAA;AA5gDF;;AA+gDA;EACE,aAAA;EACA,SAAA;EACA,eAAA;AA5gDF;;AA+gDA;EACE,SAAA;EACA,YAAA;AA5gDF;;AA+gDA;EACE,mBAAA;AA5gDF;;AA+gDA,uBAAA;AACA;EACE;IACE,sBAAA;IACA,SAAA;EA5gDF;EA+gDA;IACE,aAAA;EA7gDF;EAghDA;IACE,eAAA;EA9gDF;AACF;AAihDA,iBAAA;AACA;EACE;IACE,aAAA;EA/gDF;EAkhDA;IACE,wBAAA;EAhhDF;AACF;AAmhDA;EACE,yBAAA;EACA,yBAAA;AAjhDF;;AAohDA;EACE,2BAAA;EACA,0DAAA;EACA,oCAAA;AAjhDF;;AAohDA,mBAAA;AACA;EACE,yBAAA;AAjhDF;;AAohDA;EACE,sBAAA;AAjhDF;;AAohDA;EACE,yBAAA;AAjhDF;;AAohDA;EACE,uBAAA;AAjhDF;;AAohDA,iBAAA;AACA;EACE,yBAAA;AAjhDF;;AAohDA;EACE,2BAAA;EACA,6CAAA;AAjhDF;;AAohDA;EACE,wBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iBAAA;AAjhDF;;AAohDA;EACE,sBAAA;EACA,mDAAA;AAjhDF;;AAohDA;EACE,mBAAA;EACA,kBAAA;AAjhDF;;AAohDA;EACE,qCAAA;EACA,mBAAA;AAjhDF;;AAohDA;EACE,gBAAA;AAjhDF;;AAohDA;EACE,iBAAA;EACA,iDAAA;AAjhDF;;AAohDA;EACE,+BAAA;AAjhDF;;AAohDA;EACE,kBAAA;AAjhDF;;AAohDA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAjhDF;;AAohDA;EACE,gCAAA;EACA,sBAAA;AAjhDF;;AAohDA;;iEAAA;AAIA,6BAAA;AACA;EACE,UAAA;AAlhDF;;AAqhDA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AAlhDF;;AAqhDA;EACE,SAAA;EACA,gBAAA;AAlhDF;;AAqhDA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAlhDF;;AAqhDA;EACE,uCAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;AAlhDF;;AAqhDA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AAlhDF;;AAqhDA;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;AAlhDF;;AAqhDA;EACE,uCAAA;EACA,iBAAA;EACA,cAAA;AAlhDF;;AAqhDA,8BAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,0CAAA;EACA,mBAAA;EACA,oBAAA;AAlhDF;;AAqhDA;EACE,mBAAA;AAlhDF;;AA+hDA;EACE,gBAAA;EACA,iBAAA;EACA,kBAAA;AA5hDF;;AA+hDA;EACE,mBAAA;EACA,qBAAA;EACA,WAAA;AA5hDF;;AA+hDA;EACE,mBAAA;AA5hDF;;AA+hDA,4BAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,+EAAA;EACA,mBAAA;EACA,gBAAA;AA5hDF;;AA+hDA,8BAAA;AACA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AA5hDF;;AA+hDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AA5hDF;;AA+hDA;EACE,iBAAA;EACA,uCAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AA5hDF;;AA+hDA;;EAEE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AA5hDF;;AA+hDA;;EAEE,qBAAA;EACA,6BAAA;AA5hDF;;AA+hDA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA5hDF;;AA+hDA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA5hDF;;AA+hDA;EACE,SAAA;AA5hDF;;AA+hDA,iCAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AA5hDF;;AA+hDA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AA5hDF;;AA+hDA;EACE,qBAAA;EACA,6BAAA;AA5hDF;;AA+hDA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;AA5hDF;;AA+hDA,4BAAA;AACA;EACE,gBAAA;AA5hDF;;AA+hDA;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;AA5hDF;;AA+hDA;EACE,gBAAA;EACA,MAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,uCAAA;EACA,yBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gCAAA;EACA,mBAAA;AA5hDF;;AA+hDA;EACE,iBAAA;EACA,gCAAA;EACA,sBAAA;EACA,mBAAA;AA5hDF;;AA+hDA;EACE,mBAAA;AA5hDF;;AA+hDA;EACE,mBAAA;AA5hDF;;AA+hDA;EACE,YAAA;AA5hDF;;AA+hDA;EACE,gBAAA;AA5hDF;;AA+hDA;EACE,cAAA;EACA,eAAA;EACA,cAAA;AA5hDF;;AA+hDA;EACE,uCAAA;EACA,eAAA;AA5hDF;;AA+hDA;EACE,eAAA;AA5hDF;;AA+hDA;EACE,gBAAA;EACA,yBAAA;EACA,2BAAA;AA5hDF;;AA+hDA;EACE,mBAAA;AA5hDF;;AA+hDA;EACE,iBAAA;AA5hDF;;AA+hDA;EACE,eAAA;AA5hDF;;AA+hDA;EACE,aAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AA5hDF;;AA+hDA,6BAAA;AACA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;AA5hDF;;AAuiDA;EACE,mBAAA;EACA,cAAA;AApiDF;;AAuiDA;EACE,mBAAA;EACA,cAAA;AApiDF;;AAuiDA;EACE,mBAAA;EACA,cAAA;AApiDF;;AAuiDA;EACE,mBAAA;EACA,cAAA;AApiDF;;AAuiDA;EACE,mBAAA;EACA,cAAA;AApiDF;;AAuiDA;EACE,mBAAA;EACA,cAAA;AApiDF;;AAuiDA,2BAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;AApiDF;;AAuiDA;EACE,iBAAA;AApiDF;;AAuiDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AApiDF;;AAuiDA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;AApiDF;;AAuiDA;EACE,cAAA;AApiDF;;AAuiDA;;;EAGE,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AApiDF;;AAuiDA;;;EAGE,qBAAA;EACA,6BAAA;AApiDF;;AAuiDA,iCAAA;AACA;EACE;IAAO,UAAA;IAAY,0BAAA;EAliDnB;EAmiDA;IAAK,UAAA;IAAY,eAAA;EA/hDjB;AACF;AAiiDA;EACE;IAAO,2BAAA;IAA6B,UAAA;EA7hDpC;EA8hDA;IAAK,eAAA;IAAiB,UAAA;EA1hDtB;AACF;AA4hDA,iCAAA;AACA;EACE;IACE,sBAAA;IACA,uBAAA;EA1hDF;EA6hDA;IACE,WAAA;IACA,2BAAA;EA3hDF;EA8hDA;IACE,8BAAA;EA5hDF;EA+hDA;IACE,iBAAA;EA7hDF;EAgiDA;IACE,0BAAA;EA9hDF;EAiiDA;IACE,cAAA;EA/hDF;AACF","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Nunito:ital,wght@0,200..1000;1,200..1000&family=Sora:wght@100..800&display=swap\");\n\nbody {\n  font-family: \"Nunito\", sans-serif !important;\n}\n\n:root {\n  overflow: hidden;\n  --blue: rgb(16, 60, 94);\n  --approved_color: rgb(133, 186, 133);\n  --unapproved_color: rgb(196, 196, 196);\n  --red_color: rgb(255, 0, 0);\n  --inactive_menu_color: rgb(67, 67, 67);\n\n  /* Inactive Menu Color */\n  --base: #5e5690;\n  --base-light: #7873a7;\n  --base-dark: #555184;\n  --shadow: #4f4c6b;\n  --letter: #d8d7e5;\n  --white: rgb(255, 255, 255);\n  --border_color: rgb(237, 237, 237);\n}\n\n.br3 {\n  border-radius: 3px !important;\n}\n\n.alert {\n  padding: 3px 8px !important;\n  font-size: 10px;\n  border-radius: 2px !important;\n  margin: 0 !important;\n}\n\n.removeCaptionBorder {\n  width: 170px;\n\n  .blockquote-footer::before {\n    display: none;\n  }\n}\n\n.paneOverflow {\n  position: static !important;\n}\n\n.w-200 {\n  width: 200px;\n}\n\n.white {\n  color: var(--white) !important;\n}\n\n.bg-main {\n  background-color: var(--blue) !important;\n  border: 1px solid var(--blue) !important;\n}\n\n.white-background {\n  background: var(--white) !important;\n}\n\n:disabled {\n  cursor: no-drop;\n  pointer-events: all !important;\n}\n\n.rotate-on-load {\n  transform: rotate(360deg);\n  transition: transform 0.5s ease;\n}\n\n.btn:disabled,\nbutton:disabled {\n  background-color: #ececec !important;\n  border-color: #ececec !important;\n  color: var(--bg-secondary-subtle) !important;\n}\n\n.form-control:focus {\n  color: var(--bs-body-color);\n  background-color: var(--bs-body-bg);\n  border-color: var(--blue);\n  outline: 0;\n  box-shadow: none;\n}\n\n.normalHeight {\n  max-height: calc(100vh - 180px);\n\n  table {\n    .form-select {\n      border-radius: 3px;\n      border: 0;\n      padding: 1px 7px !important;\n      cursor: pointer;\n    }\n  }\n}\n\n.modal-header,\n.offcanvas-header {\n  padding: 10px !important;\n  background: var(--blue) !important;\n  border: 1px solid var(--blue) !important;\n  border-radius: 3px 3px 0 0 !important;\n  width: 100% !important;\n\n  .modal-title,\n  .offcanvas-title {\n    font-size: 15px;\n    color: #fff;\n  }\n\n  .btn-close {\n    --bs-btn-close-bg: url(\"data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z%27/%3e%3c/svg%3e\");\n  }\n}\n\n.offcanvas-header {\n  border-radius: 0 !important;\n}\n\n.blue {\n  color: var(--blue);\n}\n\n.green {\n  color: green;\n}\n\n.orange {\n  color: orange;\n}\n\n.red {\n  color: red;\n}\n\n.gray {\n  color: rgb(138, 138, 138);\n}\n\n.fontSize12 {\n  font-size: 12px;\n}\n\n.fontSize14 {\n  font-size: 14px;\n}\n\n.bg-blue {\n  background: var(--blue);\n}\n\n.bg-red {\n  background: red !important;\n}\n\n.gray {\n  color: gray;\n}\n\n.green {\n  color: green;\n}\n\n.dashed {\n  opacity: 0.7;\n}\n\n/* .................................................................. */\n\ntable.sortable td,\ntable.sortable th {\n  padding: 0.125em 0.25em;\n  width: 8em;\n}\n\ntable.sortable th {\n  font-weight: bold;\n  border-bottom: thin solid #888;\n  position: relative;\n}\n\ntable.sortable th.no-sort {\n  padding-top: 0.35em;\n}\n\ntable.sortable th:nth-child(5) {\n  width: 10em;\n}\n\ntable.sortable th button {\n  position: absolute;\n  padding: 4px;\n  margin: 1px;\n  font-size: 100%;\n  font-weight: bold;\n  background: transparent;\n  border: none;\n  display: inline;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  text-align: left;\n  outline: none;\n  cursor: pointer;\n}\n\ntable.sortable th button span {\n  position: absolute;\n  right: 4px;\n}\n\ntable.sortable th[aria-sort=\"descending\"] span::after {\n  content: \"▼\";\n  color: currentcolor;\n  font-size: 100%;\n  top: 0;\n}\n\ntable.sortable th[aria-sort=\"ascending\"] span::after {\n  content: \"▲\";\n  color: currentcolor;\n  font-size: 100%;\n  top: 0;\n}\n\ntable.show-unsorted-icon th:not([aria-sort]) button span::after {\n  content: \"♢\";\n  color: currentcolor;\n  font-size: 100%;\n  position: relative;\n  top: -3px;\n  left: -4px;\n}\n\ntable.sortable td.num {\n  text-align: right;\n}\n\ntable.sortable tbody tr:nth-child(odd) {\n  background-color: #ddd;\n}\n\n/* Focus and hover styling */\n\ntable.sortable th button:focus,\ntable.sortable th button:hover {\n  padding: 2px;\n  border: 2px solid currentcolor;\n  background-color: #e5f4ff;\n}\n\ntable.sortable th button:focus span,\ntable.sortable th button:hover span {\n  right: 2px;\n}\n\ntable.sortable th:not([aria-sort]) button:focus span::after,\ntable.sortable th:not([aria-sort]) button:hover span::after {\n  content: \"▼\";\n  color: currentcolor;\n  font-size: 100%;\n  top: 0;\n}\n\n.table td,\n.table th {\n  border: 1px solid var(--bs-border-color);\n}\n\n.table tr:first-child td,\ntable tr th {\n  border-top: none !important;\n}\n\n.table tr:last-child td {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.table tr td:first-child,\n.table tr th {\n  border-left: none;\n}\n\n.table tr td:last-child {\n  border-right: none;\n}\n\n/* ........................................... */\n\n.gb_Te {\n  height: 28px;\n  width: 35px;\n}\n\n.v {\n  cursor: pointer;\n  opacity: 0.4;\n}\n\n.download {\n  margin-top: 5px;\n}\n\n.userspan {\n  background: transparent;\n  border: none;\n  height: 20px;\n}\n\n.login {\n  font-size: 0.8rem;\n}\n\n.signout {\n  font-size: 0.8rem;\n  margin-left: -19px;\n}\n\n.mr-nav {\n  font-size: 1.5rem;\n  margin-bottom: 0px;\n  margin-left: 6px;\n}\n\n.rr {\n  margin: 0;\n  color: var(--white);\n  font-size: 3rem;\n}\n\n.col-form-label {\n  font-size: 0.8rem;\n}\n\n.small.text-success,\n.small.text-danger{\n  font-size: 11px;\n}\n\n.form-control,\n.text-primary,\n.text-muted,\n.form-select,\n.d-none .h5 {\n  font-size: 11px !important;\n  border-radius: 3px !important;\n}\n\n.form-label {\n  font-size: 12px;\n}\n\n.searchWrapper {\n  padding: 0 !important;\n}\n\n.multiSelectContainer li.option,\n.notFound,\n.hstack span,\nbutton span {\n  font-size: 12px;\n}\n\n.multiSelectContainer li {\n  padding: 2px 10px !important;\n}\n\n.multiSelectContainer li:hover {\n  background: var(--blue) !important;\n}\n\n.highlightOption {\n  background: var(--blue) !important;\n  color: var(--white) !important;\n  font-size: 12px;\n}\n\n.full-screen-component {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1000;\n  padding: 5px;\n  overflow: hidden;\n  background: var(--white);\n}\n\n.pdf_viwer_section_full {\n  height: 99vh;\n  overflow: auto;\n}\n\n.pdf_viwer_original_section {\n  height: calc(100vh - 424px);\n  overflow: auto;\n}\n\n.notFound {\n  position: absolute;\n  left: 50%;\n  top: 40%;\n  transform: translateX(-50%);\n}\n\n.pdf_viwer_section_full .table > thead.fixed_property_header {\n  top: 0px;\n}\n\n.searchWrapper {\n  padding: 0 !important;\n}\n\n.table > thead.fixed_property_header {\n  position: sticky;\n  top: 0px;\n  z-index: 99;\n}\n\n.multiSelectContainer input {\n  padding: 6px !important;\n  font-size: 11px;\n}\n\n.chip {\n  background: var(--blue) !important;\n  border-radius: 4px !important;\n  font-size: 11px !important;\n  line-height: 20px !important;\n  margin: 4px;\n  margin-right: 2px !important;\n  padding: 2px 10px !important;\n}\n\n.smalls {\n  font-size: small;\n}\n\n.inputsize {\n  height: 40px;\n  font-size: 0.8rem;\n}\n\n.topuseremail {\n  height: 30px;\n  font-size: 0.8rem;\n  width: 100%;\n}\n\n.useremailid {\n  width: 10%;\n}\n\n.usertopsubject {\n  padding-left: 35px;\n}\n\n.clienttophr {\n  margin-top: 4px;\n  margin-left: -24px;\n  margin-right: -24px;\n}\n\n.newclientcreation {\n  overflow-x: hidden;\n}\n\n.upload {\n  height: 1.8rem;\n  padding-top: 2px;\n}\n\n.h4 {\n  font-size: large;\n}\n\n.apps {\n  display: flex;\n}\n\n.cross {\n  height: 1.3rem;\n}\n\n.refresh {\n  height: 1rem;\n}\n\n.clientsicon {\n  height: 1rem;\n}\n\n.mailicon {\n  height: 0.8rem;\n}\n\n.usersicon {\n  height: 1rem;\n}\n\n.rolesicon {\n  height: 0.9rem;\n}\n\n.auditsicon {\n  height: 0.8rem;\n}\n\n.avatarborder {\n  border: 1px solid var(--blue);\n  border-radius: 8px;\n  padding: 1px;\n  height: 9rem;\n  width: 9rem;\n}\n\n.countryoption {\n  background-color: transparent;\n}\n\n.seclect_dropdown_status {\n  width: 69%;\n  height: 35px;\n  border: none;\n  font-size: 0.8rem;\n}\n\n.form-select:focus {\n  border-color: var(--blue);\n  box-shadow: none;\n}\n\n.newaddress {\n  height: 6rem;\n}\n\n.senthead {\n  padding-bottom: 5px;\n}\n\n.editicon {\n  height: 1rem;\n}\n\n.inputborder {\n  border: 1px solid var(--blue);\n  width: 75%;\n}\n\n.inputfonts,\n.avatarleft,\n.uploadlogo {\n  font-size: 0.8rem;\n  width: 25%;\n  opacity: 0.9;\n}\n\n.uploadlogo {\n  font-size: 0.8rem;\n  width: 25%;\n  opacity: 0.9;\n}\n\n.space {\n  width: 500px;\n  display: inline;\n  visibility: hidden;\n  background-color: red;\n  margin-left: 15rem;\n}\n\n.eventtable {\n  border: transparent;\n}\n\n.file1,\n.file2 {\n  height: 1.3rem;\n  margin-left: 0px;\n}\n\n.chooselogo {\n  border-radius: 10px;\n  width: 75%;\n}\n\n.bottombuttons {\n  margin-top: 4rem;\n}\n\n.title {\n  border-radius: 10px 10px 0 0;\n  background: hsl(206, 60%, 30%);\n  color: white;\n  font-size: 18px;\n}\n\n.updateProfile,\n.rpv-core__button {\n  background: transparent;\n  border: 1px solid #103c5e !important;\n  color: #103c5e;\n  border-radius: 3px;\n  font-size: 12px !important;\n  padding: 3px 10px 4px;\n  transition: 1s;\n\n  &:hover {\n    background: #103c5e;\n    color: white;\n    border: 1px solid #103c5e;\n  }\n}\n\n.rpv-core__button {\n  height: auto !important;\n}\n\n.rpv-thumbnail__items--selected .rpv-thumbnail__item,\n.rpv-thumbnail__item--single:hover,\n.rpv-thumbnail__item--dual-cover:hover,\n.rpv-thumbnail__items--dual:hover .rpv-thumbnail__item,\n.rpv-thumbnail__items--dual-cover:hover .rpv-thumbnail__item,\n.rpv-core__minimal-button:hover,\n.rpv-bookmark__item:hover,\n.rpv-bookmark__item:focus,\ncr .rpv-core__minimal-button--selected {\n  background-color: rgb(219 230 239) !important;\n}\n\n.rpv-bookmark__title {\n  font-size: 12px !important;\n}\n\n.removeProfile {\n  background: transparent;\n  border: 1px solid red !important;\n  color: red;\n  border-radius: 3px;\n  font-size: 12px;\n  padding: 3px 10px 4px;\n  transition: 1s;\n\n  &:hover {\n    background: red;\n    color: white;\n    border: 1px solid red;\n  }\n}\n\n.profile-section {\n  height: calc(100vh - 121px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.profileSection {\n  width: 100%;\n  height: calc(100vh - 112px);\n  margin: 4px 0;\n\n  img {\n    width: 50px;\n    height: 50px;\n    margin: 4px 0;\n    border: 1px solid;\n  }\n}\n\n.img-account-profile {\n  height: 10rem;\n}\n\n.card .card-header {\n  font-weight: 500;\n}\n\n.card-header:first-child {\n  border-radius: 0.35rem 0.35rem 0 0;\n}\n\n.card-header {\n  margin-bottom: 0 !important;\n  background-color: rgb(31 83 122) !important;\n  border: 1px solid rgb(31 83 122) !important;\n  color: #fff !important;\n}\n\n.nav-borders .nav-link.active {\n  color: #0061f2;\n  border-bottom-color: #0061f2;\n}\n\n.nav-borders .nav-link {\n  color: #69707a;\n  border-bottom-width: 0.125rem;\n  border-bottom-style: solid;\n  border-bottom-color: transparent;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-left: 0;\n  padding-right: 0;\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.col-form-label {\n  font-size: 0.9rem !important;\n}\n\n.dedicon {\n  height: 1rem;\n}\n\n.newrequest1icon {\n  height: 1rem;\n}\n\n.requesttypebox {\n  width: 100%;\n}\n\n.reqtype,\n.projectiddiv,\n.studyiddiv {\n  width: 33.33%;\n}\n\n.newrequestbuttons {\n  width: 8rem;\n}\n\n.createroleicon {\n  height: 1rem;\n}\n\n.createrolerightbottom {\n  margin-top: -11px;\n}\n\n.createroleright {\n  width: 33%;\n  margin-left: 5px;\n  height: 100vh;\n}\n\n.createrolebutton {\n  background-color: var(--white);\n  border: 1px solid rgb(34, 163, 255);\n  width: 7rem;\n}\n\n.rolename {\n  border: 1px solid var(--blue);\n  width: 30%;\n  height: 30px;\n}\n\n.roledescription {\n  border: 1px solid var(--blue);\n  width: 30%;\n  height: 93px;\n  border-radius: 10px;\n}\n\n.createrolefloppyicon {\n  font-size: 5px;\n}\n\n.createrolefloppybutton {\n  margin-top: 0px;\n}\n\n.elementana {\n  background-color: hsl(102deg 39% 94%);\n}\n\n.backupleft {\n  width: 53%;\n}\n\n.backuprightbottom {\n  width: 46%;\n  margin-left: 10px;\n  height: 43rem;\n}\n\n.createroleselect {\n  border: 1px solid var(--blue);\n  width: 30%;\n  height: 30px;\n}\n\n.createrolebuttons {\n  margin-top: 5rem;\n}\n\n.roletext {\n  opacity: 0.8;\n  width: 13%;\n}\n\n.roleform {\n  width: 100%;\n}\n\n.homecross {\n  height: 0.8rem;\n}\n\n.arrowup {\n  height: 1rem;\n}\n\n.arrowdown {\n  height: 1rem;\n}\n\n.calender {\n  height: 23px;\n}\n\n.backuprightarrow {\n  height: 1rem;\n}\n\n.rightarrow {\n  height: 1rem;\n}\n\n.visitrightarrow {\n  height: 0.8rem;\n  margin: 0px;\n  padding: 0px;\n}\n\n.mainfolder {\n  height: 1rem;\n}\n\n.demographics {\n  height: 1rem;\n}\n\n.selectfeild {\n  height: 25px;\n  width: 115px;\n}\n\n.selectfont {\n  height: 24px;\n  width: 101px;\n  margin-top: 18px;\n  padding-top: 1px;\n}\n\n.fontsize {\n  width: 67px;\n  height: 23px;\n  padding-top: 0px;\n}\n\n.democolorselect {\n  background-color: red;\n  opacity: 1;\n  height: 2px;\n}\n\n.selectfontlabel,\n.fontsizelabel,\n.fontsize,\n.feildtypelabel,\n.selectfeild {\n  margin-top: 18px;\n}\n\n.feildtype {\n  margin-bottom: -8px;\n  margin-top: 2px;\n}\n\n.studysiteedit {\n  height: 1rem;\n}\n\n.studysitebody {\n  margin-top: 2px;\n}\n\n.mail,\n.info {\n  height: 1rem;\n}\n\n.trash {\n  height: 1rem;\n}\n\n.childplay {\n  height: 1rem;\n}\n\n.customshow {\n  margin-bottom: 5px;\n}\n\n.cdashselect {\n  border-radius: 5px;\n  width: 54px;\n  color: hsl(0deg 0% 64%);\n  height: 25px;\n  padding-left: 5px;\n  font-size: 9px;\n  text-align: center;\n  border: 1px solid hsl(48deg 21% 86%);\n}\n\n.studysiteselect {\n  border-radius: 5px;\n  width: 54px;\n  color: hsl(0deg 0% 64%);\n  height: 25px;\n  padding-left: 5px;\n  font-size: 9px;\n  text-align: center;\n  border: 1px solid hsl(48deg 21% 86%);\n}\n\n.file {\n  height: 1rem;\n}\n\n.sentdatafont {\n  color: hsl(0deg 2% 52%);\n}\n\n.tborder {\n  border: 1px solid var(--blue);\n  border-radius: 10px;\n}\n\n.check {\n  height: 12px;\n}\n\n.ddob {\n  color: hsl(0deg 0% 39%);\n}\n\n.ddobs {\n  color: hsl(0deg 0% 35%);\n}\n\n.pagelink {\n  background-color: hsl(205deg 100% 38%);\n  margin-right: 4px;\n  margin-left: 4px;\n  border-radius: 6px;\n  margin-top: 1px;\n  width: 100px;\n  height: 1.5rem;\n  color: var(--white);\n  font-size: 13px;\n  border: none;\n  text-align: center;\n}\n\n.rightangle {\n  height: 1.4rem;\n  margin-top: 2px;\n  border: none;\n}\n\n.rntable {\n  padding-bottom: 20rem;\n}\n\n.rightpage {\n  height: 1.5rem;\n}\n\n.showentries {\n  font-size: 13px;\n  padding-top: 3px;\n}\n\n.showentriesselect {\n  padding-top: 2px;\n}\n\n.transferright {\n  width: 33%;\n  height: 100vh;\n  border-left: 1px solid #dee2e6 !important;\n  margin-left: 5px;\n}\n\n.transfereye {\n  background: transparent;\n  border: none;\n  padding: 0px;\n}\n\n.eyeicon {\n  height: 10px;\n}\n\n@media screen and (max-width: 761px) {\n  .transferright {\n    border-left: none;\n    margin-left: 0px;\n  }\n}\n\n/* DATA TRANSFER JOB .................................. */\n\n.datatransferjob {\n  margin-top: 3px;\n}\n\n// @media screen and (max-width: 1709px) {\n//   .transferrightbottom,\n//   .datatransferrighttop {\n//     width: 130%;\n//   }\n// }\n\n@media screen and (max-width: 1528px) {\n  //   .datatransferrighttop {\n  //     width: 130%;\n  //   }\n  // }\n\n  // @media screen and (max-width: 1320px) {\n  //   .transferrightbottom,\n  //   .datatransferrighttop {\n  //     width: 200%;\n  //   }\n  // }\n\n  // @media screen and (max-width: 1148px) {\n  //   .transferrightbottom,\n  //   .datatransferrighttop {\n  //     width: 170%;\n  //   }\n\n  .datatransferleft {\n    width: 130%;\n  }\n}\n\n// @media screen and (max-width: 1050px) {\n//   .transferrightbottom,\n//   .datatransferrighttop {\n//     width: 200%;\n//   }\n\n//   .datatransferleft {\n//     width: 140%;\n//   }\n// }\n\n@media screen and (max-width: 960px) {\n  .transferrightbottom,\n  .datatransferrighttop {\n    width: 210%;\n  }\n\n  .datatransferleft {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 877px) {\n  .transferrightbottom {\n    width: 250%;\n  }\n\n  .datatransferleft {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 816px) {\n  .datatransferleft {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 761px) {\n  .transferleft,\n  .transferright,\n  .transferrightbottom,\n  .datatransferrighttop {\n    width: 100%;\n  }\n\n  .datatransferrighttop {\n    margin-top: 5px;\n  }\n}\n\n@media screen and (max-width: 613px) {\n  .transferrightbottom {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .datatransferleft {\n    width: 210%;\n  }\n}\n\n@media screen and (max-width: 476px) {\n  .transferrightbottom {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 476px) {\n  .datatransferrighttop {\n    width: 120%;\n  }\n}\n\n@media screen and (max-width: 393px) {\n  .datatransferleft {\n    width: 270%;\n  }\n}\n\n@media screen and (max-width: 366px) {\n  .datatransferrighttop {\n    width: 150%;\n  }\n\n  .transferrightbottom {\n    width: 220%;\n  }\n}\n\n/* ..................................................... */\n\n/* STUDYDETAILS.......................................... */\n\n.studydetail {\n  width: 100%;\n  margin-top: 2px;\n}\n\n@media screen and (max-width: 1239px) {\n  .studydetailtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 956px) {\n  .studydetailtable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 830px) {\n  .studydetailtable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 693px) {\n  .studydetailtable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-width: 596px) {\n  .studydetailtable {\n    width: 260%;\n  }\n}\n\n@media screen and (max-width: 483px) {\n  .studydetailtable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-width: 403px) {\n  .studydetailtable {\n    width: 400%;\n  }\n}\n\n/* ...................................................... */\n\n/* CODELIST.............................................. */\n\n.codelistmain {\n  height: 100vh;\n}\n\n.codelistleft {\n  width: 50%;\n}\n\n.codelistright {\n  width: 49.6%;\n  margin-left: 5px;\n}\n\n@media screen and (max-width: 1313px) {\n  .codelistlefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1182px) {\n  .codelistrighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1016px) {\n  .codelistlefttable {\n    width: 140%;\n  }\n\n  .codelistrighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 945px) {\n  .codelistlefttable {\n    width: 160%;\n  }\n\n  .codelistrighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 945px) {\n  .codelistlefttable {\n    width: 160%;\n  }\n\n  .codelistrighttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 830px) {\n  .codelistlefttable {\n    width: 200%;\n  }\n\n  .codelistrighttable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 761px) {\n  .codelistmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .codelistlefttable,\n  .codelistrighttable,\n  .codelistright,\n  .codelistleft {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 667px) {\n  .codelistlefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 597px) {\n  .codelistlefttable {\n    width: 130%;\n  }\n\n  .codelistrighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 518px) {\n  .codelistlefttable {\n    width: 150%;\n  }\n\n  .codelistrighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 464px) {\n  .codelistlefttable {\n    width: 150%;\n  }\n\n  .codelistrighttable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 452px) {\n  .codelistlefttable {\n    width: 180%;\n  }\n\n  .codelistrighttable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 381px) {\n  .codelistlefttable {\n    width: 210%;\n  }\n\n  .codelistrighttable {\n    width: 200%;\n  }\n}\n\n/* ...................................................... */\n\n/* VALUELEVEL............................................ */\n\n.valuelevelleft {\n  width: 36%;\n}\n\n.valuelevelright {\n  width: 63.6%;\n  margin-left: 5px;\n}\n\n.valuelevelrighttable {\n  width: 130%;\n}\n\n@media screen and (max-width: 1533px) {\n  .valuelevellefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1462px) {\n  .valuelevelrighttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 1269px) {\n  .valuelevelrighttable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 1183px) {\n  .valuelevellefttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 1121px) {\n  .valuelevelrighttable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-width: 1027px) {\n  .valuelevellefttable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 955px) {\n  .valuelevelrighttable {\n    width: 220%;\n  }\n}\n\n@media screen and (max-width: 869px) {\n  .valuelevelmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .valuelevelleft,\n  .valuelevelright,\n  .valuelevellefttable {\n    width: 100%;\n    margin: 0px;\n  }\n}\n\n@media screen and (max-width: 869px) {\n  .valuelevellefttable {\n    width: 130%;\n  }\n\n  .valuelevelrighttable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-width: 491px) {\n  .valuelevellefttable {\n    width: 130%;\n  }\n\n  .valuelevelrighttable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-width: 433px) {\n  .valuelevellefttable {\n    width: 150%;\n  }\n\n  .valuelevelrighttable {\n    width: 320%;\n  }\n}\n\n@media screen and (max-width: 387px) {\n  .valuelevellefttable {\n    width: 150%;\n  }\n\n  .valuelevelrighttable {\n    width: 400%;\n  }\n}\n\n@media screen and (max-width: 377px) {\n  .valuelevellefttable {\n    width: 180%;\n  }\n\n  .valuelevelrighttable {\n    width: 400%;\n  }\n}\n\n/* ...................................................... */\n\n.settingright {\n  width: 58%;\n  margin-left: 5px;\n  height: 100vh;\n}\n\n.demographic2main {\n  width: 100%;\n  overflow-x: hidden;\n}\n\n.demographic2bg {\n  width: 100%;\n  height: 30vh;\n}\n\n.demo2left {\n  width: 20%;\n}\n\n.demo2genderbutton {\n  border-radius: 0px;\n}\n\n.demo2genderflex {\n  display: flex;\n  flex-direction: column;\n  height: 60vh;\n}\n\n.menuclose {\n  background: transparent;\n  border: none;\n}\n\n.demographic2genderselect {\n  background-color: hsl(0deg 0% 94%);\n  height: 30vh;\n}\n\n.demo2gender {\n  width: 20%;\n}\n\n.demographic2column {\n  // display: flex;\n  // flex-direction: column;\n  // width: 79.2%;\n  // margin-left: 12px;\n  // height: 100vh;\n  display: flex;\n  flex-direction: column;\n  width: 79.6%;\n  margin-left: 5px;\n  height: 100vh;\n}\n\n.settingtablebg {\n  background-color: #eaf1f6;\n}\n\n.demographicstablebg,\n.settingbg {\n  background-color: rgb(207, 221, 252);\n}\n\n.visitbg {\n  background-color: #eaf1f6;\n}\n\n.visitfont {\n  color: hsl(220deg 94% 31%);\n  font-weight: lighter;\n}\n\n.visitdatafont {\n  color: hsl(0deg 0% 37%);\n}\n\n.visitdatabg {\n  background-color: hsl(0deg 0% 95%);\n}\n\n.visitright {\n  width: 49.8%;\n  margin-left: 2px;\n  height: 44rem;\n}\n\n.eventsearch {\n  border: 1px solid hsl(196deg 100% 47%);\n  border-radius: 5px;\n  height: 1.7rem;\n  width: 130px;\n}\n\n.sentrequesttable {\n  // margin-top: 2px;\n  margin-left: 0px;\n  margin-right: 0px;\n}\n\n.scheduleleft {\n  width: 66.5%;\n  margin-right: 2px;\n  height: 40rem;\n}\n\n.scheduleright {\n  height: 40rem;\n}\n\n.schedulesecond {\n  height: 13rem;\n}\n\n.schedulethird {\n  height: 15rem;\n}\n\n.sno {\n  border: 1px solid rgb(1, 70, 119);\n  border-radius: 10px;\n  margin-top: 7px;\n  height: 37px;\n  padding-top: 5px;\n  width: 98.4%;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.asiancheck {\n  width: 17px;\n  height: 17px;\n  color: blue;\n}\n\n.birthcheck {\n  width: 17px;\n  height: 14px;\n}\n\n.sn {\n  padding-left: 5px;\n  width: 25%;\n}\n\n.dateofbirth {\n  margin-left: 25rem;\n}\n\n.datepick {\n  margin-right: 3rem;\n}\n\n.year {\n  margin-left: 2rem;\n}\n\n.month {\n  margin-left: 2rem;\n}\n\n.date,\n.month,\n.year {\n  width: 5rem;\n  height: 2rem;\n  padding-left: 5px;\n  padding-right: 5px;\n  border-radius: 5px;\n  border: 1px solid var(--blue);\n}\n\n.racecheck {\n  width: 20px;\n  height: 20px;\n  border-radius: 5px;\n  border: solid #ff0000 1px;\n}\n\n.race2 {\n  margin-right: 2.7rem;\n}\n\n.asian {\n  margin-right: 14px;\n}\n\n.alaska {\n  margin-left: 36.5rem;\n}\n\n.datat1 {\n  margin-left: 3.5rem;\n}\n\n.demographicsdatatype {\n  width: 25%;\n  text-align: center;\n}\n\n.demographiccdashvariable {\n  width: 25%;\n}\n\n.demographicsunit {\n  width: 25%;\n}\n\n.scheduleleft {\n  overflow: auto;\n}\n\n.labdatabg {\n  background-color: #e2f0d9;\n}\n\n.labdatabg1 {\n  background-color: #eaf1f6;\n}\n\n.labtableleft {\n  width: 60%;\n  height: 45rem;\n  overflow: auto;\n}\n\n.customlefttable {\n  height: 42rem;\n}\n\n.customrighttable {\n  height: 42rem;\n  width: 33.1%;\n  margin-left: 3px;\n}\n\n.labrighttbbg {\n  background-color: #f2f2f2;\n}\n\n.labtableright {\n  width: 39.6%;\n  height: 45rem;\n  overflow: auto;\n  margin-left: 5px;\n}\n\n.dataentryleft {\n  height: 100vh;\n}\n\n.dataentrytab {\n  background-color: hsl(48deg 21% 86%);\n}\n\n.dataentryright {\n  height: 100vh;\n}\n\n.demographicstablefont,\n.tophead {\n  color: gray;\n  font-size: 13px;\n}\n\n.settinginput {\n  height: 11px;\n}\n\n.table-bordereds {\n  border: 1px solid var(--white);\n}\n\n.leftdiv {\n  width: 65%;\n  height: 100vh;\n}\n\n.userright {\n  width: 35%;\n  height: 100vh;\n}\n\n.methodbuttons {\n  border: 1px solid #cfd3d6;\n  width: 10rem;\n  height: 2.1rem;\n  background-color: var(--white);\n  margin-bottom: 4px;\n}\n\n.middlemethod {\n  background-color: var(--white);\n  border-radius: 10px;\n  width: 93%;\n  margin: auto;\n  padding: 17px;\n}\n\n.tbackground {\n  height: 80vh;\n  background-color: hsl(48deg 21% 86%);\n}\n\n.notemessage {\n  background-color: var(--white);\n  border-radius: 10px;\n  width: 93%;\n  margin: auto;\n  padding: 17px;\n}\n\n.addlibrary {\n  width: 100%;\n  margin-bottom: 59px;\n}\n\n.endbtn {\n  padding-right: 50px;\n}\n\n.searchbar {\n  height: 2rem;\n}\n\n.ok,\n.clock {\n  height: 1rem;\n}\n\n.border-none {\n  border: none;\n  background-color: var(--white);\n}\n\n.studyscheduleedit,\n.edit {\n  height: 1rem;\n}\n\n.print {\n  height: 1rem;\n}\n\n.mainfile {\n  height: 1rem;\n}\n\n.navprofile {\n  height: 22px;\n}\n\n.profiler {\n  margin-bottom: -20px;\n  padding-top: 3px;\n  margin-right: 5px;\n}\n\n.profiler1 {\n  margin-bottom: -20px;\n  padding-top: 3px;\n  margin-right: -3px;\n}\n\n@media screen and (max-device-width: 575px) {\n  .profiler1 {\n    display: none;\n  }\n}\n\n.client1icon,\n.projectidicon {\n  height: 1rem;\n}\n\n.client1,\n.projectid,\n.studyid {\n  font-size: 12px;\n  margin-right: 5px;\n  margin-left: 3px;\n}\n\n.container-fluids {\n  width: 98%;\n  margin-left: 5px;\n}\n\n.usbjid {\n  font-weight: lighter;\n}\n\n.m11 {\n  background-color: hsl(97deg 40% 90%);\n  line-height: 1.6;\n}\n\n.m11 a {\n  text-decoration: none;\n}\n\n.margin {\n  width: 99%;\n  height: 100vh;\n}\n\n.sides {\n  display: flex;\n  flex-direction: column;\n  margin-top: 10px;\n}\n\n.methodsidebg {\n  background-color: hsl(0deg 0% 95%);\n}\n\n.methodsidefont {\n  color: hsl(0deg 0% 0%);\n}\n\n@media screen and (max-device-width: 1600px) {\n  .tbackground {\n    height: 116vh;\n  }\n}\n\n@media screen and (max-device-width: 1376px) {\n  .tbackground {\n    height: 120vh;\n  }\n}\n\n@media screen and (max-device-width: 1127px) {\n  .tbackground {\n    height: 140vh;\n  }\n}\n\n@media screen and (max-device-width: 844px) {\n  .tbackground {\n    height: 150vh;\n  }\n}\n\n/* ............................................................. */\n\n.btn-blue {\n  background: var(--blue);\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 6px;\n  width: 100%;\n  color: var(--white);\n  margin: 0px;\n  padding: 2px;\n  border: 1px solid var(--blue) !important;\n\n  &:hover {\n    background: #134971;\n    color: var(--white) !important;\n    border: 1px solid var(--blue) !important;\n  }\n\n  &:focus {\n    background: #134971;\n    color: var(--white) !important;\n    border: 1px solid var(--blue) !important;\n  }\n}\n\n.border-blue {\n  border-color: var(--blue) !important;\n  border-width: 3px !important;\n}\n\n.border-info {\n  border: 1px solid var(--blue) !important;\n}\n\n.rotate-up {\n  transform: rotate(270deg);\n}\n\n.rotate-down {\n  transform: rotate(90deg);\n}\n\n.activeclient {\n  color: rgb(80, 193, 80) !important;\n}\n\n.disableColor {\n  color: #afa7a7 !important;\n}\n\n.archievedusers {\n  color: gray;\n}\n\n.frozenusers {\n  color: #ddaf00;\n}\n\n.onBoardusers {\n  color: blue;\n}\n\n.pendingclient {\n  color: rgb(146, 113, 50);\n}\n\n.text-capitalize {\n  text-transform: capitalize;\n}\n\n.accessManage {\n  color: var(--blue);\n}\n\n.inactiveclient {\n  color: hsl(359deg 78% 61%) !important;\n}\n\n.awaiting {\n  color: hsl(200deg 94% 23%);\n}\n\n.ongoing {\n  color: rgb(110, 183, 0);\n}\n\n.locked {\n  color: hsl(149deg 95% 30%);\n}\n\n.completed {\n  color: hsl(198deg 33% 52%);\n}\n\n.inactive {\n  color: hsl(4deg 80% 66%);\n}\n\n.topbox {\n  display: flex;\n}\n\n.clients,\n.request,\n.users {\n  color: var(--blue);\n}\n\n.roles,\n.audits {\n  color: var(--blue);\n}\n\n.navcolap {\n  padding-bottom: 13px;\n}\n\n.auditcolap {\n  padding-left: 8px;\n}\n\n.rolescolap {\n  padding-left: 25px;\n}\n\n.auditscolap {\n  padding-left: 20px;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: black;\n  background-color: hsl(48deg 21% 86%);\n}\n\n.genderselect {\n  border-left: 1px solid #dee2e6;\n  height: 35rem;\n  width: 99.6%;\n  margin-left: 5px;\n}\n\n.genderpane {\n  display: flex;\n}\n\n.leftbox {\n  width: 24.6%;\n  border-right: 1px solid #dee2e6;\n}\n\n.leftbox1 {\n  margin-top: 16px;\n}\n\n.htarea {\n  width: 98%;\n  border-radius: 10px;\n}\n\n.testinput {\n  width: 45rem;\n}\n\n.testhead {\n  background-color: hsl(205deg 39% 87%);\n}\n\n.testinput1 {\n  height: 38px;\n  margin-top: 4px;\n  border-radius: 10px;\n}\n\n.testtablediv {\n  width: 100%;\n}\n\n.testt1r {\n  color: red;\n}\n\n.testt2r {\n  color: green;\n}\n\n.testbtn {\n  background-color: var(--white);\n  width: 9rem;\n  height: 35px;\n  margin-top: 5px;\n}\n\n.testdatarow {\n  background-color: hsl(202deg 40% 96%);\n}\n\n.models {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 68%;\n  pointer-events: auto;\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.6rem;\n  outline: 0;\n  height: 100%;\n  min-height: 164px;\n  background-color: hsl(24deg 84% 83%);\n  padding-bottom: 1rem;\n}\n\n.modalcross {\n  background-color: transparent;\n  border: none;\n  color: hsl(202deg 56% 53%);\n}\n\n.modals-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 0 20px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  text-align: center;\n  line-height: 1.6;\n  font-size: 16px;\n}\n\n.modaltxt {\n  color: hsl(30deg 17% 5%);\n}\n\n.historybg {\n  background-color: #d1e0eb;\n}\n\n.historydatabg,\n.historyheight {\n  background-color: var(--white);\n}\n\n.hheighttable {\n  height: 100vh;\n}\n\n.historytxt {\n  color: #262626;\n  font-weight: lighter;\n}\n\n.hrcolor {\n  color: rgb(158, 162, 162);\n  margin-bottom: 5px;\n}\n\n.testrule {\n  margin-bottom: 6px;\n  padding-top: 5px;\n}\n\n.testval {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.testsection {\n  width: 97%;\n  margin: auto;\n}\n\n.add {\n  background-color: var(--white);\n  width: 9rem;\n  padding: 5px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.custom-table td.multiselectOption,\n.query-table {\n  padding: 0px !important;\n}\n\n.multiselectOption .multiSelectContainer .searchWrapper {\n  border: 0;\n  border-radius: 0;\n}\n\n.multiselectOption .displayBlock {\n  position: fixed;\n}\n\n.multiselectOption .chip {\n  border-radius: 3px;\n  font-size: 11px;\n  line-height: 10px;\n  margin-bottom: 3px;\n  margin-right: 2px;\n  padding: 5px 10px;\n}\n\n.nav-link {\n  color: #4c4c4c;\n  padding: 3px 10px;\n  font-size: 12px;\n\n  &:hover {\n    background: var(--blue) !important;\n    color: #fff !important;\n  }\n}\n\n.page-link {\n  color: var(--blue);\n}\n\n.navcard {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-clip: border-box;\n}\n\n.navroles {\n  background: transparent;\n  border: none;\n  color: var(--white) fff;\n  text-decoration: none;\n}\n\n.drop-down02 {\n  position: relative;\n}\n\n.drop-down02 .sub-menu02 {\n  position: absolute !important;\n  left: 100%;\n  top: 0;\n}\n\n.drop-down02 .dropdown-toggle {\n  padding: 0.25rem 1.1rem !important;\n}\n\n#sub-dropdown-menu {\n  display: none;\n  position: absolute;\n  left: 260px;\n  top: 10px;\n}\n\n.studyschedulehover:hover #sub-dropdown-menu {\n  display: block;\n}\n\n@media screen and (max-width: 767px) {\n  .drop-down02 .sub-menu02 {\n    position: static !important;\n  }\n}\n\n/* SCROLLBAR........................................... */\n\n/* width */\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.blank::-webkit-scrollbar {\n  width: 0px;\n  height: 0px;\n}\n\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #b8cfdf;\n}\n\n.dropdown {\n  background: transparent;\n  border: none;\n  padding-left: 0px;\n}\n\n.dropdowns {\n  color: transparent;\n}\n\n.show > .btn-primary.dropdown-toggle {\n  background-color: transparent;\n}\n\n.dropdown:hover {\n  background: transparent;\n  border: none;\n  border-color: transparent;\n}\n\n.searchselector {\n  background-color: var(--white);\n  border: none;\n  border-radius: 5px;\n  width: 17px;\n}\n\n.searchmagnifier {\n  margin-top: 7px;\n  font-size: 12px;\n  font-weight: bolder;\n  color: black;\n}\n\n.navsearch {\n  height: 24px;\n  border: none;\n  padding-left: 1px;\n}\n\n.navdropdown {\n  margin-left: -24px;\n}\n\n.searchselectoption {\n  color: black;\n  background-color: var(--white);\n}\n\n.gaurav {\n  margin-right: 9px;\n  max-width: 23rem;\n}\n\n.adminLoggedIn {\n  max-width: 20rem;\n  margin-right: 20px;\n}\n\n.galaxbar {\n  height: 34px;\n}\n\nsection.middle-content {\n  width: 100%;\n\n  .sidebar {\n    width: 100%;\n    // height: calc(100vh - 80px);\n    border: 1px solid #e5e5e5;\n    border-radius: 3px;\n    overflow: hidden;\n\n    .menus {\n      ul {\n        display: flex;\n        width: 100%;\n        padding: 0;\n        margin: 0;\n        flex-wrap: wrap;\n        justify-content: flex-start;\n\n        li {\n          display: flex;\n          padding: 5px;\n          justify-content: space-between;\n        }\n      }\n    }\n  }\n\n  .sidebar-body {\n    overflow: auto;\n    max-height: calc(100vh - 114px);\n    min-width: 250px;\n  }\n}\n\na[aria-expanded=\"true\"] .fa-angle-right {\n  transform: rotate(90deg);\n  padding-right: 10px;\n}\n\na[aria-expanded=\"false\"] .fa-chevron-down,\n.react-datepicker-wrapper input {\n  display: none;\n}\n\n.plane {\n  color: black;\n}\n\nsection.middle-content .sidebar .menus ul li .hr-line {\n  width: 100%;\n  height: 100%;\n  border: 1px solid #e5e5e5;\n}\n\nsection.middle-content .sidebar .menus ul li a {\n  color: #000;\n  text-decoration: none;\n  font-weight: 500;\n  font-size: 13px;\n  text-wrap: nowrap;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\nsection.middle-content .inner-cont .home-line {\n  width: 100%;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 0px;\n  height: 31px;\n\n  .slideRight {\n    margin-left: auto;\n  }\n}\n\n.dedhome-line {\n  width: 100%;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 10px;\n}\n\n.home-line {\n  width: 100%;\n  border-bottom: 1px solid #e5e5e5;\n}\n\n.grid {\n  padding-left: 2px;\n}\n\nsection.middle-content .inner-cont .home-line i {\n  font-size: 0.9rem;\n}\n\nsection.middle-content .inner-cont .home-line2 {\n  width: 100%;\n  border-bottom: 1px solid #e5e5e5;\n  padding: 0px;\n}\n\nsection.middle-content .inner-cont .home-line2 i {\n  font-size: 1rem;\n  cursor: pointer;\n  margin: 0px 5px 0px 5px;\n}\n\n.dashboard-body {\n  height: calc(100vh - 155px);\n  width: 100%;\n  overflow: auto;\n}\n\n.dashboard-body .dashboard_item {\n  height: 100%;\n}\n\n.hovertablerow :hover {\n  background-color: rgb(184, 184, 186);\n}\n\n.dashboard_item .list-group {\n  border: 1px solid rgba(0, 0, 0, 0.125);\n  padding: 11px;\n  background: aliceblue;\n  height: 100%;\n}\n\n.listgroup {\n  margin-bottom: 22px;\n}\n\n.sov {\n  width: 100.5%;\n}\n\n.homedash {\n  height: calc(100vh - 37px);\n}\n\n@media screen and (max-device-width: 565px) {\n  section.middle-content .sidebar .menus ul li {\n    padding: 2px;\n  }\n}\n\n@media screen and (max-device-width: 398px) {\n  .vr {\n    visibility: hidden;\n  }\n}\n\n/* DASHBOARD RESPONSIVENESS............................ */\n\n@media screen and (max-device-width: 1401px) {\n  .list-group {\n    margin-bottom: 23px;\n  }\n\n  .sov {\n    width: 100.8%;\n  }\n\n  .homedash {\n    height: 91%;\n  }\n}\n\n@media screen and (max-device-width: 1380px) {\n  .list-group {\n    margin-bottom: 22px;\n  }\n\n  .homedash {\n    height: 91%;\n  }\n}\n\n@media screen and (max-device-width: 1339px) {\n  .list-group {\n    margin-bottom: 43px;\n  }\n}\n\n@media screen and (max-device-width: 1205px) {\n  .list-group {\n    margin-bottom: 43px;\n  }\n}\n\n@media screen and (max-device-width: 1176px) {\n  .list-group {\n    margin-bottom: 31px;\n  }\n}\n\n@media screen and (max-device-width: 1140px) {\n  .list-group {\n    margin-bottom: 31px;\n  }\n}\n\n@media screen and (max-device-width: 1132px) {\n  .list-group {\n    margin-bottom: 31px;\n  }\n}\n\n@media screen and (max-device-width: 1110px) {\n  .list-group {\n    margin-bottom: -11px;\n  }\n}\n\n@media screen and (max-device-width: 1090px) {\n  .topbox {\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .fbox {\n    width: 99.5%;\n  }\n\n  .sbox {\n    width: 100%;\n    margin-top: 5px;\n  }\n\n  .tbox,\n  .tbox1 {\n    width: 100%;\n  }\n\n  .sov {\n    width: 100%;\n  }\n}\n\n@media screen and (max-device-width: 622px) {\n  .fboxtab {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .fbox622 {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n\n  .sboxtab {\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n.dashboard_item .list-group .list-group-item {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.125);\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  background-color: transparent;\n}\n\n.dashboard_item .list-group .list-group-item span i {\n  margin-right: 10px;\n}\n\nsection.middle-content .client-collapse .card-body {\n  border: none;\n  padding: 0;\n}\n\nsection.middle-content .client-collapse .card-body a {\n  text-decoration: none;\n  color: #000;\n  padding: 6px 10px;\n  text-wrap: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  font-size: 12px;\n  border-bottom: 1px solid #e5e5e5;\n}\n\nsection.middle-content .client-collapse .card-body a:hover,\n.selectedMenu {\n  background-color: #dbe6ef !important;\n}\n\n.nav-link-selected {\n  // background-color: #e3e0d4;\n  background-color: rgba(16, 60, 94, 0.3411764706);\n}\n\nsection.middle-content .collapse:not(.show) {\n  display: none;\n}\n\n/* End Here */\n.ace_editor {\n  width: 100% !important;\n  height: 100% !important;\n}\n\nspan.ace_identifier,\n.ace-monokai .ace_support.ace_constant,\n.ace-monokai .ace_support.ace_function,\n.ace_string {\n  font-size: inherit;\n}\n\n.ace-monokai .ace_print-margin {\n  visibility: hidden !important;\n}\n\n/* user form css */\n\n.dashboard-body .form-section .form-button {\n  text-align: end;\n}\n\n.dashboard-body .form-section .img-thumbnail {\n  padding: 0.25rem;\n  background-color: var(--white);\n  border: 1px solid #0dcaf0;\n  border-radius: 0.25rem;\n  max-width: 100%;\n  height: 100px;\n}\n\n.fa-eye {\n  font-size: 10px;\n}\n\n/* user form css end */\n\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: var(--white);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 0.3rem;\n  outline: 0;\n  height: 100%;\n  min-height: 164px;\n}\n\n.updateProfiles_css {\n  background: #103c5e;\n  border: 1px solid transparent;\n  color: var(--white);\n  border-radius: 10px;\n  font-weight: bold;\n\n  &:hover {\n    background: transparent;\n    border: 1px solid #103c5e !important;\n    color: #103c5e;\n  }\n}\n\n.nav-tabs .nav-link.active {\n  color: var(--white);\n  background-color: var(--blue);\n}\n\n.nav-tabs .nav-link {\n  background-color: #dedede;\n}\n\n.login-form .form-check-label {\n  font-size: 20px;\n}\n\n.demomain {\n  overflow-x: hidden;\n}\n\n.Resizer.horizontal {\n  border-top: 1px solid var(--bs-border-color);\n  border-bottom: 1px solid var(--bs-border-color);\n  height: 4px;\n  cursor: s-resize;\n  transition: 0.2s;\n}\n\n.Resizer.vertical {\n  border-left: 1px solid var(--bs-border-color);\n  border-right: 1px solid var(--bs-border-color);\n  width: 4px;\n  cursor: e-resize;\n  transition: 0.2s;\n}\n\n.Resizer.horizontal:hover,\n.Resizer.vertical:hover {\n  background: var(--bs-border-color);\n}\n\n.Pane.horizontal.Pane2 {\n  overflow: auto;\n}\n\n.fixed_tab_button {\n  position: sticky;\n  top: 0;\n  z-index: 99;\n}\n\n.Pane {\n  overflow: auto;\n  // position: static !important;\n}\n\n.editor .Pane.Pane2 {\n  overflow: hidden !important;\n}\n\n.Pane.vertical {\n  padding: 0 0px;\n}\n\n.Pane.horizontal {\n  display: block !important;\n}\n\n.resizable-x,\n.resizable-y {\n  display: flex;\n}\n\n.resizable-x {\n  height: 100%;\n  padding: 5px;\n}\n\n.resizable-y {\n  flex-direction: column;\n  width: -webkit-fill-available;\n  width: -moz-available;\n  border: 1px solid #eef2f7;\n  border-radius: 3px;\n  overflow-y: hidden;\n  background: #eef2f7;\n}\n\n.resizer-x,\n.resizer-y {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0px;\n  padding: 0px;\n}\n\n.resizer-x {\n  z-index: 2;\n  cursor: col-resize;\n  width: 5px;\n}\n\n.resizer-x::before,\n.resizer-x::after {\n  content: \"\";\n  width: 1px;\n  height: 16px;\n  margin: 1px;\n  background: rgb(115, 115, 115);\n}\n\n.resizer-xHidden {\n  z-index: 2;\n  opacity: 0 !important;\n  cursor: none !important;\n  width: 5px;\n}\n\n.resizer-y {\n  z-index: 1;\n  cursor: col-resize;\n  flex-direction: column;\n}\n\n.resizer-y::before,\n.resizer-y::after {\n  content: \"\";\n  width: 16px;\n  height: 2px;\n  margin: 2px;\n  background: var(--white);\n}\n\n.div0 {\n  width: 300px;\n}\n\n.eventleft {\n  width: 27%;\n  height: 100vh;\n  margin-top: 3px;\n}\n\n.eventfilter {\n  background-color: transparent;\n}\n\n.eventright {\n  height: 100vh;\n  margin-top: 3px;\n}\n\n.question {\n  height: 1.5rem;\n}\n\n#client-section,\n#new-request-section,\n#sent-request-section,\n#new-user-section,\n#demographic-section,\n#demographic-2-section,\n#study-schedule-section,\n#study-randomization-section,\n#study-site-section,\n#visit-crf-martix-section,\n#data-transfer-job-section {\n  display: none;\n}\n\n/* end here */\n\n/* login-form-css */\n\n.login-form .form-check-label {\n  font-size: 20px;\n}\n\n.newuserleft,\n.newuserright {\n  width: 50%;\n}\n\n/* NEW REQUEST......................................... */\n\n.useremailmain {\n  width: 100%;\n}\n\n.useremail {\n  width: 7%;\n}\n\n.newreqemailid {\n  width: 93%;\n  height: 31px;\n  border: 1px solid var(--blue);\n}\n\n.useremail,\n.subject {\n  opacity: 0.7;\n  font-size: 0.8rem;\n}\n\n.subjectrequestmain {\n  width: 100%;\n}\n\n.subject {\n  width: 4.5%;\n}\n\n.subjectinput {\n  width: 95.5%;\n  height: 31px;\n  border: 1px solid var(--blue);\n}\n\n.schedulemain {\n  width: 99.9%;\n}\n\n.requesttypelabel {\n  width: 34%;\n}\n\n.selectrequesttype {\n  border: 1px solid var(--blue);\n  width: 66%;\n  height: 2.3rem;\n}\n\n.expected {\n  width: 9rem;\n}\n\n.attach {\n  width: 307px;\n  height: 55px;\n}\n\n.attachleft {\n  width: 90%;\n  height: 100%;\n  background-color: hsl(203deg 69% 88%);\n}\n\n.attachhr {\n  margin-top: 3px;\n  margin-bottom: 3px;\n  margin-left: -8px;\n  margin-right: -8px;\n}\n\n.newrequestbg {\n  background-color: hsl(205deg 40% 94%);\n  margin: 0px;\n  padding-top: 15px;\n  height: 100vh;\n}\n\n.projectidlabel {\n  width: 25%;\n}\n\n.projectidinput {\n  border: 1px solid var(--blue);\n  width: 75%;\n  height: 2.3rem;\n}\n\n.studyidlabel {\n  width: 25%;\n}\n\n.studyidinput {\n  width: 75%;\n  border: 1px solid var(--blue);\n  height: 2.3rem;\n}\n\n.clientlabel {\n  width: 11.4%;\n}\n\n.clientname {\n  height: 2.3rem;\n  border-radius: 5px;\n  border: 1px solid var(--blue);\n  width: 89.3%;\n  padding-left: 15px;\n}\n\n.clientnamediv {\n  width: 100%;\n}\n\n.protocolversionlabel {\n  width: 23%;\n}\n\n.protocol,\n.enrollment {\n  width: 50%;\n}\n\n.protocolversioninput {\n  height: 2.3rem;\n  border-radius: 5px;\n  border: 1px solid var(--blue);\n  width: 44%;\n}\n\n.expectedenrollmentlabel {\n  width: 40%;\n  padding-left: 10px;\n  padding-top: 4px;\n}\n\n.expectedenrollmentinput {\n  height: 2.3rem;\n  border-radius: 5px;\n  border: 1px solid var(--blue);\n  width: 60%;\n}\n\n.clientnametextarea {\n  width: 100%;\n  border-radius: 7px;\n  border: 1px solid var(--blue);\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n.clientnametextareas {\n  width: 90%;\n  border-radius: 7px;\n  border: 1px solid var(--blue);\n  transition:\n    border-color 0.15s ease-in-out,\n    box-shadow 0.15s ease-in-out;\n}\n\n.herapeutic {\n  height: 2.3rem;\n  width: 60%;\n  border: 1px solid var(--blue);\n}\n\n.studyphase {\n  width: 40%;\n}\n\n.studytype {\n  width: 13%;\n}\n\n.studytypes {\n  width: 11.3%;\n}\n\n.herapeutics {\n  width: 22%;\n  height: 2.3rem;\n  border: 1px solid var(--blue);\n}\n\n/* DATA TRANSFER JOB CREATION ........................*/\n\n.creationmain {\n  overflow-x: hidden;\n}\n\n.dataextract-dashboard-body {\n  overflow: hidden;\n}\n\n.table-responsive-creation {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.datacreationleft {\n  width: 66%;\n}\n\n.datacreationleft {\n  margin: 0px;\n}\n\n.datacreationright {\n  height: 100vh;\n  width: 33.7%;\n}\n\n.datacreationright {\n  border-left: 1px solid #dee2e6 !important;\n  margin-left: 5px;\n}\n\n.datacreationleft,\n.datacreationright {\n  height: 100vh;\n}\n\n.creationinnerflex {\n  width: 50%;\n  margin-top: 10px;\n}\n\n.creationinnerflex1 {\n  margin-top: 10px;\n}\n\n.creationlabel {\n  width: 40%;\n  padding-left: 10px;\n}\n\n.creationinput {\n  border: 1px solid var(--blue);\n  width: 60%;\n  height: 2.3rem;\n}\n\n.dattransferid {\n  width: 50%;\n}\n\n.projectidinputs {\n  border: 1px solid var(--blue);\n  width: 60%;\n  height: 2.3rem;\n}\n\n.projectidlabels {\n  width: 20%;\n  padding-left: 56px;\n}\n\n.emailsingle {\n  padding-left: 41px;\n}\n\n.projectidlabel1 {\n  width: 25%;\n}\n\n.projectidinputs1 {\n  border: 1px solid var(--blue);\n  width: 80%;\n  height: 2.3rem;\n}\n\n@media screen and (max-device-width: 1187px) {\n  .creationinput,\n  .creationlabel {\n    width: 50%;\n  }\n\n  .projectidlabels {\n    width: 25%;\n  }\n\n  .projectidinputs1 {\n    width: 75%;\n  }\n}\n\n@media screen and (max-device-width: 1053px) {\n  .projectidlabel1 {\n    width: 50%;\n    padding-left: 4px;\n  }\n\n  .projectidinputs {\n    width: 50%;\n  }\n\n  .projectidinputs1 {\n    width: 75%;\n  }\n\n  .projectidlabels {\n    width: 25%;\n  }\n}\n\n@media screen and (max-device-width: 997px) {\n  .creationtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 972px) {\n  .creationmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .creationtable {\n    width: 100%;\n  }\n\n  .datacreationright {\n    border-left: none;\n    margin-left: 0px;\n  }\n\n  .datacreationleft {\n    height: 30vh;\n    overflow: auto;\n  }\n\n  .table-responsive-creation {\n    height: 37vh;\n    overflow: auto;\n    margin-top: 10px;\n  }\n\n  .datacreationleft,\n  .datacreationright {\n    width: 100%;\n  }\n\n  .creationlabel {\n    width: 45%;\n  }\n\n  .creationlabel {\n    width: 55%;\n  }\n\n  .projectidlabels {\n    width: 26.4%;\n  }\n\n  .projectidinputs1 {\n    width: 73.6%;\n  }\n}\n\n@media screen and (max-device-width: 643px) {\n  .creationflexmain {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .creationinnerflex {\n    width: 100%;\n  }\n\n  .creationlabel,\n  .projectidlabels {\n    width: 35%;\n    padding: 0px;\n  }\n\n  .creationinput,\n  .projectidinputs1 {\n    width: 65%;\n  }\n}\n\n@media screen and (max-device-width: 467px) {\n  .creationinnerflex,\n  .creationinnerflex1 {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .creationlabel,\n  .projectidlabels,\n  .creationinput,\n  .projectidinputs1 {\n    width: 100%;\n  }\n}\n\n@media screen and (max-device-width: 336px) {\n  .creationtable {\n    width: 130%;\n  }\n}\n\n/* ................................................... */\n\n@media screen and (max-device-width: 1800px) {\n  .useremail {\n    width: 8%;\n  }\n\n  .newreqemailid {\n    width: 92%;\n  }\n\n  .subject {\n    width: 5.3%;\n  }\n\n  .subjectinput {\n    width: 94.7%;\n  }\n}\n\n@media screen and (max-device-width: 1690px) {\n  .useremail {\n    width: 9%;\n  }\n\n  .newreqemailid {\n    width: 91%;\n  }\n\n  .subject {\n    width: 6.3%;\n  }\n\n  .subjectinput {\n    width: 93.7%;\n  }\n}\n\n@media screen and (max-device-width: 1570px) {\n  .subject {\n    width: 6.1%;\n  }\n\n  .subjectinput {\n    width: 93.9%;\n  }\n}\n\n@media screen and (max-device-width: 1500px) {\n  .useremail {\n    width: 9.2%;\n  }\n\n  .newreqemailid {\n    width: 90.8%;\n  }\n\n  .subject {\n    width: 6.1%;\n  }\n\n  .subjectinput {\n    width: 93.9%;\n  }\n}\n\n@media screen and (max-device-width: 1500px) {\n  .useremail {\n    width: 10.3%;\n  }\n\n  .newreqemailid {\n    width: 89.7%;\n  }\n\n  .subject {\n    width: 7.1%;\n  }\n\n  .subjectinput {\n    width: 92.9%;\n  }\n}\n\n@media screen and (max-device-width: 1350px) {\n  .useremail {\n    width: 11.3%;\n  }\n\n  .newreqemailid {\n    width: 88.7%;\n  }\n\n  .subject {\n    width: 8.1%;\n  }\n\n  .subjectinput {\n    width: 91.9%;\n  }\n}\n\n@media screen and (max-device-width: 1143px) {\n  .subject {\n    width: 9.9%;\n  }\n\n  .subjectinput {\n    width: 90.1%;\n  }\n\n  .useremail {\n    width: 14%;\n  }\n\n  .newreqemailid {\n    width: 86%;\n  }\n}\n\n@media screen and (max-device-width: 1009px) {\n  .subject {\n    width: 10.9%;\n  }\n\n  .useremail {\n    width: 15.1%;\n  }\n}\n\n/* ......................................... */\n\n/* DATA LOCK REQUEST........................... */\n\n@media screen and (max-device-width: 1176px) {\n  .projectidlabel {\n    width: 35%;\n  }\n\n  .projectidinput {\n    width: 65%;\n  }\n}\n\n/* ............................................ */\n\n/* SENT REQUEST........................................ */\n\n@media screen and (min-device-width: 559px) and (max-width: 740px) {\n  .sentrequesttable {\n    width: 140%;\n  }\n}\n\n@media screen and (max-device-width: 559px) {\n  .sentrequesttable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 413px) {\n  .sentrequesttable {\n    width: 200%;\n  }\n\n  .sentdatafont {\n    font-size: 12px;\n  }\n\n  .sentrequestfont {\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-device-width: 413px) {\n  .sentrequesttable {\n    width: 220%;\n  }\n}\n\n/* ............................................... */\n\n@media screen and (max-width: 1284px) {\n  .useremailid {\n    width: 11%;\n  }\n\n  .topuseremail {\n    width: 89%;\n  }\n}\n\n@media screen and (max-width: 1236px) {\n  .useremailid {\n    width: 11%;\n  }\n\n  .topuseremail {\n    width: 89%;\n  }\n}\n\n@media screen and (max-width: 1236px) {\n  .useremailid {\n    width: 12%;\n  }\n\n  .topuseremail {\n    width: 88%;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .useremailid {\n    width: 12%;\n  }\n\n  .topuseremail {\n    width: 88%;\n  }\n}\n\n@media screen and (max-width: 1084px) {\n  .useremailid {\n    width: 13%;\n  }\n\n  .topuseremail {\n    width: 87%;\n  }\n}\n\n@media screen and (max-width: 1007px) {\n  .useremailid {\n    width: 14%;\n  }\n\n  .topuseremail {\n    width: 86%;\n  }\n}\n\n@media screen and (max-width: 941px) {\n  .useremailid {\n    width: 16%;\n  }\n\n  .topuseremail {\n    width: 84%;\n  }\n}\n\n@media screen and (max-width: 883px) {\n  .useremailid {\n    width: 19%;\n  }\n\n  .topuseremail {\n    width: 81%;\n  }\n}\n\n@media screen and (max-width: 715px) {\n  .useremailid {\n    width: 22%;\n  }\n\n  .topuseremail {\n    width: 78%;\n  }\n}\n\n@media screen and (max-width: 715px) {\n  .useremailid {\n    width: 21%;\n  }\n\n  .topuseremail {\n    width: 79%;\n  }\n}\n\n@media screen and (max-width: 715px) {\n  .useremailid {\n    width: 22%;\n  }\n\n  .topuseremail {\n    width: 78%;\n  }\n}\n\n@media screen and (max-width: 628px) {\n  .useremailid {\n    width: 23%;\n  }\n\n  .topuseremail {\n    width: 77%;\n  }\n}\n\n@media screen and (max-width: 605px) {\n  .useremailid {\n    width: 26%;\n  }\n\n  .topuseremail {\n    width: 74%;\n  }\n}\n\n@media screen and (max-width: 540px) {\n  .usertopbox {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .useremailid {\n    width: 100%;\n    margin-bottom: 10px;\n    padding: 0px;\n  }\n\n  .topuseremail {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 650px) {\n  .firstname,\n  .middlename,\n  .lastname,\n  .address,\n  .postalcode,\n  .state,\n  .userid,\n  .city,\n  .country,\n  .mobilenumber,\n  .officephone,\n  .emailid,\n  .designation {\n    display: flex;\n  }\n\n  .inputborder {\n    width: 100%;\n  }\n\n  .newusermaindiv {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .avatarborder {\n    height: 6rem;\n  }\n\n  .inputfonts,\n  .avatarleft {\n    width: 25%;\n  }\n\n  .inputborder,\n  .countryoption {\n    width: 75%;\n  }\n\n  .newuserleft,\n  .newuserright {\n    width: 100%;\n  }\n\n  .form-button {\n    display: flex;\n  }\n\n  .bottombuttons {\n    margin-top: 2rem;\n  }\n\n  // .updateProfile,\n  // .cancelbutton {\n  //   width: 5rem;\n  // }\n\n  .avatarleft {\n    width: 25%;\n  }\n\n  .avatarright {\n    width: 75%;\n  }\n\n  .uploadlabel {\n    width: 80%;\n  }\n\n  .chooselogo {\n    width: 20%;\n  }\n}\n\n@media screen and (min-device-width: 1000px) and (max-width: 1110px) {\n  .inputfonts,\n  .avatarleft,\n  .uploadlogo {\n    width: 30%;\n  }\n\n  .inputborder {\n    width: 70%;\n  }\n\n  .countryoption {\n    width: 70%;\n  }\n\n  .chooselogo {\n    width: 70%;\n  }\n\n  .bottombuttons {\n    margin-top: 4rem;\n  }\n}\n\n/* NEW CLIENT..................................... */\n\n.form-section {\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.uploadlogofile {\n  width: 25%;\n}\n\n.fill {\n  border: 1px solid var(--blue);\n  line-height: 1.5;\n  width: 75%;\n}\n\n.fill::file-selector-button {\n  background-color: var(--blue);\n  color: var(--white);\n  border: none;\n  border-radius: 0.2em;\n}\n\n/* ................................................ */\n\n@media screen and (max-width: 540px) {\n  .firstname,\n  .middlename,\n  .lastname,\n  .address,\n  .postalcode,\n  .state,\n  .userid,\n  .city,\n  .country,\n  .mobilenumber,\n  .officephone,\n  .emailid,\n  .designation {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .inputborder,\n  .countryoption {\n    width: 100%;\n  }\n\n  .avatarleft {\n    width: 0%;\n  }\n\n  .inputfonts {\n    width: 100%;\n  }\n\n  .uploadsection {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .chooselogo,\n  .uploadlogo {\n    width: 100%;\n  }\n\n  .fill {\n    width: 100%;\n  }\n}\n\n/* CDASH................................................ */\n\n.cdashmenuclose {\n  background: transparent;\n  border: none;\n  padding: 0px;\n}\n\n// .cdashmain {\n//   margin-top: 2px;\n// }\n\n.navigation_bar {\n  font-size: 12px;\n  padding: 5px 7px;\n  margin: 0;\n  color: var(--white);\n  border-bottom: 1px solid #668298;\n  background: #668298;\n}\n\n.cdashleft {\n  width: 65%;\n  height: 100vh;\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.Derived__veriable {\n  width: 30%;\n  height: 100vh;\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.cdashright {\n  width: 34.7%;\n  margin-left: 5px;\n  height: 100vh;\n  border-left: 1px solid #dee2e6 !important;\n  position: relative;\n}\n\n.radiobar__chart__graph {\n  h2 {\n    padding-left: 20px;\n    font-size: 17px;\n    font-weight: 800;\n    text-align: center;\n  }\n\n  p {\n    margin: 0;\n    font-size: 13px;\n  }\n}\n\n// .SaveDeriver__button {\n//   position: absolute;\n//   right: 0;\n//   top: 0;\n// }\n\n.Derived__veriable__right {\n  width: 69.7%;\n  margin-left: 5px;\n  height: 100vh;\n  border-left: 1px solid #dee2e6 !important;\n  position: relative;\n}\n\n.table-responsive-cdashleft {\n  max-height: calc(100vh - 165px);\n  overflow-y: auto;\n  position: relative;\n}\n\n// .table-responsive-cdashrighttop {\n//   max-height: 35vh;\n//   overflow: auto;\n//   position: relative;\n// }\n\n.cdashrightbottom {\n  margin-top: 8px;\n}\n\n.table-responsive-cdashrightbottom {\n  // max-height: 30vh;\n  // overflow: auto;\n  position: relative;\n}\n\n@media screen and (max-width: 1226px) {\n  .cdashrighttoptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1060px) {\n  .cdashlefttable {\n    width: 140%;\n  }\n}\n\n@media screen and (max-width: 949px) {\n  .cdashrighttoptable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 893px) {\n  .cdashrightbottomtable {\n    width: 120%;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .cdashmain {\n    flex-wrap: wrap;\n  }\n\n  .cdashleft,\n  .cdashright {\n    width: 100%;\n  }\n\n  .cdashleft,\n  .table-responsive-cdashleft,\n  .table-responsive-cdashrightbottom,\n  .table-responsive-cdashrighttop {\n    max-height: 23vh;\n    overflow: auto;\n  }\n\n  .cdashright {\n    height: 50vh;\n  }\n\n  .cdashrightbottom {\n    margin-top: 8px;\n  }\n\n  .cdashright {\n    margin-top: 5px;\n    margin-left: 0px;\n    border: none;\n  }\n}\n\n@media screen and (max-width: 738px) {\n  .cdashmain {\n    margin-top: 10px;\n  }\n\n  .cdashleft {\n    height: auto;\n  }\n\n  .table-responsive-cdashleft,\n  .table-responsive-cdashrighttop,\n  .table-responsive-cdashrightbottom {\n    max-height: 20vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-width: 507px) {\n  .cdashlefttable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 417px) {\n  .cdashmain {\n    margin-top: 8px;\n  }\n\n  .table-responsive-cdashleft,\n  .table-responsive-cdashrighttop,\n  .table-responsive-cdashrighttop {\n    max-height: 18vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-width: 399px) {\n  .cdashlefttable {\n    width: 260%;\n  }\n}\n\n.wrapper {\n  position: absolute;\n  border: 1px solid #cecece;\n  border-radius: 3px;\n  width: 200px;\n  background: var(--white);\n  box-shadow: 3px 4px 7px #bababa;\n  z-index: 1;\n}\n\n.middle-content {\n  position: relative;\n}\n\n.contextmenuoptions li a {\n  text-decoration: none;\n}\n\n.contextmenuoptions li {\n  text-decoration: none;\n  list-style-type: none;\n}\n\n@media screen and (max-width: 1587px) {\n  .customrighttop {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1226px) {\n  .customrighttop {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 1066px) {\n  .customrighttop {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .customhistory {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 1226px) {\n  .customrighttop {\n    width: 210%;\n  }\n}\n\n@media screen and (max-width: 982px) {\n  .customhistory {\n    width: 117%;\n  }\n}\n\n@media screen and (max-width: 761px) {\n  .data-transfer,\n  .custommain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .customrighttop,\n  .customleftinner {\n    width: 100%;\n  }\n\n  .cdashsecondtable,\n  .historytt {\n    width: 301%;\n  }\n\n  .customlefttable,\n  .customrighttable {\n    width: 100%;\n    height: 50%;\n  }\n}\n\n@media screen and (max-width: 627px) {\n  .custommain,\n  .data-transfer {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .customlefttable {\n    height: 40%;\n    width: 100%;\n  }\n\n  .customrighttable {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 539px) {\n  .customrighttop {\n    width: 120%;\n  }\n}\n\n@media screen and (max-width: 1221px) {\n  .schedulehistory {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1221px) {\n  .schedulelefttable {\n    width: 120%;\n  }\n}\n\n@media screen and (max-width: 499px) {\n  .schedulelefttable {\n    width: 155%;\n  }\n}\n\n@media screen and (max-width: 761px) {\n  .scheduleleft,\n  .scheduleright {\n    width: 100%;\n  }\n\n  .scheduleleft {\n    height: 50%;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .edc-nav .navbar-toggler {\n    background: var(--white);\n    line-height: 1.4;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 7px;\n    width: 35px;\n    font-size: 14px;\n  }\n\n  button#navbarDropdown1 {\n    margin-right: -166px;\n    margin-top: 1px;\n    margin-bottom: -40px;\n  }\n\n  .login {\n    display: none;\n  }\n\n  .inputborder {\n    width: 75%;\n  }\n\n  .countryoption {\n    width: 75%;\n  }\n\n  .newuserleft,\n  .newuserright {\n    width: 100%;\n  }\n\n  .newusermaindiv {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .bottombuttons {\n    margin-top: 20px;\n  }\n\n  .inputfonts {\n    width: 25%;\n  }\n\n  .filebars {\n    justify-content: end;\n    padding-left: 10px;\n  }\n\n  .filebar {\n    margin-bottom: 8px;\n  }\n\n  .w-sm-100 {\n    width: 100% !important;\n  }\n\n  /* navbar responsive css end*/\n\n  /* body content responsive css*/\n\n  section.middle-content {\n    height: 100%;\n  }\n\n  section.middle-content .sidebar-body {\n    overflow-y: scroll;\n  }\n\n  .dashboard-body {\n    width: 100%;\n  }\n\n  .navbox {\n    visibility: hidden;\n  }\n\n  /* body content responsive css end*/\n}\n\n@media screen and (max-width: 540px) {\n  .inputborder,\n  .inputsize,\n  .countryoption,\n  .inputfonts {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 575px) {\n  .profiler {\n    display: none;\n  }\n\n  button#navbarDropdown1 {\n    margin-top: -15px;\n  }\n}\n\n/* Lab Parameters ....................................... */\n\n.dbdlabparameter {\n  overflow: hidden;\n}\n\n.table-responsiveheight-lab {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n@media screen and (max-width: 1214px) {\n  .labparameterlefttable {\n    width: 130%;\n    height: 150%;\n  }\n\n  .labparameterrighttable {\n    width: 130%;\n  }\n\n  .labparameters {\n    width: 99.7%;\n  }\n}\n\n@media screen and (max-width: 950px) {\n  .table-responsiveheight-lab {\n    height: 35vh;\n    overflow: auto;\n  }\n\n  .labparameters {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .labtableleft {\n    height: 33vh;\n    width: 100%;\n    border: none;\n    overflow: hidden;\n  }\n\n  .labtableright {\n    width: 100%;\n    margin: 0px;\n  }\n}\n\n@media screen and (max-width: 636px) {\n  .labtableleft {\n    margin-top: 8px;\n  }\n}\n\n@media screen and (max-width: 609px) {\n  .table-responsiveheight-lab {\n    height: 28vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-width: 517px) {\n  .labparameterlefttable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 424px) {\n  .labparameterlefttable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-width: 336px) {\n  .labparameterlefttable {\n    width: 250%;\n  }\n}\n\n/* ...................................................... */\n\n/* Study Site .......................................... */\n\n.squaredots {\n  height: 18px;\n}\n\n@media screen and (max-width: 1320px) {\n  .studysitetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1016px) {\n  .studysitetable {\n    width: 170%;\n  }\n}\n\n/* ..................................................... */\n\n/* STUDY RANDOMISATION.................................. */\n\n@media screen and (max-width: 1430px) {\n  .studyrandomrighttoptable {\n    width: 120%;\n  }\n}\n\n@media screen and (max-width: 1202px) {\n  .studyrandomrighttoptable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 1083px) {\n  .studyrandomlefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 969px) {\n  .studyrandomrighttoptable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 838px) {\n  .studyrandomlefttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 816px) {\n  .studyrandomrighttoptable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .studyrandomrighttoptable {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 499px) {\n  .studyrandomrighttoptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 484px) {\n  .studyrandomlefttable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 407px) {\n  .studyrandomlefttable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-width: 389px) {\n  .studyrandomrighttoptable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 407px) {\n  .studyrandomlefttable {\n    width: 270%;\n  }\n}\n\n@media screen and (max-width: 554px) {\n  .rntable {\n    width: 140%;\n  }\n}\n\n/* ..................................................... */\n\n/* VISIT CRF............................................ */\n\n.visitmain {\n  margin-top: 2px;\n}\n\n.visitleft {\n  width: 50%;\n  height: 100vh;\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.visitright {\n  border-left: 1px solid #dee2e6 !important;\n  width: 49.6%;\n  height: 100vh;\n  margin-left: 5px;\n}\n\n.table-responsive-visit {\n  max-height: calc(100vh - 144px);\n  overflow: auto;\n  position: relative;\n}\n\n@media screen and (max-width: 1379px) {\n  .visitlefttable {\n    width: 140%;\n  }\n}\n\n@media screen and (max-width: 995px) {\n  .visitmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .table-responsive-visit {\n    max-height: 35vh;\n    overflow: auto;\n  }\n\n  .visitleft,\n  .visitright {\n    max-height: 41vh;\n    border: none;\n    margin-left: 0px;\n  }\n\n  .visitleft,\n  .visitright {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 608px) {\n  .visitleft {\n    margin-top: 3px;\n  }\n}\n\n@media screen and (max-width: 502px) {\n  .visitlefttable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 435px) {\n  .visitlefttable {\n    width: 180%;\n  }\n\n  .visitrighttable {\n    width: 140%;\n  }\n}\n\n/* ..................................................... */\n\n/* ADVERSE EVENT CODING................................. */\n\n.custom_nav {\n  position: relative;\n  gap: 5px;\n  padding-top: 2px;\n}\n\n.menuclose {\n  position: absolute;\n  right: 0px;\n  top: 10px;\n}\n\n.eventmain {\n  height: 100vh;\n  margin-top: 2px;\n}\n\n.adverseeventverb {\n  width: 27%;\n}\n\n.adverseeventcoding-dashboard-body {\n  overflow: hidden;\n}\n\n.table-responsive-eventcodingleft {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.table-responsive-eventcodingrighttop {\n  max-height: 35vh;\n  overflow: auto;\n  position: relative;\n}\n\n.table-responsive-eventcodingrightbottom {\n  max-height: 29vh;\n  overflow: auto;\n  position: relative;\n}\n\n.adverseeventrightbottom {\n  margin-top: 10px;\n}\n\n.adverseeventright {\n  width: 72.8%;\n}\n\n.adverseeventlefttable {\n  width: 110%;\n}\n\n@media screen and (max-width: 1636px) {\n  .adverseeventlefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1100px) {\n  .adverseeventlefttable {\n    width: 165%;\n  }\n}\n\n@media screen and (max-width: 1027px) {\n  .adverseeventlefttable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-width: 991px) {\n  .adverseeventhistorytable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 981px) {\n  .adverseeventlefttable {\n    width: 125%;\n  }\n}\n\n@media screen and (max-width: 981px) {\n  .adverseeventright,\n  .adverseeventverb {\n    width: 100%;\n  }\n\n  .table-responsive-eventcodingleft {\n    height: 20vh;\n    overflow: auto;\n    margin-bottom: 8px;\n  }\n\n  .table-responsive-eventcodingrighttop {\n    height: 23vh;\n    margin-bottom: 14px;\n  }\n\n  .eventcodingtabbutton {\n    padding: 5px;\n  }\n\n  .table-responsive-eventcodingrightbottom {\n    height: 15vh;\n    overflow: auto;\n  }\n\n  .adverseeventlefttable {\n    width: 100%;\n  }\n\n  .eventmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .eventleft {\n    height: 50vh;\n    width: 100%;\n  }\n\n  .adverseeventhistorytable {\n    width: 100%;\n  }\n\n  .eventright {\n    height: 60vh;\n  }\n\n  .eventtableleft {\n    width: 100%;\n  }\n\n  .eventtableright {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 808px) {\n  .eventright {\n    height: 80vh;\n  }\n}\n\n@media screen and (max-width: 729px) {\n  .adverseeventhistorytable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 659px) {\n  .table-responsive-eventcodingleft {\n    height: 15vh;\n    overflow: auto;\n    margin-bottom: 8px;\n  }\n}\n\n@media screen and (max-width: 583px) {\n  .adverseeventtermtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 566px) {\n  .adverseeventhistorytable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 454px) {\n  .adverseeventhistorytable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-width: 424px) {\n  .adverseeventtermtable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 369px) {\n  .adverseeventtermtable {\n    width: 200%;\n  }\n\n  .adverseeventhistorytable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-width: 355px) {\n  .adverseeventtermtable {\n    width: 200%;\n  }\n\n  .adverseeventhistorytable {\n    width: 300%;\n  }\n\n  .adverseeventlefttable {\n    width: 150%;\n  }\n}\n\n/* ..................................................... */\n\n/* BACKUP............................................... */\n\n@media screen and (max-width: 1290px) {\n  .backuprighttable {\n    width: 140%;\n  }\n}\n\n@media screen and (max-width: 950px) {\n  .backuprighttable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 828px) {\n  .backuprighttable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 774px) {\n  .backupmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .backupleft {\n    width: 100%;\n    height: 50vh;\n  }\n\n  .backuprightbottom {\n    width: 100%;\n    height: 50vh;\n  }\n\n  .backuprighttable {\n    width: 100%;\n    margin-left: 0px;\n  }\n}\n\n@media screen and (max-width: 774px) {\n  .backuprighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 479px) {\n  .backuprighttable {\n    width: 150%;\n  }\n}\n\n/* ..................................................... */\n\n/* USERS................................................ */\n\n.table-responsive-userleftleft {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.table-responsive-userrightbottom {\n  max-height: 29vh;\n  overflow: auto;\n  margin-top: 16px;\n  position: relative;\n}\n\n.usersmain {\n  display: flex;\n}\n\n.userright {\n  border-left: 1px solid #dee2e6 !important;\n  margin-left: 5px;\n}\n\n// @media screen and (max-width: 1285px) {\n//   .userlefttable {\n//     width: 130%;\n//   }\n// }\n\n@media screen and (max-width: 1056px) {\n  .userrightbottomtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 981px) {\n  .userlefttable {\n    width: 150%;\n  }\n\n  .userrighttoptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 853px) {\n  .userlefttable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 810px) {\n  .userrightbottomtable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 756px) {\n  .usersmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .userright {\n    border-left: none;\n    margin-left: 0px;\n  }\n\n  .table-responsive-userleftleft,\n  .table-responsive-userrighttop {\n    max-height: 25vh;\n  }\n\n  .table-responsive-userrightbottom {\n    max-height: 20vh;\n  }\n\n  .table-responsive-userrightbottom {\n    margin-top: 14px;\n    height: 16vh;\n  }\n\n  .leftdiv {\n    width: 100%;\n    height: 25vh;\n  }\n\n  .userright {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 560px) {\n  .userrightbottomtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 509px) {\n  .userrighttoptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 432px) {\n  .userrightbottomtable {\n    width: 230%;\n  }\n}\n\n@media screen and (max-width: 396px) {\n  .userrighttoptable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 365px) {\n  .userlefttable {\n    width: 180%;\n  }\n\n  .leftdiv {\n    width: 100%;\n    height: 22vh;\n  }\n\n  .table-responsive-userleftleft,\n  .table-responsive-userrighttop {\n    max-height: 22vh;\n  }\n}\n\n@media screen and (max-width: 346px) {\n  .userlefttable {\n    width: 220%;\n  }\n}\n\n@media screen and (max-width: 326px) {\n  .userrighttoptable {\n    width: 200%;\n  }\n}\n\n/* ..................................................... */\n\n/* TABLE RESIZE COLUMN................................... */\n\n.resizer {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 5px;\n  cursor: col-resize;\n  user-select: none;\n  cursor: e-resize;\n}\n\n.table > thead.thead-sticky {\n  position: sticky !important;\n  top: -1px;\n  z-index: 99;\n}\n\n.table {\n  --bs-table-bg: transparent !important;\n  margin: 0;\n}\n\n#resizeMe thead,\n#resizeMe1 thead,\n#resizeMe2 thead,\n#resizeMe3 thead,\n#resizeMe4 thead,\n#resizeMe5 thead,\n#resizeMe6 thead {\n  background-color: hsl(48deg 21% 86%);\n}\n\n#resizeMe tr,\n#resizeMe1 tr,\n#resizeMe2 tr,\n#resizeMe3 tr,\n#resizeMe4 tr,\n#resizeMe5 tr,\n#resizeMe6 tr {\n  line-height: 13px;\n}\n\n#resizeMe th,\n#resizeMe1 th,\n#resizeMe2 th,\n#resizeMe3 th,\n#resizeMe4 th,\n#resizeMe5 th,\n#resizeMe6 th,\n#resizeMe td,\n#resizeMe1 td,\n#resizeMe2 td,\n#resizeMe3 td,\n#resizeMe4 td,\n#resizeMe5 td,\n#resizeMe6 td {\n  font-size: small;\n  border-right: 1px solid var(--white);\n  font-weight: initial;\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  position: static;\n}\n\n.print_font td {\n  font-size: small;\n}\n\n.react-contextmenu-wrapper {\n  font-weight: initial;\n  position: relative;\n  // max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n// .studyIdLists {\n//   background: hsl(0, 0%, 85%) !important;\n// }\n\n/* ..................................................... */\n\n/* COLUMN DELETE................................................ */\n\n/* ..................................................... */\n\n/* Client................................................ */\n\n.clienttable-dashboard-body {\n  overflow: hidden;\n}\n\n.clientleftdiv {\n  width: 48%;\n  height: 100vh;\n}\n\n.table-responsive-clienttablerighttop {\n  max-height: 30vh;\n  margin-bottom: 10px;\n  overflow: auto;\n  position: relative;\n}\n\n.table-responsive-clienttablebottom {\n  max-height: 35vh;\n  overflow: auto;\n  position: relative;\n}\n\n.clientrighttop {\n  margin-bottom: -10px;\n}\n\n.clientright {\n  width: 52%;\n  height: 100vh;\n}\n\n.table-responsive-clienttableleft {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.clientmain {\n  margin-top: 2px;\n}\n\n@media screen and (max-width: 1285px) {\n  .clientlefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 964px) {\n  .clientrighttoptable {\n    width: 130%;\n    overflow: scroll;\n  }\n}\n\n@media screen and (max-width: 916px) {\n  .clientlefttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 832px) {\n  .clientrightbottomtable {\n    width: 130%;\n  }\n}\n\n.clientright {\n  margin-left: 6px;\n}\n\n@media screen and (max-width: 787px) {\n  .clientmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .table-responsive-clienttable {\n    max-height: 25vh;\n    overflow: auto;\n  }\n\n  .table-responsive-clienttablebottom {\n    height: 17vh;\n    overflow: auto;\n  }\n\n  .clientleftdiv {\n    height: 26vh;\n  }\n\n  .clientrighttop {\n    margin-bottom: 7px;\n  }\n\n  .clientleftdiv,\n  .clientright {\n    width: 100%;\n  }\n\n  .clientleftdiv {\n    height: 28vh;\n  }\n\n  .clientrighttoptable {\n    width: 100%;\n  }\n\n  .clientright {\n    margin-left: 0px;\n  }\n\n  .clientlefttable {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 617px) {\n  .clientmain {\n    margin-top: 7px;\n  }\n\n  .table-responsive-clienttable {\n    height: 20vh;\n    overflow: auto;\n  }\n\n  .clientleftdiv {\n    height: 21vh;\n  }\n}\n\n@media screen and (max-width: 608px) {\n  .clientmain {\n    margin-top: 8px;\n  }\n\n  .table-responsive-clienttablebottom {\n    margin-top: 15px;\n    height: 19vh;\n  }\n\n  .clienttablepagination {\n    margin-top: 2px;\n  }\n\n  .userspan {\n    margin-top: 3px;\n    margin-bottom: 3px;\n  }\n}\n\n@media screen and (max-width: 572px) {\n  .clientlefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 560px) {\n  .userrightbottomtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 509px) {\n  .clientrighttoptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 509px) {\n  .clientlefttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 396px) {\n  .clientrighttoptable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 379px) {\n  .clientlefttable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-width: 358px) {\n  .clientrightbottomtable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 326px) {\n  .clientrighttoptable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-width: 323px) {\n  .clientmain {\n    margin-top: 5px;\n  }\n}\n\n/* ..................................................... */\n\n/* ASSIGN STUDY......................................... */\n\n.table-responsive-assignstudy {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.assignstudytable {\n  margin-top: 2px;\n}\n\n@media screen and (max-width: 706px) {\n  .assignstudytable {\n    width: 130%;\n  }\n\n  .assignstudy {\n    margin-top: 5px;\n  }\n}\n\n@media screen and (max-width: 545px) {\n  .assignstudytable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 474px) {\n  .assignstudytable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 412px) {\n  .assignstudytable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-width: 353px) {\n  .assignstudytable {\n    width: 300%;\n  }\n}\n\n/* ...................................................... */\n\n/* ADVERSE EVENT......................................... */\n\n// .adverseevent {\n//   margin-top: 2px;\n// }\n\n/* ....................................................... */\n\n/* ADVERSEEVENT1.......................................... */\n\n@media screen and (max-width: 661px) {\n  .eventtable1 {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 511px) {\n  .eventtable1 {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 434px) {\n  .eventtable1 {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 434px) {\n  .eventtable1 {\n    width: 220%;\n  }\n}\n\n/* ...................................................... */\n\n/* CREATE ROLE.......................................... */\n\n.createrolemain {\n  margin-top: 3px;\n}\n\n@media screen and (max-width: 1287px) {\n  .createrolerighttoptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 1001px) {\n  .createrolerighttoptable,\n  .createrolerightbottomtable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 870px) {\n  .createrolerighttoptable,\n  .createrolerightbottomtable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 814px) {\n  .createrolerighttoptable,\n  .createrolerightbottomtable {\n    width: 100%;\n  }\n\n  .createrolemain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .createroleleft,\n  .createroleright {\n    width: 100%;\n  }\n\n  .createroleleft,\n  .createrolerightbottom,\n  .createrolerighttop {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 517px) {\n  .createrolelefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-width: 434px) {\n  .createrolelefttable {\n    width: 120%;\n  }\n}\n\n@media screen and (max-width: 416px) {\n  .createrolerighttoptable {\n    width: 120%;\n  }\n}\n\n@media screen and (max-width: 404px) {\n  .createrolelefttable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-width: 351px) {\n  .createrolerighttoptable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 331px) {\n  .createrolelefttable {\n    width: 190%;\n  }\n}\n\n@media screen and (max-width: 328px) {\n  .createrolerightbottomtable {\n    width: 120%;\n  }\n}\n\n/* ..................................................... */\n\n/* CREATEROLE2.......................................... */\n\n@media screen and (max-width: 1152px) {\n  .roletext {\n    width: 20%;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .rolename,\n  .roledescription,\n  .createroleselect {\n    width: 37%;\n  }\n}\n\n@media screen and (max-width: 720px) {\n  .roleform {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .rolename,\n  .createroleselect {\n    width: 55%;\n  }\n\n  .roledescription {\n    width: 55%;\n    height: 105px;\n  }\n\n  .roletext {\n    width: 100%;\n  }\n\n  .createrolebuttons {\n    margin-top: 1rem;\n  }\n}\n\n/* ..................................................... */\n\n@media screen and (max-device-width: 1143px) {\n  .subject {\n    width: 9.9%;\n  }\n\n  .clientnametextareas {\n    width: 86%;\n  }\n\n  .subjectinput {\n    width: 90.1%;\n  }\n\n  .useremail {\n    width: 14%;\n  }\n\n  .newreqemailid {\n    width: 86%;\n  }\n\n  .requesttypelabel {\n    width: 40%;\n  }\n\n  .selectrequesttype {\n    width: 60%;\n  }\n\n  .projectidlabel {\n    width: 30%;\n  }\n\n  .projectidinput {\n    width: 70%;\n  }\n\n  .studyidlabel {\n    width: 25%;\n  }\n\n  .studyidinput {\n    width: 75%;\n  }\n\n  .clientlabel {\n    width: 14%;\n  }\n\n  .clientname {\n    height: 2.3rem;\n    border-radius: 5px;\n    border: 1px solid hsl(195deg 86% 53%);\n    width: 89.3%;\n    padding-left: 15px;\n  }\n\n  .clientnamediv {\n    width: 100%;\n  }\n\n  .protocolversionlabel {\n    width: 26%;\n  }\n\n  .protocolversioninput {\n    width: 44%;\n  }\n\n  .expectedenrollmentlabel {\n    width: 49%;\n  }\n\n  .expectedenrollmentinput {\n    height: 2.3rem;\n    border-radius: 5px;\n    border: 1px solid hsl(195deg 86% 53%);\n    width: 60%;\n  }\n\n  .studytypes {\n    width: 13.6%;\n  }\n\n  .herapeutics {\n    width: 20%;\n  }\n}\n\n/* DATABSE LOCK REQUEST.................... */\n\n@media screen and (max-device-width: 1033px) {\n  .lockclientname {\n    width: 65%;\n  }\n\n  .lockclientnamee {\n    width: 35%;\n  }\n}\n\n@media screen and (max-device-width: 966px) {\n  .lockproject {\n    width: 35%;\n  }\n\n  .lockprojectid {\n    width: 65%;\n  }\n\n  .lockusermail,\n  .locksubject {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .locksubject {\n    padding-left: 0px;\n  }\n\n  .lockmailinput,\n  .locksubjectinput,\n  .locksubjects,\n  .lockmaillabel {\n    width: 100%;\n  }\n\n  .attach {\n    width: 236px;\n    height: 46px;\n  }\n\n  .cdadraft {\n    font-size: 11px;\n  }\n\n  .lockreqtype {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .lockrequesttypelabel,\n  .lockclientnamee,\n  .lockproject,\n  .lockstudyidlabel,\n  .lockrequestdetaillabel,\n  .lockstatuslabel {\n    width: 20%;\n  }\n\n  .lockselectrequesttype,\n  .lockclientname,\n  .lockprojectid,\n  .lockstudyidselect,\n  .locktextarea {\n    width: 80%;\n  }\n\n  .lockprojectid {\n    margin-top: 5px;\n  }\n\n  .lockreq {\n    width: 100%;\n  }\n\n  .lockrequesttype {\n    padding-left: 9px;\n  }\n\n  .lockstudyid {\n    padding-left: 33px;\n  }\n\n  textarea.clientnametextareas.form-control.locktextarea,\n  .lockstatusselect {\n    width: 79%;\n    margin-left: 7px;\n  }\n\n  .lockformsection {\n    height: 80vh;\n  }\n}\n\n@media screen and (max-device-width: 672px) {\n  .lockrequesttype,\n  .lockreq,\n  .locktextareacontainer,\n  .lockstatus {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .lockselectrequesttype,\n  .lockclientname,\n  .lockprojectid,\n  .lockstudyidselect,\n  .locktextarea,\n  .lockstatusselect,\n  .lockstatuslabel {\n    width: 100%;\n  }\n\n  textarea.clientnametextareas.form-control.locktextarea {\n    width: 99%;\n    margin-top: -20px;\n  }\n\n  .lockrequestdetaillabel {\n    padding-left: 10px;\n    width: 100%;\n  }\n\n  .lockrequesttypelabel,\n  .lockclientnamee,\n  .lockproject,\n  .lockstudyidlabel,\n  .lockrequestdetaillabel {\n    width: 100%;\n  }\n\n  .lockformsection {\n    height: 120vh;\n  }\n\n  .lockstatuslabel {\n    padding-left: 10px;\n  }\n}\n\n/* ......................................... */\n\n/* DEMOGRAPHIC2............................. */\n\ntr.demodemo {\n  background: transparent;\n}\n\n.table-responsive-demographic2 {\n  max-height: 36vh;\n  overflow: auto;\n  position: relative;\n}\n\n.demographiccancelbutton,\n.demographicsubmitbutton {\n  background-color: var(--blue);\n  color: var(--white);\n  border: 1px solid var(--blue) !important;\n  padding: 1px 10px 2px;\n  transition: 0.5s;\n\n  &:hover {\n    background: transparent !important;\n    border: 1px solid var(--blue) !important;\n    color: var(--blue);\n  }\n}\n\n@media screen and (max-device-width: 1627px) {\n  .demo2genderflex {\n    display: flex;\n    flex-direction: column;\n    height: 53vh;\n  }\n}\n\n@media screen and (max-device-width: 1100px) {\n  .demographiccancelbutton,\n  .demographicsubmitbutton {\n    background-color: var(--blue);\n    color: var(--white);\n    width: 65px;\n    height: 29px;\n    padding: 2px;\n    font-size: 13px;\n  }\n}\n\n@media screen and (max-device-width: 1014px) {\n  .table-responsive-demographic2 {\n    height: 26vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 981px) {\n  .querytable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-device-width: 1627px) {\n  .demo2genderflex {\n    height: 48vh;\n  }\n}\n\n@media screen and (max-device-width: 813px) {\n  .querytable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 680px) {\n  .demo2genderflex {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .demo2genderflex {\n    height: 5vh;\n  }\n\n  .demographic2main {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .demo2left {\n    width: 100%;\n    padding-left: 25px;\n    padding-bottom: 10px;\n  }\n\n  .demographic2column {\n    width: 100%;\n    margin-left: 0px;\n    border: none;\n  }\n\n  .demographic2main {\n    width: 100%;\n    height: calc(100vh - 182px);\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// .custom_nav {\n//   .demo2tabbutton {\n//     padding: 6px 4px;\n//     font-size: 14px;\n//     height: 35px;\n//   }\n// }\n\ntd {\n  vertical-align: middle;\n}\n\n.demo2table {\n  th,\n  td {\n    font-weight: 400 !important;\n  }\n}\n\n@media screen and (max-device-width: 813px) {\n  .querytable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-device-width: 369px) {\n  .querytable {\n    width: 400%;\n  }\n}\n\n@media screen and (max-device-width: 535px) {\n  .demohistorytable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 513px) {\n  .demo2table {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 459px) {\n  .demo2table {\n    width: 170%;\n  }\n}\n\n@media screen and (max-device-width: 417px) {\n  .demohistorytable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 361px) {\n  .demo2table {\n    width: 190%;\n  }\n}\n\n@media screen and (max-device-width: 326px) {\n  .demo2table {\n    width: 230%;\n  }\n}\n\n@media screen and (max-device-width: 323px) {\n  .demo2genderflex {\n    height: 10vh;\n  }\n}\n\n/* ......................................... */\n\n/* Demographic.............................. */\n\n.crfBirth {\n  width: 223px;\n}\n\n.demographicbyear,\n.demographicspace,\n.demographicc200,\n.demographicbirth {\n  width: 25%;\n}\n\n.demographicbottomsection {\n  width: 97%;\n  margin: auto;\n  padding-top: 20px;\n}\n\n.striped-border {\n  border-bottom: dashed 2px #dee2e6 !important;\n}\n\n.demographicfloatbutton {\n  background-color: transparent;\n  border: none;\n}\n\n.crfleftpills {\n  display: flex;\n  flex-direction: column;\n}\n\n.vheightleft {\n  width: 50%;\n}\n\n.vheightright {\n  width: 50%;\n}\n\n.vheightright {\n  height: calc(100vh - 182px);\n  overflow: auto;\n}\n\n.vheightselect {\n  margin-bottom: 10px;\n}\n\n.vselectlabel {\n  width: 25%;\n}\n\n.vselectselect {\n  width: 75%;\n}\n\n.vheightleft {\n  border-right: 1px solid #dee2e6;\n  height: 100vh;\n}\n\n.tvbutton {\n  background-color: var(--blue);\n  color: var(--white);\n  width: 35%;\n  padding: 0px;\n  height: 30px;\n  border-radius: 6px;\n}\n\n.vheight,\n.vadd {\n  background-color: var(--blue);\n  color: var(--white);\n  width: 70px;\n  padding: 0px;\n  height: 30px;\n  border-radius: 6px;\n}\n\n.tvalidationtext {\n  border: 2px solid var(--blue);\n  width: 70%;\n  margin-right: 10px;\n  height: 30px;\n  border-radius: 6px;\n}\n\n.vbutton {\n  background-color: transparent;\n  border: none;\n}\n\n.addvariable {\n  background-color: var(--blue);\n  border: none;\n  border-radius: 6px;\n  color: var(--white);\n  width: 100%;\n  margin: auto;\n}\n\n.sedright {\n  width: 40%;\n  border-left: 1px solid #dee2e6;\n  margin-left: 5px;\n  height: 100vh;\n}\n\n.sedleft {\n  width: 60%;\n  border-right: 1px solid #dee2e6;\n  height: 100vh;\n}\n\n.sdvlabel {\n  width: 30%;\n}\n\n.sdvselect {\n  border: 2px solid var(--blue);\n  border-radius: 6px;\n  width: 70%;\n}\n\n.crfnav {\n  border-bottom: 1px solid #dee2e6;\n}\n\n.venter {\n  width: 95%;\n  margin: auto;\n}\n\n.vheightform {\n  height: 58vh;\n}\n\n.vselectselect {\n  border: 2px solid var(--blue);\n  border-radius: 6px;\n  height: 28px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n}\n\n.vheightbottom {\n  background: hsl(0deg 0% 95%);\n  padding-top: 10px;\n  padding-bottom: 20px;\n}\n\n.vheighttop {\n  height: 50vh;\n}\n\n.leftbox {\n  padding-top: 10px;\n}\n\n.table-responsive-sedleft {\n  max-height: calc(100vh - 220px);\n  overflow: auto;\n  position: relative;\n}\n\n.table-responsive-demoeditor {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.table-responsive-historyweight {\n  height: 65vh;\n  overflow: auto;\n  position: relative;\n}\n\n@media screen and (max-device-width: 1239px) {\n  .sdvlabel {\n    width: 35%;\n  }\n\n  .sdvselect {\n    width: 65%;\n  }\n}\n\n@media screen and (max-device-width: 1072px) {\n  .sdvlabel {\n    width: 40%;\n  }\n\n  .sdvselect {\n    width: 60%;\n  }\n}\n\n@media screen and (max-device-width: 947px) {\n  .sdvlabel {\n    width: 45%;\n  }\n\n  .sdvselect {\n    width: 55%;\n  }\n}\n\n@media screen and (max-device-width: 940px) {\n  .sdvlabel {\n    width: 100%;\n  }\n\n  .sdvselect {\n    width: 100%;\n  }\n}\n\n@media screen and (max-device-width: 1244px) {\n  .vselectlabel {\n    width: 30%;\n  }\n\n  .vselectselect {\n    width: 70%;\n  }\n}\n\n@media screen and (max-device-width: 1088px) {\n  .vselectlabel {\n    width: 35%;\n  }\n\n  .vselectselect {\n    width: 65%;\n  }\n}\n\n@media screen and (max-device-width: 1027px) {\n  .vselectlabel {\n    width: 40%;\n  }\n\n  .vselectselect {\n    width: 60%;\n  }\n}\n\n@media screen and (max-device-width: 940px) {\n  .vheightselect {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .vheightform {\n    height: 90vh;\n  }\n\n  .vheightright {\n    height: calc(100vh - 182px);\n    overflow: auto;\n  }\n\n  .vselectlabel {\n    width: 100%;\n  }\n\n  .vselectselect {\n    width: 100%;\n  }\n}\n\n@media screen and (max-device-width: 896px) {\n  .table-responsive-demoeditor {\n    height: 40vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 869px) {\n  .crfmain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .table-responsive-historyweight {\n    height: 55vh;\n  }\n\n  .genderselect {\n    border: none;\n    margin-left: 0px;\n  }\n\n  .crfleft,\n  .rightbox,\n  .leftbox {\n    width: 100%;\n  }\n\n  .crfleftpills {\n    display: flex;\n    flex-direction: row;\n    padding-left: 10px;\n    padding-bottom: 10px;\n  }\n}\n\n@media screen and (max-device-width: 859px) {\n  .demoeditortable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 851px) {\n  .deographic-tab {\n    padding: 5px 10px 5px 10px;\n  }\n\n  .vheightright {\n    height: 64vh;\n    overflow: auto;\n  }\n\n  .vheighttop {\n    height: 43vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 759px) {\n  .vheighttop {\n    height: 39vh;\n    overflow: auto;\n  }\n\n  .deographic-tab {\n    padding: 4px 6px 4px 8px;\n  }\n\n  .vheightright {\n    height: 60vh;\n    overflow: auto;\n  }\n\n  .leftbox {\n    padding-top: 7px;\n  }\n}\n\n@media screen and (max-device-width: 714px) {\n  .vheightright {\n    height: 55vh;\n    overflow: auto;\n  }\n\n  .table-responsive-historyweight {\n    height: 50vh;\n  }\n\n  .table-responsive-sedleft {\n    max-height: calc(100vh - 242px);\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 658px) {\n  .testtablediv {\n    width: 100%;\n  }\n\n  .testtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 559px) {\n  .sedtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 547px) {\n  .historyweighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 514px) {\n  .vheight {\n    display: block;\n    margin-bottom: 5px;\n  }\n\n  .vheightright {\n    height: 50vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 511px) {\n  .testtablediv {\n    width: 100%;\n  }\n\n  .testtable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 505px) {\n  .vheighttop {\n    height: 33vh;\n    overflow: auto;\n  }\n\n  .table-responsive-historyweight {\n    height: 46vh;\n  }\n}\n\n@media screen and (max-device-width: 438px) {\n  .sedtable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 426px) {\n  .historyweighttable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-device-width: 424px) {\n  .table-responsive-sedleft {\n    max-height: calc(100vh - 280px);\n    overflow: auto;\n  }\n\n  .table-responsive-historyweight {\n    height: 41vh;\n  }\n\n  .vheightright {\n    height: 45vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 418px) {\n  .vheightright {\n    height: 40vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 336px) {\n  .table-responsive-historyweight {\n    height: 39vh;\n  }\n}\n\n@media screen and (max-device-width: 330px) {\n  .historyweighttable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 328px) {\n  .sedtable {\n    width: 230%;\n  }\n}\n\n/* ............................................ */\n\n/* DATAENTRY DEMOGRAPHICS....................... */\n\n.dataentryleft {\n  width: 20%;\n}\n\n.dataentrydemographicright {\n  width: 78%;\n  margin-left: 15px;\n}\n\n@media screen and (max-device-width: 686px) {\n  .dataentryleft {\n    width: 30%;\n  }\n\n  .dataentrydemographicright {\n    width: 68%;\n  }\n}\n\n@media screen and (max-device-width: 680px) {\n  .demographicscreaterolebuttons {\n    padding-top: 2px;\n  }\n}\n\n@media screen and (max-device-width: 555px) {\n  .dataentryleft {\n    width: 40%;\n  }\n\n  .dataentrydemographicright {\n    width: 58%;\n  }\n}\n\n/* ............................................ */\n\n@media screen and (max-device-width: 608px) {\n  .jobcreationpagination {\n    margin-top: -3px;\n  }\n}\n\n/* DATA SETTING ................................... */\n\n.datasettingmain {\n  margin-top: 2px;\n}\n\n@media screen and (max-device-width: 1462px) {\n  .datasettingtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 1127px) {\n  .datasettingtable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 978px) {\n  .datasettingtable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-device-width: 866px) {\n  .datasettingtable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-device-width: 736px) {\n  .datasettingtable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 591px) {\n  .datasettingtable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-device-width: 495px) {\n  .datasettingtable {\n    width: 400%;\n  }\n}\n\n@media screen and (max-device-width: 374px) {\n  .datasettingtable {\n    width: 500%;\n  }\n}\n\n/* ................................................. */\n\n/* METHODS.......................................... */\n\n.methodbottoms {\n  height: 15vh;\n  overflow: auto;\n}\n\n.table-responsive-methodleft {\n  height: 45vh;\n  overflow: auto;\n  position: relative;\n}\n\n.methodtopleft {\n  width: 60%;\n}\n\n.methodtopright {\n  width: 40%;\n}\n\n.methodrightform {\n  height: 45vh;\n  overflow: auto;\n}\n\n.home-lines {\n  width: 100%;\n  border-top: 1px solid #e5e5e5;\n}\n\n.methodrights {\n  display: flex;\n  flex-direction: column;\n  width: 84.6%;\n\n  margin-left: 5px;\n  border-left: 1px solid #dee2e6;\n}\n\n.methodleft,\n.methodleftside {\n  width: 15%;\n  height: 100vh;\n}\n\n.methodflex {\n  display: flex;\n  flex-direction: column;\n}\n\n.methodright {\n  width: 100%;\n  height: 45vh;\n}\n\n.methodmain {\n  margin-top: 2px;\n}\n\n.methodrighttable {\n  width: 100%;\n}\n\n.methodselect {\n  width: 95px;\n  display: inline;\n  height: 27px;\n  padding-left: 3px;\n  padding-right: 0px;\n  padding-bottom: 0px;\n  padding-top: 0px;\n  margin-bottom: 2px;\n}\n\n.methodselectspantext {\n  padding-left: 5px;\n  padding-right: 0px;\n}\n\n@media screen and (max-device-width: 1453px) {\n  .methodrighttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 1166px) {\n  .methodrighttable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-device-width: 1032px) {\n  .methodrighttable {\n    width: 190%;\n  }\n}\n\n@media screen and (max-device-width: 925px) {\n  .methodrighttable {\n    width: 230%;\n  }\n}\n\n@media screen and (max-device-width: 768px) {\n  .methodrighttable {\n    width: 260%;\n  }\n}\n\n@media screen and (max-device-width: 682px) {\n  .methodrighttable {\n    width: 290%;\n  }\n}\n\n@media screen and (max-device-width: 616px) {\n  .methodmain {\n    flex-wrap: wrap;\n  }\n\n  .methodleftside {\n    width: 100%;\n    height: 4vh;\n  }\n\n  .methodflex {\n    display: flex;\n    padding-bottom: 5px;\n    flex-direction: row;\n  }\n\n  .methodleft,\n  .methodrights {\n    width: 100%;\n  }\n\n  .methodright {\n    height: 30vh;\n  }\n\n  .methodrights {\n    margin-left: 0px;\n    border: none;\n  }\n\n  .methodrightform {\n    height: 27vh;\n    overflow: auto;\n  }\n\n  .table-responsive-methodleft {\n    height: 27vh;\n    overflow: auto;\n  }\n}\n\n/* .................................................. */\n\n/* CLIENT BACKUP TABLE............................ */\n\n.clientbackuptablemain {\n  height: 100vh;\n}\n\n.clientbackuptableleft {\n  width: 60%;\n}\n\n.clientbackuptableright {\n  width: 39.6%;\n  margin-left: 5px;\n}\n\n@media screen and (max-device-width: 1202px) {\n  .clientbackuptablerighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 931px) {\n  .clientbackuptablerighttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 905px) {\n  .clientbackuptablelefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 808px) {\n  .clientbackuptablerighttable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-device-width: 716px) {\n  .clientbackuptablemain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .clientbackuptableleft,\n  .clientbackuptableright {\n    width: 100%;\n  }\n\n  .clientbackuptablerighttable,\n  .clientbackuptablelefttable {\n    width: 100%;\n  }\n}\n\n@media screen and (max-device-width: 549px) {\n  .clientbackuptablelefttable,\n  .clientbackuptablerighttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 387px) {\n  .clientbackuptablelefttable,\n  .clientbackuptablerighttable {\n    width: 170%;\n  }\n}\n\n/* ................................................ */\n\n/* BACKUP.......................................... */\n\n.backuptoptions {\n  width: 100%;\n}\n\n.backuplabels {\n  width: 11%;\n  padding-top: 5px;\n  text-align: right;\n}\n\n.backupoptions {\n  width: 20%;\n  height: 32px;\n}\n\n@media screen and (max-device-width: 1552px) {\n  .backuplabels {\n    width: 12%;\n  }\n}\n\n@media screen and (max-device-width: 1429px) {\n  .backuplabels {\n    width: 13%;\n  }\n}\n\n@media screen and (max-device-width: 1324px) {\n  .backuplabels {\n    width: 14%;\n  }\n}\n\n@media screen and (max-device-width: 1235px) {\n  .backuplabels {\n    width: 15%;\n  }\n}\n\n@media screen and (max-device-width: 1157px) {\n  .backuplabels {\n    width: 16%;\n  }\n\n  .backupoptions {\n    width: 23%;\n  }\n}\n\n@media screen and (max-device-width: 1090px) {\n  .backuplabels {\n    width: 17%;\n  }\n\n  .backupoptions {\n    width: 23%;\n  }\n}\n\n@media screen and (max-device-width: 1030px) {\n  .backuplabels {\n    width: 18%;\n  }\n\n  .backupoptions {\n    width: 25%;\n  }\n}\n\n@media screen and (max-device-width: 976px) {\n  .backuplabels {\n    width: 19%;\n  }\n\n  .backupoptions {\n    width: 25%;\n  }\n}\n\n@media screen and (max-device-width: 929px) {\n  .backuplabels {\n    width: 21%;\n  }\n\n  .backupoptions {\n    width: 28%;\n  }\n}\n\n@media screen and (max-device-width: 847px) {\n  .backuplabels {\n    width: 23%;\n  }\n\n  .backupoptions {\n    width: 31%;\n  }\n}\n\n@media screen and (max-device-width: 780px) {\n  .backuplabels {\n    width: 26%;\n  }\n\n  .backupoptions {\n    width: 35%;\n  }\n}\n\n@media screen and (max-device-width: 698px) {\n  .backuplabels {\n    width: 30%;\n  }\n\n  .backupoptions {\n    width: 40%;\n  }\n}\n\n@media screen and (max-device-width: 615px) {\n  .backuptoptions {\n    display: flex;\n  }\n\n  .backuplabels {\n    width: 35%;\n    text-align: left;\n  }\n\n  .backupoptions {\n    width: 65%;\n  }\n\n  .backupdashboard {\n    height: 100vh;\n  }\n}\n\n@media screen and (max-device-width: 547px) {\n  .backuptoptions {\n    display: flex;\n  }\n\n  .backuplabels {\n    width: 42%;\n    text-align: left;\n  }\n\n  .backupoptions {\n    width: 58%;\n  }\n\n  .backupdashboard {\n    height: 100vh;\n  }\n}\n\n@media screen and (max-device-width: 470px) {\n  .backuptoptions {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .backuplabels {\n    width: 100%;\n    text-align: left;\n  }\n\n  .backupoptions {\n    width: 100%;\n  }\n\n  .backupdashboard {\n    height: 100vh;\n  }\n}\n\n/* ................................................. */\n\n/* QUERY MANAGEMENT................................. */\n\n.querymodel {\n  position: relative;\n  pointer-events: auto;\n  background-clip: padding-box;\n  border: 2px solid var(--blue);\n  // border-radius: 0.6rem;\n  outline: 0;\n  height: 100%;\n  min-height: 164px;\n  background-color: var(--white);\n  padding-bottom: 1rem;\n}\n\n.modalcross {\n  background-color: transparent;\n  border: none;\n  color: hsl(202deg 56% 53%);\n}\n\n.querymodals-body {\n  position: relative;\n  flex: 1 1 auto;\n  padding: 0 20px;\n  align-items: center;\n  display: flex;\n  text-align: center;\n  line-height: 1.6;\n  font-size: 16px;\n}\n\n.queryselectvisit,\n.queryselectsubject,\n.queryselectsite {\n  display: flex;\n  width: 33.33%;\n}\n\n.queryvisitlabel,\n.querysubjectlabel,\n.querysitelabel {\n  width: 30%;\n  padding-top: 10px;\n  padding-left: 3px;\n  padding-right: 5px;\n  text-align: right;\n}\n\n.queryvisit,\n.querysite,\n.querysubject {\n  width: 70%;\n  height: 32px;\n  border: 1px solid var(--blue);\n}\n\n.querysecondhr {\n  margin-top: 81px;\n  margin-bottom: 5px;\n}\n\n.querytableselect {\n  border: none;\n  background-color: transparent;\n  opacity: 0.8;\n  width: 85px;\n  cursor: pointer;\n}\n\n.querypopup1hr {\n  // margin-top: 2px;\n  margin: 0px;\n}\n\n.popupcross {\n  font-size: 21px;\n}\n\n.querypopuptablemain {\n  height: 50vh;\n}\n\n.querymodaldropdowns {\n  padding-top: 10px;\n}\n\n@media screen and (max-device-width: 1644px) {\n  .querypopuptablemain {\n    height: 43vh;\n  }\n}\n\n@media screen and (max-device-width: 1026px) {\n  .querypopuptablemain {\n    height: 40vh;\n  }\n\n  .queryvisitlabel,\n  .querysubjectlabel,\n  .querysitelabel {\n    width: 40%;\n  }\n\n  .queryvisit,\n  .querysite,\n  .querysubject {\n    width: 60%;\n  }\n}\n\n@media screen and (max-device-width: 783px) {\n  .queryvisitlabel,\n  .querysubjectlabel,\n  .querysitelabel {\n    width: 50%;\n  }\n\n  .queryvisit,\n  .querysite,\n  .querysubject {\n    width: 50%;\n  }\n}\n\n@media screen and (max-device-width: 722px) {\n  .querypopuptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 636px) {\n  .querypopuptable {\n    width: 130%;\n  }\n\n  .querypopuptablemain {\n    height: 30vh;\n  }\n\n  .queryselectvisit,\n  .queryselectsubject,\n  .queryselectsite {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n\n  .queryvisitlabel,\n  .querysubjectlabel,\n  .querysitelabel {\n    width: 100%;\n    text-align: left;\n  }\n\n  .queryvisit,\n  .querysite,\n  .querysubject {\n    width: 95%;\n  }\n}\n\n@media screen and (max-device-width: 564px) {\n  .querypopuptable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 491px) {\n  .querypopuptable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 412px) {\n  .querypopuptable {\n    width: 200%;\n  }\n}\n\n/* ................................................. */\n\n/*  CONTEXT MENU.................................... */\n\n.contextmenuoptions {\n  position: absolute;\n  border: 1px solid #cecece;\n  border-radius: 3px;\n  background: var(--white);\n  box-shadow: 3px 4px 7px #bababa;\n  z-index: 1;\n  transition: opacity 0.5s linear;\n}\n\n.contextmenuoptions {\n  padding: 0px;\n  margin: 0px;\n  min-width: 150px;\n  list-style: none;\n}\n\n.contextmenuoptions li {\n  padding-bottom: 7px;\n  padding-top: 7px;\n  border: 1px solid black;\n}\n\n.contextmenuoptions li a {\n  text-decoration: none;\n  color: black;\n}\n\n.contextmenuoptions li:hover {\n  background: darkgray;\n}\n\n/* ............. */\n\n.menu {\n  background-color: var(--color-bg-secondary);\n  border-radius: 10px;\n  box-shadow: 0 10px 20px #40404015;\n}\n\n.menu-list {\n  margin: 0;\n  display: block;\n  width: 100%;\n  padding: 0px;\n}\n\n.menu-list + .menu-list {\n  border-top: 1px solid #ddd;\n}\n\n.menu-sub-list:hover {\n  display: flex;\n}\n\nli.menu-item:hover {\n  background-color: var(--blue);\n  color: var(--white);\n}\n\nbutton.menu-button:hover {\n  color: var(--white);\n}\n\nbutton.menu-button {\n  padding: 5px 5px 5px 12px;\n}\n\n.menu-sub-list {\n  display: none;\n  padding: 0px;\n  background-color: var(--color-bg-secondary);\n  border-radius: 10px;\n  box-shadow: 0 10px 20px rgba(#404040, 0.15);\n  position: absolute;\n  left: 100%;\n  right: 0;\n  z-index: 100;\n  width: 100%;\n  top: 0;\n  flex-direction: column;\n}\n\n.sub-left .menu-sub-list {\n  left: -100%;\n  right: 0;\n}\n\n.menu-item {\n  position: relative;\n}\n\n.menu-button:hover {\n  background-color: var(--color-bg-primary-offset);\n}\n\n.menu-button:hover + .menu-sub-list {\n  display: flex;\n}\n\n.menu-button:hover svg {\n  stroke: var(--color-text-primary);\n}\n\n.menu-button {\n  font: inherit;\n  border: 0;\n  width: 100%;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  position: relative;\n  background-color: var(--color-bg-secondary);\n}\n\n.menu-button svg {\n  width: 20px;\n  height: 20px;\n  margin-right: 10px;\n  stroke: var(--color-text-primary-offset);\n}\n\n.menu-button:nth-of-type(2) {\n  margin-right: 0;\n  position: absolute;\n  right: 8px;\n}\n\n.containerx {\n  position: absolute;\n  width: 165px;\n  border: 1px solid rgb(236, 227, 227);\n  border-radius: 5px;\n  background: var(--white);\n  align-items: center;\n  justify-content: center;\n  z-index: 1;\n}\n\nul {\n  list-style: none;\n}\n\n/* ................................................. */\n\n/* MONITORING VISIT........................................... */\n\n.addvisitbtn {\n  background-color: var(--blue);\n  border: none;\n  border-radius: 5px;\n  font-size: 14px;\n  margin-top: 2px;\n  margin-right: 10px;\n  width: 110px;\n}\n\n.monitoringtbrow {\n  height: 105px;\n  border-bottom: 2px solid #bfc3c7;\n}\n\n.monitoringtbhead {\n  border-right: 2px solid #bfc3c7;\n  font-weight: lighter;\n}\n\n.saturday {\n  font-weight: lighter;\n}\n\n.monitormain {\n  margin-top: 2px;\n  height: 105vh;\n}\n\n.mx01 {\n  background-color: var(--blue);\n  border: none;\n  border-radius: 5px;\n  color: var(--white);\n  padding: 5px;\n  margin-top: 3px;\n}\n\n/* ........................................................... */\n\n.adverseeventrightbottom {\n  width: 100%;\n}\n\n/* SITE STATUS.................................. */\n\n.sitestatus-dashboard-body {\n  overflow: hidden;\n}\n\n.table-responsive-sitestatus {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.sitestatustable {\n  width: 200%;\n}\n\n.sitestatusmain {\n  margin-top: 2px;\n}\n\n@media screen and (max-device-width: 1574px) {\n  .sitestatustable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-device-width: 1301px) {\n  .sitestatustable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 1043px) {\n  .sitestatustable {\n    width: 280%;\n  }\n}\n\n@media screen and (max-device-width: 932px) {\n  .sitestatustable {\n    width: 310%;\n  }\n}\n\n@media screen and (max-device-width: 843px) {\n  .sitestatustable {\n    width: 350%;\n  }\n}\n\n@media screen and (max-device-width: 748px) {\n  .sitestatustable {\n    width: 400%;\n  }\n}\n\n@media screen and (max-device-width: 656px) {\n  .sitestatustable {\n    width: 450%;\n  }\n}\n\n@media screen and (max-device-width: 627px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .sitestatustable {\n    width: 450%;\n  }\n\n  .table-responsive-sitestatus {\n    height: 65vh;\n    overflow: auto;\n  }\n}\n\n@media screen and (max-device-width: 584px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .sitestatustable {\n    width: 500%;\n  }\n}\n\n@media screen and (max-device-width: 527px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .sitestatustable {\n    width: 550%;\n  }\n}\n\n@media screen and (max-device-width: 480px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .sitestatustable {\n    width: 600%;\n  }\n}\n\n@media screen and (max-device-width: 441px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .sitestatustable {\n    width: 800%;\n  }\n}\n\n@media screen and (max-device-width: 333px) {\n  .table-responsive-sitestatus {\n    height: 60vh;\n    overflow: auto;\n  }\n}\n\n/* ............................................. */\n\n/* SUBJECT STATUS.................................. */\n\n.subjectstatustable {\n  width: 250%;\n}\n\n.subjectstatusmain {\n  margin-top: 2px;\n}\n\n@media screen and (max-device-width: 1416px) {\n  .subjectstatustable {\n    width: 280%;\n  }\n}\n\n@media screen and (max-device-width: 1265px) {\n  .subjectstatustable {\n    width: 310%;\n  }\n}\n\n@media screen and (max-device-width: 1144px) {\n  .subjectstatustable {\n    width: 350%;\n  }\n}\n\n@media screen and (max-device-width: 1014px) {\n  .subjectstatustable {\n    width: 380%;\n  }\n}\n\n@media screen and (max-device-width: 935px) {\n  .subjectstatustable {\n    width: 450%;\n  }\n}\n\n@media screen and (max-device-width: 791px) {\n  .subjectstatustable {\n    width: 500%;\n  }\n}\n\n@media screen and (max-device-width: 713px) {\n  .subjectstatustable {\n    width: 560%;\n  }\n}\n\n@media screen and (max-device-width: 638px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .subjectstatustable {\n    width: 620%;\n  }\n}\n\n@media screen and (max-device-width: 577px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .subjectstatustable {\n    width: 670%;\n  }\n}\n\n@media screen and (max-device-width: 535px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .subjectstatustable {\n    width: 850%;\n  }\n}\n\n@media screen and (max-device-width: 424px) {\n  .subjectstatusmain {\n    margin-top: 6px;\n  }\n\n  .subjectstatustable {\n    width: 970%;\n  }\n}\n\n@media screen and (max-device-width: 373px) {\n  .subjectstatusmain {\n    margin-top: 6px;\n  }\n\n  .subjectstatustable {\n    width: 1200%;\n  }\n}\n\n/* ............................................. */\n\n/* SUBJECT FROM STATUS.................................. */\n\n.SubjectFormStatustable {\n  width: 165%;\n}\n\n.SubjectFormStatusmain {\n  margin-top: 2px;\n}\n\n@media screen and (max-device-width: 1574px) {\n  .SubjectFormStatustable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-device-width: 1301px) {\n  .SubjectFormStatustable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 1043px) {\n  .SubjectFormStatustable {\n    width: 280%;\n  }\n}\n\n@media screen and (max-device-width: 932px) {\n  .SubjectFormStatustable {\n    width: 310%;\n  }\n}\n\n@media screen and (max-device-width: 843px) {\n  .SubjectFormStatustable {\n    width: 350%;\n  }\n}\n\n@media screen and (max-device-width: 748px) {\n  .SubjectFormStatustable {\n    width: 400%;\n  }\n}\n\n@media screen and (max-device-width: 656px) {\n  .SubjectFormStatustable {\n    width: 450%;\n  }\n}\n\n@media screen and (max-device-width: 627px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .SubjectFormStatustable {\n    width: 450%;\n  }\n}\n\n@media screen and (max-device-width: 584px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .SubjectFormStatustable {\n    width: 500%;\n  }\n}\n\n@media screen and (max-device-width: 527px) {\n  .sitestatusmain {\n    margin-top: 6px;\n  }\n\n  .SubjectFormStatustable {\n    width: 550%;\n  }\n}\n\n@media screen and (max-device-width: 480px) {\n  .SubjectFormStatusmain {\n    margin-top: 6px;\n  }\n\n  .SubjectFormStatustable {\n    width: 600%;\n  }\n}\n\n@media screen and (max-device-width: 441px) {\n  .SubjectFormStatusmain {\n    margin-top: 6px;\n  }\n\n  .SubjectFormStatustable {\n    width: 800%;\n  }\n}\n\n/* ............................................. */\n\n/* COMPARE DATA................................ */\n\n.comparedataleft {\n  width: 35%;\n  height: 100vh;\n}\n\n.table-responsive-comparerighttop {\n  max-height: 35vh;\n  overflow: auto;\n  position: relative;\n}\n\n.table-responsive-comparerightbottom {\n  max-height: 35vh;\n  overflow: auto;\n  margin-top: 4px;\n  position: relative;\n}\n\n.comparedataright {\n  width: 65%;\n  height: 100vh;\n}\n\n.uploadsourceinput {\n  width: 500px;\n  background-color: var(--blue);\n}\n\n.compareupload {\n  width: 95%;\n  margin: auto;\n}\n\n.comparelabel {\n  width: 50%;\n}\n\n.compareuploadchoose {\n  width: 100%;\n}\n\n.compareinput {\n  width: 50%;\n}\n\n.comparebutton {\n  padding-top: 280px;\n}\n\n@media screen and (max-device-width: 1036px) {\n  .comparebottomtable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 919px) {\n  .comparelabel {\n    width: 75%;\n  }\n}\n\n@media screen and (max-device-width: 804px) {\n  .comparebottomtable {\n    width: 160%;\n  }\n}\n\n@media screen and (max-device-width: 769px) {\n  .compareupload {\n    display: flex;\n    flex-direction: column;\n    padding-left: 10px;\n  }\n\n  .comparelabel {\n    width: 100%;\n  }\n\n  .comparebutton {\n    padding-top: 200px;\n  }\n\n  .compareinput {\n    width: 100%;\n  }\n}\n\n@media screen and (max-device-width: 659px) {\n  .comparebottomtable {\n    width: 200%;\n  }\n}\n\n@media screen and (max-device-width: 533px) {\n  .comparebottomtable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 517px) {\n  .comparelabel {\n    width: 100%;\n    font-size: 12px;\n  }\n}\n\n@media screen and (max-device-width: 514px) {\n  .comparebutton {\n    padding-top: 150px;\n    padding-left: 30px;\n  }\n}\n\n@media screen and (max-device-width: 517px) {\n  .comparelabel {\n    width: 100%;\n    font-size: 11px;\n  }\n}\n\n@media screen and (max-device-width: 485px) {\n  .comparetoptable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 432px) {\n  .comparebottomtable {\n    width: 310%;\n  }\n}\n\n@media screen and (max-device-width: 380px) {\n  .comparetoptable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-device-width: 354px) {\n  .comparebottomtable {\n    width: 360%;\n  }\n}\n\n/* ............................................. */\n\n/* DISPOSITION............................. */\n\n.dispositiontable {\n  margin-top: 9px;\n}\n\n@media screen and (max-device-width: 711px) {\n  .dispositiontable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 549px) {\n  .dispositiontable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-device-width: 423px) {\n  .dispositiontable {\n    width: 210%;\n  }\n}\n\n/* ......................................... */\n\n/* CREATE ARCHIVE........................... */\n\n.carchivelabel {\n  width: 12%;\n  text-align: right;\n}\n\n.carchiveselect {\n  width: 20%;\n  border-radius: 8px;\n  border: 1px solid var(--blue);\n  height: 2rem;\n}\n\n@media screen and (max-device-width: 1312px) {\n  .carchivelabel {\n    width: 15%;\n  }\n\n  .carchiveselect {\n    width: 25%;\n  }\n}\n\n@media screen and (max-device-width: 1064px) {\n  .carchivelabel {\n    width: 18%;\n  }\n\n  .carchiveselect {\n    width: 28%;\n  }\n}\n\n@media screen and (max-device-width: 899px) {\n  .carchivelabel {\n    width: 25%;\n  }\n\n  .carchiveselect {\n    width: 35%;\n  }\n}\n\n@media screen and (max-device-width: 667px) {\n  .carchivelabel {\n    width: 35%;\n  }\n\n  .carchiveselect {\n    width: 45%;\n  }\n}\n\n@media screen and (max-device-width: 550px) {\n  .carchivemain {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .carchivelabel {\n    width: 100%;\n    text-align: left;\n  }\n\n  .carchiveselect {\n    width: 100%;\n  }\n}\n\n/* ......................................... */\n\n/* CLIENT ARCHIVE........................... */\n\n@media screen and (max-device-width: 864px) {\n  .carchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 667px) {\n  .carchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 579px) {\n  .carchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 485px) {\n  .carchivetable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 417px) {\n  .carchivetable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 352px) {\n  .carchivetable {\n    width: 300%;\n  }\n}\n\n/* ......................................... */\n\n/* STUDY ARCHIVE........................... */\n\n.sarchivetable {\n  margin-top: 2px;\n}\n\n@media screen and (max-device-width: 985px) {\n  .sarchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 760px) {\n  .sarchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 660px) {\n  .sarchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 552px) {\n  .sarchivetable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 475px) {\n  .sarchivetable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 400px) {\n  .sarchivetable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-device-width: 336px) {\n  .sarchivetable {\n    width: 330%;\n  }\n}\n\n/* ......................................... */\n\n/* USER ARCHIVE........................... */\n\n@media screen and (max-device-width: 864px) {\n  .uarchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 667px) {\n  .uarchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 579px) {\n  .uarchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 485px) {\n  .uarchivetable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 417px) {\n  .uarchivetable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 352px) {\n  .uarchivetable {\n    width: 300%;\n  }\n}\n\n/* ......................................... */\n\n/* ROLE ARCHIVE........................... */\n\n@media screen and (max-device-width: 738px) {\n  .rarchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 570px) {\n  .rarchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 496px) {\n  .rarchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 415px) {\n  .rarchivetable {\n    width: 220%;\n  }\n}\n\n@media screen and (max-device-width: 341px) {\n  .rarchivetable {\n    width: 260%;\n  }\n}\n\n/* ......................................... */\n\n/* CRFS ARCHIVE........................... */\n\n@media screen and (max-device-width: 985px) {\n  .crfsarchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 760px) {\n  .crfsarchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 660px) {\n  .crfsarchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 552px) {\n  .crfsarchivetable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 475px) {\n  .crfsarchivetable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 400px) {\n  .crfsarchivetable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-device-width: 336px) {\n  .crfsarchivetable {\n    width: 330%;\n  }\n}\n\n/* ......................................... */\n\n/* STUDY SCHEMA ARCHIVE........................... */\n\n@media screen and (max-device-width: 985px) {\n  .studyschemaarchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 760px) {\n  .studyschemaarchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 660px) {\n  .studyschemaarchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 552px) {\n  .studyschemaarchivetable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 475px) {\n  .studyschemaarchivetable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 400px) {\n  .studyschemaarchivetable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-device-width: 336px) {\n  .studyschemaarchivetable {\n    width: 330%;\n  }\n}\n\n/* ......................................... */\n\n/* PARAMETER ARCHIVE........................... */\n\n@media screen and (max-device-width: 985px) {\n  .parchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 760px) {\n  .parchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 660px) {\n  .parchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 552px) {\n  .parchivetable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 475px) {\n  .parchivetable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 400px) {\n  .parchivetable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-device-width: 336px) {\n  .parchivetable {\n    width: 330%;\n  }\n}\n\n/* ......................................... */\n\n/* TERM ARCHIVE........................... */\n\n@media screen and (max-device-width: 985px) {\n  .tarchivetable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 760px) {\n  .tarchivetable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 660px) {\n  .tarchivetable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 552px) {\n  .tarchivetable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-device-width: 475px) {\n  .tarchivetable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-device-width: 400px) {\n  .tarchivetable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-device-width: 336px) {\n  .tarchivetable {\n    width: 330%;\n  }\n}\n\n/* ......................................... */\n\n/* STUDY BACKUP TABLE....................... */\n\n@media screen and (max-device-width: 1183px) {\n  .studybackuptablelefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 1060px) {\n  .studybackuptablelefttable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 995px) {\n  .clientbackuptablerighttable,\n  .studybackuptablelefttable {\n    width: 100%;\n  }\n}\n\n@media screen and (max-device-width: 821px) {\n  .studybackuptablelefttable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 448px) {\n  .clientbackuptablerighttable {\n    width: 120%;\n  }\n}\n\n@media screen and (max-device-width: 434px) {\n  .studybackuptablelefttable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-device-width: 375px) {\n  .clientbackuptablerighttable {\n    width: 145%;\n  }\n}\n\n@media screen and (max-device-width: 348px) {\n  .studybackuptablelefttable {\n    width: 230%;\n  }\n}\n\n/* ......................................... */\n\n/* LOGIN PAGE................................. */\n\n.wtogalax {\n  background-color: hsl(0deg 0% 95%);\n  text-align: center;\n}\n\n.loggin-bottom {\n  background-color: hsl(0deg 0% 95%);\n  padding-top: 10px;\n  padding-bottom: 30px;\n}\n\n.login-historyhr {\n  padding: 1px;\n}\n\n.select-application-button {\n  padding-left: 10px;\n  padding-right: 20px;\n  padding-top: 4px;\n}\n\n.select-application-label {\n  padding-top: 6px;\n}\n\n.loginbutton {\n  background-color: var(--blue);\n  color: var(--white);\n  margin-right: 26px;\n  width: 100px;\n  height: 32px;\n  padding: 0px;\n}\n\n.welcome-to-galax {\n  margin: 0px;\n}\n\n.login-history {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.login-selectbox,\n.login-innerselectbox {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\n\n.login-history-label {\n  width: 7%;\n}\n\n.login-history-select {\n  width: 30%;\n  border: 1px solid var(--blue);\n}\n\n.login-text {\n  width: 62%;\n  margin-left: 15px;\n  border: 1px solid var(--blue);\n}\n\n@media screen and (max-device-width: 1250px) {\n  .login-history-label {\n    width: 8%;\n  }\n\n  .login-history-select {\n    width: 29%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 61.5%;\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-device-width: 1100px) {\n  .login-history-label {\n    width: 9%;\n  }\n\n  .login-history-select {\n    width: 28%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 61.5%;\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-device-width: 990px) {\n  .login-history-label {\n    width: 10%;\n  }\n\n  .login-history-select {\n    width: 27%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 61.5%;\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-device-width: 870px) {\n  .login-history-label {\n    width: 11%;\n  }\n\n  .login-history-select {\n    width: 26%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 61.5%;\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-device-width: 780px) {\n  .login-history-label {\n    width: 14%;\n  }\n\n  .login-history-select {\n    width: 30%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 54%;\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-device-width: 630px) {\n  .login-history-label {\n    width: 17%;\n  }\n\n  .login-history-select {\n    width: 33%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 47%;\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-device-width: 588px) {\n  .loggin-bottom {\n    flex-wrap: wrap;\n  }\n\n  .login-button {\n    width: 500px;\n  }\n}\n\n@media screen and (max-device-width: 520px) {\n  .login-history-label {\n    width: 22%;\n  }\n\n  .login-history-select {\n    width: 36%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 39%;\n    margin-left: 15px;\n  }\n}\n\n@media screen and (max-device-width: 462px) {\n  .login-bottoms {\n    flex-wrap: wrap;\n  }\n\n  .select-app {\n    justify-content: center;\n  }\n}\n\n@media screen and (max-device-width: 425px) {\n  .login-innerselectbox,\n  .login-history {\n    padding-top: 5px;\n    padding-bottom: 5px;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .login-history-label {\n    width: 100%;\n  }\n\n  .login-history-select {\n    width: 100%;\n    border: 1px solid var(--blue);\n  }\n\n  .login-text {\n    width: 100%;\n    margin-left: 0px;\n    margin-top: 10px;\n  }\n}\n\n/* .......................................... */\n\n/* Sr. BD EXECUTIVE................................. */\n\n@media screen and (max-device-width: 1121px) {\n  .sbdeassignstudytable {\n    width: 130%;\n  }\n}\n\n@media screen and (max-device-width: 865px) {\n  .sbdeassignstudytable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-device-width: 751px) {\n  .sbdeassignstudytable {\n    width: 190%;\n  }\n}\n\n@media screen and (max-device-width: 595px) {\n  .sbdeassignstudytable {\n    width: 240%;\n  }\n}\n\n@media screen and (max-device-width: 474px) {\n  .sbdeassignstudytable {\n    width: 290%;\n  }\n}\n\n@media screen and (max-device-width: 394px) {\n  .sbdeassignstudytable {\n    width: 350%;\n  }\n}\n\n@media screen and (max-device-width: 328px) {\n  .sbdeassignstudytable {\n    width: 400%;\n  }\n}\n\n/* .......................................... */\n\n/* DBD PROTOCOL .............................. */\n\n.dbdprotocol {\n  height: 65vh;\n  margin-top: -5px;\n}\n\n.dbprotocoltable {\n  overflow: scroll;\n}\n\n@media screen and (max-width: 706px) {\n  .dbprotocoltable {\n    width: 130%;\n  }\n\n  .assignstudy {\n    margin-top: 5px;\n  }\n}\n\n@media screen and (max-width: 545px) {\n  .dbprotocoltable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 474px) {\n  .dbprotocoltable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 421px) {\n  .dbprotocoltable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-width: 343px) {\n  .dbprotocoltable {\n    width: 260%;\n  }\n}\n\n/* ........................................... */\n\n/* PROTOCOL METADATA.......................... */\n\n.table-responsive-protocol {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n@media screen and (max-width: 706px) {\n  .protocoltable {\n    width: 130%;\n  }\n\n  .assignstudy {\n    margin-top: 5px;\n  }\n}\n\n@media screen and (max-width: 545px) {\n  .protocoltable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 474px) {\n  .protocoltable {\n    width: 170%;\n  }\n}\n\n@media screen and (max-width: 412px) {\n  .protocoltable {\n    width: 210%;\n  }\n}\n\n@media screen and (max-width: 337px) {\n  .protocoltable {\n    width: 260%;\n  }\n}\n\n/* ........................................... */\n\n/* DBD LABPARAMETER........................... */\n\n.labparameters {\n  margin-top: 2px;\n}\n\n/* ........................................... */\n/* PROGRAMMING EDITOR.............................. */\n\n.ones {\n  width: 48px;\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.table-responsive-program {\n  height: 40vh;\n  overflow: auto;\n  position: relative;\n}\n\n.programright {\n  height: 42vh;\n}\n\n.programbottom {\n  height: 20vh;\n  overflow: auto;\n}\n\n.programtab {\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.program_custom_nav {\n  border-bottom: 1px solid #dee2e6 !important;\n}\n\n/* ....................................... */\n\n/* DATA TABLE VIEW............................ */\n\n.datatableviewmain {\n  margin-top: 2px;\n}\n\n@media screen and (max-width: 1365px) {\n  .datatableviewtable {\n    width: 150%;\n  }\n}\n\n@media screen and (max-width: 919px) {\n  .datatableviewtable {\n    width: 180%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .datatableviewtable {\n    width: 250%;\n  }\n}\n\n@media screen and (max-width: 560px) {\n  .datatableviewtable {\n    width: 300%;\n  }\n}\n\n@media screen and (max-width: 473px) {\n  .datatableviewtable {\n    width: 400%;\n  }\n}\n\n@media screen and (max-width: 360px) {\n  .datatableviewtable {\n    width: 500%;\n  }\n}\n\n/* ....................................... */\n\n/* ACCESS MANAGEMENT....................... */\n\n.accessmain {\n  height: calc(100vh - 180px);\n  display: flex;\n}\n\n.accessleft {\n  width: 40%;\n  height: calc(100vh - 180px);\n}\n\n.accessright {\n  height: calc(100vh - 180px);\n  width: 100%;\n  border-left: 1px solid #dee2e6 !important;\n  margin-left: 5px;\n}\n\n.table-responsive-accessright {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n.accesslabel {\n  font-weight: lighter;\n  font-size: small;\n}\n\n.table-responsive-accessleft {\n  max-height: calc(100vh - 182px);\n  overflow: auto;\n  position: relative;\n}\n\n/* ....................................... */\n\n.bold {\n  font-weight: 600;\n}\n\n/* ....................................... */\n\n.labelTitle {\n  font-size: 0.8rem;\n}\n\n// ICONS STYLES...............................................................\n\n// ROTATE CHEVRON\n\n.fa-solid,\n.fa-regular,\n.cursorPointer,\n.CP,\n.textUser,\n.fa-folder,\n.fa-home-alt,\n.sort {\n  cursor: pointer;\n}\n\n.CD {\n  cursor: default !important;\n}\n\n.move {\n  cursor: move !important;\n}\n\n.rotateChevron {\n  transform: rotate(270deg);\n}\n\n.green {\n  color: #40c057;\n}\n\n.dropdown-item.active {\n  background: #165483;\n}\n\n.dropdown-item:active {\n  background: transparent;\n  color: #165483;\n}\n\n// VALIDATION STAR\n\n.requiredStar {\n  fill: #ff0000;\n  font-size: 7px;\n  margin-bottom: 10px;\n}\n\n// HOMELINE ICONS STYLES...........................\n\n.homeLineIcon {\n  color: var(--blue);\n  cursor: pointer;\n}\n\n// ................................................\n\n.fiftyVh {\n  height: 25vh;\n}\n\n.modal-form-section {\n  height: calc(100vh - 64px);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.form-button {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.modal-form-body {\n  overflow: hidden !important;\n}\n\n.profileImage {\n  object-fit: cover;\n}\n\n.showEntriesData {\n  max-height: 44vh;\n  overflow: auto;\n}\n\n.tableRightContent {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 182px);\n}\n\n.crfHight {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: calc(100vh - 191px);\n}\n\n.transferrightThree {\n  width: 150%;\n}\n\n.subjectstatustable1 {\n  width: 100%;\n  text-wrap: nowrap;\n}\n\n.sitestatustable1 {\n  width: 100%;\n  text-wrap: nowrap;\n}\n\n.queryField_input_size {\n  width: 607px !important;\n}\n\n.wide {\n  width: 100% !important;\n}\n\n.mid {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.button--checked {\n  background-color: transparent;\n  color: var(--blue);\n  border: 1px solid var(--blue) !important;\n}\n\n.data-item {\n  width: 33.33%;\n  padding: 10px;\n  box-sizing: border-box;\n}\n\n.datSetHead {\n  font-size: 18px;\n  font-weight: 600;\n  text-align: center;\n  margin: 10px 0;\n}\n\nnav.react-contextmenu {\n  min-width: 180px;\n  border-radius: 4px;\n  background-color: rgb(0 0 0 / 74%);\n  z-index: 999;\n  color: var(--white);\n  box-shadow:\n    rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,\n    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n\n  .react-contextmenu-item {\n    font-size: 13px;\n    display: block;\n    text-decoration: none;\n    padding: 5px 15px;\n    cursor: pointer;\n    user-select: none;\n    transition: 0.2s;\n    position: relative;\n    margin-bottom: 2px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    outline: none;\n    color: var(--white);\n\n    &:hover {\n      background: #000;\n    }\n\n    span {\n      margin-left: 10px;\n    }\n\n    svg {\n      font-size: 14px;\n    }\n\n    .edit {\n      color: rgb(80, 193, 80);\n    }\n\n    .lock {\n      color: gray;\n    }\n\n    .delete {\n      color: #e94e51;\n    }\n\n    .history {\n      color: rgb(80, 193, 80);\n    }\n  }\n}\n\n.dropend.btn-group {\n  button {\n    background: none;\n    border: none;\n    font-size: 13px;\n    padding: 0 10px;\n    width: 196px;\n    text-align: left;\n  }\n}\n\n.capitalize {\n  text-transform: capitalize !important;\n}\n\n.dropend > div {\n  border: none;\n  transform: translate3d(190px, -8px, 0px) !important;\n  background-color: rgb(0 0 0 / 74%);\n  border-radius: 4px;\n  box-shadow:\n    rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,\n    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n\n  .dropdown-item {\n    padding: 5px;\n\n    &:hover {\n      background: #000;\n    }\n  }\n}\n\n.dropend .dropdown-toggle::after {\n  position: absolute;\n  right: 0;\n  top: 10px;\n}\n\n.tab_header {\n  .tabbing_heading {\n    margin: 0;\n  }\n}\n\n.ql-snow .ql-picker {\n  height: auto !important;\n}\n\n.ql-toolbar.ql-snow {\n  padding: 0 !important;\n  background-color: var(--bs-border-color);\n}\n\n.ql-toolbar.ql-snow .ql-formats {\n  margin-right: 0px !important;\n  padding: 5px;\n  border-right: 1px solid rgb(204 204 204) !important;\n}\n\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button,\n.ql-snow .ql-picker {\n  border-radius: 0;\n}\n\n.ql-snow.ql-toolbar button,\n.ql-snow .ql-toolbar button {\n  width: 40px !important;\n  display: flex !important;\n  margin: 0 auto;\n  justify-content: center;\n}\n\n#queryWrapper > :last-child {\n  display: none;\n}\n\n#queryWrapper.switched > :last-child {\n  display: block;\n}\n\n#queryWrapper.switched > :first-child {\n  display: none;\n}\n\n.outputSection {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.outputSection p {\n  border: 1px solid #dee2e6;\n  padding: 2px 20px;\n  margin: 5px 0 5px 10px;\n  font-size: 12px;\n}\n\n.queryResponse {\n  border: 1px solid #dee2e6;\n  border-radius: 5px;\n  height: 50px;\n}\n\n.add_puls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n}\n\nspan.CP.mt-1.ps-3.small {\n  padding: 4px 2px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  text-wrap: nowrap;\n  overflow: hidden;\n  font-size: 13px;\n  border-bottom: 1px solid #e5e5e5;\n\n  &:hover {\n    background: #e3e0d4;\n  }\n\n  &:active {\n    background: #e3e0d4;\n    border-radius: 4px;\n  }\n}\n\nspan.linkClass {\n  padding: 6px 2px;\n  display: flex;\n  width: 100%;\n  align-items: center;\n  text-wrap: nowrap;\n  overflow: hidden;\n  font-size: 12px;\n  border-bottom: 1px solid #e5e5e5;\n\n  &:hover {\n    background-color: rgba(16, 60, 94, 0.3411764706);\n  }\n\n  &:active {\n    background-color: rgba(16, 60, 94, 0.3411764706);\n    border-radius: 4px;\n  }\n}\n\n.querymodel button {\n  height: 20px;\n}\n\n.validInfo h1 {\n  font-size: 15px;\n  text-align: center;\n  margin-top: 20px;\n  font-weight: 600;\n  color: #00000078;\n}\n\n.validInfo p {\n  font-size: 12px;\n  text-align: justify;\n  color: rgba(0, 0, 0, 0.4705882353);\n  padding-right: 15px;\n  height: 30vh;\n  overflow: auto;\n  margin: 0;\n}\n\n.highlighted {\n  background-color: #ccd6dd !important;\n}\n\na.mt-1.small {\n  padding: 2px;\n  transition: 1s;\n\n  &:hover {\n    background: #e3e0d4;\n    border-radius: 5px;\n  }\n\n  // &.active {\n  //   background: #e3e0d4;\n  //   border-radius: 5px;\n  // }\n}\n\n.manag_section {\n  overflow: auto;\n  height: calc(100vh - 220px);\n\n  .Management_section {\n    p {\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n}\n\n#react-select-7-placeholder {\n  font-size: 13px;\n  font-weight: 300;\n}\n\n#react-select-6-placeholder {\n  font-size: 13px;\n  font-weight: 300;\n}\n\n#react-select-5-placeholder {\n  font-size: 13px;\n  font-weight: 300;\n}\n\n#react-select-4-placeholder {\n  font-size: 13px;\n  font-weight: 300;\n}\n\n#react-select-3-placeholder {\n  font-size: 13px;\n  font-weight: 300;\n}\n\n#react-select-2-placeholder {\n  font-size: 13px;\n  font-weight: 300;\n}\n\n.css-1dimb5e-singleValue {\n  font-size: 13px;\n  font-weight: 300;\n}\n\n.css-qbdosj-Input {\n  margin: 0 !important;\n}\n\n.radio_check input {\n  margin: 0 10px 0 0;\n}\n\n.all_promices {\n  border: 1px dashed #e9ecef;\n  padding: 5px 14px 0px;\n}\n\n.View_Full_Chart {\n  background: #ee9e23;\n  padding: 0 10px;\n  border-radius: 3px;\n  color: var(--white);\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.trueClass {\n  background-color: rgba(16, 60, 94, 0.3411764706);\n}\n\n.Open__query__icon {\n  background: rgb(0, 143, 251) !important;\n  color: rgb(0, 143, 251);\n  height: 12px;\n  width: 12px;\n  left: 0px;\n  top: 0px;\n  border-width: 0px;\n  border-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  display: inline-block;\n}\n\n.Answered__query__icon {\n  background: rgb(0, 227, 150) !important;\n  color: rgb(0, 227, 150);\n  height: 12px;\n  width: 12px;\n  left: 0px;\n  top: 0px;\n  border-width: 0px;\n  border-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  display: inline-block;\n}\n\n.Cancelled__query__icon {\n  background: rgb(254, 176, 25) !important;\n  color: rgb(254, 176, 25);\n  height: 12px;\n  width: 12px;\n  left: 0px;\n  top: 0px;\n  border-width: 0px;\n  border-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  display: inline-block;\n}\n\n.Closed__query__icon {\n  background: rgb(255, 69, 96) !important;\n  color: rgb(255, 69, 96);\n  height: 12px;\n  width: 12px;\n  left: 0px;\n  top: 0px;\n  border-width: 0px;\n  border-color: rgb(255, 255, 255);\n  border-radius: 2px;\n  display: inline-block;\n}\n\nforeignObject {\n  position: relative;\n}\n\n.apexcharts-legend.apexcharts-align-center.apx-legend-position-bottom {\n  margin-top: 0;\n}\n\n.query_statuis_code_wrap {\n  height: calc(100vh - 323px);\n  overflow: auto;\n}\n\n.Assign_Permission_button {\n  position: absolute;\n  bottom: 174px;\n  width: 100%;\n  padding: 5px;\n  background: var(--white);\n}\n\n.list_of_Role {\n  height: calc(100vh - 230px);\n  overflow: auto;\n}\n\n.all___buton_style {\n  .freeze {\n    background: gray;\n  }\n\n  .unfreeze,\n  .lock,\n  .unlock,\n  .freeze {\n    font-size: 12px;\n    border-radius: 3px;\n    border: none;\n    color: green;\n    padding: 2px 12px;\n  }\n\n  .unfreeze,\n  .unlock {\n    background: #f8f9fa;\n  }\n\n  .lock {\n    background: red;\n  }\n}\n\nbutton.saveScreen {\n  background: #103c5e;\n  border: none;\n  border-radius: 4px;\n  font-size: 12px;\n  padding: 2px 12px;\n  color: var(--white);\n}\n\n.remark__modal textarea {\n  width: 100%;\n  height: 150px;\n  border: 1px solid #e6e5e5;\n  border-radius: 4px;\n  resize: none;\n  font-size: 11px;\n  padding: 5px;\n}\n\ndiv#chart {\n  // background: #cacaca3d;\n  padding: 15px;\n  position: relative;\n  // width: 90%;\n}\n\n.center__data__chart {\n  margin: 0 auto;\n  position: absolute;\n  top: 55%;\n  left: 40%;\n  transform: translate(-50%, -50%);\n}\n\n.table-responsive-dashboard {\n  overflow-x: hidden;\n  height: calc(100vh - 143px);\n}\n\n.user__info {\n  background: #103c5e;\n  color: var(--white);\n  padding: 10px;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n}\n\n.activity__section {\n  background: var(--white);\n  margin-bottom: 5px;\n  // display: flex;\n  // justify-content: flex-start;\n  padding: 10px;\n  // gap: 20px;\n}\n\n.activity__portal {\n  height: calc(100vh - 342px);\n  overflow: auto;\n\n  p {\n    font-size: 12px;\n  }\n}\n\n.leftHeightOfSection {\n  height: calc(100vh - 270px);\n  overflow: auto;\n  border-right: 1px solid rgba(128, 128, 128, 0.1411764706);\n}\n\n.activity__portal-study {\n  height: calc(100vh - 231px);\n  overflow: auto;\n\n  p {\n    font-size: 12px;\n  }\n}\n\n.chart__overview {\n  h4 {\n    font-size: 13px;\n  }\n}\n\n.doughtnutClass {\n  // box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  border-radius: 4px;\n  // background: #e3e6ed;\n\n  .chart_yaxis_legend {\n    position: relative;\n\n    p {\n      transform: rotate(-90deg);\n      text-wrap: nowrap;\n      margin: 25px;\n      margin-top: 150px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    }\n  }\n\n  .chart_xaxis_legend {\n    p {\n      text-align: center;\n    }\n  }\n}\n\n.substatus {\n  text-align: right;\n}\n\n.substatus p {\n  font-size: 13px;\n  margin: 0;\n}\n\n.substatus p i[data-tooltip]:hover::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  background-color: #333;\n  color: var(--white);\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.2s;\n  z-index: 1;\n}\n\n.substatus p i[data-tooltip]:hover::after {\n  content: \"\";\n  position: absolute;\n  border-style: solid;\n  border-width: 5px;\n  border-color: transparent transparent #333 transparent;\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.substatus p i[data-tooltip]:hover::before,\n.substatus p i[data-tooltip]:hover::after {\n  opacity: 1;\n}\n\n.addUnit__source {\n  padding: 5px;\n  font-size: 30px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: 1s;\n}\n\nsvg.addUnit__source:hover {\n  background: gray;\n  color: var(--white);\n}\n\n.dbp__mode__color {\n  color: #d1a213;\n}\n\n.qc__mode__color {\n  color: #d82d2d;\n}\n\n.live__mode__color {\n  color: #40c057;\n  font-size: 12px;\n}\n\n.error__log span {\n  font-size: 12px;\n  color: red;\n}\n\n.selectrowcolor {\n  background: rgb(204, 214, 221);\n  cursor: pointer;\n}\n\n.withoutcolorrow {\n  cursor: pointer;\n}\n\n.cdashShortleft {\n  width: 40%;\n  height: 100vh;\n  border-right: 1px solid #dee2e6 !important;\n}\n\n.table-responsive-cdashLongleft {\n  overflow-y: auto;\n  position: relative;\n  // padding: 0 12px;\n}\n\nspan.keyButton {\n  padding: 4px 10px;\n  font-size: 10px;\n  font-weight: bold;\n  margin: 4px;\n  border: 1px solid #000;\n  display: flex;\n  justify-content: center;\n  border-radius: 4px;\n}\n\nspan.keyButton:hover {\n  background: #00000024;\n  cursor: pointer;\n}\n\n.keyboard {\n  display: flex;\n  justify-content: center;\n}\n\n.textKeyButton {\n  font-size: 12px;\n}\n\n.enterKeyButton {\n  padding: 8px;\n  margin: 4px;\n  border: 1px solid #103c5e;\n  display: flex;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--white);\n  width: 25%;\n  background-color: #103c5e;\n  cursor: pointer;\n}\n\n.enterKeyButton:hover {\n  border: 1px solid #103c5e;\n  color: #103c5e;\n  background-color: var(--white);\n  transition: 0.5s;\n  font-weight: 600;\n}\n\n.cleanKeyButton {\n  padding: 8px;\n  margin: 4px;\n  border: 1px solid #103c5e;\n  display: flex;\n  justify-content: center;\n  border-radius: 4px;\n  font-size: 12px;\n  width: 25%;\n  color: #103c5e;\n  background-color: var(--white);\n  cursor: pointer;\n}\n\n.cleanKeyButton:hover {\n  border: 1px solid #103c5e;\n  color: var(--white);\n  background-color: #103c5e;\n  transition: 0.5s;\n  font-weight: 600;\n}\n\n.keyBoardButtonTitle {\n  cursor: pointer;\n  border: 1px solid #103c5e;\n  padding: 3px 18px;\n  font-size: 12px;\n  font-weight: 600;\n  border-radius: 3px;\n  color: #103c5e;\n  transition: 1s;\n\n  &:hover {\n    background-color: #103c5e;\n    color: var(--white);\n    border: 1px solid #103c5e;\n  }\n}\n\n.keyBoardButtonTitleActive {\n  background-color: #103c5e;\n  color: var(--white);\n  border: 1px solid #103c5e;\n}\n\n.letDataClass {\n  font-size: 14px;\n  margin-left: 60px;\n}\n\nbutton.clearButton {\n  background-color: #103c5e;\n  color: var(--white);\n  border-radius: 3px;\n  font-size: 12px;\n  padding: 2px 15px;\n  margin-top: 12px;\n}\n\nbutton.clearButton:hover {\n  transition: 0.3s;\n  background-color: var(--white) fff;\n  color: #103c5e;\n  border: 1px solid #103c5e;\n  font-weight: 600;\n}\n\n.accessTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  font-size: 18px;\n  font-weight: 600;\n  padding: 15px;\n}\n\n.environmentinput {\n  border: 1px solid #cacccd;\n  width: 100%;\n  height: 2.3rem;\n}\n\n.cursorPointer {\n  cursor: pointer;\n}\n\n.details_of_forms_sign {\n  h4 {\n    font-size: 17px;\n    font-weight: 600;\n  }\n\n  p {\n    font-size: 12px;\n  }\n\n  img {\n    width: 100px;\n  }\n\n  span {\n    color: red;\n  }\n\n  .date__box__ {\n    border: 1px solid #e5e5e5;\n    padding: 7px;\n    border-radius: 4px;\n    margin: 0;\n  }\n}\n\n.Header_Title {\n  p {\n    font-size: 12px;\n  }\n\n  img {\n    width: 100px;\n  }\n}\n\n.report_form {\n  height: calc(100vh - 190px);\n  overflow: auto;\n  width: 65%;\n  margin: 5px auto;\n}\n\n.sample_report_form {\n  .report_form_heading {\n    h6 {\n      background: #eee;\n      padding: 10px 0;\n      text-align: center;\n      font-weight: 600;\n    }\n\n    p {\n      text-align: center;\n      font-size: 12px;\n    }\n  }\n}\n\n.box__sign_ {\n  border: 2px solid #e5e5e5;\n  border-radius: 10px;\n  padding: 20px 20px 10px;\n  margin-bottom: 10px;\n}\n\n.formate_input {\n  input {\n    width: 30px;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    font-size: 12px;\n    height: 32px;\n    border: 1px solid #dee2e6;\n  }\n\n  .form-select {\n    font-size: 12px;\n    border-radius: 0;\n  }\n}\n\n.dd_formate {\n  input {\n    display: flex;\n    align-items: center;\n    text-align: center;\n    width: 100px;\n    border: 1px solid #dee2e6;\n    height: 32px;\n    font-size: 12px;\n  }\n}\n\n.handle___print button {\n  position: absolute;\n  bottom: -50px;\n  left: 6px;\n}\n\n// @media screen {\n//   .signauteFont {\n//     font-family: \"Dancing Script\", cursive;\n//   }\n// }\n\n// @media print {\n//   @page {\n//     .signauteFont {\n//       font-family: \"Dancing Script\", cursive;\n//     }\n\n//     i {\n//       color: #cdcdcd !important;\n//     }\n//   }\n\n//   i {\n//     color: #cdcdcd !important;\n//   }\n\n//   .signauteFont {\n//     font-family: \"Dancing Script\", cursive;\n//   }\n\n//   .report_form_heading {\n//     break-inside: avoid-page;\n//   }\n\n//   .subject__details_need p {\n//     white-space: pre-wrap !important;\n//   }\n\n//   div#chart {\n//     width: 30% !important;\n//   }\n\n//   .study_overview__rightsection,\n//   .subject__details_need,\n//   .titmeline__border .timeline__section {\n//     height: auto !important;\n//   }\n// }\n\nbutton.updateProfile.print___extract_button {\n  position: absolute;\n  bottom: -51px;\n  right: 40px;\n}\n\n.button____group {\n  button {\n    background: none;\n    transition: 1s;\n\n    &:hover {\n      background: #6c757d5e;\n    }\n  }\n\n  .activeChartType {\n    background: #6c757d5e;\n  }\n}\n\n.image_chart_image {\n  border-bottom: 1px solid #e5e5e5;\n  padding: 10px;\n\n  img {\n    width: 60px;\n  }\n}\n\n.inputText__Chart {\n  padding: 10px;\n}\n\nbutton.button_group_year {\n  margin: 0;\n  background: var(--white);\n  color: #000;\n  border-color: #dee2e6;\n  font-size: 14px;\n  padding: 7px;\n}\n\n.graph__title__border {\n  // border-bottom: 1px solid rgb(229, 229, 229);\n  // background: #80808033;\n  padding: 10px;\n}\n\n.btn:focus-visible {\n  box-shadow: none !important;\n}\n\nbutton.button_group_year_active {\n  background-color: #103c5e;\n  color: var(--white);\n}\n\n/* LineNumberTextarea.css */\n\n.editor {\n  display: flex;\n}\n\n.line-numbers {\n  width: 40px;\n  // background-color: #e5e5e5;\n  padding: 4px;\n  color: #103c5e;\n  // font-family: monospace;\n  font-weight: 600;\n}\n\n.codeEditor {\n  flex: 1;\n  font-size: 14px;\n  line-height: 1.4;\n  border: 1px solid #ccc;\n  resize: vertical;\n  overflow: hidden;\n  min-height: 243px;\n}\n\n:focus-visible {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n.tab_pane_height {\n  height: calc(100vh - 508px);\n  overflow: auto;\n}\n\n.tab_pane_height > div {\n  cursor: pointer;\n}\n\n.tab_pane_height > div:hover {\n  background: #efefef;\n}\n\n.reset_password__sections {\n  width: 60%;\n  margin: 0 auto;\n  border: 1px solid #1f537a;\n  border-radius: 10px;\n}\n\n.disablebutton {\n  background: #918f8f !important;\n  color: var(--white) !important;\n  border: 1px solid transparent !important;\n}\n\n.chart_design_port {\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  height: 320px;\n}\n\n.title_bar_items {\n  border-radius: 4px;\n  position: relative;\n  padding: 9px;\n  // margin: 5px;\n\n  h6 {\n    font-size: 13px;\n    margin: 0;\n    font-weight: 600;\n  }\n}\n\n.ForMDataInput {\n  border-radius: 4px;\n  position: relative;\n\n  h6 {\n    font-size: 13px;\n    margin: 0;\n    font-weight: 600;\n  }\n}\n\n.title_bar_scroll_height {\n  height: calc(100vh - 250px);\n  overflow-x: hidden;\n  width: 350px;\n}\n\n.title__bar_content {\n  padding: 10px;\n  border-radius: 4px;\n  width: 328px;\n  position: relative;\n\n  .study__icon {\n    i {\n      font-size: 9px;\n      margin-right: 6px;\n    }\n  }\n}\n\n.lightGreenColor {\n  color: #40c057;\n}\n\n.title__bar_value1 {\n  border-radius: 3px;\n  width: 100%;\n  // position: relative;\n  // overflow: hidden;\n  // text-overflow: ellipsis;\n  // white-space: nowrap;\n  // font-size: small;\n  // padding: 6px 10px;\n}\n\n.title__bar_value,\n.title__bar_values {\n  background: var(--white);\n  border-radius: 3px;\n  // width: 100%;\n  // position: relative;\n  // overflow: hidden;\n  // text-overflow: ellipsis;\n  // white-space: nowrap;\n  // font-size: small;\n  // padding: 6px 10px;\n}\n\n.title__bar_value:hover,\n.title__bar_value_active:hover {\n  background-color: rgba(16, 60, 94, 0.3411764706);\n}\n\n.title__bar_value_active {\n  background-color: rgba(16, 60, 94, 0.3411764706) !important;\n  border-radius: 3px;\n  // width: 100%;\n  // position: relative;\n  // overflow: hidden;\n  // text-overflow: ellipsis;\n  // white-space: nowrap;\n  // font-size: small;\n  // padding: 6px 10px;\n}\n\n.Chart1 > div,\n.Chart2 > div,\n.Chart3 > div {\n  width: 39px;\n}\n\n.graph_position {\n  margin-right: 30px;\n}\n\n// .Chart1{\n//   position: absolute;\n//   top: 0px;\n//   right: 0;\n// }\n\n// .Chart2 {\n//   position: absolute;\n//   top: 0;\n//   right: 30px;\n// }\n\n// .Chart3{\n//   position: absolute;\n//   top: 0;\n//   right: 60px;\n// }\n\n.threedots:after {\n  content: \"\\2807\";\n  font-size: 16px;\n}\n\n.dropdown a {\n  text-decoration: none;\n  color: #262626;\n  font-size: 13px;\n}\n\n// .dropdown a:hover {\n//   background-color: grey;\n//   padding: 3px 3px 2px;\n//   border-radius: 3px;\n// }\n\n.threedots:hover {\n  background-color: grey;\n  padding: 4px 2px 2px 6px;\n  border-radius: 4px;\n}\n\n.dropdown_menus_tableview {\n  min-width: 180px;\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, 0.74);\n  z-index: 999;\n  color: var(--white);\n  box-shadow:\n    rgba(0, 0, 0, 0.1) 0px 0px 5px 0px,\n    rgba(0, 0, 0, 0.1) 0px 0px 1px 0px;\n  overflow: hidden;\n  line-height: 24px;\n\n  .dropdown-item:hover {\n    background-color: rgba(0, 0, 0, 0.74) !important;\n  }\n}\n\n.data__justification {\n  display: flex;\n  overflow: auto;\n}\n\n.subject__idenetity i {\n  font-size: 20px;\n}\n\n.subject__idenetity img {\n  width: 18px;\n  height: 18px;\n}\n\n.css-1jqq78o-placeholder {\n  font-size: 12px;\n}\n\n.subject__details_need {\n  height: calc(100vh - 340px);\n  overflow: auto;\n\n  p {\n    line-height: 30px;\n    white-space: nowrap;\n  }\n}\n\n.icon__bg {\n  display: grid;\n  gap: 2px;\n}\n\n.icon__bg i {\n  background: #f0f0f0;\n  padding: 4px;\n  border-radius: 4px;\n  font-size: 10px;\n}\n\nlabel.form-check-label,\n.form-check {\n  font-size: 12px;\n}\n\n.overview_left_section {\n  img {\n    width: 100px;\n  }\n\n  span {\n    margin-bottom: 10px;\n    padding: 4px 32px;\n    text-align: center;\n  }\n\n  p {\n    font-size: 12px;\n    margin: 0;\n  }\n}\n\n.titmeline__border {\n  border-left: 1px solid #efefef;\n\n  .timeline__section {\n    background: #e0e0e0;\n    height: calc(100vh - 170px);\n    overflow: auto;\n  }\n}\n\n.timeline {\n  padding: 10px;\n\n  .tl-content .tl-header {\n    padding-left: 25.6px;\n    border-left: 2px solid rgb(190, 172, 11);\n    height: 80px;\n    align-items: center;\n  }\n\n  .tl-contents .tl-header {\n    padding-right: 25.6px;\n    border-right: 2px solid rgb(190, 172, 11);\n    text-align: end;\n    align-items: center;\n    height: 80px;\n  }\n\n  .tl-header {\n    position: relative;\n    display: grid;\n    padding-top: 1rem;\n    padding-bottom: 1rem;\n\n    p {\n      margin: 0;\n    }\n\n    .tl-title {\n      font-size: 12px;\n      font-weight: 400;\n    }\n\n    .tl-titles {\n      font-size: 12px;\n      font-weight: 400;\n      white-space: nowrap;\n    }\n\n    .tl-marker {\n      display: block;\n      position: absolute;\n      width: 15px;\n      height: 15px;\n      border-radius: 50% / 50%;\n      background: rgb(7, 230, 22);\n      left: -15px;\n      top: 50%;\n      transform: translate(50%, -50%);\n    }\n\n    .tl-marker-gray {\n      display: block;\n      position: absolute;\n      width: 15px;\n      height: 15px;\n      border-radius: 50% / 50%;\n      background: rgb(126, 131, 127);\n      left: -15px;\n      top: 50%;\n      transform: translate(50%, -50%);\n\n      i {\n        font-size: 11px;\n        top: 2px;\n        position: absolute;\n        left: 2.5px;\n      }\n    }\n\n    .tl-marker-red {\n      display: block;\n      position: absolute;\n      width: 15px;\n      height: 15px;\n      border-radius: 50%/50%;\n      background: rgb(245, 6, 6);\n      left: -15px;\n      top: 50%;\n      transform: translate(50%, -50%);\n\n      i {\n        font-size: 11px;\n        top: 2px;\n        position: absolute;\n        left: 4px;\n        color: var(--white);\n      }\n    }\n\n    .tl-markers {\n      display: block;\n      position: absolute;\n      width: 15px;\n      height: 15px;\n      border-radius: 50% / 50%;\n      background: rgb(7, 230, 22);\n      right: -0.9px;\n      top: 50%;\n      transform: translate(50%, -50%);\n    }\n\n    .tl-markers-gray {\n      display: block;\n      position: absolute;\n      width: 15px;\n      height: 15px;\n      border-radius: 50% / 50%;\n      background: rgb(126, 131, 127);\n      right: -0.9px;\n      top: 50%;\n      transform: translate(50%, -50%);\n    }\n  }\n}\n\n.study_overview__rightsection {\n  height: calc(100vh - 158px);\n  overflow-x: hidden;\n}\n\n.forn_value__section {\n  p {\n    margin: 0;\n    font-size: 12px;\n    padding: 5px;\n  }\n}\n\n#total-counter {\n  counter-reset: totalPages;\n}\n\n#total-counter span {\n  counter-increment: totalPages;\n}\n\n.page-counter:after {\n  counter-increment: page;\n  content: \"Page \" counter(page) \" / \" counter();\n}\n\n.graph__title img {\n  cursor: pointer;\n}\n\n.studyvisitPlanData {\n  height: calc(100vh - 143px);\n  overflow: auto;\n}\n\n.subjectMileStoneData {\n  height: calc(100vh - 170px);\n  overflow: auto;\n}\n\n.border_body_box {\n  margin: 10px;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n  padding: 5px;\n\n  p {\n    font-size: 12px;\n    margin: 0;\n  }\n}\n\n.Scorll___Query {\n  overflow: auto;\n  height: 340px;\n}\n\n.scroll__site_subject {\n  overflow: auto;\n  max-height: calc(100vh - 105px);\n}\n\n.border__right_query {\n  border-right: 1px solid #dee2e6;\n  max-height: calc(100vh - 105px);\n  overflow: auto;\n}\n\nbutton#dropdown-split-basic {\n  color: #000;\n  padding: 0 9px;\n}\n\n.noHaveDropdown {\n  margin-right: 25px;\n}\n\ntd.green {\n  color: green !important;\n  font-weight: 600 !important;\n}\n\ntd.red {\n  color: red !important;\n  font-weight: 600 !important;\n}\n\n.title_bar_items .btn.show:focus,\n.title_bar_items .btn:focus,\n.ForMDataInput .btn.show:focus,\n.ForMDataInput .btn:focus,\n.nombering__point .btn.show:focus,\n.nombering__point .btn:focus {\n  box-shadow: none !important;\n  background-color: #ccc !important;\n}\n\n.nombering__point ul {\n  margin: 0;\n  padding: 0;\n}\n\n.nombering__point ul li {\n  padding: 6px 12px;\n  font-size: 12px;\n  background: #f0f0f0;\n  border-radius: 3px;\n  margin: 10px 0px 0 5px;\n}\n\n.title_bar_items .dropdown-toggle::after,\n.ForMDataInput .dropdown-toggle::after,\n.nombering__point .dropdown-toggle::after {\n  content: \"⠇\";\n  border: none !important;\n}\n\n.nombering__point {\n  padding: 5px;\n  min-width: 100px;\n}\n\n.nombering__point button {\n  padding: 0px;\n}\n\n.table-responsive-dashboard-study {\n  height: calc(100vh - 155px);\n  overflow-x: hidden;\n}\n\n// Breadcrumb Design CSS ---------------------------\n\n#breadcrumb {\n  list-style: none;\n  display: inline-block;\n  padding: 0;\n  margin: 0px 0px;\n\n  li {\n    float: left;\n\n    a {\n      color: var(--white);\n      display: block;\n      background: var(--blue);\n      text-decoration: none;\n      position: relative;\n      height: 19px;\n      line-height: 18px;\n      padding: 0 10px 0 5px;\n      margin-right: 23px;\n      font-size: 12px;\n    }\n\n    &:nth-child(even) {\n      a {\n        background-color: var(--blue);\n\n        &:before {\n          border-color: var(--blue);\n          border-left-color: transparent;\n        }\n\n        &:after {\n          border-left-color: var(--blue);\n        }\n      }\n    }\n\n    &:first-child {\n      a {\n        padding-left: 15px;\n\n        &:before {\n          border: none;\n        }\n      }\n    }\n\n    &:last-child {\n      a {\n        padding-right: 15px;\n\n        &:after {\n          border: none;\n        }\n      }\n    }\n\n    a {\n      &:before,\n      &:after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        border: 0 solid var(--blue);\n        border-width: 10px 11px;\n        width: 0;\n        height: 0;\n      }\n\n      &:before {\n        left: -20px;\n        border-left-color: transparent;\n      }\n\n      &:after {\n        left: 100%;\n        border-color: transparent;\n        border-left-color: var(--blue);\n      }\n\n      &:hover {\n        background-color: #b8cfdf;\n        color: #000;\n\n        &:before {\n          border-color: #b8cfdf;\n          border-left-color: transparent;\n        }\n\n        &:after {\n          border-left-color: #b8cfdf;\n        }\n      }\n\n      &:active {\n        background-color: #b8cfdf;\n\n        &:before {\n          border-color: #b8cfdf;\n          border-left-color: transparent;\n        }\n\n        &:after {\n          border-left-color: #b8cfdf;\n        }\n      }\n    }\n  }\n}\n\n.twoFactor {\n  display: flex;\n  justify-content: center;\n  font-size: 95px;\n  color: limegreen;\n}\n\n.twoFATitle {\n  justify-content: center;\n  display: flex;\n  font-weight: 600;\n}\n\n.qr__imag {\n  display: flex;\n  justify-content: center;\n}\n\n.study_icopn i,\n.study_icopn svg {\n  background: var(--white);\n  width: 40px;\n  height: 40px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--blue);\n}\n\n.chart__overview .card {\n  border-radius: 4px;\n\n  .card-title {\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0;\n  }\n\n  .card-text:last-child {\n    font-size: 13px;\n  }\n}\n\n.assign_icopn span {\n  background: var(--white);\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 700;\n  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n  color: green;\n}\n\n.height-home {\n  height: calc(100vh - 150px);\n  overflow: auto;\n}\n\n.progress-bar {\n  background-color: #103c5e;\n}\n\n.fade.modal-backdrop {\n  display: none !important;\n}\n\n.fade.modal.show {\n  background: #00000057 !important;\n}\n\n// =============================================\n// ================== Document Css  ============\n// =============================================\n\n.tree_menu {\n  font-size: 12px;\n}\n\n.toolbar {\n  i {\n    border-radius: 2px;\n    cursor: pointer;\n    font-size: 12px;\n    padding: 5px;\n  }\n}\n\n.toolbar .breadcrumb {\n  margin: 0;\n  font-size: 12px;\n  height: 33px;\n  display: flex;\n  align-items: center;\n  padding: 0 10px;\n}\n\n.toolbar {\n  .sync {\n    cursor: pointer;\n    border-radius: 2px;\n    font-size: 7px;\n    padding: 5px;\n    padding-top: 8px;\n  }\n}\n\n.table {\n  & > thead {\n    &.fixed-DocumentList-header {\n      position: -webkit-sticky;\n      position: sticky;\n      top: 0;\n      z-index: 1;\n    }\n  }\n}\n\n.tableLibrary.custom-table th:last-child {\n  width: 100% !important;\n  table-layout: fixed;\n}\n\n.tableLibrary.custom-table {\n  width: auto;\n  max-width: max-content;\n}\n\n.custom-table {\n  width: 100%;\n  table-layout: fixed;\n}\n\n.custom-table.resizing {\n  width: 100%;\n  max-width: fit-content;\n}\n\n.tenderSwollan {\n  tr,\n  th,\n  td {\n    overflow: inherit !important;\n  }\n}\n\n.custom-table,\n.query-table,\n.data-table,\n.signTable {\n  th,\n  td {\n    text-align: left;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    vertical-align: middle;\n    font-size: 11px !important;\n  }\n\n  th {\n    resize: horizontal;\n    background-color: #b8cfdf !important;\n  }\n}\n\n.custom-table {\n  th,\n  td {\n    padding: 5px !important;\n  }\n}\n\n.activeTabButton {\n  background-color: #b8cfdf !important;\n}\n\n.table_final td {\n  font-size: 13px;\n  padding: 5px;\n}\n\n.action__buttons {\n  button {\n    background: transparent;\n    border: 1px solid var(--blue);\n    height: 17px;\n    padding: 4px;\n    transition: 1s;\n    width: 17px;\n  }\n\n  i {\n    align-items: center;\n    color: var(--blue);\n    display: flex;\n    font-size: 8px;\n    justify-content: center;\n  }\n}\n\n.action__buttons button:hover i,\n.close_circle i {\n  color: var(--white) !important;\n}\n\n.close_circle {\n  background: red !important;\n  border: 1px solid red !important;\n  transition: 1s;\n\n  &:hover {\n    background: red !important;\n    border: 1px solid red !important;\n    color: var(--white) !important;\n  }\n}\n\n.buttonForTabs {\n  background: #dedede;\n  border-radius: 3px 3px 0 0;\n  color: #000;\n  font-size: 12px;\n  min-width: 90px;\n  padding: 3.4px 10px;\n  text-align: center;\n  transition: 1s;\n  border: 0;\n\n  &:hover {\n    background: #b8cfdf;\n    // color: var(--white);\n  }\n\n  &.activee {\n    background: var(--blue);\n    color: var(--white);\n  }\n}\n\n.resizer-x,\n.resizer-y {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  position: relative;\n  transition: 1s;\n}\n\n.resizer-y {\n  border-bottom: 1px solid var(--bs-border-color);\n  border-top: 1px solid var(--bs-border-color);\n  cursor: row-resize;\n  flex-direction: column;\n  z-index: 1;\n}\n\n.resizer-y:after,\n.resizer-y:before {\n  height: 1px;\n  width: 16px;\n}\n\n.resizer-x:after,\n.resizer-x:before,\n.resizer-y:after,\n.resizer-y:before {\n  background: #737373;\n  content: \"\";\n  margin: 1px;\n}\n\n.custom-table input {\n  border: 0;\n  outline: none !important;\n  padding: 6px;\n}\n\n.saperate_action_button {\n  background: var(--white);\n  border-radius: 20px;\n  box-shadow: -10px 13px 60px 12px #0000003d;\n  display: flex;\n  padding: 2px 4px;\n  position: absolute;\n  right: 45px;\n  gap: 3px;\n}\n\n.toolbar i,\n.sync {\n  &.activee,\n  &:hover {\n    background: var(--blue);\n    color: var(--white);\n    transition: 1s;\n  }\n}\n\n.form-check-input {\n  &:checked {\n    background-color: var(--blue) !important;\n    border-color: var(--blue) !important;\n  }\n}\n\n.form-switch .form-check-input {\n  width: 30px !important;\n}\n\n.form-check-input:focus {\n  box-shadow: none !important;\n}\n\n.sidebar .link__tab {\n  border-bottom: 1px solid var(--bs-border-color);\n  transition: 1s;\n}\n\n.sidebar .link__tab .hstack .false {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sidebar__active {\n  background: #ccd6dd;\n}\n\n.sidebar .link__tab .tab_url {\n  font-size: 12px;\n  text-decoration: none;\n  color: var(--inactive_menu_color);\n  padding: 7px 10px;\n  white-space: nowrap;\n  border-left: 4px solid transparent;\n  cursor: pointer;\n}\n\n#resizeMe {\n  table-layout: fixed;\n  width: 100%;\n}\n\n#resizeMe th {\n  resize: horizontal;\n}\n\n#resizeMe th,\n#resizeMe td {\n  border: 1px solid var(--border_color);\n  text-align: left;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n.rpv-open-button,\n.rpv-open__input-wrapper,\n[aria-describedby=\"rpv-core__tooltip-body-theme-switch\"],\n[aria-describedby=\"rpv-core__tooltip-body-print\"],\n[aria-describedby=\"rpv-core__tooltip-body-get-file\"],\n[data-testid=\"properties__menu\"],\n.rpv-core__menu-divider:last-child {\n  display: none !important;\n}\n\n.rpv-core__tooltip-body {\n  font-size: 12px !important;\n  padding: 0px !important;\n}\n\n.rpv-default-layout__sidebar--opened {\n  width: 200px !important;\n}\n\n.rpv-attachment__empty,\n.rpv-bookmark__empty {\n  padding: 20px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.rpv-page-navigation__current-page-input input {\n  height: auto;\n  padding: 2px 10px;\n}\n\n.rpv-core__menu-item {\n  font-size: 11px;\n}\n\n.rpv-core__popover-body,\n.rpv-core__textbox {\n  font-size: 12px !important;\n  border: 1px solid var(--bs-border-color) !important;\n}\n\n.rpv-core__arrow {\n  border-bottom: 1px solid var(--bs-border-color) !important;\n  border-right: 1px solid var(--bs-border-color) !important;\n}\n\n.rpv-default-layout__toolbar {\n  border-top: 0;\n  border-bottom: 1px solid var(--bs-border-color) !important;\n}\n\n.rpv-default-layout__sidebar-content--ltr {\n  border-left: 1px solid var(--bs-border-color) !important;\n}\n\n.rpv-default-layout__sidebar--ltr {\n  border-right: 1px solid var(--bs-border-color) !important;\n}\n\n.rpv-default-layout__container {\n  border: 0 !important;\n}\n\n.rpv-default-layout__sidebar-headers,\n.rpv-default-layout__toolbar {\n  background-color: #f8f9fa !important;\n}\n\nbutton svg {\n  width: 15px;\n  height: 13px;\n}\n\n.efafdropdownmwnuList {\n  padding: 0;\n  font-size: 13px;\n}\n\n.efafdropdownmwnuList > div {\n  cursor: pointer;\n}\n\n.efafdropdownmwnuList > div:hover {\n  background: var(--border_color);\n}\n\n.efafdropdownmwnuList a:active,\n.rpv-core__menu-item:focus,\n.rpv-core__menu-item:hover {\n  background: var(--blue) !important;\n  color: white !important;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  // -webkit-appearance: none;\n  margin: 0;\n}\n\n.dropdownbutton_access {\n  border: none;\n  padding: 3px 20px;\n  font-size: 13px;\n  font-weight: 600;\n  border-radius: 3px;\n  background: var(--blue) !important;\n}\n\n.redCross {\n  font-size: 8px;\n  padding: 1px;\n  width: 16px;\n}\n\n.workFlowTableHeight {\n  height: calc(100vh - 147px);\n  overflow: auto;\n}\n\na {\n  cursor: pointer;\n  border: none;\n  outline: none;\n  -webkit-user-select: none;\n  user-select: none;\n  background: none;\n  box-shadow: none;\n  text-decoration: none;\n}\n\n.btn-check:focus + .btn,\n.btn:focus,\n.btn-check:active + .btn:focus,\n.btn-check:checked + .btn:focus,\n.btn.active:focus,\n.btn.show:focus,\n.btn:active:focus {\n  box-shadow: none;\n}\n\n// Table Header Css\n\n.user_filter button {\n  height: 30px;\n  padding: 0px 10px;\n  border-radius: 3px;\n  background: transparent;\n  border: 1px solid var(--blue);\n  transition: 1s;\n}\n\n.user_filter button i,\n.user_filter button p {\n  font-size: 13px;\n  color: var(--blue);\n  background: transparent;\n}\n\n.user_filter input {\n  border-radius: 3px 0px 0px 3px;\n  border-right: 0 !important;\n  height: 30px;\n  font-size: 12px;\n  border: 1px solid #00619a;\n}\n\n.user_filter input {\n  width: 125px;\n}\n\n.user_filter button:hover i {\n  color: var(--white);\n}\n\n.action__buttons button:hover,\n.user_filter button:hover {\n  border: 1px solid var(--blue) !important;\n  background: var(--blue) !important;\n}\n\n.enevelop_image img {\n  width: 141px !important;\n  height: 121px !important;\n  margin: 4px 0 !important;\n  margin-left: 18px !important;\n  border: none !important;\n}\n\n.enevelop_image p {\n  top: 24%;\n  left: 34%;\n  color: var(--white);\n  font-size: 12px;\n}\n\n// randomized css table\n\n.randomization-container {\n  // border: 1px solid #d1d1d1;\n  border-radius: 5px;\n  padding: 20px;\n  max-width: 600px;\n  margin: 20px auto;\n  // background-color: #f9f9f9;\n}\n\n.randomization-title {\n  background-color: #1f537a;\n  padding: 10px;\n  color: var(--white);\n  border-radius: 5px 5px 0 0;\n  margin: -20px -20px 20px -20px;\n  font-size: 17px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.randomization-details {\n  display: flex;\n  flex-direction: column;\n}\n\n.detail-item {\n  padding: 5px 0;\n}\n\n.treatment {\n  color: red;\n  font-weight: bold;\n}\n\n.randomizer-link:hover {\n  text-decoration: underline !important;\n  color: red !important;\n}\n\n// trial design\n\n.trial-design-container {\n  border: 1px solid #d1d1d1;\n  border-radius: 4px;\n  overflow: hidden;\n  margin: 20px;\n}\n\n.trial-design-header {\n  background-color: #1f537a;\n  padding: 10px;\n  color: var(--white);\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.trial-design-options a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.trial-design-options a:hover {\n  text-decoration: underline;\n}\n\n.trial-design-footer {\n  border-top: 1px solid #d1d1d1;\n}\n\n.parameters {\n  background-color: #f8f8f8;\n  margin-right: 4px;\n  width: 33%;\n  margin-top: 7px;\n  padding: 0;\n}\n\n.parameters button {\n  background-color: transparent;\n  color: initial;\n  border: none;\n  padding: 10px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.parameters button.active {\n  background-color: #1f537a;\n  color: var(--white);\n  border-radius: 4px;\n  font-size: 13px;\n}\n\n.factor_modal {\n  max-height: calc(75vh - 142px);\n  overflow: auto;\n}\n\n.parameter_data {\n  height: calc(100vh - 170px);\n  overflow: auto;\n}\n\n.parameter_data .form-label {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.allTreatmentClass {\n  border-bottom: 1px solid #d1d1d1;\n  font-size: 13px;\n  font-weight: bold;\n}\n\n.add_sponsor_field .input-group-text {\n  font-size: 11px;\n  background-color: #dedede;\n  padding: 5px;\n  border-radius: 3px;\n  border-color: #dedede;\n}\n\n.selected-row {\n  background-color: #ccd6dd !important;\n}\n\n.green-selected-row {\n  background-color: #ccddce !important;\n}\n\n// Query Msg CSS\n\n.chat {\n  font-size: 1.6rem;\n  background-color: #fff;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.receiverSays {\n  display: flex;\n  align-items: end;\n  gap: 1.3rem;\n}\n\n.text-box-receiver .text p {\n  background-color: #eff3f6;\n  padding: 10px;\n  width: fit-content;\n  max-width: 250px;\n  border-radius: 3px;\n  font-size: 11px;\n  margin: 0;\n}\n\n.text-box-receiver img,\n.userSays img {\n  width: 25px;\n  height: 25px;\n}\n\n.text-box-receiver .text p:not(.text-box-receiver .text p:nth-of-type(1)) {\n  margin-top: 0.5rem;\n}\n\n.userSays {\n  margin-top: 0.5rem;\n}\n\n.userSays .text {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n}\n\n.userSays .text p {\n  background-color: #dff4fc;\n  padding: 10px;\n  width: fit-content;\n  max-width: 250px;\n  border-radius: 3px;\n  font-size: 11px;\n  margin: 0;\n}\n\n.userSays .text span,\n.receiverSays .text span {\n  font-size: 10px;\n}\n\n.userSays .text p:not(.userSays .text p:nth-of-type(1)) {\n  margin-top: 0.5rem;\n}\n\n.userSays .text {\n  text-align: -webkit-right;\n}\n\n.defaultFileHeight {\n  height: calc(100vh - 162px);\n  overflow: auto;\n}\n\n.dropzone {\n  border: 1px dashed var(--bs-border-color);\n  border-radius: 4px;\n  text-align: center;\n  cursor: pointer;\n  padding: 10px 20px;\n  display: flex;\n  align-items: center;\n  height: 150px;\n  width: 100%;\n  justify-content: center;\n  transition: 1s;\n  background: var(--bs-body-bg);\n}\n\n.dropzone p {\n  font-size: 10px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.dropzone p.text-danger {\n  z-index: 999;\n}\n\n.dropzone i {\n  font-size: 40px;\n  opacity: 0.4;\n}\n\n.overlay input {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  z-index: 9;\n}\n\n.overlay .form-control:disabled {\n  opacity: 0;\n}\n\n// grid Section of List\n.GridItem {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n\n  .GridBoxItem {\n    width: 150px;\n    text-align: left;\n    margin: 5px 0px 0px 5px;\n\n    p {\n      font-size: 12px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      display: -webkit-box;\n      --webkit-line-clamp: 2;\n      -webkit-box-orient: vertical;\n      white-space: pre-wrap;\n      margin-top: 7px;\n      margin-bottom: 0;\n    }\n\n    .gridBox {\n      width: 150px;\n      height: 125px;\n      position: relative;\n\n      .details {\n        i {\n          font-size: 40px;\n          margin-bottom: 15px;\n        }\n\n        p {\n          margin: 0;\n          font-size: 10px;\n        }\n      }\n\n      .statusPower {\n        position: absolute;\n        top: 2px;\n        right: 2px;\n        width: 25px;\n        height: 25px;\n        margin-top: 0px;\n        transition: 1s;\n        border-radius: 50%;\n\n        i {\n          padding: 2px;\n          font-size: 12px;\n        }\n\n        &:hover {\n          background: #dedede;\n        }\n      }\n\n      .viewPower {\n        position: absolute;\n        top: 30px;\n        right: 2px;\n        width: 25px;\n        height: 25px;\n        margin-top: 0px;\n        transition: 1s;\n        border-radius: 50%;\n\n        i {\n          padding: 2px;\n          font-size: 12px;\n        }\n\n        &:hover {\n          background: #dedede;\n        }\n      }\n\n      .disabled {\n        opacity: 0.3;\n        pointer-events: none;\n        cursor: no-drop;\n      }\n\n      .deletePower {\n        position: absolute;\n        top: 82px;\n        right: 2px;\n        width: 25px;\n        height: 25px;\n        margin-top: 0px;\n        transition: 1s;\n        border-radius: 50%;\n\n        i {\n          padding: 2px;\n          font-size: 12px;\n        }\n\n        &:hover {\n          background: #dedede;\n        }\n      }\n      .downloadPower {\n        position: absolute;\n        top: 55px;\n        right: 2px;\n        width: 25px;\n        height: 25px;\n        margin-top: 0px;\n        transition: 1s;\n        border-radius: 50%;\n\n        i {\n          padding: 2px;\n          font-size: 12px;\n        }\n\n        &:hover {\n          background: #dedede;\n        }\n      }\n    }\n  }\n}\n\n// WorkFlow Tileline\n\n.left-circle {\n  position: relative;\n  top: 20px;\n  left: -20px;\n  width: 40px;\n  height: 40px;\n  border: 1px dashed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  label {\n    font-weight: 700;\n    margin-top: 10px;\n    opacity: 0.8;\n  }\n}\n\n.grid-wrap-left {\n  padding: 20px;\n  border-left: 1px dashed;\n  border-bottom: 1px dashed;\n  border-bottom-left-radius: 20px;\n\n  p {\n    font-size: 12px;\n    margin-bottom: 5px;\n    opacity: 0.8;\n  }\n}\n\n.right-circle {\n  position: relative;\n  top: -20px;\n  left: 96%;\n  width: 40px;\n  height: 40px;\n  border: 1px dashed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n\n  label {\n    font-weight: 700;\n    margin-top: 10px;\n    opacity: 0.8;\n  }\n}\n\n.grid-wrap-right {\n  display: grid;\n  padding: 20px;\n  margin: -40px auto;\n  grid-gap: 0;\n  border-right: 1px dashed;\n  border-bottom: 1px dashed;\n  border-bottom-right-radius: 20px;\n\n  p {\n    font-size: 12px;\n    margin-bottom: 5px;\n    opacity: 0.8;\n  }\n}\n\n.assignButton:hover {\n  background: var(--blue) !important;\n}\n\n.tooltips .tooltiptext {\n  z-index: 9999 !important;\n}\n\n.Apps {\n  .Apps_dd {\n    min-width: 200px;\n    position: absolute;\n    top: 29px;\n    background: #fff;\n    z-index: 999;\n    border-radius: 5px;\n\n    label {\n      color: var(--blue);\n      padding: 6px 15px 0;\n      border-bottom: 1px solid #80808030;\n      width: 100%;\n      margin: 0;\n      font-size: 13px;\n    }\n\n    ul {\n      li {\n        border-bottom: 1px solid #80808030;\n\n        a {\n          display: block;\n          padding: 6px 15px;\n          position: relative;\n          font-weight: 500;\n          font-size: 11px;\n          color: var(--blue);\n          text-decoration: none;\n\n          &:hover {\n            color: var(--blue);\n            background: #103c5e57;\n          }\n        }\n\n        &:last-child {\n          border-bottom: 0;\n        }\n      }\n    }\n\n    .Apps_ul {\n      padding: 0;\n      overflow: hidden;\n      margin: 0;\n      max-height: 0;\n      transition: max-height 0.5s ease-in-out;\n    }\n  }\n\n  .icon_wrap {\n    .title_name {\n      font-size: 14px;\n\n      i {\n        font-size: 14px;\n        margin-top: 1px;\n      }\n    }\n  }\n}\n\n.AppsNameActive,\n.title_name:hover {\n  background: #fff;\n  border-radius: 4px;\n  color: var(--blue);\n  transition: 1s;\n}\n\n.dotsNameActive,\n.title_name_dots:hover {\n  background: #e2e3e5;\n  color: var(--blue);\n  transition: 1s;\n}\n\n.Apps.active .Apps_ul {\n  max-height: 300px;\n  transition: max-height 0.5s ease-in-out;\n  overflow: hidden;\n}\n\n.custom-checkbox .form-check-input {\n  transform: scale(0.8);\n  margin-right: 10px;\n}\n\n.custom-checkbox {\n  display: flex;\n  align-items: center;\n}\n\n.apexcharts-legend {\n  right: 20px !important;\n}\n\n// .apexcharts-legend-marker {\n//   top: 2px !important;\n// }\n\n.tableLoader {\n  height: 21px;\n  aspect-ratio: 2.5;\n  --_g: no-repeat radial-gradient(farthest-side, #103c5e 90%, #0080);\n  background: var(--_g), var(--_g), var(--_g), var(--_g);\n  background-size: 20% 50%;\n  animation: l43 1s infinite linear;\n}\n\n@keyframes l43 {\n  0% {\n    background-position:\n      calc(0 * 100% / 3) 50%,\n      calc(1 * 100% / 3) 50%,\n      calc(2 * 100% / 3) 50%,\n      calc(3 * 100% / 3) 50%;\n  }\n\n  16.67% {\n    background-position:\n      calc(0 * 100% / 3) 0,\n      calc(1 * 100% / 3) 50%,\n      calc(2 * 100% / 3) 50%,\n      calc(3 * 100% / 3) 50%;\n  }\n\n  33.33% {\n    background-position:\n      calc(0 * 100% / 3) 100%,\n      calc(1 * 100% / 3) 0,\n      calc(2 * 100% / 3) 50%,\n      calc(3 * 100% / 3) 50%;\n  }\n\n  50% {\n    background-position:\n      calc(0 * 100% / 3) 50%,\n      calc(1 * 100% / 3) 100%,\n      calc(2 * 100% / 3) 0,\n      calc(3 * 100% / 3) 50%;\n  }\n\n  66.67% {\n    background-position:\n      calc(0 * 100% / 3) 50%,\n      calc(1 * 100% / 3) 50%,\n      calc(2 * 100% / 3) 100%,\n      calc(3 * 100% / 3) 0;\n  }\n\n  83.33% {\n    background-position:\n      calc(0 * 100% / 3) 50%,\n      calc(1 * 100% / 3) 50%,\n      calc(2 * 100% / 3) 50%,\n      calc(3 * 100% / 3) 100%;\n  }\n\n  100% {\n    background-position:\n      calc(0 * 100% / 3) 50%,\n      calc(1 * 100% / 3) 50%,\n      calc(2 * 100% / 3) 50%,\n      calc(3 * 100% / 3) 50%;\n  }\n}\n\n.Profile_img label {\n  font-weight: 700;\n  margin-bottom: 5px;\n}\n\n.avatar-upload {\n  position: relative;\n  max-width: 190px;\n  margin: 0px auto;\n}\n\n.avatar-upload .avatar-edit {\n  position: absolute;\n  right: 40px;\n  z-index: 1;\n  top: 10px;\n}\n\n.avatar-upload .avatar-edit input {\n  display: none;\n}\n\n.avatar-upload .avatar-edit input + label {\n  display: inline-block;\n  width: 34px;\n  height: 34px;\n  margin-bottom: 0;\n  border-radius: 50%;\n  background: var(--bg-100);\n  border: 1px solid transparent;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.avatar-upload .avatar-edit input + label:hover {\n  background: var(--bg-300);\n  border-color: var(--bg-300);\n}\n\n.avatar-upload .avatar-edit input + label:after {\n  content: \"\\f040\";\n  color: var(--text-100);\n  position: absolute;\n  top: 5px;\n  left: 0;\n  right: 0;\n  text-align: center;\n  margin: auto;\n}\n\n.avatar-upload .avatar-preview {\n  width: 155px;\n  position: relative;\n  border-radius: 100%;\n  border: 1px solid var(--border-color);\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n}\n\n.avatar-upload .avatar-preview img {\n  border-radius: 50%;\n  object-fit: cover;\n  height: 155px;\n}\n\n.tabbars > svg {\n  background: var(--bs-border-color);\n  width: 25px;\n  height: 27px;\n  padding: 3px;\n  cursor: pointer;\n  border-radius: 3px 3px 0 0;\n  transition: 1s;\n}\n\n.tablist {\n  background: var(--bs-border-color);\n  border-radius: 3px 3px 0 0;\n  cursor: pointer;\n}\n\n.tabbars > svg:hover,\n.tabButtons:hover,\n.activee {\n  background: var(--blue) !important;\n  fill: #fff;\n  color: #fff;\n}\n\n.tablist svg:hover {\n  background: rgb(209 217 224);\n  fill: var(--blue);\n}\n\n.timeline-card {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  position: relative;\n}\n\n.timeline-card-last {\n  display: flex;\n  align-items: baseline;\n  justify-content: center;\n  position: relative;\n}\n\n.timeline-card:first-of-type::before {\n  content: \"\";\n  width: 2px;\n  height: 70px;\n  background: #dfdfdf;\n  position: absolute;\n}\n\n.circle-custom {\n  font-size: 0.5rem !important;\n}\n\n.timeline-item {\n  align-content: center;\n  justify-items: start;\n}\n\n.subcard {\n  position: relative;\n  padding: 0.5em 1.5em;\n  background: #fdfdfd;\n  color: black;\n}\n\n.eSignDesignWrapper {\n  display: grid;\n  align-items: center;\n  width: 100%;\n  grid-auto-flow: column;\n  justify-content: space-between;\n}\n\n.eSignDesign {\n  position: relative;\n  border: 2px solid green;\n  border-right: 0px;\n  border-radius: 4px 0 0 4px;\n}\n\n.esign {\n  position: absolute;\n  top: -8px;\n  background-color: #fff;\n  padding: 0 5px;\n  font-size: 10px;\n  width: 100%;\n}\n\n.esignId {\n  position: absolute;\n  bottom: -8px;\n  background-color: #fff;\n  padding: 0 5px;\n  font-size: 10px;\n  width: 100%;\n}\n\n// .signauteFont {\n//   font-family: \"Dancing Script\", cursive;\n//   font-optical-sizing: auto;\n// }\n\n@media screen {\n  .print-only {\n    display: none;\n  }\n}\n\n.form-check-input[type=\"radio\"] {\n  border: var(--bs-border-width) solid var(--blue);\n}\n\n.content .form-check-input[type=\"radio\"],\n.radioMap .form-check-input[type=\"radio\"] {\n  font-size: 13px;\n  margin-top: 8px;\n  border: var(--bs-border-width) solid var(--blue);\n}\n\n// .pageStyle .form-check-input[type=\"radio\"],\n// .pageStyle .radioMap .form-check-input[type=\"radio\"] {\n//   font-size: 13px;\n//   margin-top: px;\n//   border: var(--bs-border-width) solid var(--blue);\n// }\n\n.h-285 {\n  max-height: 285px !important;\n}\n\n.selectValues > div {\n  text-align: center;\n  width: 45px;\n  justify-content: center;\n  display: flex;\n  transition: 0.5s;\n  height: 26px;\n\n  &:hover,\n  &.active {\n    background: #ccd6dd;\n  }\n}\n\n.time_picker_container {\n  .wrapper {\n    width: 100%;\n    box-shadow: none;\n    border: 0;\n  }\n\n  .time_picker_preview {\n    height: 32px;\n  }\n\n  .react_times_button {\n    box-shadow: none;\n    border: 0;\n  }\n\n  .time_picker_preview:not(.disabled).active,\n  .time_picker_preview:not(.disabled):active {\n    box-shadow: none;\n  }\n\n  .time_picker_modal_header span {\n    font-size: smaller;\n  }\n\n  .time_picker_modal_header,\n  .time_picker_modal_footer,\n  .timezone_picker_modal_header {\n    height: 35px;\n    line-height: 30px;\n    margin-bottom: 20px;\n    background-color: #ccd6dd;\n    color: #000000;\n    font-size: larger;\n    border-radius: 2px 2px 0 0;\n  }\n\n  .preview_container {\n    height: 35px;\n    line-height: 30px;\n    position: relative;\n\n    svg {\n      width: 30px;\n      height: 21px;\n      top: 5px;\n    }\n  }\n\n  .buttons_wrapper {\n    display: none;\n  }\n}\n\n.scaleTemparature {\n  width: 70px;\n  height: 30px;\n  border: 1px solid #ededed;\n  transition: background-color 0.3s ease;\n}\n\n.cardHoverAdd {\n  transition: 0.5s;\n}\n\n.cardHoverAdd:hover {\n  background-color: #0003 !important;\n}\n\n.step {\n  font-size: 12px;\n  display: contents;\n  position: relative;\n}\n\n.step::before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background-color: #ddd;\n  z-index: -1;\n}\n\n.step.active > div {\n  color: #fff;\n  background-color: var(--blue) !important;\n  border: 1px solid var(--blue) !important;\n}\n\n.step.active::before {\n  background-color: var(--blue);\n}\n\n// .btn-primary {\n//   --bs-btn-bg: transparent !important;\n// }\n\n// .btn:hover {\n//   background-color: transparent !important;\n//   color: #000 !important;\n// }\n\n// envelop design\n\n.envelope {\n  position: relative;\n  width: 95px;\n  height: 50px;\n  background-color: #b12a3d;\n  transform-style: preserve-3d;\n  transition: all 0.5s ease;\n  perspective: 1000px;\n  cursor: pointer;\n}\n\n.envelope .flap {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  // background-color: rgba(0, 0, 0, 0.1);\n  background-color: #4609097a;\n  clip-path: polygon(50% 51%, 100% 0%, 0% 0%);\n  transform-origin: top;\n  transform: rotateX(0deg);\n  transition: transform 0.6s ease;\n  box-shadow: inset 0px -5px 10px rgba(0, 0, 0, 0.3);\n}\n\n.envelope.open .flap {\n  transform: rotateX(160deg);\n}\n\n.envelope .card_enevelop {\n  position: absolute;\n  top: 25%;\n  left: 10%;\n  right: 10%;\n  width: 80%;\n  height: 60%;\n  background-color: white;\n  color: #333;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  transform: translateY(100%);\n  opacity: 0;\n  transition:\n    transform 0.6s ease,\n    opacity 0.6s ease;\n}\n\n.envelope.open .card_enevelop {\n  transform: translateY(0%);\n  opacity: 1;\n}\n\n.card_enevelop p {\n  margin: 0;\n  font-size: 10px;\n  text-align: center;\n}\n\n.envelope::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  transition: all 0.5s ease;\n  // box-shadow: inset 0px -3px 10px rgba(0, 0, 0, 0.3);\n}\n\n.envelope.open::before {\n  opacity: 0;\n}\n\n.full-screen {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  background-color: white;\n}\n\n.uploadLogo button {\n  overflow: hidden;\n  width: max-content;\n  position: relative;\n  cursor: pointer;\n}\n\n.uploadLogo button input {\n  opacity: 0;\n  cursor: pointer;\n  position: absolute;\n}\n\n.uploadLogoPreview {\n  border: 1px dashed var(--blue);\n  border-radius: 3px;\n  padding: 10px;\n  width: 150px;\n  height: 150px;\n  overflow: hidden;\n}\n\n.rpv-core__page-layer::after {\n  box-shadow: none !important;\n  border: 1px solid var(--border_color);\n}\n\n.hover_actions {\n  display: none;\n  opacity: 0;\n  transition: opacity 0.5s ease-in-out;\n}\n\n.pageMapRender > div:hover .hover_actions {\n  display: block;\n  opacity: 1;\n}\n\n.hover-icon .hover-icon-visible {\n  display: none;\n}\n\n.hover-icon .default-icon {\n  display: inline;\n}\n\n.hover-icon:hover .default-icon {\n  display: none;\n}\n\n.hover-icon:hover .hover-icon-visible {\n  display: inline;\n}\n\n.showToolbar {\n  display: none;\n}\n\n.showtextBox:hover .showToolbar {\n  display: block;\n}\n\n.group-start {\n  border-top: 2px solid black !important;\n}\n\n.group-end {\n  border-bottom: 2px solid black !important;\n}\n\n/* General Rules For Range Slider */\n.custom-rangeslider {\n  position: relative;\n  margin-top: 50px;\n}\n\n.custom-rangeInput,\n.custom-rangeInputDisabled {\n  width: 100%;\n  // appearance: none;\n  background-color: transparent;\n  height: 4px;\n}\n\n.custom-rangeInput::-webkit-slider-thumb {\n  // appearance: none;\n  background-color: var(--blue);\n  outline: 2px solid #fff;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  cursor: move;\n  cursor: grab;\n  margin-top: -8px;\n}\n\n.custom-rangeInputDisabled::-webkit-slider-thumb {\n  // appearance: none;\n  background-color: transparent;\n  outline: 2px solid transparent;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  cursor: default;\n  margin-top: -8px;\n}\n\n.custom-rangeInput::-webkit-slider-thumb:active {\n  cursor: grabbing;\n}\n\n.custom-rangeInput::-webkit-slider-runnable-track {\n  // appearance: none;\n  height: 5px;\n  width: 100%;\n  cursor: pointer;\n  border: none;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n}\n\n.custom-rangeInput:focus,\n.custom-rangeInput:active {\n  outline: none;\n}\n\n.custom-rangeslider__tooltip {\n  position: absolute;\n  width: 40px;\n  padding: 3px;\n  background-color: #fff;\n  border: 1px solid var(--blue);\n  top: -40px;\n  text-align: center;\n  border-radius: 3px;\n  user-select: none;\n  pointer-events: none;\n}\n\n.custom-rangeslider__tooltip:after {\n  display: block;\n  content: \" \";\n  background: #fff;\n  position: absolute;\n  border: 1px solid var(--blue);\n  border-top: 0;\n  border-left: 0;\n  width: 10px;\n  height: 10px;\n  left: calc(50% - 6px);\n  bottom: -6px;\n  transform: rotate(45deg);\n}\n\n.custom-rangeslider__label {\n  width: 100%;\n  display: block;\n}\n\n.custom-rangeslider__label span {\n  display: block;\n}\n\n.custom-rangeslider__label-min {\n  float: left;\n}\n\n.custom-rangeslider__label-max {\n  float: right;\n}\n\n.custom-rangeslider__label:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.Apps .Apps_dd ul li p {\n  display: block;\n  padding: 6px 15px;\n  position: relative;\n  font-weight: 500;\n  font-size: 11px;\n  color: var(--blue);\n  text-decoration: none;\n}\n\n.innerHTML p {\n  margin: 0;\n  white-space: normal;\n  width: 100%;\n}\n\n// .print-container {\n//   display: block !important;\n// }\n\n// .page-break {\n//   page-break-inside: avoid !important;\n// }\n\n// @media print {\n//   .print-container {\n//     margin: 0 !important;\n//     padding: 0 !important;\n//     page-break-after: auto !important;\n//     page-break-before: auto !important;\n//   }\n\n//   table {\n//     width: 100% !important;\n//     border-collapse: collapse !important;\n//   }\n\n//   .page-break {\n//     page-break-inside: avoid !important;\n//   }\n// }\n\n.rotate360 {\n  animation: rotate 2s linear infinite;\n}\n\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.calendar-weekdays,\n.calendar-days {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  text-align: center;\n  padding: 5px;\n}\n\n.calendar-day {\n  transition: 0.2s ease;\n  border-radius: 50%;\n}\n\n.calendar-day:hover,\n.clock-number:hover {\n  background-color: var(--bg-blue-subtle);\n  border: 1px solid var(--bs-border-color);\n}\n\n.calendar-day.today {\n  border: 1px solid var(--bgGold);\n}\n\n.calendar-day.selected,\n.clock-number.selected {\n  background-color: var(--bgGold);\n  font-weight: bold;\n  border: 1px solid var(--bs-border-color);\n  color: var(--textColor);\n}\n\n.headPrint {\n  display: none;\n}\n\n@media print {\n  body::before {\n    content: \"Confidential\";\n    position: fixed;\n    top: 40%;\n    left: 5%;\n    font-size: 120px;\n    color: rgba(150, 150, 150, 0.2);\n    transform: rotate(-30deg);\n    z-index: -1;\n    white-space: nowrap;\n  }\n  @page {\n    size: A4 !important;\n    margin: 0.3in 0.5in 1in !important;\n\n    @bottom-left {\n      content: \"This is an electronically authenticated report generated by Galax CTMS System\";\n      font-family: \"Nunito\", sans-serif !important;\n      font-size: 12px;\n    }\n\n    // @bottom-center {\n    //   content: \"Confidentials\";\n    //   font-family: \"Nunito\", sans-serif !important;\n    //   font-size: 12px;\n    //   color: red;\n    // }\n\n    @bottom-right {\n      content: \"Page \" counter(page) \" of \" counter(pages);\n      font-family: \"Nunito\", sans-serif !important;\n      font-size: 12px;\n    }\n  }\n\n  .headPrint {\n    display: block;\n  }\n\n  .page-break {\n    page-break-before: always;\n    break-before: page;\n  }\n\n  table,\n  thead,\n  tbody,\n  tr,\n  td,\n  th {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .actionBtn {\n    display: none;\n  }\n\n  .crfHeader{\n    width: 100% !important;\n  }\n}\n\n.borderLight {\n  border: 1px solid #6b6b6b1c !important;\n  border-bottom: 0px !important;\n}\n.borderLight:last-child {\n  border-bottom: 1px solid #6b6b6b1c !important;\n}\n\n.bg-blue-subtle {\n  background-color: #f9fcfe !important;\n}\n\n.bg-purple-subtle {\n  background-color: #daa6f7 !important;\n}\n\n.bg-purple {\n  background-color: #c681ed !important;\n}\n\n.text-purple {\n  color: #c681ed !important;\n}\n\n.border-purple {\n  border-color: #c681ed !important;\n}\n\n.rsw-editor span,\n.rsw-ce {\n  font-size: 12px !important;\n}\n\n.rsw-dd {\n  border: 0 !important;\n  font-size: 12px !important;\n  background-color: transparent !important;\n}\n\n.rsw-editor {\n  border-radius: 3px !important;\n}\n\n.rsw-btn {\n  font-size: 13px !important;\n}\n\n.rsw-btn svg {\n  width: 15px !important;\n  height: 15px !important;\n  margin-top: 2px;\n}\n\n.rsw-ce:focus {\n  outline: 1px solid transparent !important;\n}\n\n.fs-14 {\n  font-size: 14px !important;\n}\n\n.swal2-shown {\n  padding: 0px !important;\n}\n\n.ql-editor {\n  min-height: 150px !important;\n}\n\n.folder-drag-over {\n  background-color: #dbe6ef !important;\n  animation: folderGlow 0.5s ease-in-out infinite alternate;\n}\n\n@keyframes folderGlow {\n  from {\n    box-shadow: 0 0 5px #7cc2fa;\n  }\n  to {\n    box-shadow: 0 0 15px #62b1f1;\n  }\n}\n\n// Swal Design\n\ndiv:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm),\ndiv:where(.swal2-container) .swal2-input,\ndiv:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel) {\n  font-size: 12px;\n}\n\ndiv:where(.swal2-container) div:where(.swal2-actions) {\n  margin: 1em auto 0;\n}\n\ndiv:where(.swal2-container) h2:where(.swal2-title) {\n  font-size: 18px;\n  padding: 0.3em 1.6em 0.3em;\n}\ndiv:where(.swal2-container) div:where(.swal2-html-container) {\n  font-size: 15px;\n  padding: 0.3em 1.6em 0.3em;\n}\n\ndiv:where(.swal2-icon) .swal2-icon-content {\n  font-size: 2.75em;\n}\n\ndiv:where(.swal2-icon) {\n  width: 3em;\n  height: 3em;\n}\n\ndiv:where(.swal2-container) div:where(.swal2-popup) {\n  width: 20em;\n}\n\n.margin-view-overlays .line-numbers {\n  font-size: 12px;\n}\n\n.decorationsOverviewRuler,\n.scrollbar {\n  width: 6px !important;\n  height: 6px !important;\n}\n\n// .monaco-editor span{\n//   font-size: unset !important;\n// }\n\n.log_change {\n  background-color: #f5f5f5;\n  background-size: 100%;\n  border: 1px solid #d4d4d4;\n  display: block;\n  font-size: 14px;\n  line-height: 19px;\n  margin-bottom: 10px;\n  overflow: visible;\n  overflow-y: hidden;\n  padding: 0 0 0 4px;\n}\n\n.step::before {\n  display: none;\n}\n\n.builder-main {\n  display: flex;\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n}\n\n/* Loading Animation */\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n.loading {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 1000px 100%;\n  animation: shimmer 2s infinite;\n}\n\n/* Responsive Canvas */\n@media (max-width: 1024px) {\n  .builder-main {\n    flex-direction: column;\n  }\n}\n\n.elementor-sidebar {\n  width: 320px;\n  background: white;\n  border-right: 1px solid #e0e0e0;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.05);\n}\n\n.tab-btn.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #667eea;\n}\n\n.sidebar-content {\n  overflow-y: auto;\n  padding: 20px;\n  height: calc(100vh - 210px);\n}\n\n/* Sections Library */\n.sections-library h3,\n.widgets-library h3 {\n  font-size: 16px;\n  margin-bottom: 16px;\n  color: #333;\n}\n\n.sections-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Elementor-Style Icons */\n.section-template svg,\n.widget-item svg {\n  width: 24px;\n  height: 24px;\n  stroke: currentColor;\n  stroke-width: 1.5;\n  transition: all 0.2s ease;\n}\n\n.section-template:hover svg,\n.widget-item:hover svg {\n  transform: scale(1.05);\n  color: #667eea;\n}\n\n/* Icon container styling */\n.template-preview {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n}\n\n.widget-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  margin: 0 auto 8px;\n  background: linear-gradient(135deg, #667eea15 0%, #764ba215 100%);\n  border-radius: 6px;\n}\n\n/* Category header icons */\n.widget-category h4::before {\n  content: \"\";\n  display: inline-block;\n  width: 4px;\n  height: 16px;\n  background: #667eea;\n  margin-right: 8px;\n  border-radius: 2px;\n  vertical-align: middle;\n}\n\n/* Animation for icons */\n@keyframes iconPop {\n  0% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n.section-template:active svg,\n.widget-item:active svg {\n  animation: iconPop 0.2s ease;\n}\n\n.section-template {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.section-template:hover {\n  background: #e9ecef;\n  transform: translateX(4px);\n  border-color: #667eea;\n}\n\n.template-preview {\n  width: 48px;\n  height: 48px;\n  background: white;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #ddd;\n}\n\n.preview-icon {\n  font-size: 24px;\n}\n\n.template-info {\n  flex: 1;\n}\n\n.template-info h4 {\n  font-size: 14px;\n  margin-bottom: 4px;\n  color: #333;\n}\n\n.template-info p {\n  font-size: 12px;\n  color: #666;\n  margin: 0;\n}\n\n/* Widgets Library */\n.widget-category {\n  margin-bottom: 24px;\n}\n\n.widget-category h4 {\n  font-size: 13px;\n  text-transform: uppercase;\n  color: #999;\n  margin-bottom: 12px;\n  letter-spacing: 0.5px;\n}\n\n.widgets-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n}\n\n.widget-item {\n  background: #f8f9fa;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  padding: 10px;\n  cursor: grab;\n  transition: all 0.2s ease;\n  text-align: center;\n  user-select: none;\n}\n\n.widget-item:hover {\n  background: #e9ecef;\n  transform: translateY(-2px);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border-color: #667eea;\n}\n\n.widget-item:active {\n  cursor: grabbing;\n}\n\n.widget-icon {\n  font-size: 24px;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.widget-name {\n  font-size: 12px;\n  color: #555;\n  font-weight: 500;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .elementor-sidebar {\n    width: 280px;\n  }\n}\n\n@media (max-width: 768px) {\n  .elementor-sidebar {\n    position: fixed;\n    left: -100%;\n    top: 0;\n    height: 100%;\n    z-index: 1000;\n    transition: left 0.3s ease;\n    width: 280px;\n  }\n\n  .elementor-sidebar.open {\n    left: 0;\n  }\n}\n\n.elementor-canvas {\n  flex: 1;\n  overflow-y: auto;\n  padding: 10px 10px 0;\n  // background: #f0f0f0;\n  transition: all 0.3s ease;\n  height: calc(100vh - 182px);\n}\n\n.canvas-container {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Builder Section */\n.builder-section {\n  background: white;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  position: relative;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);\n}\n\n.builder-section:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);\n}\n\n.builder-section.selected {\n  outline: 2px solid #667eea;\n  outline-offset: 2px;\n}\n\n.section-controls {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: flex;\n  gap: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  z-index: 10;\n}\n\n.builder-section:hover .section-controls {\n  opacity: 1;\n}\n\n.section-control {\n  padding: 4px 10px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.section-control:hover {\n  background: #5a67d8;\n  transform: translateY(-1px);\n}\n\n.section-control.delete {\n  background: #fc8181;\n}\n\n.section-control.delete:hover {\n  background: #f56565;\n}\n\n.section-drag-handle {\n  padding: 4px 10px;\n  background: #718096;\n  color: white;\n  border-radius: 4px;\n  cursor: grab;\n  font-size: 16px;\n  user-select: none;\n}\n\n.section-drag-handle:active {\n  cursor: grabbing;\n}\n\n.section-content {\n  padding: 20px;\n  transition: all 0.3s ease;\n}\n\n/* Columns Container */\n.columns-container {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.builder-column {\n  flex: 1;\n  min-width: 0;\n  position: relative;\n  transition: all 0.3s ease;\n  border-radius: 6px;\n}\n\n.builder-column:hover {\n  background: rgba(102, 126, 234, 0.05);\n}\n\n.column-header {\n  position: absolute;\n  top: -25px;\n  left: 25;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.builder-column:hover .column-header {\n  opacity: 1;\n}\n\n.column-label {\n  font-size: 11px;\n  color: #667eea;\n  background: white;\n  padding: 2px 8px;\n  border-radius: 4px;\n  border: 1px solid #667eea;\n  font-weight: 500;\n}\n\n/* Widgets Container */\n.widgets-container {\n  min-height: 100px;\n  padding: 10px;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.widgets-container.drag-over {\n  background: rgba(102, 126, 234, 0.1);\n  border: 2px dashed #667eea;\n}\n\n.empty-column {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n  border: 2px dashed #ddd;\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.empty-column:hover {\n  border-color: #667eea;\n  background: rgba(102, 126, 234, 0.05);\n}\n\n.empty-column p {\n  margin: 0;\n  font-size: 14px;\n}\n\n/* Empty Canvas */\n.empty-canvas {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: calc(100vh - 182px);\n}\n\n.empty-message {\n  text-align: center;\n  padding: 60px;\n}\n\n.empty-icon {\n  font-size: 80px;\n  margin-bottom: 20px;\n  opacity: 0.5;\n}\n\n.empty-message h3 {\n  font-size: 24px;\n  margin-bottom: 12px;\n  color: #333;\n}\n\n.empty-message p {\n  color: #666;\n  font-size: 16px;\n}\n\n/* Responsive Columns */\n@media (max-width: 768px) {\n  .elementor-canvas {\n    padding: 20px;\n  }\n\n  .columns-container {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .builder-column {\n    width: 100% !important;\n  }\n\n  .section-controls {\n    top: -35px;\n  }\n\n  .section-control {\n    padding: 4px 10px;\n    font-size: 11px;\n  }\n}\n\n/* Tablet View */\n@media (max-width: 1024px) and (min-width: 769px) {\n  .builder-section {\n    margin-bottom: 25px;\n  }\n\n  .columns-container {\n    gap: 15px;\n  }\n}\n\n/* Drag and Drop Animation */\n.dragging {\n  opacity: 0.5;\n  cursor: grabbing;\n}\n\n/* Animation for new elements */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.builder-section {\n  animation: slideIn 0.3s ease;\n}\n.widget-renderer {\n  position: relative;\n  margin-bottom: 15px;\n  padding: 15px;\n  background: white;\n  border: 2px solid transparent;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.widget-renderer:hover {\n  border-color: #ddd;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.widget-renderer.selected {\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);\n}\n\n/* Widget Controls */\n.widget-controls {\n  position: absolute;\n  top: -30px;\n  right: 0;\n  display: flex;\n  gap: 6px;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n  z-index: 10;\n}\n\n.widget-renderer:hover .widget-controls {\n  opacity: 1;\n}\n\n.widget-control {\n  padding: 4px 8px;\n  background: #667eea;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.widget-control:hover {\n  background: #5a67d8;\n  transform: translateY(-1px);\n}\n\n.widget-control.delete {\n  background: #fc8181;\n}\n\n.widget-control.delete:hover {\n  background: #f56565;\n}\n\n.widget-drag-handle {\n  padding: 4px 8px;\n  background: #718096;\n  color: white;\n  border-radius: 4px;\n  cursor: grab;\n  font-size: 12px;\n  user-select: none;\n}\n\n.widget-drag-handle:active {\n  cursor: grabbing;\n}\n\n/* Widget Editor */\n.widget-editor {\n  margin-bottom: 10px;\n}\n\n.widget-editor input,\n.widget-editor textarea {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  font-family: inherit;\n  transition: all 0.2s ease;\n}\n\n.widget-editor input:focus,\n.widget-editor textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.widget-editor textarea {\n  min-height: 100px;\n  resize: vertical;\n}\n\n/* Widget Content */\n.widget-content {\n  word-wrap: break-word;\n}\n\n/* Heading Widget */\n.widget-heading {\n  margin: 0;\n  line-height: 1.2;\n}\n\n.widget-heading h1,\n.widget-heading h2,\n.widget-heading h3,\n.widget-heading h4 {\n  margin: 0;\n}\n\n/* Text Widget */\n.widget-text {\n  line-height: 1.6;\n  color: #4a5568;\n}\n\n/* Button Widget */\n.widget-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.widget-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.button-icon {\n  font-size: 1.2em;\n}\n\n/* Image Widget */\n.widget-image {\n  text-align: center;\n}\n\n.widget-image img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 4px;\n}\n\n.image-caption {\n  margin-top: 8px;\n  font-size: 14px;\n  color: #718096;\n  text-align: center;\n}\n\n/* Video Widget */\n.widget-video {\n  position: relative;\n  padding-bottom: 56.25%;\n  height: 0;\n  overflow: hidden;\n}\n\n.widget-video iframe {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 8px;\n}\n\n/* Icon Widget */\n.widget-icon {\n  display: inline-block;\n}\n\n.widget-icon span {\n  display: inline-block;\n  transition: all 0.2s ease;\n}\n\n.widget-icon span:hover {\n  transform: scale(1.1);\n}\n\n/* Divider Widget */\n.widget-divider {\n  margin: 20px 0;\n}\n\n/* Spacer Widget */\n.widget-spacer {\n  width: 100%;\n}\n\n/* Counter Widget */\n.widget-counter {\n  text-align: center;\n}\n\n.counter-number {\n  font-size: 48px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.counter-title {\n  font-size: 18px;\n  color: #718096;\n}\n\n/* Progress Bar Widget */\n.widget-progress {\n  margin: 10px 0;\n}\n\n.progress-title {\n  margin-bottom: 8px;\n  font-weight: 500;\n}\n\n.progress-bar-container {\n  background: #e2e8f0;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.progress-bar-fill {\n  position: relative;\n  height: 30px;\n  background: #667eea;\n  transition: width 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  padding-right: 10px;\n}\n\n.progress-percentage {\n  color: white;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n/* Gallery Widget */\n.widget-gallery {\n  display: grid;\n  gap: 10px;\n}\n\n.gallery-image {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border-radius: 8px;\n  transition: transform 0.2s ease;\n}\n\n.gallery-image:hover {\n  transform: scale(1.05);\n}\n\n/* Animation Classes */\n.widget-renderer {\n  animation: fadeInUp 0.3s ease;\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Widgets */\n@media (max-width: 768px) {\n  .widget-renderer {\n    padding: 12px;\n  }\n\n  .widget-controls {\n    top: -25px;\n  }\n\n  .widget-control {\n    padding: 3px 6px;\n    font-size: 10px;\n  }\n\n  .counter-number {\n    font-size: 36px;\n  }\n\n  .progress-bar-fill {\n    height: 25px;\n  }\n}\n\n.settings-panel {\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  animation: slideInRight 0.3s ease;\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px 10px;\n  border-bottom: 1px solid #e0e0e0;\n  background: #fafafa;\n}\n\n.settings-header h3 {\n  font-size: 18px;\n  margin: 0;\n  color: #333;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 28px;\n  cursor: pointer;\n  color: #999;\n  transition: all 0.2s ease;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n}\n\n.close-btn:hover {\n  background: #e0e0e0;\n  color: #333;\n}\n\n/* Settings Tabs */\n.settings-tabs {\n  display: flex;\n  border-bottom: 1px solid #e0e0e0;\n  background: white;\n}\n\n.settings-tabs .tab {\n  padding: 12px 16px;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  color: #666;\n  transition: all 0.2s ease;\n  position: relative;\n}\n\n.settings-tabs .tab:hover {\n  color: #667eea;\n}\n\n.settings-tabs .tab.active {\n  color: #667eea;\n}\n\n.settings-tabs .tab.active::after {\n  content: \"\";\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #667eea;\n}\n\n/* Settings Content */\n.settings-content {\n  // flex: 1;\n  overflow: auto;\n  padding: 20px;\n  height: calc(100vh - 270px);\n}\n\n.settings-group {\n  margin-bottom: 24px;\n}\n\n.settings-group h4 {\n  font-size: 14px;\n  font-weight: 600;\n  margin-bottom: 16px;\n  color: #333;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.setting-field {\n  margin-bottom: 16px;\n}\n\n.setting-field label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  color: #555;\n}\n\n.setting-field input[type=\"text\"],\n.setting-field input[type=\"number\"],\n.setting-field input[type=\"url\"],\n.setting-field select,\n.setting-field textarea {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 13px;\n  transition: all 0.2s ease;\n  font-family: inherit;\n}\n\n.setting-field input:focus,\n.setting-field select:focus,\n.setting-field textarea:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.1);\n}\n\n.setting-field input[type=\"color\"] {\n  width: 60px;\n  height: 40px;\n  padding: 2px;\n  cursor: pointer;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n}\n\n.setting-field input[type=\"range\"] {\n  width: 100%;\n  margin: 10px 0;\n}\n\n/* Spacing Controls */\n.spacing-controls {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n}\n\n.spacing-field {\n  text-align: center;\n}\n\n.spacing-field label {\n  display: block;\n  font-size: 11px;\n  margin-bottom: 4px;\n  color: #999;\n}\n\n.spacing-field input {\n  width: 100%;\n  padding: 6px;\n  text-align: center;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n/* Checkbox and Radio */\n.setting-field input[type=\"checkbox\"],\n.setting-field input[type=\"radio\"] {\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n.setting-field .checkbox-label,\n.setting-field .radio-label {\n  display: inline-flex;\n  align-items: center;\n  cursor: pointer;\n  margin-right: 16px;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .spacing-controls {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .settings-header {\n    padding: 16px;\n  }\n\n  .settings-content {\n    padding: 16px;\n  }\n}\n\n/* Settings Animations */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.settings-group {\n  animation: slideDown 0.3s ease;\n}\n\n/* Tooltips */\n.setting-field {\n  position: relative;\n}\n\n.tooltip {\n  position: absolute;\n  right: 0;\n  top: 0;\n  cursor: help;\n}\n\n.tooltip:hover::after {\n  content: attr(data-tip);\n  position: absolute;\n  right: 0;\n  top: 20px;\n  background: #333;\n  color: white;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n  white-space: nowrap;\n  z-index: 100;\n}\n\n/* Loading State */\n.settings-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 200px;\n}\n\n.settings-loading::after {\n  content: \"\";\n  width: 30px;\n  height: 30px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #667eea;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.preview-mode {\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu,\n    sans-serif;\n  padding: 0;\n  margin: 0;\n  background: white;\n}\n\n.preview-header {\n  background: #f8f9fa;\n  border-bottom: 1px solid #e0e0e0;\n  padding: 16px 24px;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.95);\n}\n\n.preview-header h1 {\n  margin: 0;\n  font-size: 24px;\n  color: #333;\n}\n\n.preview-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.preview-section {\n  margin-bottom: 40px;\n}\n\n.preview-section:last-child {\n  margin-bottom: 0;\n}\n\n.preview-columns {\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.preview-column {\n  flex: 1;\n  min-width: 0;\n}\n\n.preview-widget {\n  margin-bottom: 20px;\n}\n\n/* Responsive Preview */\n@media (max-width: 768px) {\n  .preview-columns {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .preview-content {\n    padding: 20px;\n  }\n\n  .preview-header h1 {\n    font-size: 20px;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .preview-header {\n    display: none;\n  }\n\n  .preview-section {\n    page-break-inside: avoid;\n  }\n}\n\n.app-card {\n  transition: all 0.3s ease;\n  border: 1px solid #dee2e6;\n}\n\n.app-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 30px rgba(37, 99, 235, 0.15) !important;\n  border-color: var(--blue) !important;\n}\n\n/* Analytics icon */\n.study_icopn {\n  transition: all 0.3s ease;\n}\n\n.study_icopn:hover {\n  transform: scale(1.05);\n}\n\n.study_icopn img {\n  transition: all 0.3s ease;\n}\n\n.study_icopn:hover img {\n  transform: rotate(3deg);\n}\n\n/* Login Button */\n.updateProfile {\n  transition: all 0.3s ease;\n}\n\n.updateProfile:hover:not(:disabled) {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.2);\n}\n\n.thin-toggle .form-check-input {\n  width: 1.8rem !important;\n  height: 13px !important;\n  min-height: 13px !important;\n  border-width: 1px;\n}\n\n.crfHeader {\n  width: 100% !important;\n  border: 1px solid rgba(107, 107, 107, 0.1098039216);\n}\n\n.crfTop {\n  background: #1d426c;\n  padding: 22px 30px;\n}\n\n.crfInfoRow {\n  grid-template-columns: repeat(3, 1fr);\n  background: #214c75;\n}\n\n.crfInfoRow.light {\n  background: #fff;\n}\n\n.crfCell {\n  padding: 5px 26px;\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.crfInfoRow.light .crfCell {\n  border-right: 1px solid #d9dfe6;\n}\n\n.crfCell:last-child {\n  border-right: none;\n}\n\n.cellLabel {\n  color: #b8d0e6;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-bottom: 8px;\n}\n\n.btn-link{\n  text-decoration: none !important;\n  color: #000 !important;\n}\n\n/* ============================================================\n   DOCUMENT MANAGEMENT STYLES\n   ============================================================ */\n\n/* -------- Layout -------- */\n.doc-mgmt {\n  padding: 0;\n}\n\n.doc-mgmt-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.doc-mgmt-header-left {\n  flex: 1;\n  min-width: 200px;\n}\n\n.doc-mgmt-header-right {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.doc-mgmt-crumb {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11px;\n  color: #7A909A;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  margin-bottom: 4px;\n}\n\n.doc-mgmt-title {\n  font-size: 19px;\n  font-weight: 700;\n  letter-spacing: -0.2px;\n  margin: 0;\n}\n\n.doc-mgmt-sub {\n  font-size: 12.5px;\n  color: #7A909A;\n  margin: 2px 0 0 0;\n}\n\n.doc-mgmt-count {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 11.5px;\n  color: #7A909A;\n}\n\n/* -------- Buttons -------- */\n.btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  border-radius: 8px;\n  border: 1px solid #C3D1D6;\n  background: #FFFFFF;\n  color: #15262C;\n  font-size: 12.5px;\n  font-weight: 600;\n  padding: 7px 13px;\n  cursor: pointer;\n  transition: background 0.15s, filter 0.15s;\n  white-space: nowrap;\n  font-family: inherit;\n}\n\n.btn:hover {\n  background: #EFF3F4;\n}\n\n// .btn-primary {\n//   background: #0E6E7E;\n//   border-color: #0E6E7E;\n//   color: #fff;\n// }\n\n// .btn-primary:hover {\n//   background: #0A4854;\n// }\n\n.btn-sm {\n  padding: 4px 9px;\n  font-size: 11.5px;\n  border-radius: 6px;\n}\n\n.btn-bad {\n  background: #B42323;\n  border-color: #B42323;\n  color: #fff;\n}\n\n.btn-bad:hover {\n  background: #8E1F1F;\n}\n\n/* -------- Panel -------- */\n.doc-mgmt-panel {\n  background: #FFFFFF;\n  border: 1px solid #DCE5E8;\n  border-radius: 10px;\n  box-shadow: 0 1px 2px rgba(21,38,44,0.06), 0 4px 14px rgba(21,38,44,0.06);\n  margin-bottom: 18px;\n  overflow: hidden;\n}\n\n/* -------- Filters -------- */\n.doc-mgmt-filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #DCE5E8;\n  background: #FAFCFC;\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.filter-group label {\n  font-size: 10.5px;\n  font-family: 'IBM Plex Mono', monospace;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  color: #7A909A;\n  font-weight: 600;\n}\n\n.filter-group select,\n.filter-group input {\n  border: 1px solid #C3D1D6;\n  border-radius: 7px;\n  padding: 6px 9px;\n  background: #fff;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.filter-group select:focus,\n.filter-group input:focus {\n  border-color: #0E6E7E;\n  box-shadow: 0 0 0 2px #E2F0F2;\n}\n\n.filter-checks {\n  display: flex;\n  gap: 14px;\n  align-items: center;\n  grid-column: 1 / -1;\n  flex-wrap: wrap;\n}\n\n.filter-checks label {\n  display: flex;\n  gap: 6px;\n  align-items: center;\n  font-size: 12.5px;\n  color: #48606A;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.filter-spacer {\n  flex: 1;\n}\n\n/* -------- Search Box -------- */\n.search-box {\n  position: relative;\n  flex: 1;\n  min-width: 220px;\n}\n\n.search-box input {\n  width: 100%;\n  border: 1px solid #C3D1D6;\n  border-radius: 8px;\n  padding: 8px 12px 8px 34px;\n  background: #fff;\n  outline: none;\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.search-box input:focus {\n  border-color: #0E6E7E;\n  box-shadow: 0 0 0 2px #E2F0F2;\n}\n\n.search-box svg {\n  position: absolute;\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #7A909A;\n}\n\n/* -------- Table -------- */\n.doc-mgmt-table-wrap {\n  overflow-x: auto;\n}\n\n.doc-mgmt-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12.5px;\n  min-width: 1100px;\n}\n\n.doc-mgmt-table thead th {\n  position: sticky;\n  top: 0;\n  background: #F4F8F9;\n  color: #48606A;\n  font-size: 10.5px;\n  font-family: 'IBM Plex Mono', monospace;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  font-weight: 600;\n  text-align: left;\n  padding: 9px 12px;\n  border-bottom: 1px solid #C3D1D6;\n  white-space: nowrap;\n}\n\n.doc-mgmt-table tbody td {\n  padding: 9px 12px;\n  border-bottom: 1px solid #DCE5E8;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.doc-mgmt-table tbody tr:hover {\n  background: #F6FAFA;\n}\n\n.doc-mgmt-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.doc-deleted {\n  opacity: 0.5;\n}\n\n.cell-strong {\n  font-weight: 600;\n}\n\n.cell-sub {\n  display: block;\n  font-size: 11px;\n  color: #7A909A;\n}\n\n.mono {\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n}\n\n.file-cell {\n  font-size: 11px;\n}\n\n.meta-badge {\n  margin-left: 4px;\n  font-size: 9px !important;\n  padding: 1px 5px !important;\n}\n\n.action-cell {\n  white-space: nowrap;\n}\n\n.action-cell .btn {\n  margin-right: 4px;\n}\n\n.action-cell .btn:last-child {\n  margin-right: 0;\n}\n\n.doc-mgmt-empty {\n  padding: 34px;\n  text-align: center;\n  color: #7A909A;\n  font-size: 13px;\n}\n\n/* -------- Badges -------- */\n.badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 20px;\n  padding: 2.5px 9px;\n  white-space: nowrap;\n  letter-spacing: 0.1px;\n}\n\n// .badge::before {\n//   content: \"\";\n//   width: 6px;\n//   height: 6px;\n//   border-radius: 50%;\n//   background: currentColor;\n// }\n\n.badge-ok {\n  background: #DCF3E6;\n  color: #177245;\n}\n\n.badge-warn {\n  background: #FCEFD4;\n  color: #A05E03;\n}\n\n.badge-bad {\n  background: #FBE2E2;\n  color: #B42323;\n}\n\n.badge-info {\n  background: #DFEAFB;\n  color: #1D5FBF;\n}\n\n.badge-auth {\n  background: #ECE4FA;\n  color: #6633B8;\n}\n\n.badge-neutral {\n  background: #E7EDEF;\n  color: #5A6E77;\n}\n\n/* -------- Form -------- */\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 13px;\n}\n\n.form-grid .full {\n  grid-column: 1 / -1;\n}\n\n.fg {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.fg label {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #48606A;\n}\n\n.fg label .req {\n  color: #B42323;\n}\n\n.fg input,\n.fg select,\n.fg textarea {\n  border: 1px solid #C3D1D6;\n  border-radius: 8px;\n  padding: 8px 10px;\n  outline: none;\n  background: #fff;\n  font-size: 13px;\n  font-family: inherit;\n}\n\n.fg input:focus,\n.fg select:focus,\n.fg textarea:focus {\n  border-color: #0E6E7E;\n  box-shadow: 0 0 0 2px #E2F0F2;\n}\n\n/* -------- Animations -------- */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to { opacity: 1; transform: none; }\n}\n\n@keyframes pop {\n  from { transform: translateY(10px); opacity: 0; }\n  to { transform: none; opacity: 1; }\n}\n\n/* -------- Responsive -------- */\n@media (max-width: 920px) {\n  .doc-mgmt-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .doc-mgmt-header-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n  \n  .doc-mgmt-filters {\n    grid-template-columns: 1fr 1fr;\n  }\n  \n  .filter-checks {\n    grid-column: 1 / -1;\n  }\n  \n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n  \n  .form-grid .full {\n    grid-column: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
